var Dd = Object.defineProperty;
var Od = (e, r, i) => r in e ? Dd(e, r, { enumerable: !0, configurable: !0, writable: !0, value: i }) : e[r] = i;
var Ie = (e, r, i) => (Od(e, typeof r != "symbol" ? r + "" : r, i), i), Us = (e, r, i) => {
  if (!r.has(e))
    throw TypeError("Cannot " + i);
};
var Br = (e, r, i) => (Us(e, r, "read from private field"), i ? i.call(e) : r.get(e)), hi = (e, r, i) => {
  if (r.has(e))
    throw TypeError("Cannot add the same private member more than once");
  r instanceof WeakSet ? r.add(e) : r.set(e, i);
}, gn = (e, r, i, s) => (Us(e, r, "write to private field"), s ? s.call(e, i) : r.set(e, i), i);
import sa, { forwardRef as Md, useState as Wr, useRef as br, useMemo as Td, useImperativeHandle as Ld, useEffect as Ys } from "react";
var ki = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ai(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var xn = { exports: {} }, jr = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ns;
function kd() {
  if (Ns)
    return jr;
  Ns = 1;
  var e = sa, r = Symbol.for("react.element"), i = Symbol.for("react.fragment"), s = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, b = { key: !0, ref: !0, __self: !0, __source: !0 };
  function T(w, O, R) {
    var v, h = {}, l = null, u = null;
    R !== void 0 && (l = "" + R), O.key !== void 0 && (l = "" + O.key), O.ref !== void 0 && (u = O.ref);
    for (v in O)
      s.call(O, v) && !b.hasOwnProperty(v) && (h[v] = O[v]);
    if (w && w.defaultProps)
      for (v in O = w.defaultProps, O)
        h[v] === void 0 && (h[v] = O[v]);
    return { $$typeof: r, type: w, key: l, ref: u, props: h, _owner: o.current };
  }
  return jr.Fragment = i, jr.jsx = T, jr.jsxs = T, jr;
}
var Gr = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Bs;
function Ad() {
  return Bs || (Bs = 1, process.env.NODE_ENV !== "production" && function() {
    var e = sa, r = Symbol.for("react.element"), i = Symbol.for("react.portal"), s = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), b = Symbol.for("react.profiler"), T = Symbol.for("react.provider"), w = Symbol.for("react.context"), O = Symbol.for("react.forward_ref"), R = Symbol.for("react.suspense"), v = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), l = Symbol.for("react.lazy"), u = Symbol.for("react.offscreen"), f = Symbol.iterator, p = "@@iterator";
    function m(A) {
      if (A === null || typeof A != "object")
        return null;
      var W = f && A[f] || A[p];
      return typeof W == "function" ? W : null;
    }
    var g = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(A) {
      {
        for (var W = arguments.length, $ = new Array(W > 1 ? W - 1 : 0), fe = 1; fe < W; fe++)
          $[fe - 1] = arguments[fe];
        _("error", A, $);
      }
    }
    function _(A, W, $) {
      {
        var fe = g.ReactDebugCurrentFrame, he = fe.getStackAddendum();
        he !== "" && (W += "%s", $ = $.concat([he]));
        var we = $.map(function(_e) {
          return String(_e);
        });
        we.unshift("Warning: " + W), Function.prototype.apply.call(console[A], console, we);
      }
    }
    var x = !1, d = !1, E = !1, D = !1, M = !1, C;
    C = Symbol.for("react.module.reference");
    function I(A) {
      return !!(typeof A == "string" || typeof A == "function" || A === s || A === b || M || A === o || A === R || A === v || D || A === u || x || d || E || typeof A == "object" && A !== null && (A.$$typeof === l || A.$$typeof === h || A.$$typeof === T || A.$$typeof === w || A.$$typeof === O || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      A.$$typeof === C || A.getModuleId !== void 0));
    }
    function k(A, W, $) {
      var fe = A.displayName;
      if (fe)
        return fe;
      var he = W.displayName || W.name || "";
      return he !== "" ? $ + "(" + he + ")" : $;
    }
    function F(A) {
      return A.displayName || "Context";
    }
    function L(A) {
      if (A == null)
        return null;
      if (typeof A.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof A == "function")
        return A.displayName || A.name || null;
      if (typeof A == "string")
        return A;
      switch (A) {
        case s:
          return "Fragment";
        case i:
          return "Portal";
        case b:
          return "Profiler";
        case o:
          return "StrictMode";
        case R:
          return "Suspense";
        case v:
          return "SuspenseList";
      }
      if (typeof A == "object")
        switch (A.$$typeof) {
          case w:
            var W = A;
            return F(W) + ".Consumer";
          case T:
            var $ = A;
            return F($._context) + ".Provider";
          case O:
            return k(A, A.render, "ForwardRef");
          case h:
            var fe = A.displayName || null;
            return fe !== null ? fe : L(A.type) || "Memo";
          case l: {
            var he = A, we = he._payload, _e = he._init;
            try {
              return L(_e(we));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var U = Object.assign, j = 0, G, B, re, le, Q, ue, ce;
    function de() {
    }
    de.__reactDisabledLog = !0;
    function te() {
      {
        if (j === 0) {
          G = console.log, B = console.info, re = console.warn, le = console.error, Q = console.group, ue = console.groupCollapsed, ce = console.groupEnd;
          var A = {
            configurable: !0,
            enumerable: !0,
            value: de,
            writable: !0
          };
          Object.defineProperties(console, {
            info: A,
            log: A,
            warn: A,
            error: A,
            group: A,
            groupCollapsed: A,
            groupEnd: A
          });
        }
        j++;
      }
    }
    function V() {
      {
        if (j--, j === 0) {
          var A = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: U({}, A, {
              value: G
            }),
            info: U({}, A, {
              value: B
            }),
            warn: U({}, A, {
              value: re
            }),
            error: U({}, A, {
              value: le
            }),
            group: U({}, A, {
              value: Q
            }),
            groupCollapsed: U({}, A, {
              value: ue
            }),
            groupEnd: U({}, A, {
              value: ce
            })
          });
        }
        j < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var xe = g.ReactCurrentDispatcher, be;
    function je(A, W, $) {
      {
        if (be === void 0)
          try {
            throw Error();
          } catch (he) {
            var fe = he.stack.trim().match(/\n( *(at )?)/);
            be = fe && fe[1] || "";
          }
        return `
` + be + A;
      }
    }
    var H = !1, Me;
    {
      var Ve = typeof WeakMap == "function" ? WeakMap : Map;
      Me = new Ve();
    }
    function Se(A, W) {
      if (!A || H)
        return "";
      {
        var $ = Me.get(A);
        if ($ !== void 0)
          return $;
      }
      var fe;
      H = !0;
      var he = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var we;
      we = xe.current, xe.current = null, te();
      try {
        if (W) {
          var _e = function() {
            throw Error();
          };
          if (Object.defineProperty(_e.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(_e, []);
            } catch (Ce) {
              fe = Ce;
            }
            Reflect.construct(A, [], _e);
          } else {
            try {
              _e.call();
            } catch (Ce) {
              fe = Ce;
            }
            A.call(_e.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Ce) {
            fe = Ce;
          }
          A();
        }
      } catch (Ce) {
        if (Ce && fe && typeof Ce.stack == "string") {
          for (var se = Ce.stack.split(`
`), Ge = fe.stack.split(`
`), Pe = se.length - 1, Ne = Ge.length - 1; Pe >= 1 && Ne >= 0 && se[Pe] !== Ge[Ne]; )
            Ne--;
          for (; Pe >= 1 && Ne >= 0; Pe--, Ne--)
            if (se[Pe] !== Ge[Ne]) {
              if (Pe !== 1 || Ne !== 1)
                do
                  if (Pe--, Ne--, Ne < 0 || se[Pe] !== Ge[Ne]) {
                    var dt = `
` + se[Pe].replace(" at new ", " at ");
                    return A.displayName && dt.includes("<anonymous>") && (dt = dt.replace("<anonymous>", A.displayName)), typeof A == "function" && Me.set(A, dt), dt;
                  }
                while (Pe >= 1 && Ne >= 0);
              break;
            }
        }
      } finally {
        H = !1, xe.current = we, V(), Error.prepareStackTrace = he;
      }
      var Jt = A ? A.displayName || A.name : "", an = Jt ? je(Jt) : "";
      return typeof A == "function" && Me.set(A, an), an;
    }
    function ne(A, W, $) {
      return Se(A, !1);
    }
    function Qe(A) {
      var W = A.prototype;
      return !!(W && W.isReactComponent);
    }
    function qe(A, W, $) {
      if (A == null)
        return "";
      if (typeof A == "function")
        return Se(A, Qe(A));
      if (typeof A == "string")
        return je(A);
      switch (A) {
        case R:
          return je("Suspense");
        case v:
          return je("SuspenseList");
      }
      if (typeof A == "object")
        switch (A.$$typeof) {
          case O:
            return ne(A.render);
          case h:
            return qe(A.type, W, $);
          case l: {
            var fe = A, he = fe._payload, we = fe._init;
            try {
              return qe(we(he), W, $);
            } catch {
            }
          }
        }
      return "";
    }
    var rt = Object.prototype.hasOwnProperty, lt = {}, ht = g.ReactDebugCurrentFrame;
    function ct(A) {
      if (A) {
        var W = A._owner, $ = qe(A.type, A._source, W ? W.type : null);
        ht.setExtraStackFrame($);
      } else
        ht.setExtraStackFrame(null);
    }
    function ut(A, W, $, fe, he) {
      {
        var we = Function.call.bind(rt);
        for (var _e in A)
          if (we(A, _e)) {
            var se = void 0;
            try {
              if (typeof A[_e] != "function") {
                var Ge = Error((fe || "React class") + ": " + $ + " type `" + _e + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof A[_e] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Ge.name = "Invariant Violation", Ge;
              }
              se = A[_e](W, _e, fe, $, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Pe) {
              se = Pe;
            }
            se && !(se instanceof Error) && (ct(he), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", fe || "React class", $, _e, typeof se), ct(null)), se instanceof Error && !(se.message in lt) && (lt[se.message] = !0, ct(he), y("Failed %s type: %s", $, se.message), ct(null));
          }
      }
    }
    var Fe = Array.isArray;
    function Ue(A) {
      return Fe(A);
    }
    function Et(A) {
      {
        var W = typeof Symbol == "function" && Symbol.toStringTag, $ = W && A[Symbol.toStringTag] || A.constructor.name || "Object";
        return $;
      }
    }
    function Pt(A) {
      try {
        return $e(A), !1;
      } catch {
        return !0;
      }
    }
    function $e(A) {
      return "" + A;
    }
    function _r(A) {
      if (Pt(A))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Et(A)), $e(A);
    }
    var pt = g.ReactCurrentOwner, Ye = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, Y, z;
    z = {};
    function X(A) {
      if (rt.call(A, "ref")) {
        var W = Object.getOwnPropertyDescriptor(A, "ref").get;
        if (W && W.isReactWarning)
          return !1;
      }
      return A.ref !== void 0;
    }
    function ie(A) {
      if (rt.call(A, "key")) {
        var W = Object.getOwnPropertyDescriptor(A, "key").get;
        if (W && W.isReactWarning)
          return !1;
      }
      return A.key !== void 0;
    }
    function me(A, W) {
      if (typeof A.ref == "string" && pt.current && W && pt.current.stateNode !== W) {
        var $ = L(pt.current.type);
        z[$] || (y('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', L(pt.current.type), A.ref), z[$] = !0);
      }
    }
    function ve(A, W) {
      {
        var $ = function() {
          pe || (pe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", W));
        };
        $.isReactWarning = !0, Object.defineProperty(A, "key", {
          get: $,
          configurable: !0
        });
      }
    }
    function Re(A, W) {
      {
        var $ = function() {
          Y || (Y = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", W));
        };
        $.isReactWarning = !0, Object.defineProperty(A, "ref", {
          get: $,
          configurable: !0
        });
      }
    }
    var St = function(A, W, $, fe, he, we, _e) {
      var se = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: A,
        key: W,
        ref: $,
        props: _e,
        // Record the component responsible for creating this element.
        _owner: we
      };
      return se._store = {}, Object.defineProperty(se._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(se, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: fe
      }), Object.defineProperty(se, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: he
      }), Object.freeze && (Object.freeze(se.props), Object.freeze(se)), se;
    };
    function Mt(A, W, $, fe, he) {
      {
        var we, _e = {}, se = null, Ge = null;
        $ !== void 0 && (_r($), se = "" + $), ie(W) && (_r(W.key), se = "" + W.key), X(W) && (Ge = W.ref, me(W, he));
        for (we in W)
          rt.call(W, we) && !Ye.hasOwnProperty(we) && (_e[we] = W[we]);
        if (A && A.defaultProps) {
          var Pe = A.defaultProps;
          for (we in Pe)
            _e[we] === void 0 && (_e[we] = Pe[we]);
        }
        if (se || Ge) {
          var Ne = typeof A == "function" ? A.displayName || A.name || "Unknown" : A;
          se && ve(_e, Ne), Ge && Re(_e, Ne);
        }
        return St(A, se, Ge, he, fe, pt.current, _e);
      }
    }
    var vt = g.ReactCurrentOwner, Te = g.ReactDebugCurrentFrame;
    function Ct(A) {
      if (A) {
        var W = A._owner, $ = qe(A.type, A._source, W ? W.type : null);
        Te.setExtraStackFrame($);
      } else
        Te.setExtraStackFrame(null);
    }
    var mr;
    mr = !1;
    function $t(A) {
      return typeof A == "object" && A !== null && A.$$typeof === r;
    }
    function pr() {
      {
        if (vt.current) {
          var A = L(vt.current.type);
          if (A)
            return `

Check the render method of \`` + A + "`.";
        }
        return "";
      }
    }
    function vr(A) {
      {
        if (A !== void 0) {
          var W = A.fileName.replace(/^.*[\\\/]/, ""), $ = A.lineNumber;
          return `

Check your code at ` + W + ":" + $ + ".";
        }
        return "";
      }
    }
    var It = {};
    function yr(A) {
      {
        var W = pr();
        if (!W) {
          var $ = typeof A == "string" ? A : A.displayName || A.name;
          $ && (W = `

Check the top-level render call using <` + $ + ">.");
        }
        return W;
      }
    }
    function sn(A, W) {
      {
        if (!A._store || A._store.validated || A.key != null)
          return;
        A._store.validated = !0;
        var $ = yr(W);
        if (It[$])
          return;
        It[$] = !0;
        var fe = "";
        A && A._owner && A._owner !== vt.current && (fe = " It was passed a child from " + L(A._owner.type) + "."), Ct(A), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', $, fe), Ct(null);
      }
    }
    function ir(A, W) {
      {
        if (typeof A != "object")
          return;
        if (Ue(A))
          for (var $ = 0; $ < A.length; $++) {
            var fe = A[$];
            $t(fe) && sn(fe, W);
          }
        else if ($t(A))
          A._store && (A._store.validated = !0);
        else if (A) {
          var he = m(A);
          if (typeof he == "function" && he !== A.entries)
            for (var we = he.call(A), _e; !(_e = we.next()).done; )
              $t(_e.value) && sn(_e.value, W);
        }
      }
    }
    function Kn(A) {
      {
        var W = A.type;
        if (W == null || typeof W == "string")
          return;
        var $;
        if (typeof W == "function")
          $ = W.propTypes;
        else if (typeof W == "object" && (W.$$typeof === O || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        W.$$typeof === h))
          $ = W.propTypes;
        else
          return;
        if ($) {
          var fe = L(W);
          ut($, A.props, "prop", fe, A);
        } else if (W.PropTypes !== void 0 && !mr) {
          mr = !0;
          var he = L(W);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", he || "Unknown");
        }
        typeof W.getDefaultProps == "function" && !W.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function sr(A) {
      {
        for (var W = Object.keys(A.props), $ = 0; $ < W.length; $++) {
          var fe = W[$];
          if (fe !== "children" && fe !== "key") {
            Ct(A), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", fe), Ct(null);
            break;
          }
        }
        A.ref !== null && (Ct(A), y("Invalid attribute `ref` supplied to `React.Fragment`."), Ct(null));
      }
    }
    function ar(A, W, $, fe, he, we) {
      {
        var _e = I(A);
        if (!_e) {
          var se = "";
          (A === void 0 || typeof A == "object" && A !== null && Object.keys(A).length === 0) && (se += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Ge = vr(he);
          Ge ? se += Ge : se += pr();
          var Pe;
          A === null ? Pe = "null" : Ue(A) ? Pe = "array" : A !== void 0 && A.$$typeof === r ? (Pe = "<" + (L(A.type) || "Unknown") + " />", se = " Did you accidentally export a JSX literal instead of a component?") : Pe = typeof A, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Pe, se);
        }
        var Ne = Mt(A, W, $, he, we);
        if (Ne == null)
          return Ne;
        if (_e) {
          var dt = W.children;
          if (dt !== void 0)
            if (fe)
              if (Ue(dt)) {
                for (var Jt = 0; Jt < dt.length; Jt++)
                  ir(dt[Jt], A);
                Object.freeze && Object.freeze(dt);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              ir(dt, A);
        }
        return A === s ? sr(Ne) : Kn(Ne), Ne;
      }
    }
    function q(A, W, $) {
      return ar(A, W, $, !0);
    }
    function Zn(A, W, $) {
      return ar(A, W, $, !1);
    }
    var zn = Zn, at = q;
    Gr.Fragment = s, Gr.jsx = zn, Gr.jsxs = at;
  }()), Gr;
}
var Ws;
function Pd() {
  return Ws || (Ws = 1, process.env.NODE_ENV === "production" ? xn.exports = kd() : xn.exports = Ad()), xn.exports;
}
var En = Pd();
function Pi(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var aa;
function J() {
  return aa.apply(null, arguments);
}
function Cd(e) {
  aa = e;
}
function Rt(e) {
  return e instanceof Array || Object.prototype.toString.call(e) === "[object Array]";
}
function hr(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Object]";
}
function ke(e, r) {
  return Object.prototype.hasOwnProperty.call(e, r);
}
function Ci(e) {
  if (Object.getOwnPropertyNames)
    return Object.getOwnPropertyNames(e).length === 0;
  var r;
  for (r in e)
    if (ke(e, r))
      return !1;
  return !0;
}
function ft(e) {
  return e === void 0;
}
function Zt(e) {
  return typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]";
}
function qr(e) {
  return e instanceof Date || Object.prototype.toString.call(e) === "[object Date]";
}
function oa(e, r) {
  var i = [], s, o = e.length;
  for (s = 0; s < o; ++s)
    i.push(r(e[s], s));
  return i;
}
function tr(e, r) {
  for (var i in r)
    ke(r, i) && (e[i] = r[i]);
  return ke(r, "toString") && (e.toString = r.toString), ke(r, "valueOf") && (e.valueOf = r.valueOf), e;
}
function kt(e, r, i, s) {
  return ka(e, r, i, s, !0).utc();
}
function Id() {
  return {
    empty: !1,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: !1,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: !1,
    userInvalidated: !1,
    iso: !1,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: !1,
    weekdayMismatch: !1
  };
}
function ye(e) {
  return e._pf == null && (e._pf = Id()), e._pf;
}
var bi;
Array.prototype.some ? bi = Array.prototype.some : bi = function(e) {
  var r = Object(this), i = r.length >>> 0, s;
  for (s = 0; s < i; s++)
    if (s in r && e.call(this, r[s], s, r))
      return !0;
  return !1;
};
function Ii(e) {
  if (e._isValid == null) {
    var r = ye(e), i = bi.call(r.parsedDateParts, function(o) {
      return o != null;
    }), s = !isNaN(e._d.getTime()) && r.overflow < 0 && !r.empty && !r.invalidEra && !r.invalidMonth && !r.invalidWeekday && !r.weekdayMismatch && !r.nullInput && !r.invalidFormat && !r.userInvalidated && (!r.meridiem || r.meridiem && i);
    if (e._strict && (s = s && r.charsLeftOver === 0 && r.unusedTokens.length === 0 && r.bigHour === void 0), Object.isFrozen == null || !Object.isFrozen(e))
      e._isValid = s;
    else
      return s;
  }
  return e._isValid;
}
function Cn(e) {
  var r = kt(NaN);
  return e != null ? tr(ye(r), e) : ye(r).userInvalidated = !0, r;
}
var js = J.momentProperties = [], ci = !1;
function Fi(e, r) {
  var i, s, o, b = js.length;
  if (ft(r._isAMomentObject) || (e._isAMomentObject = r._isAMomentObject), ft(r._i) || (e._i = r._i), ft(r._f) || (e._f = r._f), ft(r._l) || (e._l = r._l), ft(r._strict) || (e._strict = r._strict), ft(r._tzm) || (e._tzm = r._tzm), ft(r._isUTC) || (e._isUTC = r._isUTC), ft(r._offset) || (e._offset = r._offset), ft(r._pf) || (e._pf = ye(r)), ft(r._locale) || (e._locale = r._locale), b > 0)
    for (i = 0; i < b; i++)
      s = js[i], o = r[s], ft(o) || (e[s] = o);
  return e;
}
function en(e) {
  Fi(this, e), this._d = new Date(e._d != null ? e._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), ci === !1 && (ci = !0, J.updateOffset(this), ci = !1);
}
function Dt(e) {
  return e instanceof en || e != null && e._isAMomentObject != null;
}
function la(e) {
  J.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + e);
}
function gt(e, r) {
  var i = !0;
  return tr(function() {
    if (J.deprecationHandler != null && J.deprecationHandler(null, e), i) {
      var s = [], o, b, T, w = arguments.length;
      for (b = 0; b < w; b++) {
        if (o = "", typeof arguments[b] == "object") {
          o += `
[` + b + "] ";
          for (T in arguments[0])
            ke(arguments[0], T) && (o += T + ": " + arguments[0][T] + ", ");
          o = o.slice(0, -2);
        } else
          o = arguments[b];
        s.push(o);
      }
      la(
        e + `
Arguments: ` + Array.prototype.slice.call(s).join("") + `
` + new Error().stack
      ), i = !1;
    }
    return r.apply(this, arguments);
  }, r);
}
var Gs = {};
function ua(e, r) {
  J.deprecationHandler != null && J.deprecationHandler(e, r), Gs[e] || (la(r), Gs[e] = !0);
}
J.suppressDeprecationWarnings = !1;
J.deprecationHandler = null;
function At(e) {
  return typeof Function < "u" && e instanceof Function || Object.prototype.toString.call(e) === "[object Function]";
}
function Fd(e) {
  var r, i;
  for (i in e)
    ke(e, i) && (r = e[i], At(r) ? this[i] = r : this["_" + i] = r);
  this._config = e, this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function Ri(e, r) {
  var i = tr({}, e), s;
  for (s in r)
    ke(r, s) && (hr(e[s]) && hr(r[s]) ? (i[s] = {}, tr(i[s], e[s]), tr(i[s], r[s])) : r[s] != null ? i[s] = r[s] : delete i[s]);
  for (s in e)
    ke(e, s) && !ke(r, s) && hr(e[s]) && (i[s] = tr({}, i[s]));
  return i;
}
function Ui(e) {
  e != null && this.set(e);
}
var Di;
Object.keys ? Di = Object.keys : Di = function(e) {
  var r, i = [];
  for (r in e)
    ke(e, r) && i.push(r);
  return i;
};
var Ud = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function Yd(e, r, i) {
  var s = this._calendar[e] || this._calendar.sameElse;
  return At(s) ? s.call(r, i) : s;
}
function Lt(e, r, i) {
  var s = "" + Math.abs(e), o = r - s.length, b = e >= 0;
  return (b ? i ? "+" : "" : "-") + Math.pow(10, Math.max(0, o)).toString().substr(1) + s;
}
var Yi = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, Sn = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, _i = {}, Mr = {};
function oe(e, r, i, s) {
  var o = s;
  typeof s == "string" && (o = function() {
    return this[s]();
  }), e && (Mr[e] = o), r && (Mr[r[0]] = function() {
    return Lt(o.apply(this, arguments), r[1], r[2]);
  }), i && (Mr[i] = function() {
    return this.localeData().ordinal(
      o.apply(this, arguments),
      e
    );
  });
}
function Nd(e) {
  return e.match(/\[[\s\S]/) ? e.replace(/^\[|\]$/g, "") : e.replace(/\\/g, "");
}
function Bd(e) {
  var r = e.match(Yi), i, s;
  for (i = 0, s = r.length; i < s; i++)
    Mr[r[i]] ? r[i] = Mr[r[i]] : r[i] = Nd(r[i]);
  return function(o) {
    var b = "", T;
    for (T = 0; T < s; T++)
      b += At(r[T]) ? r[T].call(o, e) : r[T];
    return b;
  };
}
function Rn(e, r) {
  return e.isValid() ? (r = da(r, e.localeData()), _i[r] = _i[r] || Bd(r), _i[r](e)) : e.localeData().invalidDate();
}
function da(e, r) {
  var i = 5;
  function s(o) {
    return r.longDateFormat(o) || o;
  }
  for (Sn.lastIndex = 0; i >= 0 && Sn.test(e); )
    e = e.replace(
      Sn,
      s
    ), Sn.lastIndex = 0, i -= 1;
  return e;
}
var Wd = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function jd(e) {
  var r = this._longDateFormat[e], i = this._longDateFormat[e.toUpperCase()];
  return r || !i ? r : (this._longDateFormat[e] = i.match(Yi).map(function(s) {
    return s === "MMMM" || s === "MM" || s === "DD" || s === "dddd" ? s.slice(1) : s;
  }).join(""), this._longDateFormat[e]);
}
var Gd = "Invalid date";
function Vd() {
  return this._invalidDate;
}
var Hd = "%d", Kd = /\d{1,2}/;
function Zd(e) {
  return this._ordinal.replace("%d", e);
}
var zd = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function Xd(e, r, i, s) {
  var o = this._relativeTime[i];
  return At(o) ? o(e, r, i, s) : o.replace(/%d/i, e);
}
function $d(e, r) {
  var i = this._relativeTime[e > 0 ? "future" : "past"];
  return At(i) ? i(r) : i.replace(/%s/i, r);
}
var Kr = {};
function it(e, r) {
  var i = e.toLowerCase();
  Kr[i] = Kr[i + "s"] = Kr[r] = e;
}
function xt(e) {
  return typeof e == "string" ? Kr[e] || Kr[e.toLowerCase()] : void 0;
}
function Ni(e) {
  var r = {}, i, s;
  for (s in e)
    ke(e, s) && (i = xt(s), i && (r[i] = e[s]));
  return r;
}
var fa = {};
function st(e, r) {
  fa[e] = r;
}
function Jd(e) {
  var r = [], i;
  for (i in e)
    ke(e, i) && r.push({ unit: i, priority: fa[i] });
  return r.sort(function(s, o) {
    return s.priority - o.priority;
  }), r;
}
function In(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
function yt(e) {
  return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
}
function Ee(e) {
  var r = +e, i = 0;
  return r !== 0 && isFinite(r) && (i = yt(r)), i;
}
function Ar(e, r) {
  return function(i) {
    return i != null ? (ha(this, e, i), J.updateOffset(this, r), this) : Mn(this, e);
  };
}
function Mn(e, r) {
  return e.isValid() ? e._d["get" + (e._isUTC ? "UTC" : "") + r]() : NaN;
}
function ha(e, r, i) {
  e.isValid() && !isNaN(i) && (r === "FullYear" && In(e.year()) && e.month() === 1 && e.date() === 29 ? (i = Ee(i), e._d["set" + (e._isUTC ? "UTC" : "") + r](
    i,
    e.month(),
    Wn(i, e.month())
  )) : e._d["set" + (e._isUTC ? "UTC" : "") + r](i));
}
function Qd(e) {
  return e = xt(e), At(this[e]) ? this[e]() : this;
}
function qd(e, r) {
  if (typeof e == "object") {
    e = Ni(e);
    var i = Jd(e), s, o = i.length;
    for (s = 0; s < o; s++)
      this[i[s].unit](e[i[s].unit]);
  } else if (e = xt(e), At(this[e]))
    return this[e](r);
  return this;
}
var ca = /\d/, mt = /\d\d/, _a = /\d{3}/, Bi = /\d{4}/, Fn = /[+-]?\d{6}/, Ze = /\d\d?/, ma = /\d\d\d\d?/, pa = /\d\d\d\d\d\d?/, Un = /\d{1,3}/, Wi = /\d{1,4}/, Yn = /[+-]?\d{1,6}/, Pr = /\d+/, Nn = /[+-]?\d+/, ef = /Z|[+-]\d\d:?\d\d/gi, Bn = /Z|[+-]\d\d(?::?\d\d)?/gi, tf = /[+-]?\d+(\.\d{1,3})?/, tn = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, Tn;
Tn = {};
function ee(e, r, i) {
  Tn[e] = At(r) ? r : function(s, o) {
    return s && i ? i : r;
  };
}
function rf(e, r) {
  return ke(Tn, e) ? Tn[e](r._strict, r._locale) : new RegExp(nf(e));
}
function nf(e) {
  return _t(
    e.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(r, i, s, o, b) {
        return i || s || o || b;
      }
    )
  );
}
function _t(e) {
  return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
var Oi = {};
function We(e, r) {
  var i, s = r, o;
  for (typeof e == "string" && (e = [e]), Zt(r) && (s = function(b, T) {
    T[r] = Ee(b);
  }), o = e.length, i = 0; i < o; i++)
    Oi[e[i]] = s;
}
function rn(e, r) {
  We(e, function(i, s, o, b) {
    o._w = o._w || {}, r(i, o._w, o, b);
  });
}
function sf(e, r, i) {
  r != null && ke(Oi, e) && Oi[e](r, i._a, i, e);
}
var nt = 0, Vt = 1, Tt = 2, et = 3, bt = 4, Ht = 5, dr = 6, af = 7, of = 8;
function lf(e, r) {
  return (e % r + r) % r;
}
var Je;
Array.prototype.indexOf ? Je = Array.prototype.indexOf : Je = function(e) {
  var r;
  for (r = 0; r < this.length; ++r)
    if (this[r] === e)
      return r;
  return -1;
};
function Wn(e, r) {
  if (isNaN(e) || isNaN(r))
    return NaN;
  var i = lf(r, 12);
  return e += (r - i) / 12, i === 1 ? In(e) ? 29 : 28 : 31 - i % 7 % 2;
}
oe("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
oe("MMM", 0, 0, function(e) {
  return this.localeData().monthsShort(this, e);
});
oe("MMMM", 0, 0, function(e) {
  return this.localeData().months(this, e);
});
it("month", "M");
st("month", 8);
ee("M", Ze);
ee("MM", Ze, mt);
ee("MMM", function(e, r) {
  return r.monthsShortRegex(e);
});
ee("MMMM", function(e, r) {
  return r.monthsRegex(e);
});
We(["M", "MM"], function(e, r) {
  r[Vt] = Ee(e) - 1;
});
We(["MMM", "MMMM"], function(e, r, i, s) {
  var o = i._locale.monthsParse(e, s, i._strict);
  o != null ? r[Vt] = o : ye(i).invalidMonth = e;
});
var uf = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), va = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), ya = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, df = tn, ff = tn;
function hf(e, r) {
  return e ? Rt(this._months) ? this._months[e.month()] : this._months[(this._months.isFormat || ya).test(r) ? "format" : "standalone"][e.month()] : Rt(this._months) ? this._months : this._months.standalone;
}
function cf(e, r) {
  return e ? Rt(this._monthsShort) ? this._monthsShort[e.month()] : this._monthsShort[ya.test(r) ? "format" : "standalone"][e.month()] : Rt(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
}
function _f(e, r, i) {
  var s, o, b, T = e.toLocaleLowerCase();
  if (!this._monthsParse)
    for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], s = 0; s < 12; ++s)
      b = kt([2e3, s]), this._shortMonthsParse[s] = this.monthsShort(
        b,
        ""
      ).toLocaleLowerCase(), this._longMonthsParse[s] = this.months(b, "").toLocaleLowerCase();
  return i ? r === "MMM" ? (o = Je.call(this._shortMonthsParse, T), o !== -1 ? o : null) : (o = Je.call(this._longMonthsParse, T), o !== -1 ? o : null) : r === "MMM" ? (o = Je.call(this._shortMonthsParse, T), o !== -1 ? o : (o = Je.call(this._longMonthsParse, T), o !== -1 ? o : null)) : (o = Je.call(this._longMonthsParse, T), o !== -1 ? o : (o = Je.call(this._shortMonthsParse, T), o !== -1 ? o : null));
}
function mf(e, r, i) {
  var s, o, b;
  if (this._monthsParseExact)
    return _f.call(this, e, r, i);
  for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), s = 0; s < 12; s++) {
    if (o = kt([2e3, s]), i && !this._longMonthsParse[s] && (this._longMonthsParse[s] = new RegExp(
      "^" + this.months(o, "").replace(".", "") + "$",
      "i"
    ), this._shortMonthsParse[s] = new RegExp(
      "^" + this.monthsShort(o, "").replace(".", "") + "$",
      "i"
    )), !i && !this._monthsParse[s] && (b = "^" + this.months(o, "") + "|^" + this.monthsShort(o, ""), this._monthsParse[s] = new RegExp(b.replace(".", ""), "i")), i && r === "MMMM" && this._longMonthsParse[s].test(e))
      return s;
    if (i && r === "MMM" && this._shortMonthsParse[s].test(e))
      return s;
    if (!i && this._monthsParse[s].test(e))
      return s;
  }
}
function ga(e, r) {
  var i;
  if (!e.isValid())
    return e;
  if (typeof r == "string") {
    if (/^\d+$/.test(r))
      r = Ee(r);
    else if (r = e.localeData().monthsParse(r), !Zt(r))
      return e;
  }
  return i = Math.min(e.date(), Wn(e.year(), r)), e._d["set" + (e._isUTC ? "UTC" : "") + "Month"](r, i), e;
}
function xa(e) {
  return e != null ? (ga(this, e), J.updateOffset(this, !0), this) : Mn(this, "Month");
}
function pf() {
  return Wn(this.year(), this.month());
}
function vf(e) {
  return this._monthsParseExact ? (ke(this, "_monthsRegex") || Ea.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex) : (ke(this, "_monthsShortRegex") || (this._monthsShortRegex = df), this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
}
function yf(e) {
  return this._monthsParseExact ? (ke(this, "_monthsRegex") || Ea.call(this), e ? this._monthsStrictRegex : this._monthsRegex) : (ke(this, "_monthsRegex") || (this._monthsRegex = ff), this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
}
function Ea() {
  function e(T, w) {
    return w.length - T.length;
  }
  var r = [], i = [], s = [], o, b;
  for (o = 0; o < 12; o++)
    b = kt([2e3, o]), r.push(this.monthsShort(b, "")), i.push(this.months(b, "")), s.push(this.months(b, "")), s.push(this.monthsShort(b, ""));
  for (r.sort(e), i.sort(e), s.sort(e), o = 0; o < 12; o++)
    r[o] = _t(r[o]), i[o] = _t(i[o]);
  for (o = 0; o < 24; o++)
    s[o] = _t(s[o]);
  this._monthsRegex = new RegExp("^(" + s.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
    "^(" + i.join("|") + ")",
    "i"
  ), this._monthsShortStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  );
}
oe("Y", 0, 0, function() {
  var e = this.year();
  return e <= 9999 ? Lt(e, 4) : "+" + e;
});
oe(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
oe(0, ["YYYY", 4], 0, "year");
oe(0, ["YYYYY", 5], 0, "year");
oe(0, ["YYYYYY", 6, !0], 0, "year");
it("year", "y");
st("year", 1);
ee("Y", Nn);
ee("YY", Ze, mt);
ee("YYYY", Wi, Bi);
ee("YYYYY", Yn, Fn);
ee("YYYYYY", Yn, Fn);
We(["YYYYY", "YYYYYY"], nt);
We("YYYY", function(e, r) {
  r[nt] = e.length === 2 ? J.parseTwoDigitYear(e) : Ee(e);
});
We("YY", function(e, r) {
  r[nt] = J.parseTwoDigitYear(e);
});
We("Y", function(e, r) {
  r[nt] = parseInt(e, 10);
});
function Zr(e) {
  return In(e) ? 366 : 365;
}
J.parseTwoDigitYear = function(e) {
  return Ee(e) + (Ee(e) > 68 ? 1900 : 2e3);
};
var Sa = Ar("FullYear", !0);
function gf() {
  return In(this.year());
}
function xf(e, r, i, s, o, b, T) {
  var w;
  return e < 100 && e >= 0 ? (w = new Date(e + 400, r, i, s, o, b, T), isFinite(w.getFullYear()) && w.setFullYear(e)) : w = new Date(e, r, i, s, o, b, T), w;
}
function $r(e) {
  var r, i;
  return e < 100 && e >= 0 ? (i = Array.prototype.slice.call(arguments), i[0] = e + 400, r = new Date(Date.UTC.apply(null, i)), isFinite(r.getUTCFullYear()) && r.setUTCFullYear(e)) : r = new Date(Date.UTC.apply(null, arguments)), r;
}
function Ln(e, r, i) {
  var s = 7 + r - i, o = (7 + $r(e, 0, s).getUTCDay() - r) % 7;
  return -o + s - 1;
}
function wa(e, r, i, s, o) {
  var b = (7 + i - s) % 7, T = Ln(e, s, o), w = 1 + 7 * (r - 1) + b + T, O, R;
  return w <= 0 ? (O = e - 1, R = Zr(O) + w) : w > Zr(e) ? (O = e + 1, R = w - Zr(e)) : (O = e, R = w), {
    year: O,
    dayOfYear: R
  };
}
function Jr(e, r, i) {
  var s = Ln(e.year(), r, i), o = Math.floor((e.dayOfYear() - s - 1) / 7) + 1, b, T;
  return o < 1 ? (T = e.year() - 1, b = o + Kt(T, r, i)) : o > Kt(e.year(), r, i) ? (b = o - Kt(e.year(), r, i), T = e.year() + 1) : (T = e.year(), b = o), {
    week: b,
    year: T
  };
}
function Kt(e, r, i) {
  var s = Ln(e, r, i), o = Ln(e + 1, r, i);
  return (Zr(e) - s + o) / 7;
}
oe("w", ["ww", 2], "wo", "week");
oe("W", ["WW", 2], "Wo", "isoWeek");
it("week", "w");
it("isoWeek", "W");
st("week", 5);
st("isoWeek", 5);
ee("w", Ze);
ee("ww", Ze, mt);
ee("W", Ze);
ee("WW", Ze, mt);
rn(
  ["w", "ww", "W", "WW"],
  function(e, r, i, s) {
    r[s.substr(0, 1)] = Ee(e);
  }
);
function Ef(e) {
  return Jr(e, this._week.dow, this._week.doy).week;
}
var Sf = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function wf() {
  return this._week.dow;
}
function bf() {
  return this._week.doy;
}
function Rf(e) {
  var r = this.localeData().week(this);
  return e == null ? r : this.add((e - r) * 7, "d");
}
function Df(e) {
  var r = Jr(this, 1, 4).week;
  return e == null ? r : this.add((e - r) * 7, "d");
}
oe("d", 0, "do", "day");
oe("dd", 0, 0, function(e) {
  return this.localeData().weekdaysMin(this, e);
});
oe("ddd", 0, 0, function(e) {
  return this.localeData().weekdaysShort(this, e);
});
oe("dddd", 0, 0, function(e) {
  return this.localeData().weekdays(this, e);
});
oe("e", 0, 0, "weekday");
oe("E", 0, 0, "isoWeekday");
it("day", "d");
it("weekday", "e");
it("isoWeekday", "E");
st("day", 11);
st("weekday", 11);
st("isoWeekday", 11);
ee("d", Ze);
ee("e", Ze);
ee("E", Ze);
ee("dd", function(e, r) {
  return r.weekdaysMinRegex(e);
});
ee("ddd", function(e, r) {
  return r.weekdaysShortRegex(e);
});
ee("dddd", function(e, r) {
  return r.weekdaysRegex(e);
});
rn(["dd", "ddd", "dddd"], function(e, r, i, s) {
  var o = i._locale.weekdaysParse(e, s, i._strict);
  o != null ? r.d = o : ye(i).invalidWeekday = e;
});
rn(["d", "e", "E"], function(e, r, i, s) {
  r[s] = Ee(e);
});
function Of(e, r) {
  return typeof e != "string" ? e : isNaN(e) ? (e = r.weekdaysParse(e), typeof e == "number" ? e : null) : parseInt(e, 10);
}
function Mf(e, r) {
  return typeof e == "string" ? r.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e;
}
function ji(e, r) {
  return e.slice(r, 7).concat(e.slice(0, r));
}
var Tf = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), ba = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), Lf = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), kf = tn, Af = tn, Pf = tn;
function Cf(e, r) {
  var i = Rt(this._weekdays) ? this._weekdays : this._weekdays[e && e !== !0 && this._weekdays.isFormat.test(r) ? "format" : "standalone"];
  return e === !0 ? ji(i, this._week.dow) : e ? i[e.day()] : i;
}
function If(e) {
  return e === !0 ? ji(this._weekdaysShort, this._week.dow) : e ? this._weekdaysShort[e.day()] : this._weekdaysShort;
}
function Ff(e) {
  return e === !0 ? ji(this._weekdaysMin, this._week.dow) : e ? this._weekdaysMin[e.day()] : this._weekdaysMin;
}
function Uf(e, r, i) {
  var s, o, b, T = e.toLocaleLowerCase();
  if (!this._weekdaysParse)
    for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], s = 0; s < 7; ++s)
      b = kt([2e3, 1]).day(s), this._minWeekdaysParse[s] = this.weekdaysMin(
        b,
        ""
      ).toLocaleLowerCase(), this._shortWeekdaysParse[s] = this.weekdaysShort(
        b,
        ""
      ).toLocaleLowerCase(), this._weekdaysParse[s] = this.weekdays(b, "").toLocaleLowerCase();
  return i ? r === "dddd" ? (o = Je.call(this._weekdaysParse, T), o !== -1 ? o : null) : r === "ddd" ? (o = Je.call(this._shortWeekdaysParse, T), o !== -1 ? o : null) : (o = Je.call(this._minWeekdaysParse, T), o !== -1 ? o : null) : r === "dddd" ? (o = Je.call(this._weekdaysParse, T), o !== -1 || (o = Je.call(this._shortWeekdaysParse, T), o !== -1) ? o : (o = Je.call(this._minWeekdaysParse, T), o !== -1 ? o : null)) : r === "ddd" ? (o = Je.call(this._shortWeekdaysParse, T), o !== -1 || (o = Je.call(this._weekdaysParse, T), o !== -1) ? o : (o = Je.call(this._minWeekdaysParse, T), o !== -1 ? o : null)) : (o = Je.call(this._minWeekdaysParse, T), o !== -1 || (o = Je.call(this._weekdaysParse, T), o !== -1) ? o : (o = Je.call(this._shortWeekdaysParse, T), o !== -1 ? o : null));
}
function Yf(e, r, i) {
  var s, o, b;
  if (this._weekdaysParseExact)
    return Uf.call(this, e, r, i);
  for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), s = 0; s < 7; s++) {
    if (o = kt([2e3, 1]).day(s), i && !this._fullWeekdaysParse[s] && (this._fullWeekdaysParse[s] = new RegExp(
      "^" + this.weekdays(o, "").replace(".", "\\.?") + "$",
      "i"
    ), this._shortWeekdaysParse[s] = new RegExp(
      "^" + this.weekdaysShort(o, "").replace(".", "\\.?") + "$",
      "i"
    ), this._minWeekdaysParse[s] = new RegExp(
      "^" + this.weekdaysMin(o, "").replace(".", "\\.?") + "$",
      "i"
    )), this._weekdaysParse[s] || (b = "^" + this.weekdays(o, "") + "|^" + this.weekdaysShort(o, "") + "|^" + this.weekdaysMin(o, ""), this._weekdaysParse[s] = new RegExp(b.replace(".", ""), "i")), i && r === "dddd" && this._fullWeekdaysParse[s].test(e))
      return s;
    if (i && r === "ddd" && this._shortWeekdaysParse[s].test(e))
      return s;
    if (i && r === "dd" && this._minWeekdaysParse[s].test(e))
      return s;
    if (!i && this._weekdaysParse[s].test(e))
      return s;
  }
}
function Nf(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var r = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
  return e != null ? (e = Of(e, this.localeData()), this.add(e - r, "d")) : r;
}
function Bf(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var r = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return e == null ? r : this.add(e - r, "d");
}
function Wf(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    var r = Mf(e, this.localeData());
    return this.day(this.day() % 7 ? r : r - 7);
  } else
    return this.day() || 7;
}
function jf(e) {
  return this._weekdaysParseExact ? (ke(this, "_weekdaysRegex") || Gi.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex) : (ke(this, "_weekdaysRegex") || (this._weekdaysRegex = kf), this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
}
function Gf(e) {
  return this._weekdaysParseExact ? (ke(this, "_weekdaysRegex") || Gi.call(this), e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (ke(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = Af), this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
}
function Vf(e) {
  return this._weekdaysParseExact ? (ke(this, "_weekdaysRegex") || Gi.call(this), e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (ke(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = Pf), this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
}
function Gi() {
  function e(v, h) {
    return h.length - v.length;
  }
  var r = [], i = [], s = [], o = [], b, T, w, O, R;
  for (b = 0; b < 7; b++)
    T = kt([2e3, 1]).day(b), w = _t(this.weekdaysMin(T, "")), O = _t(this.weekdaysShort(T, "")), R = _t(this.weekdays(T, "")), r.push(w), i.push(O), s.push(R), o.push(w), o.push(O), o.push(R);
  r.sort(e), i.sort(e), s.sort(e), o.sort(e), this._weekdaysRegex = new RegExp("^(" + o.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
    "^(" + s.join("|") + ")",
    "i"
  ), this._weekdaysShortStrictRegex = new RegExp(
    "^(" + i.join("|") + ")",
    "i"
  ), this._weekdaysMinStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  );
}
function Vi() {
  return this.hours() % 12 || 12;
}
function Hf() {
  return this.hours() || 24;
}
oe("H", ["HH", 2], 0, "hour");
oe("h", ["hh", 2], 0, Vi);
oe("k", ["kk", 2], 0, Hf);
oe("hmm", 0, 0, function() {
  return "" + Vi.apply(this) + Lt(this.minutes(), 2);
});
oe("hmmss", 0, 0, function() {
  return "" + Vi.apply(this) + Lt(this.minutes(), 2) + Lt(this.seconds(), 2);
});
oe("Hmm", 0, 0, function() {
  return "" + this.hours() + Lt(this.minutes(), 2);
});
oe("Hmmss", 0, 0, function() {
  return "" + this.hours() + Lt(this.minutes(), 2) + Lt(this.seconds(), 2);
});
function Ra(e, r) {
  oe(e, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      r
    );
  });
}
Ra("a", !0);
Ra("A", !1);
it("hour", "h");
st("hour", 13);
function Da(e, r) {
  return r._meridiemParse;
}
ee("a", Da);
ee("A", Da);
ee("H", Ze);
ee("h", Ze);
ee("k", Ze);
ee("HH", Ze, mt);
ee("hh", Ze, mt);
ee("kk", Ze, mt);
ee("hmm", ma);
ee("hmmss", pa);
ee("Hmm", ma);
ee("Hmmss", pa);
We(["H", "HH"], et);
We(["k", "kk"], function(e, r, i) {
  var s = Ee(e);
  r[et] = s === 24 ? 0 : s;
});
We(["a", "A"], function(e, r, i) {
  i._isPm = i._locale.isPM(e), i._meridiem = e;
});
We(["h", "hh"], function(e, r, i) {
  r[et] = Ee(e), ye(i).bigHour = !0;
});
We("hmm", function(e, r, i) {
  var s = e.length - 2;
  r[et] = Ee(e.substr(0, s)), r[bt] = Ee(e.substr(s)), ye(i).bigHour = !0;
});
We("hmmss", function(e, r, i) {
  var s = e.length - 4, o = e.length - 2;
  r[et] = Ee(e.substr(0, s)), r[bt] = Ee(e.substr(s, 2)), r[Ht] = Ee(e.substr(o)), ye(i).bigHour = !0;
});
We("Hmm", function(e, r, i) {
  var s = e.length - 2;
  r[et] = Ee(e.substr(0, s)), r[bt] = Ee(e.substr(s));
});
We("Hmmss", function(e, r, i) {
  var s = e.length - 4, o = e.length - 2;
  r[et] = Ee(e.substr(0, s)), r[bt] = Ee(e.substr(s, 2)), r[Ht] = Ee(e.substr(o));
});
function Kf(e) {
  return (e + "").toLowerCase().charAt(0) === "p";
}
var Zf = /[ap]\.?m?\.?/i, zf = Ar("Hours", !0);
function Xf(e, r, i) {
  return e > 11 ? i ? "pm" : "PM" : i ? "am" : "AM";
}
var Oa = {
  calendar: Ud,
  longDateFormat: Wd,
  invalidDate: Gd,
  ordinal: Hd,
  dayOfMonthOrdinalParse: Kd,
  relativeTime: zd,
  months: uf,
  monthsShort: va,
  week: Sf,
  weekdays: Tf,
  weekdaysMin: Lf,
  weekdaysShort: ba,
  meridiemParse: Zf
}, Xe = {}, Vr = {}, Qr;
function $f(e, r) {
  var i, s = Math.min(e.length, r.length);
  for (i = 0; i < s; i += 1)
    if (e[i] !== r[i])
      return i;
  return s;
}
function Vs(e) {
  return e && e.toLowerCase().replace("_", "-");
}
function Jf(e) {
  for (var r = 0, i, s, o, b; r < e.length; ) {
    for (b = Vs(e[r]).split("-"), i = b.length, s = Vs(e[r + 1]), s = s ? s.split("-") : null; i > 0; ) {
      if (o = jn(b.slice(0, i).join("-")), o)
        return o;
      if (s && s.length >= i && $f(b, s) >= i - 1)
        break;
      i--;
    }
    r++;
  }
  return Qr;
}
function Qf(e) {
  return e.match("^[^/\\\\]*$") != null;
}
function jn(e) {
  var r = null, i;
  if (Xe[e] === void 0 && typeof module < "u" && module && module.exports && Qf(e))
    try {
      r = Qr._abbr, i = Pi, i("./locale/" + e), nr(r);
    } catch {
      Xe[e] = null;
    }
  return Xe[e];
}
function nr(e, r) {
  var i;
  return e && (ft(r) ? i = zt(e) : i = Hi(e, r), i ? Qr = i : typeof console < "u" && console.warn && console.warn(
    "Locale " + e + " not found. Did you forget to load it?"
  )), Qr._abbr;
}
function Hi(e, r) {
  if (r !== null) {
    var i, s = Oa;
    if (r.abbr = e, Xe[e] != null)
      ua(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      ), s = Xe[e]._config;
    else if (r.parentLocale != null)
      if (Xe[r.parentLocale] != null)
        s = Xe[r.parentLocale]._config;
      else if (i = jn(r.parentLocale), i != null)
        s = i._config;
      else
        return Vr[r.parentLocale] || (Vr[r.parentLocale] = []), Vr[r.parentLocale].push({
          name: e,
          config: r
        }), null;
    return Xe[e] = new Ui(Ri(s, r)), Vr[e] && Vr[e].forEach(function(o) {
      Hi(o.name, o.config);
    }), nr(e), Xe[e];
  } else
    return delete Xe[e], null;
}
function qf(e, r) {
  if (r != null) {
    var i, s, o = Oa;
    Xe[e] != null && Xe[e].parentLocale != null ? Xe[e].set(Ri(Xe[e]._config, r)) : (s = jn(e), s != null && (o = s._config), r = Ri(o, r), s == null && (r.abbr = e), i = new Ui(r), i.parentLocale = Xe[e], Xe[e] = i), nr(e);
  } else
    Xe[e] != null && (Xe[e].parentLocale != null ? (Xe[e] = Xe[e].parentLocale, e === nr() && nr(e)) : Xe[e] != null && delete Xe[e]);
  return Xe[e];
}
function zt(e) {
  var r;
  if (e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e)
    return Qr;
  if (!Rt(e)) {
    if (r = jn(e), r)
      return r;
    e = [e];
  }
  return Jf(e);
}
function eh() {
  return Di(Xe);
}
function Ki(e) {
  var r, i = e._a;
  return i && ye(e).overflow === -2 && (r = i[Vt] < 0 || i[Vt] > 11 ? Vt : i[Tt] < 1 || i[Tt] > Wn(i[nt], i[Vt]) ? Tt : i[et] < 0 || i[et] > 24 || i[et] === 24 && (i[bt] !== 0 || i[Ht] !== 0 || i[dr] !== 0) ? et : i[bt] < 0 || i[bt] > 59 ? bt : i[Ht] < 0 || i[Ht] > 59 ? Ht : i[dr] < 0 || i[dr] > 999 ? dr : -1, ye(e)._overflowDayOfYear && (r < nt || r > Tt) && (r = Tt), ye(e)._overflowWeeks && r === -1 && (r = af), ye(e)._overflowWeekday && r === -1 && (r = of), ye(e).overflow = r), e;
}
var th = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, rh = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, nh = /Z|[+-]\d\d(?::?\d\d)?/, wn = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, !1],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, !1],
  ["YYYY", /\d{4}/, !1]
], mi = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], ih = /^\/?Date\((-?\d+)/i, sh = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, ah = {
  UT: 0,
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function Ma(e) {
  var r, i, s = e._i, o = th.exec(s) || rh.exec(s), b, T, w, O, R = wn.length, v = mi.length;
  if (o) {
    for (ye(e).iso = !0, r = 0, i = R; r < i; r++)
      if (wn[r][1].exec(o[1])) {
        T = wn[r][0], b = wn[r][2] !== !1;
        break;
      }
    if (T == null) {
      e._isValid = !1;
      return;
    }
    if (o[3]) {
      for (r = 0, i = v; r < i; r++)
        if (mi[r][1].exec(o[3])) {
          w = (o[2] || " ") + mi[r][0];
          break;
        }
      if (w == null) {
        e._isValid = !1;
        return;
      }
    }
    if (!b && w != null) {
      e._isValid = !1;
      return;
    }
    if (o[4])
      if (nh.exec(o[4]))
        O = "Z";
      else {
        e._isValid = !1;
        return;
      }
    e._f = T + (w || "") + (O || ""), zi(e);
  } else
    e._isValid = !1;
}
function oh(e, r, i, s, o, b) {
  var T = [
    lh(e),
    va.indexOf(r),
    parseInt(i, 10),
    parseInt(s, 10),
    parseInt(o, 10)
  ];
  return b && T.push(parseInt(b, 10)), T;
}
function lh(e) {
  var r = parseInt(e, 10);
  return r <= 49 ? 2e3 + r : r <= 999 ? 1900 + r : r;
}
function uh(e) {
  return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function dh(e, r, i) {
  if (e) {
    var s = ba.indexOf(e), o = new Date(
      r[0],
      r[1],
      r[2]
    ).getDay();
    if (s !== o)
      return ye(i).weekdayMismatch = !0, i._isValid = !1, !1;
  }
  return !0;
}
function fh(e, r, i) {
  if (e)
    return ah[e];
  if (r)
    return 0;
  var s = parseInt(i, 10), o = s % 100, b = (s - o) / 100;
  return b * 60 + o;
}
function Ta(e) {
  var r = sh.exec(uh(e._i)), i;
  if (r) {
    if (i = oh(
      r[4],
      r[3],
      r[2],
      r[5],
      r[6],
      r[7]
    ), !dh(r[1], i, e))
      return;
    e._a = i, e._tzm = fh(r[8], r[9], r[10]), e._d = $r.apply(null, e._a), e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), ye(e).rfc2822 = !0;
  } else
    e._isValid = !1;
}
function hh(e) {
  var r = ih.exec(e._i);
  if (r !== null) {
    e._d = /* @__PURE__ */ new Date(+r[1]);
    return;
  }
  if (Ma(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  if (Ta(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  e._strict ? e._isValid = !1 : J.createFromInputFallback(e);
}
J.createFromInputFallback = gt(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(e) {
    e._d = /* @__PURE__ */ new Date(e._i + (e._useUTC ? " UTC" : ""));
  }
);
function Dr(e, r, i) {
  return e ?? r ?? i;
}
function ch(e) {
  var r = new Date(J.now());
  return e._useUTC ? [
    r.getUTCFullYear(),
    r.getUTCMonth(),
    r.getUTCDate()
  ] : [r.getFullYear(), r.getMonth(), r.getDate()];
}
function Zi(e) {
  var r, i, s = [], o, b, T;
  if (!e._d) {
    for (o = ch(e), e._w && e._a[Tt] == null && e._a[Vt] == null && _h(e), e._dayOfYear != null && (T = Dr(e._a[nt], o[nt]), (e._dayOfYear > Zr(T) || e._dayOfYear === 0) && (ye(e)._overflowDayOfYear = !0), i = $r(T, 0, e._dayOfYear), e._a[Vt] = i.getUTCMonth(), e._a[Tt] = i.getUTCDate()), r = 0; r < 3 && e._a[r] == null; ++r)
      e._a[r] = s[r] = o[r];
    for (; r < 7; r++)
      e._a[r] = s[r] = e._a[r] == null ? r === 2 ? 1 : 0 : e._a[r];
    e._a[et] === 24 && e._a[bt] === 0 && e._a[Ht] === 0 && e._a[dr] === 0 && (e._nextDay = !0, e._a[et] = 0), e._d = (e._useUTC ? $r : xf).apply(
      null,
      s
    ), b = e._useUTC ? e._d.getUTCDay() : e._d.getDay(), e._tzm != null && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), e._nextDay && (e._a[et] = 24), e._w && typeof e._w.d < "u" && e._w.d !== b && (ye(e).weekdayMismatch = !0);
  }
}
function _h(e) {
  var r, i, s, o, b, T, w, O, R;
  r = e._w, r.GG != null || r.W != null || r.E != null ? (b = 1, T = 4, i = Dr(
    r.GG,
    e._a[nt],
    Jr(Ke(), 1, 4).year
  ), s = Dr(r.W, 1), o = Dr(r.E, 1), (o < 1 || o > 7) && (O = !0)) : (b = e._locale._week.dow, T = e._locale._week.doy, R = Jr(Ke(), b, T), i = Dr(r.gg, e._a[nt], R.year), s = Dr(r.w, R.week), r.d != null ? (o = r.d, (o < 0 || o > 6) && (O = !0)) : r.e != null ? (o = r.e + b, (r.e < 0 || r.e > 6) && (O = !0)) : o = b), s < 1 || s > Kt(i, b, T) ? ye(e)._overflowWeeks = !0 : O != null ? ye(e)._overflowWeekday = !0 : (w = wa(i, s, o, b, T), e._a[nt] = w.year, e._dayOfYear = w.dayOfYear);
}
J.ISO_8601 = function() {
};
J.RFC_2822 = function() {
};
function zi(e) {
  if (e._f === J.ISO_8601) {
    Ma(e);
    return;
  }
  if (e._f === J.RFC_2822) {
    Ta(e);
    return;
  }
  e._a = [], ye(e).empty = !0;
  var r = "" + e._i, i, s, o, b, T, w = r.length, O = 0, R, v;
  for (o = da(e._f, e._locale).match(Yi) || [], v = o.length, i = 0; i < v; i++)
    b = o[i], s = (r.match(rf(b, e)) || [])[0], s && (T = r.substr(0, r.indexOf(s)), T.length > 0 && ye(e).unusedInput.push(T), r = r.slice(
      r.indexOf(s) + s.length
    ), O += s.length), Mr[b] ? (s ? ye(e).empty = !1 : ye(e).unusedTokens.push(b), sf(b, s, e)) : e._strict && !s && ye(e).unusedTokens.push(b);
  ye(e).charsLeftOver = w - O, r.length > 0 && ye(e).unusedInput.push(r), e._a[et] <= 12 && ye(e).bigHour === !0 && e._a[et] > 0 && (ye(e).bigHour = void 0), ye(e).parsedDateParts = e._a.slice(0), ye(e).meridiem = e._meridiem, e._a[et] = mh(
    e._locale,
    e._a[et],
    e._meridiem
  ), R = ye(e).era, R !== null && (e._a[nt] = e._locale.erasConvertYear(R, e._a[nt])), Zi(e), Ki(e);
}
function mh(e, r, i) {
  var s;
  return i == null ? r : e.meridiemHour != null ? e.meridiemHour(r, i) : (e.isPM != null && (s = e.isPM(i), s && r < 12 && (r += 12), !s && r === 12 && (r = 0)), r);
}
function ph(e) {
  var r, i, s, o, b, T, w = !1, O = e._f.length;
  if (O === 0) {
    ye(e).invalidFormat = !0, e._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (o = 0; o < O; o++)
    b = 0, T = !1, r = Fi({}, e), e._useUTC != null && (r._useUTC = e._useUTC), r._f = e._f[o], zi(r), Ii(r) && (T = !0), b += ye(r).charsLeftOver, b += ye(r).unusedTokens.length * 10, ye(r).score = b, w ? b < s && (s = b, i = r) : (s == null || b < s || T) && (s = b, i = r, T && (w = !0));
  tr(e, i || r);
}
function vh(e) {
  if (!e._d) {
    var r = Ni(e._i), i = r.day === void 0 ? r.date : r.day;
    e._a = oa(
      [r.year, r.month, i, r.hour, r.minute, r.second, r.millisecond],
      function(s) {
        return s && parseInt(s, 10);
      }
    ), Zi(e);
  }
}
function yh(e) {
  var r = new en(Ki(La(e)));
  return r._nextDay && (r.add(1, "d"), r._nextDay = void 0), r;
}
function La(e) {
  var r = e._i, i = e._f;
  return e._locale = e._locale || zt(e._l), r === null || i === void 0 && r === "" ? Cn({ nullInput: !0 }) : (typeof r == "string" && (e._i = r = e._locale.preparse(r)), Dt(r) ? new en(Ki(r)) : (qr(r) ? e._d = r : Rt(i) ? ph(e) : i ? zi(e) : gh(e), Ii(e) || (e._d = null), e));
}
function gh(e) {
  var r = e._i;
  ft(r) ? e._d = new Date(J.now()) : qr(r) ? e._d = new Date(r.valueOf()) : typeof r == "string" ? hh(e) : Rt(r) ? (e._a = oa(r.slice(0), function(i) {
    return parseInt(i, 10);
  }), Zi(e)) : hr(r) ? vh(e) : Zt(r) ? e._d = new Date(r) : J.createFromInputFallback(e);
}
function ka(e, r, i, s, o) {
  var b = {};
  return (r === !0 || r === !1) && (s = r, r = void 0), (i === !0 || i === !1) && (s = i, i = void 0), (hr(e) && Ci(e) || Rt(e) && e.length === 0) && (e = void 0), b._isAMomentObject = !0, b._useUTC = b._isUTC = o, b._l = i, b._i = e, b._f = r, b._strict = s, yh(b);
}
function Ke(e, r, i, s) {
  return ka(e, r, i, s, !1);
}
var xh = gt(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = Ke.apply(null, arguments);
    return this.isValid() && e.isValid() ? e < this ? this : e : Cn();
  }
), Eh = gt(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = Ke.apply(null, arguments);
    return this.isValid() && e.isValid() ? e > this ? this : e : Cn();
  }
);
function Aa(e, r) {
  var i, s;
  if (r.length === 1 && Rt(r[0]) && (r = r[0]), !r.length)
    return Ke();
  for (i = r[0], s = 1; s < r.length; ++s)
    (!r[s].isValid() || r[s][e](i)) && (i = r[s]);
  return i;
}
function Sh() {
  var e = [].slice.call(arguments, 0);
  return Aa("isBefore", e);
}
function wh() {
  var e = [].slice.call(arguments, 0);
  return Aa("isAfter", e);
}
var bh = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
}, Hr = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function Rh(e) {
  var r, i = !1, s, o = Hr.length;
  for (r in e)
    if (ke(e, r) && !(Je.call(Hr, r) !== -1 && (e[r] == null || !isNaN(e[r]))))
      return !1;
  for (s = 0; s < o; ++s)
    if (e[Hr[s]]) {
      if (i)
        return !1;
      parseFloat(e[Hr[s]]) !== Ee(e[Hr[s]]) && (i = !0);
    }
  return !0;
}
function Dh() {
  return this._isValid;
}
function Oh() {
  return Ot(NaN);
}
function Gn(e) {
  var r = Ni(e), i = r.year || 0, s = r.quarter || 0, o = r.month || 0, b = r.week || r.isoWeek || 0, T = r.day || 0, w = r.hour || 0, O = r.minute || 0, R = r.second || 0, v = r.millisecond || 0;
  this._isValid = Rh(r), this._milliseconds = +v + R * 1e3 + // 1000
  O * 6e4 + // 1000 * 60
  w * 1e3 * 60 * 60, this._days = +T + b * 7, this._months = +o + s * 3 + i * 12, this._data = {}, this._locale = zt(), this._bubble();
}
function Dn(e) {
  return e instanceof Gn;
}
function Mi(e) {
  return e < 0 ? Math.round(-1 * e) * -1 : Math.round(e);
}
function Mh(e, r, i) {
  var s = Math.min(e.length, r.length), o = Math.abs(e.length - r.length), b = 0, T;
  for (T = 0; T < s; T++)
    (i && e[T] !== r[T] || !i && Ee(e[T]) !== Ee(r[T])) && b++;
  return b + o;
}
function Pa(e, r) {
  oe(e, 0, 0, function() {
    var i = this.utcOffset(), s = "+";
    return i < 0 && (i = -i, s = "-"), s + Lt(~~(i / 60), 2) + r + Lt(~~i % 60, 2);
  });
}
Pa("Z", ":");
Pa("ZZ", "");
ee("Z", Bn);
ee("ZZ", Bn);
We(["Z", "ZZ"], function(e, r, i) {
  i._useUTC = !0, i._tzm = Xi(Bn, e);
});
var Th = /([\+\-]|\d\d)/gi;
function Xi(e, r) {
  var i = (r || "").match(e), s, o, b;
  return i === null ? null : (s = i[i.length - 1] || [], o = (s + "").match(Th) || ["-", 0, 0], b = +(o[1] * 60) + Ee(o[2]), b === 0 ? 0 : o[0] === "+" ? b : -b);
}
function $i(e, r) {
  var i, s;
  return r._isUTC ? (i = r.clone(), s = (Dt(e) || qr(e) ? e.valueOf() : Ke(e).valueOf()) - i.valueOf(), i._d.setTime(i._d.valueOf() + s), J.updateOffset(i, !1), i) : Ke(e).local();
}
function Ti(e) {
  return -Math.round(e._d.getTimezoneOffset());
}
J.updateOffset = function() {
};
function Lh(e, r, i) {
  var s = this._offset || 0, o;
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    if (typeof e == "string") {
      if (e = Xi(Bn, e), e === null)
        return this;
    } else
      Math.abs(e) < 16 && !i && (e = e * 60);
    return !this._isUTC && r && (o = Ti(this)), this._offset = e, this._isUTC = !0, o != null && this.add(o, "m"), s !== e && (!r || this._changeInProgress ? Fa(
      this,
      Ot(e - s, "m"),
      1,
      !1
    ) : this._changeInProgress || (this._changeInProgress = !0, J.updateOffset(this, !0), this._changeInProgress = null)), this;
  } else
    return this._isUTC ? s : Ti(this);
}
function kh(e, r) {
  return e != null ? (typeof e != "string" && (e = -e), this.utcOffset(e, r), this) : -this.utcOffset();
}
function Ah(e) {
  return this.utcOffset(0, e);
}
function Ph(e) {
  return this._isUTC && (this.utcOffset(0, e), this._isUTC = !1, e && this.subtract(Ti(this), "m")), this;
}
function Ch() {
  if (this._tzm != null)
    this.utcOffset(this._tzm, !1, !0);
  else if (typeof this._i == "string") {
    var e = Xi(ef, this._i);
    e != null ? this.utcOffset(e) : this.utcOffset(0, !0);
  }
  return this;
}
function Ih(e) {
  return this.isValid() ? (e = e ? Ke(e).utcOffset() : 0, (this.utcOffset() - e) % 60 === 0) : !1;
}
function Fh() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function Uh() {
  if (!ft(this._isDSTShifted))
    return this._isDSTShifted;
  var e = {}, r;
  return Fi(e, this), e = La(e), e._a ? (r = e._isUTC ? kt(e._a) : Ke(e._a), this._isDSTShifted = this.isValid() && Mh(e._a, r.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
}
function Yh() {
  return this.isValid() ? !this._isUTC : !1;
}
function Nh() {
  return this.isValid() ? this._isUTC : !1;
}
function Ca() {
  return this.isValid() ? this._isUTC && this._offset === 0 : !1;
}
var Bh = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, Wh = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function Ot(e, r) {
  var i = e, s = null, o, b, T;
  return Dn(e) ? i = {
    ms: e._milliseconds,
    d: e._days,
    M: e._months
  } : Zt(e) || !isNaN(+e) ? (i = {}, r ? i[r] = +e : i.milliseconds = +e) : (s = Bh.exec(e)) ? (o = s[1] === "-" ? -1 : 1, i = {
    y: 0,
    d: Ee(s[Tt]) * o,
    h: Ee(s[et]) * o,
    m: Ee(s[bt]) * o,
    s: Ee(s[Ht]) * o,
    ms: Ee(Mi(s[dr] * 1e3)) * o
    // the millisecond decimal point is included in the match
  }) : (s = Wh.exec(e)) ? (o = s[1] === "-" ? -1 : 1, i = {
    y: ur(s[2], o),
    M: ur(s[3], o),
    w: ur(s[4], o),
    d: ur(s[5], o),
    h: ur(s[6], o),
    m: ur(s[7], o),
    s: ur(s[8], o)
  }) : i == null ? i = {} : typeof i == "object" && ("from" in i || "to" in i) && (T = jh(
    Ke(i.from),
    Ke(i.to)
  ), i = {}, i.ms = T.milliseconds, i.M = T.months), b = new Gn(i), Dn(e) && ke(e, "_locale") && (b._locale = e._locale), Dn(e) && ke(e, "_isValid") && (b._isValid = e._isValid), b;
}
Ot.fn = Gn.prototype;
Ot.invalid = Oh;
function ur(e, r) {
  var i = e && parseFloat(e.replace(",", "."));
  return (isNaN(i) ? 0 : i) * r;
}
function Hs(e, r) {
  var i = {};
  return i.months = r.month() - e.month() + (r.year() - e.year()) * 12, e.clone().add(i.months, "M").isAfter(r) && --i.months, i.milliseconds = +r - +e.clone().add(i.months, "M"), i;
}
function jh(e, r) {
  var i;
  return e.isValid() && r.isValid() ? (r = $i(r, e), e.isBefore(r) ? i = Hs(e, r) : (i = Hs(r, e), i.milliseconds = -i.milliseconds, i.months = -i.months), i) : { milliseconds: 0, months: 0 };
}
function Ia(e, r) {
  return function(i, s) {
    var o, b;
    return s !== null && !isNaN(+s) && (ua(
      r,
      "moment()." + r + "(period, number) is deprecated. Please use moment()." + r + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
    ), b = i, i = s, s = b), o = Ot(i, s), Fa(this, o, e), this;
  };
}
function Fa(e, r, i, s) {
  var o = r._milliseconds, b = Mi(r._days), T = Mi(r._months);
  e.isValid() && (s = s ?? !0, T && ga(e, Mn(e, "Month") + T * i), b && ha(e, "Date", Mn(e, "Date") + b * i), o && e._d.setTime(e._d.valueOf() + o * i), s && J.updateOffset(e, b || T));
}
var Gh = Ia(1, "add"), Vh = Ia(-1, "subtract");
function Ua(e) {
  return typeof e == "string" || e instanceof String;
}
function Hh(e) {
  return Dt(e) || qr(e) || Ua(e) || Zt(e) || Zh(e) || Kh(e) || e === null || e === void 0;
}
function Kh(e) {
  var r = hr(e) && !Ci(e), i = !1, s = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], o, b, T = s.length;
  for (o = 0; o < T; o += 1)
    b = s[o], i = i || ke(e, b);
  return r && i;
}
function Zh(e) {
  var r = Rt(e), i = !1;
  return r && (i = e.filter(function(s) {
    return !Zt(s) && Ua(e);
  }).length === 0), r && i;
}
function zh(e) {
  var r = hr(e) && !Ci(e), i = !1, s = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], o, b;
  for (o = 0; o < s.length; o += 1)
    b = s[o], i = i || ke(e, b);
  return r && i;
}
function Xh(e, r) {
  var i = e.diff(r, "days", !0);
  return i < -6 ? "sameElse" : i < -1 ? "lastWeek" : i < 0 ? "lastDay" : i < 1 ? "sameDay" : i < 2 ? "nextDay" : i < 7 ? "nextWeek" : "sameElse";
}
function $h(e, r) {
  arguments.length === 1 && (arguments[0] ? Hh(arguments[0]) ? (e = arguments[0], r = void 0) : zh(arguments[0]) && (r = arguments[0], e = void 0) : (e = void 0, r = void 0));
  var i = e || Ke(), s = $i(i, this).startOf("day"), o = J.calendarFormat(this, s) || "sameElse", b = r && (At(r[o]) ? r[o].call(this, i) : r[o]);
  return this.format(
    b || this.localeData().calendar(o, this, Ke(i))
  );
}
function Jh() {
  return new en(this);
}
function Qh(e, r) {
  var i = Dt(e) ? e : Ke(e);
  return this.isValid() && i.isValid() ? (r = xt(r) || "millisecond", r === "millisecond" ? this.valueOf() > i.valueOf() : i.valueOf() < this.clone().startOf(r).valueOf()) : !1;
}
function qh(e, r) {
  var i = Dt(e) ? e : Ke(e);
  return this.isValid() && i.isValid() ? (r = xt(r) || "millisecond", r === "millisecond" ? this.valueOf() < i.valueOf() : this.clone().endOf(r).valueOf() < i.valueOf()) : !1;
}
function ec(e, r, i, s) {
  var o = Dt(e) ? e : Ke(e), b = Dt(r) ? r : Ke(r);
  return this.isValid() && o.isValid() && b.isValid() ? (s = s || "()", (s[0] === "(" ? this.isAfter(o, i) : !this.isBefore(o, i)) && (s[1] === ")" ? this.isBefore(b, i) : !this.isAfter(b, i))) : !1;
}
function tc(e, r) {
  var i = Dt(e) ? e : Ke(e), s;
  return this.isValid() && i.isValid() ? (r = xt(r) || "millisecond", r === "millisecond" ? this.valueOf() === i.valueOf() : (s = i.valueOf(), this.clone().startOf(r).valueOf() <= s && s <= this.clone().endOf(r).valueOf())) : !1;
}
function rc(e, r) {
  return this.isSame(e, r) || this.isAfter(e, r);
}
function nc(e, r) {
  return this.isSame(e, r) || this.isBefore(e, r);
}
function ic(e, r, i) {
  var s, o, b;
  if (!this.isValid())
    return NaN;
  if (s = $i(e, this), !s.isValid())
    return NaN;
  switch (o = (s.utcOffset() - this.utcOffset()) * 6e4, r = xt(r), r) {
    case "year":
      b = On(this, s) / 12;
      break;
    case "month":
      b = On(this, s);
      break;
    case "quarter":
      b = On(this, s) / 3;
      break;
    case "second":
      b = (this - s) / 1e3;
      break;
    case "minute":
      b = (this - s) / 6e4;
      break;
    case "hour":
      b = (this - s) / 36e5;
      break;
    case "day":
      b = (this - s - o) / 864e5;
      break;
    case "week":
      b = (this - s - o) / 6048e5;
      break;
    default:
      b = this - s;
  }
  return i ? b : yt(b);
}
function On(e, r) {
  if (e.date() < r.date())
    return -On(r, e);
  var i = (r.year() - e.year()) * 12 + (r.month() - e.month()), s = e.clone().add(i, "months"), o, b;
  return r - s < 0 ? (o = e.clone().add(i - 1, "months"), b = (r - s) / (s - o)) : (o = e.clone().add(i + 1, "months"), b = (r - s) / (o - s)), -(i + b) || 0;
}
J.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
J.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function sc() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function ac(e) {
  if (!this.isValid())
    return null;
  var r = e !== !0, i = r ? this.clone().utc() : this;
  return i.year() < 0 || i.year() > 9999 ? Rn(
    i,
    r ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
  ) : At(Date.prototype.toISOString) ? r ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", Rn(i, "Z")) : Rn(
    i,
    r ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function oc() {
  if (!this.isValid())
    return "moment.invalid(/* " + this._i + " */)";
  var e = "moment", r = "", i, s, o, b;
  return this.isLocal() || (e = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", r = "Z"), i = "[" + e + '("]', s = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", o = "-MM-DD[T]HH:mm:ss.SSS", b = r + '[")]', this.format(i + s + o + b);
}
function lc(e) {
  e || (e = this.isUtc() ? J.defaultFormatUtc : J.defaultFormat);
  var r = Rn(this, e);
  return this.localeData().postformat(r);
}
function uc(e, r) {
  return this.isValid() && (Dt(e) && e.isValid() || Ke(e).isValid()) ? Ot({ to: this, from: e }).locale(this.locale()).humanize(!r) : this.localeData().invalidDate();
}
function dc(e) {
  return this.from(Ke(), e);
}
function fc(e, r) {
  return this.isValid() && (Dt(e) && e.isValid() || Ke(e).isValid()) ? Ot({ from: this, to: e }).locale(this.locale()).humanize(!r) : this.localeData().invalidDate();
}
function hc(e) {
  return this.to(Ke(), e);
}
function Ya(e) {
  var r;
  return e === void 0 ? this._locale._abbr : (r = zt(e), r != null && (this._locale = r), this);
}
var Na = gt(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(e) {
    return e === void 0 ? this.localeData() : this.locale(e);
  }
);
function Ba() {
  return this._locale;
}
var kn = 1e3, Tr = 60 * kn, An = 60 * Tr, Wa = (365 * 400 + 97) * 24 * An;
function Lr(e, r) {
  return (e % r + r) % r;
}
function ja(e, r, i) {
  return e < 100 && e >= 0 ? new Date(e + 400, r, i) - Wa : new Date(e, r, i).valueOf();
}
function Ga(e, r, i) {
  return e < 100 && e >= 0 ? Date.UTC(e + 400, r, i) - Wa : Date.UTC(e, r, i);
}
function cc(e) {
  var r, i;
  if (e = xt(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (i = this._isUTC ? Ga : ja, e) {
    case "year":
      r = i(this.year(), 0, 1);
      break;
    case "quarter":
      r = i(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      r = i(this.year(), this.month(), 1);
      break;
    case "week":
      r = i(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      r = i(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      r = i(this.year(), this.month(), this.date());
      break;
    case "hour":
      r = this._d.valueOf(), r -= Lr(
        r + (this._isUTC ? 0 : this.utcOffset() * Tr),
        An
      );
      break;
    case "minute":
      r = this._d.valueOf(), r -= Lr(r, Tr);
      break;
    case "second":
      r = this._d.valueOf(), r -= Lr(r, kn);
      break;
  }
  return this._d.setTime(r), J.updateOffset(this, !0), this;
}
function _c(e) {
  var r, i;
  if (e = xt(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (i = this._isUTC ? Ga : ja, e) {
    case "year":
      r = i(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      r = i(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      r = i(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      r = i(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      r = i(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      r = i(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      r = this._d.valueOf(), r += An - Lr(
        r + (this._isUTC ? 0 : this.utcOffset() * Tr),
        An
      ) - 1;
      break;
    case "minute":
      r = this._d.valueOf(), r += Tr - Lr(r, Tr) - 1;
      break;
    case "second":
      r = this._d.valueOf(), r += kn - Lr(r, kn) - 1;
      break;
  }
  return this._d.setTime(r), J.updateOffset(this, !0), this;
}
function mc() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function pc() {
  return Math.floor(this.valueOf() / 1e3);
}
function vc() {
  return new Date(this.valueOf());
}
function yc() {
  var e = this;
  return [
    e.year(),
    e.month(),
    e.date(),
    e.hour(),
    e.minute(),
    e.second(),
    e.millisecond()
  ];
}
function gc() {
  var e = this;
  return {
    years: e.year(),
    months: e.month(),
    date: e.date(),
    hours: e.hours(),
    minutes: e.minutes(),
    seconds: e.seconds(),
    milliseconds: e.milliseconds()
  };
}
function xc() {
  return this.isValid() ? this.toISOString() : null;
}
function Ec() {
  return Ii(this);
}
function Sc() {
  return tr({}, ye(this));
}
function wc() {
  return ye(this).overflow;
}
function bc() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
oe("N", 0, 0, "eraAbbr");
oe("NN", 0, 0, "eraAbbr");
oe("NNN", 0, 0, "eraAbbr");
oe("NNNN", 0, 0, "eraName");
oe("NNNNN", 0, 0, "eraNarrow");
oe("y", ["y", 1], "yo", "eraYear");
oe("y", ["yy", 2], 0, "eraYear");
oe("y", ["yyy", 3], 0, "eraYear");
oe("y", ["yyyy", 4], 0, "eraYear");
ee("N", Ji);
ee("NN", Ji);
ee("NNN", Ji);
ee("NNNN", Ic);
ee("NNNNN", Fc);
We(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(e, r, i, s) {
    var o = i._locale.erasParse(e, s, i._strict);
    o ? ye(i).era = o : ye(i).invalidEra = e;
  }
);
ee("y", Pr);
ee("yy", Pr);
ee("yyy", Pr);
ee("yyyy", Pr);
ee("yo", Uc);
We(["y", "yy", "yyy", "yyyy"], nt);
We(["yo"], function(e, r, i, s) {
  var o;
  i._locale._eraYearOrdinalRegex && (o = e.match(i._locale._eraYearOrdinalRegex)), i._locale.eraYearOrdinalParse ? r[nt] = i._locale.eraYearOrdinalParse(e, o) : r[nt] = parseInt(e, 10);
});
function Rc(e, r) {
  var i, s, o, b = this._eras || zt("en")._eras;
  for (i = 0, s = b.length; i < s; ++i) {
    switch (typeof b[i].since) {
      case "string":
        o = J(b[i].since).startOf("day"), b[i].since = o.valueOf();
        break;
    }
    switch (typeof b[i].until) {
      case "undefined":
        b[i].until = 1 / 0;
        break;
      case "string":
        o = J(b[i].until).startOf("day").valueOf(), b[i].until = o.valueOf();
        break;
    }
  }
  return b;
}
function Dc(e, r, i) {
  var s, o, b = this.eras(), T, w, O;
  for (e = e.toUpperCase(), s = 0, o = b.length; s < o; ++s)
    if (T = b[s].name.toUpperCase(), w = b[s].abbr.toUpperCase(), O = b[s].narrow.toUpperCase(), i)
      switch (r) {
        case "N":
        case "NN":
        case "NNN":
          if (w === e)
            return b[s];
          break;
        case "NNNN":
          if (T === e)
            return b[s];
          break;
        case "NNNNN":
          if (O === e)
            return b[s];
          break;
      }
    else if ([T, w, O].indexOf(e) >= 0)
      return b[s];
}
function Oc(e, r) {
  var i = e.since <= e.until ? 1 : -1;
  return r === void 0 ? J(e.since).year() : J(e.since).year() + (r - e.offset) * i;
}
function Mc() {
  var e, r, i, s = this.localeData().eras();
  for (e = 0, r = s.length; e < r; ++e)
    if (i = this.clone().startOf("day").valueOf(), s[e].since <= i && i <= s[e].until || s[e].until <= i && i <= s[e].since)
      return s[e].name;
  return "";
}
function Tc() {
  var e, r, i, s = this.localeData().eras();
  for (e = 0, r = s.length; e < r; ++e)
    if (i = this.clone().startOf("day").valueOf(), s[e].since <= i && i <= s[e].until || s[e].until <= i && i <= s[e].since)
      return s[e].narrow;
  return "";
}
function Lc() {
  var e, r, i, s = this.localeData().eras();
  for (e = 0, r = s.length; e < r; ++e)
    if (i = this.clone().startOf("day").valueOf(), s[e].since <= i && i <= s[e].until || s[e].until <= i && i <= s[e].since)
      return s[e].abbr;
  return "";
}
function kc() {
  var e, r, i, s, o = this.localeData().eras();
  for (e = 0, r = o.length; e < r; ++e)
    if (i = o[e].since <= o[e].until ? 1 : -1, s = this.clone().startOf("day").valueOf(), o[e].since <= s && s <= o[e].until || o[e].until <= s && s <= o[e].since)
      return (this.year() - J(o[e].since).year()) * i + o[e].offset;
  return this.year();
}
function Ac(e) {
  return ke(this, "_erasNameRegex") || Qi.call(this), e ? this._erasNameRegex : this._erasRegex;
}
function Pc(e) {
  return ke(this, "_erasAbbrRegex") || Qi.call(this), e ? this._erasAbbrRegex : this._erasRegex;
}
function Cc(e) {
  return ke(this, "_erasNarrowRegex") || Qi.call(this), e ? this._erasNarrowRegex : this._erasRegex;
}
function Ji(e, r) {
  return r.erasAbbrRegex(e);
}
function Ic(e, r) {
  return r.erasNameRegex(e);
}
function Fc(e, r) {
  return r.erasNarrowRegex(e);
}
function Uc(e, r) {
  return r._eraYearOrdinalRegex || Pr;
}
function Qi() {
  var e = [], r = [], i = [], s = [], o, b, T = this.eras();
  for (o = 0, b = T.length; o < b; ++o)
    r.push(_t(T[o].name)), e.push(_t(T[o].abbr)), i.push(_t(T[o].narrow)), s.push(_t(T[o].name)), s.push(_t(T[o].abbr)), s.push(_t(T[o].narrow));
  this._erasRegex = new RegExp("^(" + s.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + e.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
    "^(" + i.join("|") + ")",
    "i"
  );
}
oe(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
oe(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function Vn(e, r) {
  oe(0, [e, e.length], 0, r);
}
Vn("gggg", "weekYear");
Vn("ggggg", "weekYear");
Vn("GGGG", "isoWeekYear");
Vn("GGGGG", "isoWeekYear");
it("weekYear", "gg");
it("isoWeekYear", "GG");
st("weekYear", 1);
st("isoWeekYear", 1);
ee("G", Nn);
ee("g", Nn);
ee("GG", Ze, mt);
ee("gg", Ze, mt);
ee("GGGG", Wi, Bi);
ee("gggg", Wi, Bi);
ee("GGGGG", Yn, Fn);
ee("ggggg", Yn, Fn);
rn(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(e, r, i, s) {
    r[s.substr(0, 2)] = Ee(e);
  }
);
rn(["gg", "GG"], function(e, r, i, s) {
  r[s] = J.parseTwoDigitYear(e);
});
function Yc(e) {
  return Va.call(
    this,
    e,
    this.week(),
    this.weekday(),
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function Nc(e) {
  return Va.call(
    this,
    e,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function Bc() {
  return Kt(this.year(), 1, 4);
}
function Wc() {
  return Kt(this.isoWeekYear(), 1, 4);
}
function jc() {
  var e = this.localeData()._week;
  return Kt(this.year(), e.dow, e.doy);
}
function Gc() {
  var e = this.localeData()._week;
  return Kt(this.weekYear(), e.dow, e.doy);
}
function Va(e, r, i, s, o) {
  var b;
  return e == null ? Jr(this, s, o).year : (b = Kt(e, s, o), r > b && (r = b), Vc.call(this, e, r, i, s, o));
}
function Vc(e, r, i, s, o) {
  var b = wa(e, r, i, s, o), T = $r(b.year, 0, b.dayOfYear);
  return this.year(T.getUTCFullYear()), this.month(T.getUTCMonth()), this.date(T.getUTCDate()), this;
}
oe("Q", 0, "Qo", "quarter");
it("quarter", "Q");
st("quarter", 7);
ee("Q", ca);
We("Q", function(e, r) {
  r[Vt] = (Ee(e) - 1) * 3;
});
function Hc(e) {
  return e == null ? Math.ceil((this.month() + 1) / 3) : this.month((e - 1) * 3 + this.month() % 3);
}
oe("D", ["DD", 2], "Do", "date");
it("date", "D");
st("date", 9);
ee("D", Ze);
ee("DD", Ze, mt);
ee("Do", function(e, r) {
  return e ? r._dayOfMonthOrdinalParse || r._ordinalParse : r._dayOfMonthOrdinalParseLenient;
});
We(["D", "DD"], Tt);
We("Do", function(e, r) {
  r[Tt] = Ee(e.match(Ze)[0]);
});
var Ha = Ar("Date", !0);
oe("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
it("dayOfYear", "DDD");
st("dayOfYear", 4);
ee("DDD", Un);
ee("DDDD", _a);
We(["DDD", "DDDD"], function(e, r, i) {
  i._dayOfYear = Ee(e);
});
function Kc(e) {
  var r = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return e == null ? r : this.add(e - r, "d");
}
oe("m", ["mm", 2], 0, "minute");
it("minute", "m");
st("minute", 14);
ee("m", Ze);
ee("mm", Ze, mt);
We(["m", "mm"], bt);
var Zc = Ar("Minutes", !1);
oe("s", ["ss", 2], 0, "second");
it("second", "s");
st("second", 15);
ee("s", Ze);
ee("ss", Ze, mt);
We(["s", "ss"], Ht);
var zc = Ar("Seconds", !1);
oe("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
oe(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
oe(0, ["SSS", 3], 0, "millisecond");
oe(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
oe(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
oe(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
oe(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
oe(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
oe(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
it("millisecond", "ms");
st("millisecond", 16);
ee("S", Un, ca);
ee("SS", Un, mt);
ee("SSS", Un, _a);
var rr, Ka;
for (rr = "SSSS"; rr.length <= 9; rr += "S")
  ee(rr, Pr);
function Xc(e, r) {
  r[dr] = Ee(("0." + e) * 1e3);
}
for (rr = "S"; rr.length <= 9; rr += "S")
  We(rr, Xc);
Ka = Ar("Milliseconds", !1);
oe("z", 0, 0, "zoneAbbr");
oe("zz", 0, 0, "zoneName");
function $c() {
  return this._isUTC ? "UTC" : "";
}
function Jc() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var Z = en.prototype;
Z.add = Gh;
Z.calendar = $h;
Z.clone = Jh;
Z.diff = ic;
Z.endOf = _c;
Z.format = lc;
Z.from = uc;
Z.fromNow = dc;
Z.to = fc;
Z.toNow = hc;
Z.get = Qd;
Z.invalidAt = wc;
Z.isAfter = Qh;
Z.isBefore = qh;
Z.isBetween = ec;
Z.isSame = tc;
Z.isSameOrAfter = rc;
Z.isSameOrBefore = nc;
Z.isValid = Ec;
Z.lang = Na;
Z.locale = Ya;
Z.localeData = Ba;
Z.max = Eh;
Z.min = xh;
Z.parsingFlags = Sc;
Z.set = qd;
Z.startOf = cc;
Z.subtract = Vh;
Z.toArray = yc;
Z.toObject = gc;
Z.toDate = vc;
Z.toISOString = ac;
Z.inspect = oc;
typeof Symbol < "u" && Symbol.for != null && (Z[Symbol.for("nodejs.util.inspect.custom")] = function() {
  return "Moment<" + this.format() + ">";
});
Z.toJSON = xc;
Z.toString = sc;
Z.unix = pc;
Z.valueOf = mc;
Z.creationData = bc;
Z.eraName = Mc;
Z.eraNarrow = Tc;
Z.eraAbbr = Lc;
Z.eraYear = kc;
Z.year = Sa;
Z.isLeapYear = gf;
Z.weekYear = Yc;
Z.isoWeekYear = Nc;
Z.quarter = Z.quarters = Hc;
Z.month = xa;
Z.daysInMonth = pf;
Z.week = Z.weeks = Rf;
Z.isoWeek = Z.isoWeeks = Df;
Z.weeksInYear = jc;
Z.weeksInWeekYear = Gc;
Z.isoWeeksInYear = Bc;
Z.isoWeeksInISOWeekYear = Wc;
Z.date = Ha;
Z.day = Z.days = Nf;
Z.weekday = Bf;
Z.isoWeekday = Wf;
Z.dayOfYear = Kc;
Z.hour = Z.hours = zf;
Z.minute = Z.minutes = Zc;
Z.second = Z.seconds = zc;
Z.millisecond = Z.milliseconds = Ka;
Z.utcOffset = Lh;
Z.utc = Ah;
Z.local = Ph;
Z.parseZone = Ch;
Z.hasAlignedHourOffset = Ih;
Z.isDST = Fh;
Z.isLocal = Yh;
Z.isUtcOffset = Nh;
Z.isUtc = Ca;
Z.isUTC = Ca;
Z.zoneAbbr = $c;
Z.zoneName = Jc;
Z.dates = gt(
  "dates accessor is deprecated. Use date instead.",
  Ha
);
Z.months = gt(
  "months accessor is deprecated. Use month instead",
  xa
);
Z.years = gt(
  "years accessor is deprecated. Use year instead",
  Sa
);
Z.zone = gt(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  kh
);
Z.isDSTShifted = gt(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  Uh
);
function Qc(e) {
  return Ke(e * 1e3);
}
function qc() {
  return Ke.apply(null, arguments).parseZone();
}
function Za(e) {
  return e;
}
var Ae = Ui.prototype;
Ae.calendar = Yd;
Ae.longDateFormat = jd;
Ae.invalidDate = Vd;
Ae.ordinal = Zd;
Ae.preparse = Za;
Ae.postformat = Za;
Ae.relativeTime = Xd;
Ae.pastFuture = $d;
Ae.set = Fd;
Ae.eras = Rc;
Ae.erasParse = Dc;
Ae.erasConvertYear = Oc;
Ae.erasAbbrRegex = Pc;
Ae.erasNameRegex = Ac;
Ae.erasNarrowRegex = Cc;
Ae.months = hf;
Ae.monthsShort = cf;
Ae.monthsParse = mf;
Ae.monthsRegex = yf;
Ae.monthsShortRegex = vf;
Ae.week = Ef;
Ae.firstDayOfYear = bf;
Ae.firstDayOfWeek = wf;
Ae.weekdays = Cf;
Ae.weekdaysMin = Ff;
Ae.weekdaysShort = If;
Ae.weekdaysParse = Yf;
Ae.weekdaysRegex = jf;
Ae.weekdaysShortRegex = Gf;
Ae.weekdaysMinRegex = Vf;
Ae.isPM = Kf;
Ae.meridiem = Xf;
function Pn(e, r, i, s) {
  var o = zt(), b = kt().set(s, r);
  return o[i](b, e);
}
function za(e, r, i) {
  if (Zt(e) && (r = e, e = void 0), e = e || "", r != null)
    return Pn(e, r, i, "month");
  var s, o = [];
  for (s = 0; s < 12; s++)
    o[s] = Pn(e, s, i, "month");
  return o;
}
function qi(e, r, i, s) {
  typeof e == "boolean" ? (Zt(r) && (i = r, r = void 0), r = r || "") : (r = e, i = r, e = !1, Zt(r) && (i = r, r = void 0), r = r || "");
  var o = zt(), b = e ? o._week.dow : 0, T, w = [];
  if (i != null)
    return Pn(r, (i + b) % 7, s, "day");
  for (T = 0; T < 7; T++)
    w[T] = Pn(r, (T + b) % 7, s, "day");
  return w;
}
function e_(e, r) {
  return za(e, r, "months");
}
function t_(e, r) {
  return za(e, r, "monthsShort");
}
function r_(e, r, i) {
  return qi(e, r, i, "weekdays");
}
function n_(e, r, i) {
  return qi(e, r, i, "weekdaysShort");
}
function i_(e, r, i) {
  return qi(e, r, i, "weekdaysMin");
}
nr("en", {
  eras: [
    {
      since: "0001-01-01",
      until: 1 / 0,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -1 / 0,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(e) {
    var r = e % 10, i = Ee(e % 100 / 10) === 1 ? "th" : r === 1 ? "st" : r === 2 ? "nd" : r === 3 ? "rd" : "th";
    return e + i;
  }
});
J.lang = gt(
  "moment.lang is deprecated. Use moment.locale instead.",
  nr
);
J.langData = gt(
  "moment.langData is deprecated. Use moment.localeData instead.",
  zt
);
var jt = Math.abs;
function s_() {
  var e = this._data;
  return this._milliseconds = jt(this._milliseconds), this._days = jt(this._days), this._months = jt(this._months), e.milliseconds = jt(e.milliseconds), e.seconds = jt(e.seconds), e.minutes = jt(e.minutes), e.hours = jt(e.hours), e.months = jt(e.months), e.years = jt(e.years), this;
}
function Xa(e, r, i, s) {
  var o = Ot(r, i);
  return e._milliseconds += s * o._milliseconds, e._days += s * o._days, e._months += s * o._months, e._bubble();
}
function a_(e, r) {
  return Xa(this, e, r, 1);
}
function o_(e, r) {
  return Xa(this, e, r, -1);
}
function Ks(e) {
  return e < 0 ? Math.floor(e) : Math.ceil(e);
}
function l_() {
  var e = this._milliseconds, r = this._days, i = this._months, s = this._data, o, b, T, w, O;
  return e >= 0 && r >= 0 && i >= 0 || e <= 0 && r <= 0 && i <= 0 || (e += Ks(Li(i) + r) * 864e5, r = 0, i = 0), s.milliseconds = e % 1e3, o = yt(e / 1e3), s.seconds = o % 60, b = yt(o / 60), s.minutes = b % 60, T = yt(b / 60), s.hours = T % 24, r += yt(T / 24), O = yt($a(r)), i += O, r -= Ks(Li(O)), w = yt(i / 12), i %= 12, s.days = r, s.months = i, s.years = w, this;
}
function $a(e) {
  return e * 4800 / 146097;
}
function Li(e) {
  return e * 146097 / 4800;
}
function u_(e) {
  if (!this.isValid())
    return NaN;
  var r, i, s = this._milliseconds;
  if (e = xt(e), e === "month" || e === "quarter" || e === "year")
    switch (r = this._days + s / 864e5, i = this._months + $a(r), e) {
      case "month":
        return i;
      case "quarter":
        return i / 3;
      case "year":
        return i / 12;
    }
  else
    switch (r = this._days + Math.round(Li(this._months)), e) {
      case "week":
        return r / 7 + s / 6048e5;
      case "day":
        return r + s / 864e5;
      case "hour":
        return r * 24 + s / 36e5;
      case "minute":
        return r * 1440 + s / 6e4;
      case "second":
        return r * 86400 + s / 1e3;
      case "millisecond":
        return Math.floor(r * 864e5) + s;
      default:
        throw new Error("Unknown unit " + e);
    }
}
function d_() {
  return this.isValid() ? this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + Ee(this._months / 12) * 31536e6 : NaN;
}
function Xt(e) {
  return function() {
    return this.as(e);
  };
}
var f_ = Xt("ms"), h_ = Xt("s"), c_ = Xt("m"), __ = Xt("h"), m_ = Xt("d"), p_ = Xt("w"), v_ = Xt("M"), y_ = Xt("Q"), g_ = Xt("y");
function x_() {
  return Ot(this);
}
function E_(e) {
  return e = xt(e), this.isValid() ? this[e + "s"]() : NaN;
}
function cr(e) {
  return function() {
    return this.isValid() ? this._data[e] : NaN;
  };
}
var S_ = cr("milliseconds"), w_ = cr("seconds"), b_ = cr("minutes"), R_ = cr("hours"), D_ = cr("days"), O_ = cr("months"), M_ = cr("years");
function T_() {
  return yt(this.days() / 7);
}
var Gt = Math.round, Or = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function L_(e, r, i, s, o) {
  return o.relativeTime(r || 1, !!i, e, s);
}
function k_(e, r, i, s) {
  var o = Ot(e).abs(), b = Gt(o.as("s")), T = Gt(o.as("m")), w = Gt(o.as("h")), O = Gt(o.as("d")), R = Gt(o.as("M")), v = Gt(o.as("w")), h = Gt(o.as("y")), l = b <= i.ss && ["s", b] || b < i.s && ["ss", b] || T <= 1 && ["m"] || T < i.m && ["mm", T] || w <= 1 && ["h"] || w < i.h && ["hh", w] || O <= 1 && ["d"] || O < i.d && ["dd", O];
  return i.w != null && (l = l || v <= 1 && ["w"] || v < i.w && ["ww", v]), l = l || R <= 1 && ["M"] || R < i.M && ["MM", R] || h <= 1 && ["y"] || ["yy", h], l[2] = r, l[3] = +e > 0, l[4] = s, L_.apply(null, l);
}
function A_(e) {
  return e === void 0 ? Gt : typeof e == "function" ? (Gt = e, !0) : !1;
}
function P_(e, r) {
  return Or[e] === void 0 ? !1 : r === void 0 ? Or[e] : (Or[e] = r, e === "s" && (Or.ss = r - 1), !0);
}
function C_(e, r) {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var i = !1, s = Or, o, b;
  return typeof e == "object" && (r = e, e = !1), typeof e == "boolean" && (i = e), typeof r == "object" && (s = Object.assign({}, Or, r), r.s != null && r.ss == null && (s.ss = r.s - 1)), o = this.localeData(), b = k_(this, !i, s, o), i && (b = o.pastFuture(+this, b)), o.postformat(b);
}
var pi = Math.abs;
function Rr(e) {
  return (e > 0) - (e < 0) || +e;
}
function Hn() {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var e = pi(this._milliseconds) / 1e3, r = pi(this._days), i = pi(this._months), s, o, b, T, w = this.asSeconds(), O, R, v, h;
  return w ? (s = yt(e / 60), o = yt(s / 60), e %= 60, s %= 60, b = yt(i / 12), i %= 12, T = e ? e.toFixed(3).replace(/\.?0+$/, "") : "", O = w < 0 ? "-" : "", R = Rr(this._months) !== Rr(w) ? "-" : "", v = Rr(this._days) !== Rr(w) ? "-" : "", h = Rr(this._milliseconds) !== Rr(w) ? "-" : "", O + "P" + (b ? R + b + "Y" : "") + (i ? R + i + "M" : "") + (r ? v + r + "D" : "") + (o || s || e ? "T" : "") + (o ? h + o + "H" : "") + (s ? h + s + "M" : "") + (e ? h + T + "S" : "")) : "P0D";
}
var Oe = Gn.prototype;
Oe.isValid = Dh;
Oe.abs = s_;
Oe.add = a_;
Oe.subtract = o_;
Oe.as = u_;
Oe.asMilliseconds = f_;
Oe.asSeconds = h_;
Oe.asMinutes = c_;
Oe.asHours = __;
Oe.asDays = m_;
Oe.asWeeks = p_;
Oe.asMonths = v_;
Oe.asQuarters = y_;
Oe.asYears = g_;
Oe.valueOf = d_;
Oe._bubble = l_;
Oe.clone = x_;
Oe.get = E_;
Oe.milliseconds = S_;
Oe.seconds = w_;
Oe.minutes = b_;
Oe.hours = R_;
Oe.days = D_;
Oe.weeks = T_;
Oe.months = O_;
Oe.years = M_;
Oe.humanize = C_;
Oe.toISOString = Hn;
Oe.toString = Hn;
Oe.toJSON = Hn;
Oe.locale = Ya;
Oe.localeData = Ba;
Oe.toIsoString = gt(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  Hn
);
Oe.lang = Na;
oe("X", 0, 0, "unix");
oe("x", 0, 0, "valueOf");
ee("x", Nn);
ee("X", tf);
We("X", function(e, r, i) {
  i._d = new Date(parseFloat(e) * 1e3);
});
We("x", function(e, r, i) {
  i._d = new Date(Ee(e));
});
//! moment.js
J.version = "2.29.4";
Cd(Ke);
J.fn = Z;
J.min = Sh;
J.max = wh;
J.now = bh;
J.utc = kt;
J.unix = Qc;
J.months = e_;
J.isDate = qr;
J.locale = nr;
J.invalid = Cn;
J.duration = Ot;
J.isMoment = Dt;
J.weekdays = r_;
J.parseZone = qc;
J.localeData = zt;
J.isDuration = Dn;
J.monthsShort = t_;
J.weekdaysMin = i_;
J.defineLocale = Hi;
J.updateLocale = qf;
J.locales = eh;
J.weekdaysShort = n_;
J.normalizeUnits = xt;
J.relativeTimeRounding = A_;
J.relativeTimeThreshold = P_;
J.calendarFormat = Xh;
J.prototype = Z;
J.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
var Zs = { exports: {} }, vi = { exports: {} }, zs;
function I_() {
  return zs || (zs = 1, function(e, r) {
    (function(i, s) {
      e.exports = s();
    })(ki, function() {
      var i;
      function s() {
        return i.apply(null, arguments);
      }
      function o(t) {
        i = t;
      }
      function b(t) {
        return t instanceof Array || Object.prototype.toString.call(t) === "[object Array]";
      }
      function T(t) {
        return t != null && Object.prototype.toString.call(t) === "[object Object]";
      }
      function w(t, n) {
        return Object.prototype.hasOwnProperty.call(t, n);
      }
      function O(t) {
        if (Object.getOwnPropertyNames)
          return Object.getOwnPropertyNames(t).length === 0;
        var n;
        for (n in t)
          if (w(t, n))
            return !1;
        return !0;
      }
      function R(t) {
        return t === void 0;
      }
      function v(t) {
        return typeof t == "number" || Object.prototype.toString.call(t) === "[object Number]";
      }
      function h(t) {
        return t instanceof Date || Object.prototype.toString.call(t) === "[object Date]";
      }
      function l(t, n) {
        var a = [], c, S = t.length;
        for (c = 0; c < S; ++c)
          a.push(n(t[c], c));
        return a;
      }
      function u(t, n) {
        for (var a in n)
          w(n, a) && (t[a] = n[a]);
        return w(n, "toString") && (t.toString = n.toString), w(n, "valueOf") && (t.valueOf = n.valueOf), t;
      }
      function f(t, n, a, c) {
        return ms(t, n, a, c, !0).utc();
      }
      function p() {
        return {
          empty: !1,
          unusedTokens: [],
          unusedInput: [],
          overflow: -2,
          charsLeftOver: 0,
          nullInput: !1,
          invalidEra: null,
          invalidMonth: null,
          invalidFormat: !1,
          userInvalidated: !1,
          iso: !1,
          parsedDateParts: [],
          era: null,
          meridiem: null,
          rfc2822: !1,
          weekdayMismatch: !1
        };
      }
      function m(t) {
        return t._pf == null && (t._pf = p()), t._pf;
      }
      var g;
      Array.prototype.some ? g = Array.prototype.some : g = function(t) {
        var n = Object(this), a = n.length >>> 0, c;
        for (c = 0; c < a; c++)
          if (c in n && t.call(this, n[c], c, n))
            return !0;
        return !1;
      };
      function y(t) {
        if (t._isValid == null) {
          var n = m(t), a = g.call(n.parsedDateParts, function(S) {
            return S != null;
          }), c = !isNaN(t._d.getTime()) && n.overflow < 0 && !n.empty && !n.invalidEra && !n.invalidMonth && !n.invalidWeekday && !n.weekdayMismatch && !n.nullInput && !n.invalidFormat && !n.userInvalidated && (!n.meridiem || n.meridiem && a);
          if (t._strict && (c = c && n.charsLeftOver === 0 && n.unusedTokens.length === 0 && n.bigHour === void 0), Object.isFrozen == null || !Object.isFrozen(t))
            t._isValid = c;
          else
            return c;
        }
        return t._isValid;
      }
      function _(t) {
        var n = f(NaN);
        return t != null ? u(m(n), t) : m(n).userInvalidated = !0, n;
      }
      var x = s.momentProperties = [], d = !1;
      function E(t, n) {
        var a, c, S, P = x.length;
        if (R(n._isAMomentObject) || (t._isAMomentObject = n._isAMomentObject), R(n._i) || (t._i = n._i), R(n._f) || (t._f = n._f), R(n._l) || (t._l = n._l), R(n._strict) || (t._strict = n._strict), R(n._tzm) || (t._tzm = n._tzm), R(n._isUTC) || (t._isUTC = n._isUTC), R(n._offset) || (t._offset = n._offset), R(n._pf) || (t._pf = m(n)), R(n._locale) || (t._locale = n._locale), P > 0)
          for (a = 0; a < P; a++)
            c = x[a], S = n[c], R(S) || (t[c] = S);
        return t;
      }
      function D(t) {
        E(this, t), this._d = new Date(t._d != null ? t._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), d === !1 && (d = !0, s.updateOffset(this), d = !1);
      }
      function M(t) {
        return t instanceof D || t != null && t._isAMomentObject != null;
      }
      function C(t) {
        s.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + t);
      }
      function I(t, n) {
        var a = !0;
        return u(function() {
          if (s.deprecationHandler != null && s.deprecationHandler(null, t), a) {
            var c = [], S, P, N, ae = arguments.length;
            for (P = 0; P < ae; P++) {
              if (S = "", typeof arguments[P] == "object") {
                S += `
[` + P + "] ";
                for (N in arguments[0])
                  w(arguments[0], N) && (S += N + ": " + arguments[0][N] + ", ");
                S = S.slice(0, -2);
              } else
                S = arguments[P];
              c.push(S);
            }
            C(
              t + `
Arguments: ` + Array.prototype.slice.call(c).join("") + `
` + new Error().stack
            ), a = !1;
          }
          return n.apply(this, arguments);
        }, n);
      }
      var k = {};
      function F(t, n) {
        s.deprecationHandler != null && s.deprecationHandler(t, n), k[t] || (C(n), k[t] = !0);
      }
      s.suppressDeprecationWarnings = !1, s.deprecationHandler = null;
      function L(t) {
        return typeof Function < "u" && t instanceof Function || Object.prototype.toString.call(t) === "[object Function]";
      }
      function U(t) {
        var n, a;
        for (a in t)
          w(t, a) && (n = t[a], L(n) ? this[a] = n : this["_" + a] = n);
        this._config = t, this._dayOfMonthOrdinalParseLenient = new RegExp(
          (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
        );
      }
      function j(t, n) {
        var a = u({}, t), c;
        for (c in n)
          w(n, c) && (T(t[c]) && T(n[c]) ? (a[c] = {}, u(a[c], t[c]), u(a[c], n[c])) : n[c] != null ? a[c] = n[c] : delete a[c]);
        for (c in t)
          w(t, c) && !w(n, c) && T(t[c]) && (a[c] = u({}, a[c]));
        return a;
      }
      function G(t) {
        t != null && this.set(t);
      }
      var B;
      Object.keys ? B = Object.keys : B = function(t) {
        var n, a = [];
        for (n in t)
          w(t, n) && a.push(n);
        return a;
      };
      var re = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
      };
      function le(t, n, a) {
        var c = this._calendar[t] || this._calendar.sameElse;
        return L(c) ? c.call(n, a) : c;
      }
      function Q(t, n, a) {
        var c = "" + Math.abs(t), S = n - c.length, P = t >= 0;
        return (P ? a ? "+" : "" : "-") + Math.pow(10, Math.max(0, S)).toString().substr(1) + c;
      }
      var ue = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, ce = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, de = {}, te = {};
      function V(t, n, a, c) {
        var S = c;
        typeof c == "string" && (S = function() {
          return this[c]();
        }), t && (te[t] = S), n && (te[n[0]] = function() {
          return Q(S.apply(this, arguments), n[1], n[2]);
        }), a && (te[a] = function() {
          return this.localeData().ordinal(
            S.apply(this, arguments),
            t
          );
        });
      }
      function xe(t) {
        return t.match(/\[[\s\S]/) ? t.replace(/^\[|\]$/g, "") : t.replace(/\\/g, "");
      }
      function be(t) {
        var n = t.match(ue), a, c;
        for (a = 0, c = n.length; a < c; a++)
          te[n[a]] ? n[a] = te[n[a]] : n[a] = xe(n[a]);
        return function(S) {
          var P = "", N;
          for (N = 0; N < c; N++)
            P += L(n[N]) ? n[N].call(S, t) : n[N];
          return P;
        };
      }
      function je(t, n) {
        return t.isValid() ? (n = H(n, t.localeData()), de[n] = de[n] || be(n), de[n](t)) : t.localeData().invalidDate();
      }
      function H(t, n) {
        var a = 5;
        function c(S) {
          return n.longDateFormat(S) || S;
        }
        for (ce.lastIndex = 0; a >= 0 && ce.test(t); )
          t = t.replace(
            ce,
            c
          ), ce.lastIndex = 0, a -= 1;
        return t;
      }
      var Me = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
      };
      function Ve(t) {
        var n = this._longDateFormat[t], a = this._longDateFormat[t.toUpperCase()];
        return n || !a ? n : (this._longDateFormat[t] = a.match(ue).map(function(c) {
          return c === "MMMM" || c === "MM" || c === "DD" || c === "dddd" ? c.slice(1) : c;
        }).join(""), this._longDateFormat[t]);
      }
      var Se = "Invalid date";
      function ne() {
        return this._invalidDate;
      }
      var Qe = "%d", qe = /\d{1,2}/;
      function rt(t) {
        return this._ordinal.replace("%d", t);
      }
      var lt = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        w: "a week",
        ww: "%d weeks",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
      };
      function ht(t, n, a, c) {
        var S = this._relativeTime[a];
        return L(S) ? S(t, n, a, c) : S.replace(/%d/i, t);
      }
      function ct(t, n) {
        var a = this._relativeTime[t > 0 ? "future" : "past"];
        return L(a) ? a(n) : a.replace(/%s/i, n);
      }
      var ut = {};
      function Fe(t, n) {
        var a = t.toLowerCase();
        ut[a] = ut[a + "s"] = ut[n] = t;
      }
      function Ue(t) {
        return typeof t == "string" ? ut[t] || ut[t.toLowerCase()] : void 0;
      }
      function Et(t) {
        var n = {}, a, c;
        for (c in t)
          w(t, c) && (a = Ue(c), a && (n[a] = t[c]));
        return n;
      }
      var Pt = {};
      function $e(t, n) {
        Pt[t] = n;
      }
      function _r(t) {
        var n = [], a;
        for (a in t)
          w(t, a) && n.push({ unit: a, priority: Pt[a] });
        return n.sort(function(c, S) {
          return c.priority - S.priority;
        }), n;
      }
      function pt(t) {
        return t % 4 === 0 && t % 100 !== 0 || t % 400 === 0;
      }
      function Ye(t) {
        return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
      }
      function pe(t) {
        var n = +t, a = 0;
        return n !== 0 && isFinite(n) && (a = Ye(n)), a;
      }
      function Y(t, n) {
        return function(a) {
          return a != null ? (X(this, t, a), s.updateOffset(this, n), this) : z(this, t);
        };
      }
      function z(t, n) {
        return t.isValid() ? t._d["get" + (t._isUTC ? "UTC" : "") + n]() : NaN;
      }
      function X(t, n, a) {
        t.isValid() && !isNaN(a) && (n === "FullYear" && pt(t.year()) && t.month() === 1 && t.date() === 29 ? (a = pe(a), t._d["set" + (t._isUTC ? "UTC" : "") + n](
          a,
          t.month(),
          on(a, t.month())
        )) : t._d["set" + (t._isUTC ? "UTC" : "") + n](a));
      }
      function ie(t) {
        return t = Ue(t), L(this[t]) ? this[t]() : this;
      }
      function me(t, n) {
        if (typeof t == "object") {
          t = Et(t);
          var a = _r(t), c, S = a.length;
          for (c = 0; c < S; c++)
            this[a[c].unit](t[a[c].unit]);
        } else if (t = Ue(t), L(this[t]))
          return this[t](n);
        return this;
      }
      var ve = /\d/, Re = /\d\d/, St = /\d{3}/, Mt = /\d{4}/, vt = /[+-]?\d{6}/, Te = /\d\d?/, Ct = /\d\d\d\d?/, mr = /\d\d\d\d\d\d?/, $t = /\d{1,3}/, pr = /\d{1,4}/, vr = /[+-]?\d{1,6}/, It = /\d+/, yr = /[+-]?\d+/, sn = /Z|[+-]\d\d:?\d\d/gi, ir = /Z|[+-]\d\d(?::?\d\d)?/gi, Kn = /[+-]?\d+(\.\d{1,3})?/, sr = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, ar;
      ar = {};
      function q(t, n, a) {
        ar[t] = L(n) ? n : function(c, S) {
          return c && a ? a : n;
        };
      }
      function Zn(t, n) {
        return w(ar, t) ? ar[t](n._strict, n._locale) : new RegExp(zn(t));
      }
      function zn(t) {
        return at(
          t.replace("\\", "").replace(
            /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
            function(n, a, c, S, P) {
              return a || c || S || P;
            }
          )
        );
      }
      function at(t) {
        return t.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
      }
      var A = {};
      function W(t, n) {
        var a, c = n, S;
        for (typeof t == "string" && (t = [t]), v(n) && (c = function(P, N) {
          N[n] = pe(P);
        }), S = t.length, a = 0; a < S; a++)
          A[t[a]] = c;
      }
      function $(t, n) {
        W(t, function(a, c, S, P) {
          S._w = S._w || {}, n(a, S._w, S, P);
        });
      }
      function fe(t, n, a) {
        n != null && w(A, t) && A[t](n, a._a, a, t);
      }
      var he = 0, we = 1, _e = 2, se = 3, Ge = 4, Pe = 5, Ne = 6, dt = 7, Jt = 8;
      function an(t, n) {
        return (t % n + n) % n;
      }
      var Ce;
      Array.prototype.indexOf ? Ce = Array.prototype.indexOf : Ce = function(t) {
        var n;
        for (n = 0; n < this.length; ++n)
          if (this[n] === t)
            return n;
        return -1;
      };
      function on(t, n) {
        if (isNaN(t) || isNaN(n))
          return NaN;
        var a = an(n, 12);
        return t += (n - a) / 12, a === 1 ? pt(t) ? 29 : 28 : 31 - a % 7 % 2;
      }
      V("M", ["MM", 2], "Mo", function() {
        return this.month() + 1;
      }), V("MMM", 0, 0, function(t) {
        return this.localeData().monthsShort(this, t);
      }), V("MMMM", 0, 0, function(t) {
        return this.localeData().months(this, t);
      }), Fe("month", "M"), $e("month", 8), q("M", Te), q("MM", Te, Re), q("MMM", function(t, n) {
        return n.monthsShortRegex(t);
      }), q("MMMM", function(t, n) {
        return n.monthsRegex(t);
      }), W(["M", "MM"], function(t, n) {
        n[we] = pe(t) - 1;
      }), W(["MMM", "MMMM"], function(t, n, a, c) {
        var S = a._locale.monthsParse(t, c, a._strict);
        S != null ? n[we] = S : m(a).invalidMonth = t;
      });
      var qa = "January_February_March_April_May_June_July_August_September_October_November_December".split(
        "_"
      ), es = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), ts = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, eo = sr, to = sr;
      function ro(t, n) {
        return t ? b(this._months) ? this._months[t.month()] : this._months[(this._months.isFormat || ts).test(n) ? "format" : "standalone"][t.month()] : b(this._months) ? this._months : this._months.standalone;
      }
      function no(t, n) {
        return t ? b(this._monthsShort) ? this._monthsShort[t.month()] : this._monthsShort[ts.test(n) ? "format" : "standalone"][t.month()] : b(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
      }
      function io(t, n, a) {
        var c, S, P, N = t.toLocaleLowerCase();
        if (!this._monthsParse)
          for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], c = 0; c < 12; ++c)
            P = f([2e3, c]), this._shortMonthsParse[c] = this.monthsShort(
              P,
              ""
            ).toLocaleLowerCase(), this._longMonthsParse[c] = this.months(P, "").toLocaleLowerCase();
        return a ? n === "MMM" ? (S = Ce.call(this._shortMonthsParse, N), S !== -1 ? S : null) : (S = Ce.call(this._longMonthsParse, N), S !== -1 ? S : null) : n === "MMM" ? (S = Ce.call(this._shortMonthsParse, N), S !== -1 ? S : (S = Ce.call(this._longMonthsParse, N), S !== -1 ? S : null)) : (S = Ce.call(this._longMonthsParse, N), S !== -1 ? S : (S = Ce.call(this._shortMonthsParse, N), S !== -1 ? S : null));
      }
      function so(t, n, a) {
        var c, S, P;
        if (this._monthsParseExact)
          return io.call(this, t, n, a);
        for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), c = 0; c < 12; c++) {
          if (S = f([2e3, c]), a && !this._longMonthsParse[c] && (this._longMonthsParse[c] = new RegExp(
            "^" + this.months(S, "").replace(".", "") + "$",
            "i"
          ), this._shortMonthsParse[c] = new RegExp(
            "^" + this.monthsShort(S, "").replace(".", "") + "$",
            "i"
          )), !a && !this._monthsParse[c] && (P = "^" + this.months(S, "") + "|^" + this.monthsShort(S, ""), this._monthsParse[c] = new RegExp(P.replace(".", ""), "i")), a && n === "MMMM" && this._longMonthsParse[c].test(t))
            return c;
          if (a && n === "MMM" && this._shortMonthsParse[c].test(t))
            return c;
          if (!a && this._monthsParse[c].test(t))
            return c;
        }
      }
      function rs(t, n) {
        var a;
        if (!t.isValid())
          return t;
        if (typeof n == "string") {
          if (/^\d+$/.test(n))
            n = pe(n);
          else if (n = t.localeData().monthsParse(n), !v(n))
            return t;
        }
        return a = Math.min(t.date(), on(t.year(), n)), t._d["set" + (t._isUTC ? "UTC" : "") + "Month"](n, a), t;
      }
      function ns(t) {
        return t != null ? (rs(this, t), s.updateOffset(this, !0), this) : z(this, "Month");
      }
      function ao() {
        return on(this.year(), this.month());
      }
      function oo(t) {
        return this._monthsParseExact ? (w(this, "_monthsRegex") || is.call(this), t ? this._monthsShortStrictRegex : this._monthsShortRegex) : (w(this, "_monthsShortRegex") || (this._monthsShortRegex = eo), this._monthsShortStrictRegex && t ? this._monthsShortStrictRegex : this._monthsShortRegex);
      }
      function lo(t) {
        return this._monthsParseExact ? (w(this, "_monthsRegex") || is.call(this), t ? this._monthsStrictRegex : this._monthsRegex) : (w(this, "_monthsRegex") || (this._monthsRegex = to), this._monthsStrictRegex && t ? this._monthsStrictRegex : this._monthsRegex);
      }
      function is() {
        function t(N, ae) {
          return ae.length - N.length;
        }
        var n = [], a = [], c = [], S, P;
        for (S = 0; S < 12; S++)
          P = f([2e3, S]), n.push(this.monthsShort(P, "")), a.push(this.months(P, "")), c.push(this.months(P, "")), c.push(this.monthsShort(P, ""));
        for (n.sort(t), a.sort(t), c.sort(t), S = 0; S < 12; S++)
          n[S] = at(n[S]), a[S] = at(a[S]);
        for (S = 0; S < 24; S++)
          c[S] = at(c[S]);
        this._monthsRegex = new RegExp("^(" + c.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
          "^(" + a.join("|") + ")",
          "i"
        ), this._monthsShortStrictRegex = new RegExp(
          "^(" + n.join("|") + ")",
          "i"
        );
      }
      V("Y", 0, 0, function() {
        var t = this.year();
        return t <= 9999 ? Q(t, 4) : "+" + t;
      }), V(0, ["YY", 2], 0, function() {
        return this.year() % 100;
      }), V(0, ["YYYY", 4], 0, "year"), V(0, ["YYYYY", 5], 0, "year"), V(0, ["YYYYYY", 6, !0], 0, "year"), Fe("year", "y"), $e("year", 1), q("Y", yr), q("YY", Te, Re), q("YYYY", pr, Mt), q("YYYYY", vr, vt), q("YYYYYY", vr, vt), W(["YYYYY", "YYYYYY"], he), W("YYYY", function(t, n) {
        n[he] = t.length === 2 ? s.parseTwoDigitYear(t) : pe(t);
      }), W("YY", function(t, n) {
        n[he] = s.parseTwoDigitYear(t);
      }), W("Y", function(t, n) {
        n[he] = parseInt(t, 10);
      });
      function Cr(t) {
        return pt(t) ? 366 : 365;
      }
      s.parseTwoDigitYear = function(t) {
        return pe(t) + (pe(t) > 68 ? 1900 : 2e3);
      };
      var ss = Y("FullYear", !0);
      function uo() {
        return pt(this.year());
      }
      function fo(t, n, a, c, S, P, N) {
        var ae;
        return t < 100 && t >= 0 ? (ae = new Date(t + 400, n, a, c, S, P, N), isFinite(ae.getFullYear()) && ae.setFullYear(t)) : ae = new Date(t, n, a, c, S, P, N), ae;
      }
      function Ir(t) {
        var n, a;
        return t < 100 && t >= 0 ? (a = Array.prototype.slice.call(arguments), a[0] = t + 400, n = new Date(Date.UTC.apply(null, a)), isFinite(n.getUTCFullYear()) && n.setUTCFullYear(t)) : n = new Date(Date.UTC.apply(null, arguments)), n;
      }
      function ln(t, n, a) {
        var c = 7 + n - a, S = (7 + Ir(t, 0, c).getUTCDay() - n) % 7;
        return -S + c - 1;
      }
      function as(t, n, a, c, S) {
        var P = (7 + a - c) % 7, N = ln(t, c, S), ae = 1 + 7 * (n - 1) + P + N, ge, Be;
        return ae <= 0 ? (ge = t - 1, Be = Cr(ge) + ae) : ae > Cr(t) ? (ge = t + 1, Be = ae - Cr(t)) : (ge = t, Be = ae), {
          year: ge,
          dayOfYear: Be
        };
      }
      function Fr(t, n, a) {
        var c = ln(t.year(), n, a), S = Math.floor((t.dayOfYear() - c - 1) / 7) + 1, P, N;
        return S < 1 ? (N = t.year() - 1, P = S + Ft(N, n, a)) : S > Ft(t.year(), n, a) ? (P = S - Ft(t.year(), n, a), N = t.year() + 1) : (N = t.year(), P = S), {
          week: P,
          year: N
        };
      }
      function Ft(t, n, a) {
        var c = ln(t, n, a), S = ln(t + 1, n, a);
        return (Cr(t) - c + S) / 7;
      }
      V("w", ["ww", 2], "wo", "week"), V("W", ["WW", 2], "Wo", "isoWeek"), Fe("week", "w"), Fe("isoWeek", "W"), $e("week", 5), $e("isoWeek", 5), q("w", Te), q("ww", Te, Re), q("W", Te), q("WW", Te, Re), $(
        ["w", "ww", "W", "WW"],
        function(t, n, a, c) {
          n[c.substr(0, 1)] = pe(t);
        }
      );
      function ho(t) {
        return Fr(t, this._week.dow, this._week.doy).week;
      }
      var co = {
        dow: 0,
        // Sunday is the first day of the week.
        doy: 6
        // The week that contains Jan 6th is the first week of the year.
      };
      function _o() {
        return this._week.dow;
      }
      function mo() {
        return this._week.doy;
      }
      function po(t) {
        var n = this.localeData().week(this);
        return t == null ? n : this.add((t - n) * 7, "d");
      }
      function vo(t) {
        var n = Fr(this, 1, 4).week;
        return t == null ? n : this.add((t - n) * 7, "d");
      }
      V("d", 0, "do", "day"), V("dd", 0, 0, function(t) {
        return this.localeData().weekdaysMin(this, t);
      }), V("ddd", 0, 0, function(t) {
        return this.localeData().weekdaysShort(this, t);
      }), V("dddd", 0, 0, function(t) {
        return this.localeData().weekdays(this, t);
      }), V("e", 0, 0, "weekday"), V("E", 0, 0, "isoWeekday"), Fe("day", "d"), Fe("weekday", "e"), Fe("isoWeekday", "E"), $e("day", 11), $e("weekday", 11), $e("isoWeekday", 11), q("d", Te), q("e", Te), q("E", Te), q("dd", function(t, n) {
        return n.weekdaysMinRegex(t);
      }), q("ddd", function(t, n) {
        return n.weekdaysShortRegex(t);
      }), q("dddd", function(t, n) {
        return n.weekdaysRegex(t);
      }), $(["dd", "ddd", "dddd"], function(t, n, a, c) {
        var S = a._locale.weekdaysParse(t, c, a._strict);
        S != null ? n.d = S : m(a).invalidWeekday = t;
      }), $(["d", "e", "E"], function(t, n, a, c) {
        n[c] = pe(t);
      });
      function yo(t, n) {
        return typeof t != "string" ? t : isNaN(t) ? (t = n.weekdaysParse(t), typeof t == "number" ? t : null) : parseInt(t, 10);
      }
      function go(t, n) {
        return typeof t == "string" ? n.weekdaysParse(t) % 7 || 7 : isNaN(t) ? null : t;
      }
      function Xn(t, n) {
        return t.slice(n, 7).concat(t.slice(0, n));
      }
      var xo = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), os = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), Eo = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), So = sr, wo = sr, bo = sr;
      function Ro(t, n) {
        var a = b(this._weekdays) ? this._weekdays : this._weekdays[t && t !== !0 && this._weekdays.isFormat.test(n) ? "format" : "standalone"];
        return t === !0 ? Xn(a, this._week.dow) : t ? a[t.day()] : a;
      }
      function Do(t) {
        return t === !0 ? Xn(this._weekdaysShort, this._week.dow) : t ? this._weekdaysShort[t.day()] : this._weekdaysShort;
      }
      function Oo(t) {
        return t === !0 ? Xn(this._weekdaysMin, this._week.dow) : t ? this._weekdaysMin[t.day()] : this._weekdaysMin;
      }
      function Mo(t, n, a) {
        var c, S, P, N = t.toLocaleLowerCase();
        if (!this._weekdaysParse)
          for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], c = 0; c < 7; ++c)
            P = f([2e3, 1]).day(c), this._minWeekdaysParse[c] = this.weekdaysMin(
              P,
              ""
            ).toLocaleLowerCase(), this._shortWeekdaysParse[c] = this.weekdaysShort(
              P,
              ""
            ).toLocaleLowerCase(), this._weekdaysParse[c] = this.weekdays(P, "").toLocaleLowerCase();
        return a ? n === "dddd" ? (S = Ce.call(this._weekdaysParse, N), S !== -1 ? S : null) : n === "ddd" ? (S = Ce.call(this._shortWeekdaysParse, N), S !== -1 ? S : null) : (S = Ce.call(this._minWeekdaysParse, N), S !== -1 ? S : null) : n === "dddd" ? (S = Ce.call(this._weekdaysParse, N), S !== -1 || (S = Ce.call(this._shortWeekdaysParse, N), S !== -1) ? S : (S = Ce.call(this._minWeekdaysParse, N), S !== -1 ? S : null)) : n === "ddd" ? (S = Ce.call(this._shortWeekdaysParse, N), S !== -1 || (S = Ce.call(this._weekdaysParse, N), S !== -1) ? S : (S = Ce.call(this._minWeekdaysParse, N), S !== -1 ? S : null)) : (S = Ce.call(this._minWeekdaysParse, N), S !== -1 || (S = Ce.call(this._weekdaysParse, N), S !== -1) ? S : (S = Ce.call(this._shortWeekdaysParse, N), S !== -1 ? S : null));
      }
      function To(t, n, a) {
        var c, S, P;
        if (this._weekdaysParseExact)
          return Mo.call(this, t, n, a);
        for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), c = 0; c < 7; c++) {
          if (S = f([2e3, 1]).day(c), a && !this._fullWeekdaysParse[c] && (this._fullWeekdaysParse[c] = new RegExp(
            "^" + this.weekdays(S, "").replace(".", "\\.?") + "$",
            "i"
          ), this._shortWeekdaysParse[c] = new RegExp(
            "^" + this.weekdaysShort(S, "").replace(".", "\\.?") + "$",
            "i"
          ), this._minWeekdaysParse[c] = new RegExp(
            "^" + this.weekdaysMin(S, "").replace(".", "\\.?") + "$",
            "i"
          )), this._weekdaysParse[c] || (P = "^" + this.weekdays(S, "") + "|^" + this.weekdaysShort(S, "") + "|^" + this.weekdaysMin(S, ""), this._weekdaysParse[c] = new RegExp(P.replace(".", ""), "i")), a && n === "dddd" && this._fullWeekdaysParse[c].test(t))
            return c;
          if (a && n === "ddd" && this._shortWeekdaysParse[c].test(t))
            return c;
          if (a && n === "dd" && this._minWeekdaysParse[c].test(t))
            return c;
          if (!a && this._weekdaysParse[c].test(t))
            return c;
        }
      }
      function Lo(t) {
        if (!this.isValid())
          return t != null ? this : NaN;
        var n = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        return t != null ? (t = yo(t, this.localeData()), this.add(t - n, "d")) : n;
      }
      function ko(t) {
        if (!this.isValid())
          return t != null ? this : NaN;
        var n = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return t == null ? n : this.add(t - n, "d");
      }
      function Ao(t) {
        if (!this.isValid())
          return t != null ? this : NaN;
        if (t != null) {
          var n = go(t, this.localeData());
          return this.day(this.day() % 7 ? n : n - 7);
        } else
          return this.day() || 7;
      }
      function Po(t) {
        return this._weekdaysParseExact ? (w(this, "_weekdaysRegex") || $n.call(this), t ? this._weekdaysStrictRegex : this._weekdaysRegex) : (w(this, "_weekdaysRegex") || (this._weekdaysRegex = So), this._weekdaysStrictRegex && t ? this._weekdaysStrictRegex : this._weekdaysRegex);
      }
      function Co(t) {
        return this._weekdaysParseExact ? (w(this, "_weekdaysRegex") || $n.call(this), t ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (w(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = wo), this._weekdaysShortStrictRegex && t ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
      }
      function Io(t) {
        return this._weekdaysParseExact ? (w(this, "_weekdaysRegex") || $n.call(this), t ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (w(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = bo), this._weekdaysMinStrictRegex && t ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
      }
      function $n() {
        function t(ot, Wt) {
          return Wt.length - ot.length;
        }
        var n = [], a = [], c = [], S = [], P, N, ae, ge, Be;
        for (P = 0; P < 7; P++)
          N = f([2e3, 1]).day(P), ae = at(this.weekdaysMin(N, "")), ge = at(this.weekdaysShort(N, "")), Be = at(this.weekdays(N, "")), n.push(ae), a.push(ge), c.push(Be), S.push(ae), S.push(ge), S.push(Be);
        n.sort(t), a.sort(t), c.sort(t), S.sort(t), this._weekdaysRegex = new RegExp("^(" + S.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
          "^(" + c.join("|") + ")",
          "i"
        ), this._weekdaysShortStrictRegex = new RegExp(
          "^(" + a.join("|") + ")",
          "i"
        ), this._weekdaysMinStrictRegex = new RegExp(
          "^(" + n.join("|") + ")",
          "i"
        );
      }
      function Jn() {
        return this.hours() % 12 || 12;
      }
      function Fo() {
        return this.hours() || 24;
      }
      V("H", ["HH", 2], 0, "hour"), V("h", ["hh", 2], 0, Jn), V("k", ["kk", 2], 0, Fo), V("hmm", 0, 0, function() {
        return "" + Jn.apply(this) + Q(this.minutes(), 2);
      }), V("hmmss", 0, 0, function() {
        return "" + Jn.apply(this) + Q(this.minutes(), 2) + Q(this.seconds(), 2);
      }), V("Hmm", 0, 0, function() {
        return "" + this.hours() + Q(this.minutes(), 2);
      }), V("Hmmss", 0, 0, function() {
        return "" + this.hours() + Q(this.minutes(), 2) + Q(this.seconds(), 2);
      });
      function ls(t, n) {
        V(t, 0, 0, function() {
          return this.localeData().meridiem(
            this.hours(),
            this.minutes(),
            n
          );
        });
      }
      ls("a", !0), ls("A", !1), Fe("hour", "h"), $e("hour", 13);
      function us(t, n) {
        return n._meridiemParse;
      }
      q("a", us), q("A", us), q("H", Te), q("h", Te), q("k", Te), q("HH", Te, Re), q("hh", Te, Re), q("kk", Te, Re), q("hmm", Ct), q("hmmss", mr), q("Hmm", Ct), q("Hmmss", mr), W(["H", "HH"], se), W(["k", "kk"], function(t, n, a) {
        var c = pe(t);
        n[se] = c === 24 ? 0 : c;
      }), W(["a", "A"], function(t, n, a) {
        a._isPm = a._locale.isPM(t), a._meridiem = t;
      }), W(["h", "hh"], function(t, n, a) {
        n[se] = pe(t), m(a).bigHour = !0;
      }), W("hmm", function(t, n, a) {
        var c = t.length - 2;
        n[se] = pe(t.substr(0, c)), n[Ge] = pe(t.substr(c)), m(a).bigHour = !0;
      }), W("hmmss", function(t, n, a) {
        var c = t.length - 4, S = t.length - 2;
        n[se] = pe(t.substr(0, c)), n[Ge] = pe(t.substr(c, 2)), n[Pe] = pe(t.substr(S)), m(a).bigHour = !0;
      }), W("Hmm", function(t, n, a) {
        var c = t.length - 2;
        n[se] = pe(t.substr(0, c)), n[Ge] = pe(t.substr(c));
      }), W("Hmmss", function(t, n, a) {
        var c = t.length - 4, S = t.length - 2;
        n[se] = pe(t.substr(0, c)), n[Ge] = pe(t.substr(c, 2)), n[Pe] = pe(t.substr(S));
      });
      function Uo(t) {
        return (t + "").toLowerCase().charAt(0) === "p";
      }
      var Yo = /[ap]\.?m?\.?/i, No = Y("Hours", !0);
      function Bo(t, n, a) {
        return t > 11 ? a ? "pm" : "PM" : a ? "am" : "AM";
      }
      var ds = {
        calendar: re,
        longDateFormat: Me,
        invalidDate: Se,
        ordinal: Qe,
        dayOfMonthOrdinalParse: qe,
        relativeTime: lt,
        months: qa,
        monthsShort: es,
        week: co,
        weekdays: xo,
        weekdaysMin: Eo,
        weekdaysShort: os,
        meridiemParse: Yo
      }, ze = {}, Ur = {}, Yr;
      function Wo(t, n) {
        var a, c = Math.min(t.length, n.length);
        for (a = 0; a < c; a += 1)
          if (t[a] !== n[a])
            return a;
        return c;
      }
      function fs(t) {
        return t && t.toLowerCase().replace("_", "-");
      }
      function jo(t) {
        for (var n = 0, a, c, S, P; n < t.length; ) {
          for (P = fs(t[n]).split("-"), a = P.length, c = fs(t[n + 1]), c = c ? c.split("-") : null; a > 0; ) {
            if (S = un(P.slice(0, a).join("-")), S)
              return S;
            if (c && c.length >= a && Wo(P, c) >= a - 1)
              break;
            a--;
          }
          n++;
        }
        return Yr;
      }
      function Go(t) {
        return t.match("^[^/\\\\]*$") != null;
      }
      function un(t) {
        var n = null, a;
        if (ze[t] === void 0 && e && e.exports && Go(t))
          try {
            n = Yr._abbr, a = Pi, a("./locale/" + t), Qt(n);
          } catch {
            ze[t] = null;
          }
        return ze[t];
      }
      function Qt(t, n) {
        var a;
        return t && (R(n) ? a = Ut(t) : a = Qn(t, n), a ? Yr = a : typeof console < "u" && console.warn && console.warn(
          "Locale " + t + " not found. Did you forget to load it?"
        )), Yr._abbr;
      }
      function Qn(t, n) {
        if (n !== null) {
          var a, c = ds;
          if (n.abbr = t, ze[t] != null)
            F(
              "defineLocaleOverride",
              "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
            ), c = ze[t]._config;
          else if (n.parentLocale != null)
            if (ze[n.parentLocale] != null)
              c = ze[n.parentLocale]._config;
            else if (a = un(n.parentLocale), a != null)
              c = a._config;
            else
              return Ur[n.parentLocale] || (Ur[n.parentLocale] = []), Ur[n.parentLocale].push({
                name: t,
                config: n
              }), null;
          return ze[t] = new G(j(c, n)), Ur[t] && Ur[t].forEach(function(S) {
            Qn(S.name, S.config);
          }), Qt(t), ze[t];
        } else
          return delete ze[t], null;
      }
      function Vo(t, n) {
        if (n != null) {
          var a, c, S = ds;
          ze[t] != null && ze[t].parentLocale != null ? ze[t].set(j(ze[t]._config, n)) : (c = un(t), c != null && (S = c._config), n = j(S, n), c == null && (n.abbr = t), a = new G(n), a.parentLocale = ze[t], ze[t] = a), Qt(t);
        } else
          ze[t] != null && (ze[t].parentLocale != null ? (ze[t] = ze[t].parentLocale, t === Qt() && Qt(t)) : ze[t] != null && delete ze[t]);
        return ze[t];
      }
      function Ut(t) {
        var n;
        if (t && t._locale && t._locale._abbr && (t = t._locale._abbr), !t)
          return Yr;
        if (!b(t)) {
          if (n = un(t), n)
            return n;
          t = [t];
        }
        return jo(t);
      }
      function Ho() {
        return B(ze);
      }
      function qn(t) {
        var n, a = t._a;
        return a && m(t).overflow === -2 && (n = a[we] < 0 || a[we] > 11 ? we : a[_e] < 1 || a[_e] > on(a[he], a[we]) ? _e : a[se] < 0 || a[se] > 24 || a[se] === 24 && (a[Ge] !== 0 || a[Pe] !== 0 || a[Ne] !== 0) ? se : a[Ge] < 0 || a[Ge] > 59 ? Ge : a[Pe] < 0 || a[Pe] > 59 ? Pe : a[Ne] < 0 || a[Ne] > 999 ? Ne : -1, m(t)._overflowDayOfYear && (n < he || n > _e) && (n = _e), m(t)._overflowWeeks && n === -1 && (n = dt), m(t)._overflowWeekday && n === -1 && (n = Jt), m(t).overflow = n), t;
      }
      var Ko = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, Zo = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, zo = /Z|[+-]\d\d(?::?\d\d)?/, dn = [
        ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
        ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
        ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
        ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
        ["YYYY-DDD", /\d{4}-\d{3}/],
        ["YYYY-MM", /\d{4}-\d\d/, !1],
        ["YYYYYYMMDD", /[+-]\d{10}/],
        ["YYYYMMDD", /\d{8}/],
        ["GGGG[W]WWE", /\d{4}W\d{3}/],
        ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
        ["YYYYDDD", /\d{7}/],
        ["YYYYMM", /\d{6}/, !1],
        ["YYYY", /\d{4}/, !1]
      ], ei = [
        ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
        ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
        ["HH:mm:ss", /\d\d:\d\d:\d\d/],
        ["HH:mm", /\d\d:\d\d/],
        ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
        ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
        ["HHmmss", /\d\d\d\d\d\d/],
        ["HHmm", /\d\d\d\d/],
        ["HH", /\d\d/]
      ], Xo = /^\/?Date\((-?\d+)/i, $o = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, Jo = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
      };
      function hs(t) {
        var n, a, c = t._i, S = Ko.exec(c) || Zo.exec(c), P, N, ae, ge, Be = dn.length, ot = ei.length;
        if (S) {
          for (m(t).iso = !0, n = 0, a = Be; n < a; n++)
            if (dn[n][1].exec(S[1])) {
              N = dn[n][0], P = dn[n][2] !== !1;
              break;
            }
          if (N == null) {
            t._isValid = !1;
            return;
          }
          if (S[3]) {
            for (n = 0, a = ot; n < a; n++)
              if (ei[n][1].exec(S[3])) {
                ae = (S[2] || " ") + ei[n][0];
                break;
              }
            if (ae == null) {
              t._isValid = !1;
              return;
            }
          }
          if (!P && ae != null) {
            t._isValid = !1;
            return;
          }
          if (S[4])
            if (zo.exec(S[4]))
              ge = "Z";
            else {
              t._isValid = !1;
              return;
            }
          t._f = N + (ae || "") + (ge || ""), ri(t);
        } else
          t._isValid = !1;
      }
      function Qo(t, n, a, c, S, P) {
        var N = [
          qo(t),
          es.indexOf(n),
          parseInt(a, 10),
          parseInt(c, 10),
          parseInt(S, 10)
        ];
        return P && N.push(parseInt(P, 10)), N;
      }
      function qo(t) {
        var n = parseInt(t, 10);
        return n <= 49 ? 2e3 + n : n <= 999 ? 1900 + n : n;
      }
      function el(t) {
        return t.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
      }
      function tl(t, n, a) {
        if (t) {
          var c = os.indexOf(t), S = new Date(
            n[0],
            n[1],
            n[2]
          ).getDay();
          if (c !== S)
            return m(a).weekdayMismatch = !0, a._isValid = !1, !1;
        }
        return !0;
      }
      function rl(t, n, a) {
        if (t)
          return Jo[t];
        if (n)
          return 0;
        var c = parseInt(a, 10), S = c % 100, P = (c - S) / 100;
        return P * 60 + S;
      }
      function cs(t) {
        var n = $o.exec(el(t._i)), a;
        if (n) {
          if (a = Qo(
            n[4],
            n[3],
            n[2],
            n[5],
            n[6],
            n[7]
          ), !tl(n[1], a, t))
            return;
          t._a = a, t._tzm = rl(n[8], n[9], n[10]), t._d = Ir.apply(null, t._a), t._d.setUTCMinutes(t._d.getUTCMinutes() - t._tzm), m(t).rfc2822 = !0;
        } else
          t._isValid = !1;
      }
      function nl(t) {
        var n = Xo.exec(t._i);
        if (n !== null) {
          t._d = /* @__PURE__ */ new Date(+n[1]);
          return;
        }
        if (hs(t), t._isValid === !1)
          delete t._isValid;
        else
          return;
        if (cs(t), t._isValid === !1)
          delete t._isValid;
        else
          return;
        t._strict ? t._isValid = !1 : s.createFromInputFallback(t);
      }
      s.createFromInputFallback = I(
        "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
        function(t) {
          t._d = /* @__PURE__ */ new Date(t._i + (t._useUTC ? " UTC" : ""));
        }
      );
      function gr(t, n, a) {
        return t ?? n ?? a;
      }
      function il(t) {
        var n = new Date(s.now());
        return t._useUTC ? [
          n.getUTCFullYear(),
          n.getUTCMonth(),
          n.getUTCDate()
        ] : [n.getFullYear(), n.getMonth(), n.getDate()];
      }
      function ti(t) {
        var n, a, c = [], S, P, N;
        if (!t._d) {
          for (S = il(t), t._w && t._a[_e] == null && t._a[we] == null && sl(t), t._dayOfYear != null && (N = gr(t._a[he], S[he]), (t._dayOfYear > Cr(N) || t._dayOfYear === 0) && (m(t)._overflowDayOfYear = !0), a = Ir(N, 0, t._dayOfYear), t._a[we] = a.getUTCMonth(), t._a[_e] = a.getUTCDate()), n = 0; n < 3 && t._a[n] == null; ++n)
            t._a[n] = c[n] = S[n];
          for (; n < 7; n++)
            t._a[n] = c[n] = t._a[n] == null ? n === 2 ? 1 : 0 : t._a[n];
          t._a[se] === 24 && t._a[Ge] === 0 && t._a[Pe] === 0 && t._a[Ne] === 0 && (t._nextDay = !0, t._a[se] = 0), t._d = (t._useUTC ? Ir : fo).apply(
            null,
            c
          ), P = t._useUTC ? t._d.getUTCDay() : t._d.getDay(), t._tzm != null && t._d.setUTCMinutes(t._d.getUTCMinutes() - t._tzm), t._nextDay && (t._a[se] = 24), t._w && typeof t._w.d < "u" && t._w.d !== P && (m(t).weekdayMismatch = !0);
        }
      }
      function sl(t) {
        var n, a, c, S, P, N, ae, ge, Be;
        n = t._w, n.GG != null || n.W != null || n.E != null ? (P = 1, N = 4, a = gr(
          n.GG,
          t._a[he],
          Fr(He(), 1, 4).year
        ), c = gr(n.W, 1), S = gr(n.E, 1), (S < 1 || S > 7) && (ge = !0)) : (P = t._locale._week.dow, N = t._locale._week.doy, Be = Fr(He(), P, N), a = gr(n.gg, t._a[he], Be.year), c = gr(n.w, Be.week), n.d != null ? (S = n.d, (S < 0 || S > 6) && (ge = !0)) : n.e != null ? (S = n.e + P, (n.e < 0 || n.e > 6) && (ge = !0)) : S = P), c < 1 || c > Ft(a, P, N) ? m(t)._overflowWeeks = !0 : ge != null ? m(t)._overflowWeekday = !0 : (ae = as(a, c, S, P, N), t._a[he] = ae.year, t._dayOfYear = ae.dayOfYear);
      }
      s.ISO_8601 = function() {
      }, s.RFC_2822 = function() {
      };
      function ri(t) {
        if (t._f === s.ISO_8601) {
          hs(t);
          return;
        }
        if (t._f === s.RFC_2822) {
          cs(t);
          return;
        }
        t._a = [], m(t).empty = !0;
        var n = "" + t._i, a, c, S, P, N, ae = n.length, ge = 0, Be, ot;
        for (S = H(t._f, t._locale).match(ue) || [], ot = S.length, a = 0; a < ot; a++)
          P = S[a], c = (n.match(Zn(P, t)) || [])[0], c && (N = n.substr(0, n.indexOf(c)), N.length > 0 && m(t).unusedInput.push(N), n = n.slice(
            n.indexOf(c) + c.length
          ), ge += c.length), te[P] ? (c ? m(t).empty = !1 : m(t).unusedTokens.push(P), fe(P, c, t)) : t._strict && !c && m(t).unusedTokens.push(P);
        m(t).charsLeftOver = ae - ge, n.length > 0 && m(t).unusedInput.push(n), t._a[se] <= 12 && m(t).bigHour === !0 && t._a[se] > 0 && (m(t).bigHour = void 0), m(t).parsedDateParts = t._a.slice(0), m(t).meridiem = t._meridiem, t._a[se] = al(
          t._locale,
          t._a[se],
          t._meridiem
        ), Be = m(t).era, Be !== null && (t._a[he] = t._locale.erasConvertYear(Be, t._a[he])), ti(t), qn(t);
      }
      function al(t, n, a) {
        var c;
        return a == null ? n : t.meridiemHour != null ? t.meridiemHour(n, a) : (t.isPM != null && (c = t.isPM(a), c && n < 12 && (n += 12), !c && n === 12 && (n = 0)), n);
      }
      function ol(t) {
        var n, a, c, S, P, N, ae = !1, ge = t._f.length;
        if (ge === 0) {
          m(t).invalidFormat = !0, t._d = /* @__PURE__ */ new Date(NaN);
          return;
        }
        for (S = 0; S < ge; S++)
          P = 0, N = !1, n = E({}, t), t._useUTC != null && (n._useUTC = t._useUTC), n._f = t._f[S], ri(n), y(n) && (N = !0), P += m(n).charsLeftOver, P += m(n).unusedTokens.length * 10, m(n).score = P, ae ? P < c && (c = P, a = n) : (c == null || P < c || N) && (c = P, a = n, N && (ae = !0));
        u(t, a || n);
      }
      function ll(t) {
        if (!t._d) {
          var n = Et(t._i), a = n.day === void 0 ? n.date : n.day;
          t._a = l(
            [n.year, n.month, a, n.hour, n.minute, n.second, n.millisecond],
            function(c) {
              return c && parseInt(c, 10);
            }
          ), ti(t);
        }
      }
      function ul(t) {
        var n = new D(qn(_s(t)));
        return n._nextDay && (n.add(1, "d"), n._nextDay = void 0), n;
      }
      function _s(t) {
        var n = t._i, a = t._f;
        return t._locale = t._locale || Ut(t._l), n === null || a === void 0 && n === "" ? _({ nullInput: !0 }) : (typeof n == "string" && (t._i = n = t._locale.preparse(n)), M(n) ? new D(qn(n)) : (h(n) ? t._d = n : b(a) ? ol(t) : a ? ri(t) : dl(t), y(t) || (t._d = null), t));
      }
      function dl(t) {
        var n = t._i;
        R(n) ? t._d = new Date(s.now()) : h(n) ? t._d = new Date(n.valueOf()) : typeof n == "string" ? nl(t) : b(n) ? (t._a = l(n.slice(0), function(a) {
          return parseInt(a, 10);
        }), ti(t)) : T(n) ? ll(t) : v(n) ? t._d = new Date(n) : s.createFromInputFallback(t);
      }
      function ms(t, n, a, c, S) {
        var P = {};
        return (n === !0 || n === !1) && (c = n, n = void 0), (a === !0 || a === !1) && (c = a, a = void 0), (T(t) && O(t) || b(t) && t.length === 0) && (t = void 0), P._isAMomentObject = !0, P._useUTC = P._isUTC = S, P._l = a, P._i = t, P._f = n, P._strict = c, ul(P);
      }
      function He(t, n, a, c) {
        return ms(t, n, a, c, !1);
      }
      var fl = I(
        "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
        function() {
          var t = He.apply(null, arguments);
          return this.isValid() && t.isValid() ? t < this ? this : t : _();
        }
      ), hl = I(
        "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
        function() {
          var t = He.apply(null, arguments);
          return this.isValid() && t.isValid() ? t > this ? this : t : _();
        }
      );
      function ps(t, n) {
        var a, c;
        if (n.length === 1 && b(n[0]) && (n = n[0]), !n.length)
          return He();
        for (a = n[0], c = 1; c < n.length; ++c)
          (!n[c].isValid() || n[c][t](a)) && (a = n[c]);
        return a;
      }
      function cl() {
        var t = [].slice.call(arguments, 0);
        return ps("isBefore", t);
      }
      function _l() {
        var t = [].slice.call(arguments, 0);
        return ps("isAfter", t);
      }
      var ml = function() {
        return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
      }, Nr = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond"
      ];
      function pl(t) {
        var n, a = !1, c, S = Nr.length;
        for (n in t)
          if (w(t, n) && !(Ce.call(Nr, n) !== -1 && (t[n] == null || !isNaN(t[n]))))
            return !1;
        for (c = 0; c < S; ++c)
          if (t[Nr[c]]) {
            if (a)
              return !1;
            parseFloat(t[Nr[c]]) !== pe(t[Nr[c]]) && (a = !0);
          }
        return !0;
      }
      function vl() {
        return this._isValid;
      }
      function yl() {
        return wt(NaN);
      }
      function fn(t) {
        var n = Et(t), a = n.year || 0, c = n.quarter || 0, S = n.month || 0, P = n.week || n.isoWeek || 0, N = n.day || 0, ae = n.hour || 0, ge = n.minute || 0, Be = n.second || 0, ot = n.millisecond || 0;
        this._isValid = pl(n), this._milliseconds = +ot + Be * 1e3 + // 1000
        ge * 6e4 + // 1000 * 60
        ae * 1e3 * 60 * 60, this._days = +N + P * 7, this._months = +S + c * 3 + a * 12, this._data = {}, this._locale = Ut(), this._bubble();
      }
      function hn(t) {
        return t instanceof fn;
      }
      function ni(t) {
        return t < 0 ? Math.round(-1 * t) * -1 : Math.round(t);
      }
      function gl(t, n, a) {
        var c = Math.min(t.length, n.length), S = Math.abs(t.length - n.length), P = 0, N;
        for (N = 0; N < c; N++)
          (a && t[N] !== n[N] || !a && pe(t[N]) !== pe(n[N])) && P++;
        return P + S;
      }
      function vs(t, n) {
        V(t, 0, 0, function() {
          var a = this.utcOffset(), c = "+";
          return a < 0 && (a = -a, c = "-"), c + Q(~~(a / 60), 2) + n + Q(~~a % 60, 2);
        });
      }
      vs("Z", ":"), vs("ZZ", ""), q("Z", ir), q("ZZ", ir), W(["Z", "ZZ"], function(t, n, a) {
        a._useUTC = !0, a._tzm = ii(ir, t);
      });
      var xl = /([\+\-]|\d\d)/gi;
      function ii(t, n) {
        var a = (n || "").match(t), c, S, P;
        return a === null ? null : (c = a[a.length - 1] || [], S = (c + "").match(xl) || ["-", 0, 0], P = +(S[1] * 60) + pe(S[2]), P === 0 ? 0 : S[0] === "+" ? P : -P);
      }
      function si(t, n) {
        var a, c;
        return n._isUTC ? (a = n.clone(), c = (M(t) || h(t) ? t.valueOf() : He(t).valueOf()) - a.valueOf(), a._d.setTime(a._d.valueOf() + c), s.updateOffset(a, !1), a) : He(t).local();
      }
      function ai(t) {
        return -Math.round(t._d.getTimezoneOffset());
      }
      s.updateOffset = function() {
      };
      function El(t, n, a) {
        var c = this._offset || 0, S;
        if (!this.isValid())
          return t != null ? this : NaN;
        if (t != null) {
          if (typeof t == "string") {
            if (t = ii(ir, t), t === null)
              return this;
          } else
            Math.abs(t) < 16 && !a && (t = t * 60);
          return !this._isUTC && n && (S = ai(this)), this._offset = t, this._isUTC = !0, S != null && this.add(S, "m"), c !== t && (!n || this._changeInProgress ? Es(
            this,
            wt(t - c, "m"),
            1,
            !1
          ) : this._changeInProgress || (this._changeInProgress = !0, s.updateOffset(this, !0), this._changeInProgress = null)), this;
        } else
          return this._isUTC ? c : ai(this);
      }
      function Sl(t, n) {
        return t != null ? (typeof t != "string" && (t = -t), this.utcOffset(t, n), this) : -this.utcOffset();
      }
      function wl(t) {
        return this.utcOffset(0, t);
      }
      function bl(t) {
        return this._isUTC && (this.utcOffset(0, t), this._isUTC = !1, t && this.subtract(ai(this), "m")), this;
      }
      function Rl() {
        if (this._tzm != null)
          this.utcOffset(this._tzm, !1, !0);
        else if (typeof this._i == "string") {
          var t = ii(sn, this._i);
          t != null ? this.utcOffset(t) : this.utcOffset(0, !0);
        }
        return this;
      }
      function Dl(t) {
        return this.isValid() ? (t = t ? He(t).utcOffset() : 0, (this.utcOffset() - t) % 60 === 0) : !1;
      }
      function Ol() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
      }
      function Ml() {
        if (!R(this._isDSTShifted))
          return this._isDSTShifted;
        var t = {}, n;
        return E(t, this), t = _s(t), t._a ? (n = t._isUTC ? f(t._a) : He(t._a), this._isDSTShifted = this.isValid() && gl(t._a, n.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
      }
      function Tl() {
        return this.isValid() ? !this._isUTC : !1;
      }
      function Ll() {
        return this.isValid() ? this._isUTC : !1;
      }
      function ys() {
        return this.isValid() ? this._isUTC && this._offset === 0 : !1;
      }
      var kl = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, Al = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
      function wt(t, n) {
        var a = t, c = null, S, P, N;
        return hn(t) ? a = {
          ms: t._milliseconds,
          d: t._days,
          M: t._months
        } : v(t) || !isNaN(+t) ? (a = {}, n ? a[n] = +t : a.milliseconds = +t) : (c = kl.exec(t)) ? (S = c[1] === "-" ? -1 : 1, a = {
          y: 0,
          d: pe(c[_e]) * S,
          h: pe(c[se]) * S,
          m: pe(c[Ge]) * S,
          s: pe(c[Pe]) * S,
          ms: pe(ni(c[Ne] * 1e3)) * S
          // the millisecond decimal point is included in the match
        }) : (c = Al.exec(t)) ? (S = c[1] === "-" ? -1 : 1, a = {
          y: or(c[2], S),
          M: or(c[3], S),
          w: or(c[4], S),
          d: or(c[5], S),
          h: or(c[6], S),
          m: or(c[7], S),
          s: or(c[8], S)
        }) : a == null ? a = {} : typeof a == "object" && ("from" in a || "to" in a) && (N = Pl(
          He(a.from),
          He(a.to)
        ), a = {}, a.ms = N.milliseconds, a.M = N.months), P = new fn(a), hn(t) && w(t, "_locale") && (P._locale = t._locale), hn(t) && w(t, "_isValid") && (P._isValid = t._isValid), P;
      }
      wt.fn = fn.prototype, wt.invalid = yl;
      function or(t, n) {
        var a = t && parseFloat(t.replace(",", "."));
        return (isNaN(a) ? 0 : a) * n;
      }
      function gs(t, n) {
        var a = {};
        return a.months = n.month() - t.month() + (n.year() - t.year()) * 12, t.clone().add(a.months, "M").isAfter(n) && --a.months, a.milliseconds = +n - +t.clone().add(a.months, "M"), a;
      }
      function Pl(t, n) {
        var a;
        return t.isValid() && n.isValid() ? (n = si(n, t), t.isBefore(n) ? a = gs(t, n) : (a = gs(n, t), a.milliseconds = -a.milliseconds, a.months = -a.months), a) : { milliseconds: 0, months: 0 };
      }
      function xs(t, n) {
        return function(a, c) {
          var S, P;
          return c !== null && !isNaN(+c) && (F(
            n,
            "moment()." + n + "(period, number) is deprecated. Please use moment()." + n + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
          ), P = a, a = c, c = P), S = wt(a, c), Es(this, S, t), this;
        };
      }
      function Es(t, n, a, c) {
        var S = n._milliseconds, P = ni(n._days), N = ni(n._months);
        t.isValid() && (c = c ?? !0, N && rs(t, z(t, "Month") + N * a), P && X(t, "Date", z(t, "Date") + P * a), S && t._d.setTime(t._d.valueOf() + S * a), c && s.updateOffset(t, P || N));
      }
      var Cl = xs(1, "add"), Il = xs(-1, "subtract");
      function Ss(t) {
        return typeof t == "string" || t instanceof String;
      }
      function Fl(t) {
        return M(t) || h(t) || Ss(t) || v(t) || Yl(t) || Ul(t) || t === null || t === void 0;
      }
      function Ul(t) {
        var n = T(t) && !O(t), a = !1, c = [
          "years",
          "year",
          "y",
          "months",
          "month",
          "M",
          "days",
          "day",
          "d",
          "dates",
          "date",
          "D",
          "hours",
          "hour",
          "h",
          "minutes",
          "minute",
          "m",
          "seconds",
          "second",
          "s",
          "milliseconds",
          "millisecond",
          "ms"
        ], S, P, N = c.length;
        for (S = 0; S < N; S += 1)
          P = c[S], a = a || w(t, P);
        return n && a;
      }
      function Yl(t) {
        var n = b(t), a = !1;
        return n && (a = t.filter(function(c) {
          return !v(c) && Ss(t);
        }).length === 0), n && a;
      }
      function Nl(t) {
        var n = T(t) && !O(t), a = !1, c = [
          "sameDay",
          "nextDay",
          "lastDay",
          "nextWeek",
          "lastWeek",
          "sameElse"
        ], S, P;
        for (S = 0; S < c.length; S += 1)
          P = c[S], a = a || w(t, P);
        return n && a;
      }
      function Bl(t, n) {
        var a = t.diff(n, "days", !0);
        return a < -6 ? "sameElse" : a < -1 ? "lastWeek" : a < 0 ? "lastDay" : a < 1 ? "sameDay" : a < 2 ? "nextDay" : a < 7 ? "nextWeek" : "sameElse";
      }
      function Wl(t, n) {
        arguments.length === 1 && (arguments[0] ? Fl(arguments[0]) ? (t = arguments[0], n = void 0) : Nl(arguments[0]) && (n = arguments[0], t = void 0) : (t = void 0, n = void 0));
        var a = t || He(), c = si(a, this).startOf("day"), S = s.calendarFormat(this, c) || "sameElse", P = n && (L(n[S]) ? n[S].call(this, a) : n[S]);
        return this.format(
          P || this.localeData().calendar(S, this, He(a))
        );
      }
      function jl() {
        return new D(this);
      }
      function Gl(t, n) {
        var a = M(t) ? t : He(t);
        return this.isValid() && a.isValid() ? (n = Ue(n) || "millisecond", n === "millisecond" ? this.valueOf() > a.valueOf() : a.valueOf() < this.clone().startOf(n).valueOf()) : !1;
      }
      function Vl(t, n) {
        var a = M(t) ? t : He(t);
        return this.isValid() && a.isValid() ? (n = Ue(n) || "millisecond", n === "millisecond" ? this.valueOf() < a.valueOf() : this.clone().endOf(n).valueOf() < a.valueOf()) : !1;
      }
      function Hl(t, n, a, c) {
        var S = M(t) ? t : He(t), P = M(n) ? n : He(n);
        return this.isValid() && S.isValid() && P.isValid() ? (c = c || "()", (c[0] === "(" ? this.isAfter(S, a) : !this.isBefore(S, a)) && (c[1] === ")" ? this.isBefore(P, a) : !this.isAfter(P, a))) : !1;
      }
      function Kl(t, n) {
        var a = M(t) ? t : He(t), c;
        return this.isValid() && a.isValid() ? (n = Ue(n) || "millisecond", n === "millisecond" ? this.valueOf() === a.valueOf() : (c = a.valueOf(), this.clone().startOf(n).valueOf() <= c && c <= this.clone().endOf(n).valueOf())) : !1;
      }
      function Zl(t, n) {
        return this.isSame(t, n) || this.isAfter(t, n);
      }
      function zl(t, n) {
        return this.isSame(t, n) || this.isBefore(t, n);
      }
      function Xl(t, n, a) {
        var c, S, P;
        if (!this.isValid())
          return NaN;
        if (c = si(t, this), !c.isValid())
          return NaN;
        switch (S = (c.utcOffset() - this.utcOffset()) * 6e4, n = Ue(n), n) {
          case "year":
            P = cn(this, c) / 12;
            break;
          case "month":
            P = cn(this, c);
            break;
          case "quarter":
            P = cn(this, c) / 3;
            break;
          case "second":
            P = (this - c) / 1e3;
            break;
          case "minute":
            P = (this - c) / 6e4;
            break;
          case "hour":
            P = (this - c) / 36e5;
            break;
          case "day":
            P = (this - c - S) / 864e5;
            break;
          case "week":
            P = (this - c - S) / 6048e5;
            break;
          default:
            P = this - c;
        }
        return a ? P : Ye(P);
      }
      function cn(t, n) {
        if (t.date() < n.date())
          return -cn(n, t);
        var a = (n.year() - t.year()) * 12 + (n.month() - t.month()), c = t.clone().add(a, "months"), S, P;
        return n - c < 0 ? (S = t.clone().add(a - 1, "months"), P = (n - c) / (c - S)) : (S = t.clone().add(a + 1, "months"), P = (n - c) / (S - c)), -(a + P) || 0;
      }
      s.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ", s.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
      function $l() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
      }
      function Jl(t) {
        if (!this.isValid())
          return null;
        var n = t !== !0, a = n ? this.clone().utc() : this;
        return a.year() < 0 || a.year() > 9999 ? je(
          a,
          n ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
        ) : L(Date.prototype.toISOString) ? n ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", je(a, "Z")) : je(
          a,
          n ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
        );
      }
      function Ql() {
        if (!this.isValid())
          return "moment.invalid(/* " + this._i + " */)";
        var t = "moment", n = "", a, c, S, P;
        return this.isLocal() || (t = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", n = "Z"), a = "[" + t + '("]', c = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", S = "-MM-DD[T]HH:mm:ss.SSS", P = n + '[")]', this.format(a + c + S + P);
      }
      function ql(t) {
        t || (t = this.isUtc() ? s.defaultFormatUtc : s.defaultFormat);
        var n = je(this, t);
        return this.localeData().postformat(n);
      }
      function eu(t, n) {
        return this.isValid() && (M(t) && t.isValid() || He(t).isValid()) ? wt({ to: this, from: t }).locale(this.locale()).humanize(!n) : this.localeData().invalidDate();
      }
      function tu(t) {
        return this.from(He(), t);
      }
      function ru(t, n) {
        return this.isValid() && (M(t) && t.isValid() || He(t).isValid()) ? wt({ from: this, to: t }).locale(this.locale()).humanize(!n) : this.localeData().invalidDate();
      }
      function nu(t) {
        return this.to(He(), t);
      }
      function ws(t) {
        var n;
        return t === void 0 ? this._locale._abbr : (n = Ut(t), n != null && (this._locale = n), this);
      }
      var bs = I(
        "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
        function(t) {
          return t === void 0 ? this.localeData() : this.locale(t);
        }
      );
      function Rs() {
        return this._locale;
      }
      var _n = 1e3, xr = 60 * _n, mn = 60 * xr, Ds = (365 * 400 + 97) * 24 * mn;
      function Er(t, n) {
        return (t % n + n) % n;
      }
      function Os(t, n, a) {
        return t < 100 && t >= 0 ? new Date(t + 400, n, a) - Ds : new Date(t, n, a).valueOf();
      }
      function Ms(t, n, a) {
        return t < 100 && t >= 0 ? Date.UTC(t + 400, n, a) - Ds : Date.UTC(t, n, a);
      }
      function iu(t) {
        var n, a;
        if (t = Ue(t), t === void 0 || t === "millisecond" || !this.isValid())
          return this;
        switch (a = this._isUTC ? Ms : Os, t) {
          case "year":
            n = a(this.year(), 0, 1);
            break;
          case "quarter":
            n = a(
              this.year(),
              this.month() - this.month() % 3,
              1
            );
            break;
          case "month":
            n = a(this.year(), this.month(), 1);
            break;
          case "week":
            n = a(
              this.year(),
              this.month(),
              this.date() - this.weekday()
            );
            break;
          case "isoWeek":
            n = a(
              this.year(),
              this.month(),
              this.date() - (this.isoWeekday() - 1)
            );
            break;
          case "day":
          case "date":
            n = a(this.year(), this.month(), this.date());
            break;
          case "hour":
            n = this._d.valueOf(), n -= Er(
              n + (this._isUTC ? 0 : this.utcOffset() * xr),
              mn
            );
            break;
          case "minute":
            n = this._d.valueOf(), n -= Er(n, xr);
            break;
          case "second":
            n = this._d.valueOf(), n -= Er(n, _n);
            break;
        }
        return this._d.setTime(n), s.updateOffset(this, !0), this;
      }
      function su(t) {
        var n, a;
        if (t = Ue(t), t === void 0 || t === "millisecond" || !this.isValid())
          return this;
        switch (a = this._isUTC ? Ms : Os, t) {
          case "year":
            n = a(this.year() + 1, 0, 1) - 1;
            break;
          case "quarter":
            n = a(
              this.year(),
              this.month() - this.month() % 3 + 3,
              1
            ) - 1;
            break;
          case "month":
            n = a(this.year(), this.month() + 1, 1) - 1;
            break;
          case "week":
            n = a(
              this.year(),
              this.month(),
              this.date() - this.weekday() + 7
            ) - 1;
            break;
          case "isoWeek":
            n = a(
              this.year(),
              this.month(),
              this.date() - (this.isoWeekday() - 1) + 7
            ) - 1;
            break;
          case "day":
          case "date":
            n = a(this.year(), this.month(), this.date() + 1) - 1;
            break;
          case "hour":
            n = this._d.valueOf(), n += mn - Er(
              n + (this._isUTC ? 0 : this.utcOffset() * xr),
              mn
            ) - 1;
            break;
          case "minute":
            n = this._d.valueOf(), n += xr - Er(n, xr) - 1;
            break;
          case "second":
            n = this._d.valueOf(), n += _n - Er(n, _n) - 1;
            break;
        }
        return this._d.setTime(n), s.updateOffset(this, !0), this;
      }
      function au() {
        return this._d.valueOf() - (this._offset || 0) * 6e4;
      }
      function ou() {
        return Math.floor(this.valueOf() / 1e3);
      }
      function lu() {
        return new Date(this.valueOf());
      }
      function uu() {
        var t = this;
        return [
          t.year(),
          t.month(),
          t.date(),
          t.hour(),
          t.minute(),
          t.second(),
          t.millisecond()
        ];
      }
      function du() {
        var t = this;
        return {
          years: t.year(),
          months: t.month(),
          date: t.date(),
          hours: t.hours(),
          minutes: t.minutes(),
          seconds: t.seconds(),
          milliseconds: t.milliseconds()
        };
      }
      function fu() {
        return this.isValid() ? this.toISOString() : null;
      }
      function hu() {
        return y(this);
      }
      function cu() {
        return u({}, m(this));
      }
      function _u() {
        return m(this).overflow;
      }
      function mu() {
        return {
          input: this._i,
          format: this._f,
          locale: this._locale,
          isUTC: this._isUTC,
          strict: this._strict
        };
      }
      V("N", 0, 0, "eraAbbr"), V("NN", 0, 0, "eraAbbr"), V("NNN", 0, 0, "eraAbbr"), V("NNNN", 0, 0, "eraName"), V("NNNNN", 0, 0, "eraNarrow"), V("y", ["y", 1], "yo", "eraYear"), V("y", ["yy", 2], 0, "eraYear"), V("y", ["yyy", 3], 0, "eraYear"), V("y", ["yyyy", 4], 0, "eraYear"), q("N", oi), q("NN", oi), q("NNN", oi), q("NNNN", Du), q("NNNNN", Ou), W(
        ["N", "NN", "NNN", "NNNN", "NNNNN"],
        function(t, n, a, c) {
          var S = a._locale.erasParse(t, c, a._strict);
          S ? m(a).era = S : m(a).invalidEra = t;
        }
      ), q("y", It), q("yy", It), q("yyy", It), q("yyyy", It), q("yo", Mu), W(["y", "yy", "yyy", "yyyy"], he), W(["yo"], function(t, n, a, c) {
        var S;
        a._locale._eraYearOrdinalRegex && (S = t.match(a._locale._eraYearOrdinalRegex)), a._locale.eraYearOrdinalParse ? n[he] = a._locale.eraYearOrdinalParse(t, S) : n[he] = parseInt(t, 10);
      });
      function pu(t, n) {
        var a, c, S, P = this._eras || Ut("en")._eras;
        for (a = 0, c = P.length; a < c; ++a) {
          switch (typeof P[a].since) {
            case "string":
              S = s(P[a].since).startOf("day"), P[a].since = S.valueOf();
              break;
          }
          switch (typeof P[a].until) {
            case "undefined":
              P[a].until = 1 / 0;
              break;
            case "string":
              S = s(P[a].until).startOf("day").valueOf(), P[a].until = S.valueOf();
              break;
          }
        }
        return P;
      }
      function vu(t, n, a) {
        var c, S, P = this.eras(), N, ae, ge;
        for (t = t.toUpperCase(), c = 0, S = P.length; c < S; ++c)
          if (N = P[c].name.toUpperCase(), ae = P[c].abbr.toUpperCase(), ge = P[c].narrow.toUpperCase(), a)
            switch (n) {
              case "N":
              case "NN":
              case "NNN":
                if (ae === t)
                  return P[c];
                break;
              case "NNNN":
                if (N === t)
                  return P[c];
                break;
              case "NNNNN":
                if (ge === t)
                  return P[c];
                break;
            }
          else if ([N, ae, ge].indexOf(t) >= 0)
            return P[c];
      }
      function yu(t, n) {
        var a = t.since <= t.until ? 1 : -1;
        return n === void 0 ? s(t.since).year() : s(t.since).year() + (n - t.offset) * a;
      }
      function gu() {
        var t, n, a, c = this.localeData().eras();
        for (t = 0, n = c.length; t < n; ++t)
          if (a = this.clone().startOf("day").valueOf(), c[t].since <= a && a <= c[t].until || c[t].until <= a && a <= c[t].since)
            return c[t].name;
        return "";
      }
      function xu() {
        var t, n, a, c = this.localeData().eras();
        for (t = 0, n = c.length; t < n; ++t)
          if (a = this.clone().startOf("day").valueOf(), c[t].since <= a && a <= c[t].until || c[t].until <= a && a <= c[t].since)
            return c[t].narrow;
        return "";
      }
      function Eu() {
        var t, n, a, c = this.localeData().eras();
        for (t = 0, n = c.length; t < n; ++t)
          if (a = this.clone().startOf("day").valueOf(), c[t].since <= a && a <= c[t].until || c[t].until <= a && a <= c[t].since)
            return c[t].abbr;
        return "";
      }
      function Su() {
        var t, n, a, c, S = this.localeData().eras();
        for (t = 0, n = S.length; t < n; ++t)
          if (a = S[t].since <= S[t].until ? 1 : -1, c = this.clone().startOf("day").valueOf(), S[t].since <= c && c <= S[t].until || S[t].until <= c && c <= S[t].since)
            return (this.year() - s(S[t].since).year()) * a + S[t].offset;
        return this.year();
      }
      function wu(t) {
        return w(this, "_erasNameRegex") || li.call(this), t ? this._erasNameRegex : this._erasRegex;
      }
      function bu(t) {
        return w(this, "_erasAbbrRegex") || li.call(this), t ? this._erasAbbrRegex : this._erasRegex;
      }
      function Ru(t) {
        return w(this, "_erasNarrowRegex") || li.call(this), t ? this._erasNarrowRegex : this._erasRegex;
      }
      function oi(t, n) {
        return n.erasAbbrRegex(t);
      }
      function Du(t, n) {
        return n.erasNameRegex(t);
      }
      function Ou(t, n) {
        return n.erasNarrowRegex(t);
      }
      function Mu(t, n) {
        return n._eraYearOrdinalRegex || It;
      }
      function li() {
        var t = [], n = [], a = [], c = [], S, P, N = this.eras();
        for (S = 0, P = N.length; S < P; ++S)
          n.push(at(N[S].name)), t.push(at(N[S].abbr)), a.push(at(N[S].narrow)), c.push(at(N[S].name)), c.push(at(N[S].abbr)), c.push(at(N[S].narrow));
        this._erasRegex = new RegExp("^(" + c.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + n.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + t.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
          "^(" + a.join("|") + ")",
          "i"
        );
      }
      V(0, ["gg", 2], 0, function() {
        return this.weekYear() % 100;
      }), V(0, ["GG", 2], 0, function() {
        return this.isoWeekYear() % 100;
      });
      function pn(t, n) {
        V(0, [t, t.length], 0, n);
      }
      pn("gggg", "weekYear"), pn("ggggg", "weekYear"), pn("GGGG", "isoWeekYear"), pn("GGGGG", "isoWeekYear"), Fe("weekYear", "gg"), Fe("isoWeekYear", "GG"), $e("weekYear", 1), $e("isoWeekYear", 1), q("G", yr), q("g", yr), q("GG", Te, Re), q("gg", Te, Re), q("GGGG", pr, Mt), q("gggg", pr, Mt), q("GGGGG", vr, vt), q("ggggg", vr, vt), $(
        ["gggg", "ggggg", "GGGG", "GGGGG"],
        function(t, n, a, c) {
          n[c.substr(0, 2)] = pe(t);
        }
      ), $(["gg", "GG"], function(t, n, a, c) {
        n[c] = s.parseTwoDigitYear(t);
      });
      function Tu(t) {
        return Ts.call(
          this,
          t,
          this.week(),
          this.weekday(),
          this.localeData()._week.dow,
          this.localeData()._week.doy
        );
      }
      function Lu(t) {
        return Ts.call(
          this,
          t,
          this.isoWeek(),
          this.isoWeekday(),
          1,
          4
        );
      }
      function ku() {
        return Ft(this.year(), 1, 4);
      }
      function Au() {
        return Ft(this.isoWeekYear(), 1, 4);
      }
      function Pu() {
        var t = this.localeData()._week;
        return Ft(this.year(), t.dow, t.doy);
      }
      function Cu() {
        var t = this.localeData()._week;
        return Ft(this.weekYear(), t.dow, t.doy);
      }
      function Ts(t, n, a, c, S) {
        var P;
        return t == null ? Fr(this, c, S).year : (P = Ft(t, c, S), n > P && (n = P), Iu.call(this, t, n, a, c, S));
      }
      function Iu(t, n, a, c, S) {
        var P = as(t, n, a, c, S), N = Ir(P.year, 0, P.dayOfYear);
        return this.year(N.getUTCFullYear()), this.month(N.getUTCMonth()), this.date(N.getUTCDate()), this;
      }
      V("Q", 0, "Qo", "quarter"), Fe("quarter", "Q"), $e("quarter", 7), q("Q", ve), W("Q", function(t, n) {
        n[we] = (pe(t) - 1) * 3;
      });
      function Fu(t) {
        return t == null ? Math.ceil((this.month() + 1) / 3) : this.month((t - 1) * 3 + this.month() % 3);
      }
      V("D", ["DD", 2], "Do", "date"), Fe("date", "D"), $e("date", 9), q("D", Te), q("DD", Te, Re), q("Do", function(t, n) {
        return t ? n._dayOfMonthOrdinalParse || n._ordinalParse : n._dayOfMonthOrdinalParseLenient;
      }), W(["D", "DD"], _e), W("Do", function(t, n) {
        n[_e] = pe(t.match(Te)[0]);
      });
      var Ls = Y("Date", !0);
      V("DDD", ["DDDD", 3], "DDDo", "dayOfYear"), Fe("dayOfYear", "DDD"), $e("dayOfYear", 4), q("DDD", $t), q("DDDD", St), W(["DDD", "DDDD"], function(t, n, a) {
        a._dayOfYear = pe(t);
      });
      function Uu(t) {
        var n = Math.round(
          (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
        ) + 1;
        return t == null ? n : this.add(t - n, "d");
      }
      V("m", ["mm", 2], 0, "minute"), Fe("minute", "m"), $e("minute", 14), q("m", Te), q("mm", Te, Re), W(["m", "mm"], Ge);
      var Yu = Y("Minutes", !1);
      V("s", ["ss", 2], 0, "second"), Fe("second", "s"), $e("second", 15), q("s", Te), q("ss", Te, Re), W(["s", "ss"], Pe);
      var Nu = Y("Seconds", !1);
      V("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
      }), V(0, ["SS", 2], 0, function() {
        return ~~(this.millisecond() / 10);
      }), V(0, ["SSS", 3], 0, "millisecond"), V(0, ["SSSS", 4], 0, function() {
        return this.millisecond() * 10;
      }), V(0, ["SSSSS", 5], 0, function() {
        return this.millisecond() * 100;
      }), V(0, ["SSSSSS", 6], 0, function() {
        return this.millisecond() * 1e3;
      }), V(0, ["SSSSSSS", 7], 0, function() {
        return this.millisecond() * 1e4;
      }), V(0, ["SSSSSSSS", 8], 0, function() {
        return this.millisecond() * 1e5;
      }), V(0, ["SSSSSSSSS", 9], 0, function() {
        return this.millisecond() * 1e6;
      }), Fe("millisecond", "ms"), $e("millisecond", 16), q("S", $t, ve), q("SS", $t, Re), q("SSS", $t, St);
      var qt, ks;
      for (qt = "SSSS"; qt.length <= 9; qt += "S")
        q(qt, It);
      function Bu(t, n) {
        n[Ne] = pe(("0." + t) * 1e3);
      }
      for (qt = "S"; qt.length <= 9; qt += "S")
        W(qt, Bu);
      ks = Y("Milliseconds", !1), V("z", 0, 0, "zoneAbbr"), V("zz", 0, 0, "zoneName");
      function Wu() {
        return this._isUTC ? "UTC" : "";
      }
      function ju() {
        return this._isUTC ? "Coordinated Universal Time" : "";
      }
      var K = D.prototype;
      K.add = Cl, K.calendar = Wl, K.clone = jl, K.diff = Xl, K.endOf = su, K.format = ql, K.from = eu, K.fromNow = tu, K.to = ru, K.toNow = nu, K.get = ie, K.invalidAt = _u, K.isAfter = Gl, K.isBefore = Vl, K.isBetween = Hl, K.isSame = Kl, K.isSameOrAfter = Zl, K.isSameOrBefore = zl, K.isValid = hu, K.lang = bs, K.locale = ws, K.localeData = Rs, K.max = hl, K.min = fl, K.parsingFlags = cu, K.set = me, K.startOf = iu, K.subtract = Il, K.toArray = uu, K.toObject = du, K.toDate = lu, K.toISOString = Jl, K.inspect = Ql, typeof Symbol < "u" && Symbol.for != null && (K[Symbol.for("nodejs.util.inspect.custom")] = function() {
        return "Moment<" + this.format() + ">";
      }), K.toJSON = fu, K.toString = $l, K.unix = ou, K.valueOf = au, K.creationData = mu, K.eraName = gu, K.eraNarrow = xu, K.eraAbbr = Eu, K.eraYear = Su, K.year = ss, K.isLeapYear = uo, K.weekYear = Tu, K.isoWeekYear = Lu, K.quarter = K.quarters = Fu, K.month = ns, K.daysInMonth = ao, K.week = K.weeks = po, K.isoWeek = K.isoWeeks = vo, K.weeksInYear = Pu, K.weeksInWeekYear = Cu, K.isoWeeksInYear = ku, K.isoWeeksInISOWeekYear = Au, K.date = Ls, K.day = K.days = Lo, K.weekday = ko, K.isoWeekday = Ao, K.dayOfYear = Uu, K.hour = K.hours = No, K.minute = K.minutes = Yu, K.second = K.seconds = Nu, K.millisecond = K.milliseconds = ks, K.utcOffset = El, K.utc = wl, K.local = bl, K.parseZone = Rl, K.hasAlignedHourOffset = Dl, K.isDST = Ol, K.isLocal = Tl, K.isUtcOffset = Ll, K.isUtc = ys, K.isUTC = ys, K.zoneAbbr = Wu, K.zoneName = ju, K.dates = I(
        "dates accessor is deprecated. Use date instead.",
        Ls
      ), K.months = I(
        "months accessor is deprecated. Use month instead",
        ns
      ), K.years = I(
        "years accessor is deprecated. Use year instead",
        ss
      ), K.zone = I(
        "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
        Sl
      ), K.isDSTShifted = I(
        "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
        Ml
      );
      function Gu(t) {
        return He(t * 1e3);
      }
      function Vu() {
        return He.apply(null, arguments).parseZone();
      }
      function As(t) {
        return t;
      }
      var Le = G.prototype;
      Le.calendar = le, Le.longDateFormat = Ve, Le.invalidDate = ne, Le.ordinal = rt, Le.preparse = As, Le.postformat = As, Le.relativeTime = ht, Le.pastFuture = ct, Le.set = U, Le.eras = pu, Le.erasParse = vu, Le.erasConvertYear = yu, Le.erasAbbrRegex = bu, Le.erasNameRegex = wu, Le.erasNarrowRegex = Ru, Le.months = ro, Le.monthsShort = no, Le.monthsParse = so, Le.monthsRegex = lo, Le.monthsShortRegex = oo, Le.week = ho, Le.firstDayOfYear = mo, Le.firstDayOfWeek = _o, Le.weekdays = Ro, Le.weekdaysMin = Oo, Le.weekdaysShort = Do, Le.weekdaysParse = To, Le.weekdaysRegex = Po, Le.weekdaysShortRegex = Co, Le.weekdaysMinRegex = Io, Le.isPM = Uo, Le.meridiem = Bo;
      function vn(t, n, a, c) {
        var S = Ut(), P = f().set(c, n);
        return S[a](P, t);
      }
      function Ps(t, n, a) {
        if (v(t) && (n = t, t = void 0), t = t || "", n != null)
          return vn(t, n, a, "month");
        var c, S = [];
        for (c = 0; c < 12; c++)
          S[c] = vn(t, c, a, "month");
        return S;
      }
      function ui(t, n, a, c) {
        typeof t == "boolean" ? (v(n) && (a = n, n = void 0), n = n || "") : (n = t, a = n, t = !1, v(n) && (a = n, n = void 0), n = n || "");
        var S = Ut(), P = t ? S._week.dow : 0, N, ae = [];
        if (a != null)
          return vn(n, (a + P) % 7, c, "day");
        for (N = 0; N < 7; N++)
          ae[N] = vn(n, (N + P) % 7, c, "day");
        return ae;
      }
      function Hu(t, n) {
        return Ps(t, n, "months");
      }
      function Ku(t, n) {
        return Ps(t, n, "monthsShort");
      }
      function Zu(t, n, a) {
        return ui(t, n, a, "weekdays");
      }
      function zu(t, n, a) {
        return ui(t, n, a, "weekdaysShort");
      }
      function Xu(t, n, a) {
        return ui(t, n, a, "weekdaysMin");
      }
      Qt("en", {
        eras: [
          {
            since: "0001-01-01",
            until: 1 / 0,
            offset: 1,
            name: "Anno Domini",
            narrow: "AD",
            abbr: "AD"
          },
          {
            since: "0000-12-31",
            until: -1 / 0,
            offset: 1,
            name: "Before Christ",
            narrow: "BC",
            abbr: "BC"
          }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(t) {
          var n = t % 10, a = pe(t % 100 / 10) === 1 ? "th" : n === 1 ? "st" : n === 2 ? "nd" : n === 3 ? "rd" : "th";
          return t + a;
        }
      }), s.lang = I(
        "moment.lang is deprecated. Use moment.locale instead.",
        Qt
      ), s.langData = I(
        "moment.langData is deprecated. Use moment.localeData instead.",
        Ut
      );
      var Yt = Math.abs;
      function $u() {
        var t = this._data;
        return this._milliseconds = Yt(this._milliseconds), this._days = Yt(this._days), this._months = Yt(this._months), t.milliseconds = Yt(t.milliseconds), t.seconds = Yt(t.seconds), t.minutes = Yt(t.minutes), t.hours = Yt(t.hours), t.months = Yt(t.months), t.years = Yt(t.years), this;
      }
      function Cs(t, n, a, c) {
        var S = wt(n, a);
        return t._milliseconds += c * S._milliseconds, t._days += c * S._days, t._months += c * S._months, t._bubble();
      }
      function Ju(t, n) {
        return Cs(this, t, n, 1);
      }
      function Qu(t, n) {
        return Cs(this, t, n, -1);
      }
      function Is(t) {
        return t < 0 ? Math.floor(t) : Math.ceil(t);
      }
      function qu() {
        var t = this._milliseconds, n = this._days, a = this._months, c = this._data, S, P, N, ae, ge;
        return t >= 0 && n >= 0 && a >= 0 || t <= 0 && n <= 0 && a <= 0 || (t += Is(di(a) + n) * 864e5, n = 0, a = 0), c.milliseconds = t % 1e3, S = Ye(t / 1e3), c.seconds = S % 60, P = Ye(S / 60), c.minutes = P % 60, N = Ye(P / 60), c.hours = N % 24, n += Ye(N / 24), ge = Ye(Fs(n)), a += ge, n -= Is(di(ge)), ae = Ye(a / 12), a %= 12, c.days = n, c.months = a, c.years = ae, this;
      }
      function Fs(t) {
        return t * 4800 / 146097;
      }
      function di(t) {
        return t * 146097 / 4800;
      }
      function ed(t) {
        if (!this.isValid())
          return NaN;
        var n, a, c = this._milliseconds;
        if (t = Ue(t), t === "month" || t === "quarter" || t === "year")
          switch (n = this._days + c / 864e5, a = this._months + Fs(n), t) {
            case "month":
              return a;
            case "quarter":
              return a / 3;
            case "year":
              return a / 12;
          }
        else
          switch (n = this._days + Math.round(di(this._months)), t) {
            case "week":
              return n / 7 + c / 6048e5;
            case "day":
              return n + c / 864e5;
            case "hour":
              return n * 24 + c / 36e5;
            case "minute":
              return n * 1440 + c / 6e4;
            case "second":
              return n * 86400 + c / 1e3;
            case "millisecond":
              return Math.floor(n * 864e5) + c;
            default:
              throw new Error("Unknown unit " + t);
          }
      }
      function td() {
        return this.isValid() ? this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + pe(this._months / 12) * 31536e6 : NaN;
      }
      function Nt(t) {
        return function() {
          return this.as(t);
        };
      }
      var rd = Nt("ms"), nd = Nt("s"), id = Nt("m"), sd = Nt("h"), ad = Nt("d"), od = Nt("w"), ld = Nt("M"), ud = Nt("Q"), dd = Nt("y");
      function fd() {
        return wt(this);
      }
      function hd(t) {
        return t = Ue(t), this.isValid() ? this[t + "s"]() : NaN;
      }
      function lr(t) {
        return function() {
          return this.isValid() ? this._data[t] : NaN;
        };
      }
      var cd = lr("milliseconds"), _d = lr("seconds"), md = lr("minutes"), pd = lr("hours"), vd = lr("days"), yd = lr("months"), gd = lr("years");
      function xd() {
        return Ye(this.days() / 7);
      }
      var Bt = Math.round, Sr = {
        ss: 44,
        // a few seconds to seconds
        s: 45,
        // seconds to minute
        m: 45,
        // minutes to hour
        h: 22,
        // hours to day
        d: 26,
        // days to month/week
        w: null,
        // weeks to month
        M: 11
        // months to year
      };
      function Ed(t, n, a, c, S) {
        return S.relativeTime(n || 1, !!a, t, c);
      }
      function Sd(t, n, a, c) {
        var S = wt(t).abs(), P = Bt(S.as("s")), N = Bt(S.as("m")), ae = Bt(S.as("h")), ge = Bt(S.as("d")), Be = Bt(S.as("M")), ot = Bt(S.as("w")), Wt = Bt(S.as("y")), er = P <= a.ss && ["s", P] || P < a.s && ["ss", P] || N <= 1 && ["m"] || N < a.m && ["mm", N] || ae <= 1 && ["h"] || ae < a.h && ["hh", ae] || ge <= 1 && ["d"] || ge < a.d && ["dd", ge];
        return a.w != null && (er = er || ot <= 1 && ["w"] || ot < a.w && ["ww", ot]), er = er || Be <= 1 && ["M"] || Be < a.M && ["MM", Be] || Wt <= 1 && ["y"] || ["yy", Wt], er[2] = n, er[3] = +t > 0, er[4] = c, Ed.apply(null, er);
      }
      function wd(t) {
        return t === void 0 ? Bt : typeof t == "function" ? (Bt = t, !0) : !1;
      }
      function bd(t, n) {
        return Sr[t] === void 0 ? !1 : n === void 0 ? Sr[t] : (Sr[t] = n, t === "s" && (Sr.ss = n - 1), !0);
      }
      function Rd(t, n) {
        if (!this.isValid())
          return this.localeData().invalidDate();
        var a = !1, c = Sr, S, P;
        return typeof t == "object" && (n = t, t = !1), typeof t == "boolean" && (a = t), typeof n == "object" && (c = Object.assign({}, Sr, n), n.s != null && n.ss == null && (c.ss = n.s - 1)), S = this.localeData(), P = Sd(this, !a, c, S), a && (P = S.pastFuture(+this, P)), S.postformat(P);
      }
      var fi = Math.abs;
      function wr(t) {
        return (t > 0) - (t < 0) || +t;
      }
      function yn() {
        if (!this.isValid())
          return this.localeData().invalidDate();
        var t = fi(this._milliseconds) / 1e3, n = fi(this._days), a = fi(this._months), c, S, P, N, ae = this.asSeconds(), ge, Be, ot, Wt;
        return ae ? (c = Ye(t / 60), S = Ye(c / 60), t %= 60, c %= 60, P = Ye(a / 12), a %= 12, N = t ? t.toFixed(3).replace(/\.?0+$/, "") : "", ge = ae < 0 ? "-" : "", Be = wr(this._months) !== wr(ae) ? "-" : "", ot = wr(this._days) !== wr(ae) ? "-" : "", Wt = wr(this._milliseconds) !== wr(ae) ? "-" : "", ge + "P" + (P ? Be + P + "Y" : "") + (a ? Be + a + "M" : "") + (n ? ot + n + "D" : "") + (S || c || t ? "T" : "") + (S ? Wt + S + "H" : "") + (c ? Wt + c + "M" : "") + (t ? Wt + N + "S" : "")) : "P0D";
      }
      var De = fn.prototype;
      De.isValid = vl, De.abs = $u, De.add = Ju, De.subtract = Qu, De.as = ed, De.asMilliseconds = rd, De.asSeconds = nd, De.asMinutes = id, De.asHours = sd, De.asDays = ad, De.asWeeks = od, De.asMonths = ld, De.asQuarters = ud, De.asYears = dd, De.valueOf = td, De._bubble = qu, De.clone = fd, De.get = hd, De.milliseconds = cd, De.seconds = _d, De.minutes = md, De.hours = pd, De.days = vd, De.weeks = xd, De.months = yd, De.years = gd, De.humanize = Rd, De.toISOString = yn, De.toString = yn, De.toJSON = yn, De.locale = ws, De.localeData = Rs, De.toIsoString = I(
        "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
        yn
      ), De.lang = bs, V("X", 0, 0, "unix"), V("x", 0, 0, "valueOf"), q("x", yr), q("X", Kn), W("X", function(t, n, a) {
        a._d = new Date(parseFloat(t) * 1e3);
      }), W("x", function(t, n, a) {
        a._d = new Date(pe(t));
      });
      //! moment.js
      return s.version = "2.29.4", o(He), s.fn = K, s.min = cl, s.max = _l, s.now = ml, s.utc = f, s.unix = Gu, s.months = Hu, s.isDate = h, s.locale = Qt, s.invalid = _, s.duration = wt, s.isMoment = M, s.weekdays = Zu, s.parseZone = Vu, s.localeData = Ut, s.isDuration = hn, s.monthsShort = Ku, s.weekdaysMin = Xu, s.defineLocale = Qn, s.updateLocale = Vo, s.locales = Ho, s.weekdaysShort = zu, s.normalizeUnits = Ue, s.relativeTimeRounding = wd, s.relativeTimeThreshold = bd, s.calendarFormat = Bl, s.prototype = K, s.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        // <input type="datetime-local" step="0.001" />
        DATE: "YYYY-MM-DD",
        // <input type="date" />
        TIME: "HH:mm",
        // <input type="time" />
        TIME_SECONDS: "HH:mm:ss",
        // <input type="time" step="1" />
        TIME_MS: "HH:mm:ss.SSS",
        // <input type="time" step="0.001" />
        WEEK: "GGGG-[W]WW",
        // <input type="week" />
        MONTH: "YYYY-MM"
        // <input type="month" />
      }, s;
    });
  }(vi)), vi.exports;
}
var Xs;
function F_() {
  return Xs || (Xs = 1, function(e, r) {
    (function(i, s) {
      s(typeof Pi == "function" ? I_() : i.moment);
    })(ki, function(i) {
      //! moment.js locale configuration
      var s = i.defineLocale("zh-cn", {
        months: "一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split(
          "_"
        ),
        monthsShort: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split(
          "_"
        ),
        weekdays: "星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),
        weekdaysShort: "周日_周一_周二_周三_周四_周五_周六".split("_"),
        weekdaysMin: "日_一_二_三_四_五_六".split("_"),
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "YYYY/MM/DD",
          LL: "YYYY年M月D日",
          LLL: "YYYY年M月D日Ah点mm分",
          LLLL: "YYYY年M月D日ddddAh点mm分",
          l: "YYYY/M/D",
          ll: "YYYY年M月D日",
          lll: "YYYY年M月D日 HH:mm",
          llll: "YYYY年M月D日dddd HH:mm"
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function(o, b) {
          return o === 12 && (o = 0), b === "凌晨" || b === "早上" || b === "上午" ? o : b === "下午" || b === "晚上" ? o + 12 : o >= 11 ? o : o + 12;
        },
        meridiem: function(o, b, T) {
          var w = o * 100 + b;
          return w < 600 ? "凌晨" : w < 900 ? "早上" : w < 1130 ? "上午" : w < 1230 ? "中午" : w < 1800 ? "下午" : "晚上";
        },
        calendar: {
          sameDay: "[今天]LT",
          nextDay: "[明天]LT",
          nextWeek: function(o) {
            return o.week() !== this.week() ? "[下]dddLT" : "[本]dddLT";
          },
          lastDay: "[昨天]LT",
          lastWeek: function(o) {
            return this.week() !== o.week() ? "[上]dddLT" : "[本]dddLT";
          },
          sameElse: "L"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
        ordinal: function(o, b) {
          switch (b) {
            case "d":
            case "D":
            case "DDD":
              return o + "日";
            case "M":
              return o + "月";
            case "w":
            case "W":
              return o + "周";
            default:
              return o;
          }
        },
        relativeTime: {
          future: "%s后",
          past: "%s前",
          s: "几秒",
          ss: "%d 秒",
          m: "1 分钟",
          mm: "%d 分钟",
          h: "1 小时",
          hh: "%d 小时",
          d: "1 天",
          dd: "%d 天",
          w: "1 周",
          ww: "%d 周",
          M: "1 个月",
          MM: "%d 个月",
          y: "1 年",
          yy: "%d 年"
        },
        week: {
          // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
          dow: 1,
          // Monday is the first day of the week.
          doy: 4
          // The week that contains Jan 4th is the first week of the year.
        }
      });
      return s;
    });
  }()), Zs.exports;
}
F_();
var yi = { exports: {} }, gi = { exports: {} }, $s;
function U_() {
  return $s || ($s = 1, function() {
    var e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", r = {
      // Bit-wise rotation left
      rotl: function(i, s) {
        return i << s | i >>> 32 - s;
      },
      // Bit-wise rotation right
      rotr: function(i, s) {
        return i << 32 - s | i >>> s;
      },
      // Swap big-endian to little-endian and vice versa
      endian: function(i) {
        if (i.constructor == Number)
          return r.rotl(i, 8) & 16711935 | r.rotl(i, 24) & 4278255360;
        for (var s = 0; s < i.length; s++)
          i[s] = r.endian(i[s]);
        return i;
      },
      // Generate an array of any length of random bytes
      randomBytes: function(i) {
        for (var s = []; i > 0; i--)
          s.push(Math.floor(Math.random() * 256));
        return s;
      },
      // Convert a byte array to big-endian 32-bit words
      bytesToWords: function(i) {
        for (var s = [], o = 0, b = 0; o < i.length; o++, b += 8)
          s[b >>> 5] |= i[o] << 24 - b % 32;
        return s;
      },
      // Convert big-endian 32-bit words to a byte array
      wordsToBytes: function(i) {
        for (var s = [], o = 0; o < i.length * 32; o += 8)
          s.push(i[o >>> 5] >>> 24 - o % 32 & 255);
        return s;
      },
      // Convert a byte array to a hex string
      bytesToHex: function(i) {
        for (var s = [], o = 0; o < i.length; o++)
          s.push((i[o] >>> 4).toString(16)), s.push((i[o] & 15).toString(16));
        return s.join("");
      },
      // Convert a hex string to a byte array
      hexToBytes: function(i) {
        for (var s = [], o = 0; o < i.length; o += 2)
          s.push(parseInt(i.substr(o, 2), 16));
        return s;
      },
      // Convert a byte array to a base-64 string
      bytesToBase64: function(i) {
        for (var s = [], o = 0; o < i.length; o += 3)
          for (var b = i[o] << 16 | i[o + 1] << 8 | i[o + 2], T = 0; T < 4; T++)
            o * 8 + T * 6 <= i.length * 8 ? s.push(e.charAt(b >>> 6 * (3 - T) & 63)) : s.push("=");
        return s.join("");
      },
      // Convert a base-64 string to a byte array
      base64ToBytes: function(i) {
        i = i.replace(/[^A-Z0-9+\/]/ig, "");
        for (var s = [], o = 0, b = 0; o < i.length; b = ++o % 4)
          b != 0 && s.push((e.indexOf(i.charAt(o - 1)) & Math.pow(2, -2 * b + 8) - 1) << b * 2 | e.indexOf(i.charAt(o)) >>> 6 - b * 2);
        return s;
      }
    };
    gi.exports = r;
  }()), gi.exports;
}
var xi, Js;
function Qs() {
  if (Js)
    return xi;
  Js = 1;
  var e = {
    // UTF-8 encoding
    utf8: {
      // Convert a string to a byte array
      stringToBytes: function(r) {
        return e.bin.stringToBytes(unescape(encodeURIComponent(r)));
      },
      // Convert a byte array to a string
      bytesToString: function(r) {
        return decodeURIComponent(escape(e.bin.bytesToString(r)));
      }
    },
    // Binary encoding
    bin: {
      // Convert a string to a byte array
      stringToBytes: function(r) {
        for (var i = [], s = 0; s < r.length; s++)
          i.push(r.charCodeAt(s) & 255);
        return i;
      },
      // Convert a byte array to a string
      bytesToString: function(r) {
        for (var i = [], s = 0; s < r.length; s++)
          i.push(String.fromCharCode(r[s]));
        return i.join("");
      }
    }
  };
  return xi = e, xi;
}
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
var Ei, qs;
function Y_() {
  if (qs)
    return Ei;
  qs = 1, Ei = function(i) {
    return i != null && (e(i) || r(i) || !!i._isBuffer);
  };
  function e(i) {
    return !!i.constructor && typeof i.constructor.isBuffer == "function" && i.constructor.isBuffer(i);
  }
  function r(i) {
    return typeof i.readFloatLE == "function" && typeof i.slice == "function" && e(i.slice(0, 0));
  }
  return Ei;
}
var ea;
function N_() {
  return ea || (ea = 1, function() {
    var e = U_(), r = Qs().utf8, i = Y_(), s = Qs().bin, o = function(b, T) {
      b.constructor == String ? T && T.encoding === "binary" ? b = s.stringToBytes(b) : b = r.stringToBytes(b) : i(b) ? b = Array.prototype.slice.call(b, 0) : !Array.isArray(b) && b.constructor !== Uint8Array && (b = b.toString());
      for (var w = e.bytesToWords(b), O = b.length * 8, R = 1732584193, v = -271733879, h = -1732584194, l = 271733878, u = 0; u < w.length; u++)
        w[u] = (w[u] << 8 | w[u] >>> 24) & 16711935 | (w[u] << 24 | w[u] >>> 8) & 4278255360;
      w[O >>> 5] |= 128 << O % 32, w[(O + 64 >>> 9 << 4) + 14] = O;
      for (var f = o._ff, p = o._gg, m = o._hh, g = o._ii, u = 0; u < w.length; u += 16) {
        var y = R, _ = v, x = h, d = l;
        R = f(R, v, h, l, w[u + 0], 7, -680876936), l = f(l, R, v, h, w[u + 1], 12, -389564586), h = f(h, l, R, v, w[u + 2], 17, 606105819), v = f(v, h, l, R, w[u + 3], 22, -1044525330), R = f(R, v, h, l, w[u + 4], 7, -176418897), l = f(l, R, v, h, w[u + 5], 12, 1200080426), h = f(h, l, R, v, w[u + 6], 17, -1473231341), v = f(v, h, l, R, w[u + 7], 22, -45705983), R = f(R, v, h, l, w[u + 8], 7, 1770035416), l = f(l, R, v, h, w[u + 9], 12, -1958414417), h = f(h, l, R, v, w[u + 10], 17, -42063), v = f(v, h, l, R, w[u + 11], 22, -1990404162), R = f(R, v, h, l, w[u + 12], 7, 1804603682), l = f(l, R, v, h, w[u + 13], 12, -40341101), h = f(h, l, R, v, w[u + 14], 17, -1502002290), v = f(v, h, l, R, w[u + 15], 22, 1236535329), R = p(R, v, h, l, w[u + 1], 5, -165796510), l = p(l, R, v, h, w[u + 6], 9, -1069501632), h = p(h, l, R, v, w[u + 11], 14, 643717713), v = p(v, h, l, R, w[u + 0], 20, -373897302), R = p(R, v, h, l, w[u + 5], 5, -701558691), l = p(l, R, v, h, w[u + 10], 9, 38016083), h = p(h, l, R, v, w[u + 15], 14, -660478335), v = p(v, h, l, R, w[u + 4], 20, -405537848), R = p(R, v, h, l, w[u + 9], 5, 568446438), l = p(l, R, v, h, w[u + 14], 9, -1019803690), h = p(h, l, R, v, w[u + 3], 14, -187363961), v = p(v, h, l, R, w[u + 8], 20, 1163531501), R = p(R, v, h, l, w[u + 13], 5, -1444681467), l = p(l, R, v, h, w[u + 2], 9, -51403784), h = p(h, l, R, v, w[u + 7], 14, 1735328473), v = p(v, h, l, R, w[u + 12], 20, -1926607734), R = m(R, v, h, l, w[u + 5], 4, -378558), l = m(l, R, v, h, w[u + 8], 11, -2022574463), h = m(h, l, R, v, w[u + 11], 16, 1839030562), v = m(v, h, l, R, w[u + 14], 23, -35309556), R = m(R, v, h, l, w[u + 1], 4, -1530992060), l = m(l, R, v, h, w[u + 4], 11, 1272893353), h = m(h, l, R, v, w[u + 7], 16, -155497632), v = m(v, h, l, R, w[u + 10], 23, -1094730640), R = m(R, v, h, l, w[u + 13], 4, 681279174), l = m(l, R, v, h, w[u + 0], 11, -358537222), h = m(h, l, R, v, w[u + 3], 16, -722521979), v = m(v, h, l, R, w[u + 6], 23, 76029189), R = m(R, v, h, l, w[u + 9], 4, -640364487), l = m(l, R, v, h, w[u + 12], 11, -421815835), h = m(h, l, R, v, w[u + 15], 16, 530742520), v = m(v, h, l, R, w[u + 2], 23, -995338651), R = g(R, v, h, l, w[u + 0], 6, -198630844), l = g(l, R, v, h, w[u + 7], 10, 1126891415), h = g(h, l, R, v, w[u + 14], 15, -1416354905), v = g(v, h, l, R, w[u + 5], 21, -57434055), R = g(R, v, h, l, w[u + 12], 6, 1700485571), l = g(l, R, v, h, w[u + 3], 10, -1894986606), h = g(h, l, R, v, w[u + 10], 15, -1051523), v = g(v, h, l, R, w[u + 1], 21, -2054922799), R = g(R, v, h, l, w[u + 8], 6, 1873313359), l = g(l, R, v, h, w[u + 15], 10, -30611744), h = g(h, l, R, v, w[u + 6], 15, -1560198380), v = g(v, h, l, R, w[u + 13], 21, 1309151649), R = g(R, v, h, l, w[u + 4], 6, -145523070), l = g(l, R, v, h, w[u + 11], 10, -1120210379), h = g(h, l, R, v, w[u + 2], 15, 718787259), v = g(v, h, l, R, w[u + 9], 21, -343485551), R = R + y >>> 0, v = v + _ >>> 0, h = h + x >>> 0, l = l + d >>> 0;
      }
      return e.endian([R, v, h, l]);
    };
    o._ff = function(b, T, w, O, R, v, h) {
      var l = b + (T & w | ~T & O) + (R >>> 0) + h;
      return (l << v | l >>> 32 - v) + T;
    }, o._gg = function(b, T, w, O, R, v, h) {
      var l = b + (T & O | w & ~O) + (R >>> 0) + h;
      return (l << v | l >>> 32 - v) + T;
    }, o._hh = function(b, T, w, O, R, v, h) {
      var l = b + (T ^ w ^ O) + (R >>> 0) + h;
      return (l << v | l >>> 32 - v) + T;
    }, o._ii = function(b, T, w, O, R, v, h) {
      var l = b + (w ^ (T | ~O)) + (R >>> 0) + h;
      return (l << v | l >>> 32 - v) + T;
    }, o._blocksize = 16, o._digestsize = 16, yi.exports = function(b, T) {
      if (b == null)
        throw new Error("Illegal argument " + b);
      var w = e.wordsToBytes(o(b, T));
      return T && T.asBytes ? w : T && T.asString ? s.bytesToString(w) : e.bytesToHex(w);
    };
  }()), yi.exports;
}
var B_ = N_();
const W_ = /* @__PURE__ */ Ai(B_);
var Si = { exports: {} }, ta;
function j_() {
  return ta || (ta = 1, function(e, r) {
    (function(s, o) {
      e.exports = o();
    })(self, function() {
      return (
        /******/
        function() {
          var i = {
            /***/
            "./node_modules/es6-promise/dist/es6-promise.js": (
              /*!******************************************************!*\
                !*** ./node_modules/es6-promise/dist/es6-promise.js ***!
                \******************************************************/
              /***/
              function(T, w, O) {
                /*!
                 * @overview es6-promise - a tiny implementation of Promises/A+.
                 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
                 * @license   Licensed under MIT license
                 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
                 * @version   v4.2.8+1e68dce6
                 */
                (function(R, v) {
                  T.exports = v();
                })(this, function() {
                  function R(Y) {
                    var z = typeof Y;
                    return Y !== null && (z === "object" || z === "function");
                  }
                  function v(Y) {
                    return typeof Y == "function";
                  }
                  var h = void 0;
                  Array.isArray ? h = Array.isArray : h = function(Y) {
                    return Object.prototype.toString.call(Y) === "[object Array]";
                  };
                  var l = h, u = 0, f = void 0, p = void 0, m = function(z, X) {
                    L[u] = z, L[u + 1] = X, u += 2, u === 2 && (p ? p(U) : G());
                  };
                  function g(Y) {
                    p = Y;
                  }
                  function y(Y) {
                    m = Y;
                  }
                  var _ = typeof window < "u" ? window : void 0, x = _ || {}, d = x.MutationObserver || x.WebKitMutationObserver, E = typeof self > "u" && typeof process < "u" && {}.toString.call(process) === "[object process]", D = typeof Uint8ClampedArray < "u" && typeof importScripts < "u" && typeof MessageChannel < "u";
                  function M() {
                    return function() {
                      return process.nextTick(U);
                    };
                  }
                  function C() {
                    return typeof f < "u" ? function() {
                      f(U);
                    } : F();
                  }
                  function I() {
                    var Y = 0, z = new d(U), X = document.createTextNode("");
                    return z.observe(X, { characterData: !0 }), function() {
                      X.data = Y = ++Y % 2;
                    };
                  }
                  function k() {
                    var Y = new MessageChannel();
                    return Y.port1.onmessage = U, function() {
                      return Y.port2.postMessage(0);
                    };
                  }
                  function F() {
                    var Y = setTimeout;
                    return function() {
                      return Y(U, 1);
                    };
                  }
                  var L = new Array(1e3);
                  function U() {
                    for (var Y = 0; Y < u; Y += 2) {
                      var z = L[Y], X = L[Y + 1];
                      z(X), L[Y] = void 0, L[Y + 1] = void 0;
                    }
                    u = 0;
                  }
                  function j() {
                    try {
                      var Y = Function("return this")().require("vertx");
                      return f = Y.runOnLoop || Y.runOnContext, C();
                    } catch {
                      return F();
                    }
                  }
                  var G = void 0;
                  E ? G = M() : d ? G = I() : D ? G = k() : _ === void 0 ? G = j() : G = F();
                  function B(Y, z) {
                    var X = this, ie = new this.constructor(Q);
                    ie[le] === void 0 && ut(ie);
                    var me = X._state;
                    if (me) {
                      var ve = arguments[me - 1];
                      m(function() {
                        return rt(me, ie, ve, X._result);
                      });
                    } else
                      Qe(X, ie, Y, z);
                    return ie;
                  }
                  function re(Y) {
                    var z = this;
                    if (Y && typeof Y == "object" && Y.constructor === z)
                      return Y;
                    var X = new z(Q);
                    return Me(X, Y), X;
                  }
                  var le = Math.random().toString(36).substring(2);
                  function Q() {
                  }
                  var ue = void 0, ce = 1, de = 2;
                  function te() {
                    return new TypeError("You cannot resolve a promise with itself");
                  }
                  function V() {
                    return new TypeError("A promises callback cannot return that same promise.");
                  }
                  function xe(Y, z, X, ie) {
                    try {
                      Y.call(z, X, ie);
                    } catch (me) {
                      return me;
                    }
                  }
                  function be(Y, z, X) {
                    m(function(ie) {
                      var me = !1, ve = xe(X, z, function(Re) {
                        me || (me = !0, z !== Re ? Me(ie, Re) : Se(ie, Re));
                      }, function(Re) {
                        me || (me = !0, ne(ie, Re));
                      }, "Settle: " + (ie._label || " unknown promise"));
                      !me && ve && (me = !0, ne(ie, ve));
                    }, Y);
                  }
                  function je(Y, z) {
                    z._state === ce ? Se(Y, z._result) : z._state === de ? ne(Y, z._result) : Qe(z, void 0, function(X) {
                      return Me(Y, X);
                    }, function(X) {
                      return ne(Y, X);
                    });
                  }
                  function H(Y, z, X) {
                    z.constructor === Y.constructor && X === B && z.constructor.resolve === re ? je(Y, z) : X === void 0 ? Se(Y, z) : v(X) ? be(Y, z, X) : Se(Y, z);
                  }
                  function Me(Y, z) {
                    if (Y === z)
                      ne(Y, te());
                    else if (R(z)) {
                      var X = void 0;
                      try {
                        X = z.then;
                      } catch (ie) {
                        ne(Y, ie);
                        return;
                      }
                      H(Y, z, X);
                    } else
                      Se(Y, z);
                  }
                  function Ve(Y) {
                    Y._onerror && Y._onerror(Y._result), qe(Y);
                  }
                  function Se(Y, z) {
                    Y._state === ue && (Y._result = z, Y._state = ce, Y._subscribers.length !== 0 && m(qe, Y));
                  }
                  function ne(Y, z) {
                    Y._state === ue && (Y._state = de, Y._result = z, m(Ve, Y));
                  }
                  function Qe(Y, z, X, ie) {
                    var me = Y._subscribers, ve = me.length;
                    Y._onerror = null, me[ve] = z, me[ve + ce] = X, me[ve + de] = ie, ve === 0 && Y._state && m(qe, Y);
                  }
                  function qe(Y) {
                    var z = Y._subscribers, X = Y._state;
                    if (z.length !== 0) {
                      for (var ie = void 0, me = void 0, ve = Y._result, Re = 0; Re < z.length; Re += 3)
                        ie = z[Re], me = z[Re + X], ie ? rt(X, ie, me, ve) : me(ve);
                      Y._subscribers.length = 0;
                    }
                  }
                  function rt(Y, z, X, ie) {
                    var me = v(X), ve = void 0, Re = void 0, St = !0;
                    if (me) {
                      try {
                        ve = X(ie);
                      } catch (Mt) {
                        St = !1, Re = Mt;
                      }
                      if (z === ve) {
                        ne(z, V());
                        return;
                      }
                    } else
                      ve = ie;
                    z._state !== ue || (me && St ? Me(z, ve) : St === !1 ? ne(z, Re) : Y === ce ? Se(z, ve) : Y === de && ne(z, ve));
                  }
                  function lt(Y, z) {
                    try {
                      z(function(ie) {
                        Me(Y, ie);
                      }, function(ie) {
                        ne(Y, ie);
                      });
                    } catch (X) {
                      ne(Y, X);
                    }
                  }
                  var ht = 0;
                  function ct() {
                    return ht++;
                  }
                  function ut(Y) {
                    Y[le] = ht++, Y._state = void 0, Y._result = void 0, Y._subscribers = [];
                  }
                  function Fe() {
                    return new Error("Array Methods must be provided an Array");
                  }
                  var Ue = function() {
                    function Y(z, X) {
                      this._instanceConstructor = z, this.promise = new z(Q), this.promise[le] || ut(this.promise), l(X) ? (this.length = X.length, this._remaining = X.length, this._result = new Array(this.length), this.length === 0 ? Se(this.promise, this._result) : (this.length = this.length || 0, this._enumerate(X), this._remaining === 0 && Se(this.promise, this._result))) : ne(this.promise, Fe());
                    }
                    return Y.prototype._enumerate = function(X) {
                      for (var ie = 0; this._state === ue && ie < X.length; ie++)
                        this._eachEntry(X[ie], ie);
                    }, Y.prototype._eachEntry = function(X, ie) {
                      var me = this._instanceConstructor, ve = me.resolve;
                      if (ve === re) {
                        var Re = void 0, St = void 0, Mt = !1;
                        try {
                          Re = X.then;
                        } catch (Te) {
                          Mt = !0, St = Te;
                        }
                        if (Re === B && X._state !== ue)
                          this._settledAt(X._state, ie, X._result);
                        else if (typeof Re != "function")
                          this._remaining--, this._result[ie] = X;
                        else if (me === Ye) {
                          var vt = new me(Q);
                          Mt ? ne(vt, St) : H(vt, X, Re), this._willSettleAt(vt, ie);
                        } else
                          this._willSettleAt(new me(function(Te) {
                            return Te(X);
                          }), ie);
                      } else
                        this._willSettleAt(ve(X), ie);
                    }, Y.prototype._settledAt = function(X, ie, me) {
                      var ve = this.promise;
                      ve._state === ue && (this._remaining--, X === de ? ne(ve, me) : this._result[ie] = me), this._remaining === 0 && Se(ve, this._result);
                    }, Y.prototype._willSettleAt = function(X, ie) {
                      var me = this;
                      Qe(X, void 0, function(ve) {
                        return me._settledAt(ce, ie, ve);
                      }, function(ve) {
                        return me._settledAt(de, ie, ve);
                      });
                    }, Y;
                  }();
                  function Et(Y) {
                    return new Ue(this, Y).promise;
                  }
                  function Pt(Y) {
                    var z = this;
                    return l(Y) ? new z(function(X, ie) {
                      for (var me = Y.length, ve = 0; ve < me; ve++)
                        z.resolve(Y[ve]).then(X, ie);
                    }) : new z(function(X, ie) {
                      return ie(new TypeError("You must pass an array to race."));
                    });
                  }
                  function $e(Y) {
                    var z = this, X = new z(Q);
                    return ne(X, Y), X;
                  }
                  function _r() {
                    throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");
                  }
                  function pt() {
                    throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
                  }
                  var Ye = function() {
                    function Y(z) {
                      this[le] = ct(), this._result = this._state = void 0, this._subscribers = [], Q !== z && (typeof z != "function" && _r(), this instanceof Y ? lt(this, z) : pt());
                    }
                    return Y.prototype.catch = function(X) {
                      return this.then(null, X);
                    }, Y.prototype.finally = function(X) {
                      var ie = this, me = ie.constructor;
                      return v(X) ? ie.then(function(ve) {
                        return me.resolve(X()).then(function() {
                          return ve;
                        });
                      }, function(ve) {
                        return me.resolve(X()).then(function() {
                          throw ve;
                        });
                      }) : ie.then(X, X);
                    }, Y;
                  }();
                  Ye.prototype.then = B, Ye.all = Et, Ye.race = Pt, Ye.resolve = re, Ye.reject = $e, Ye._setScheduler = g, Ye._setAsap = y, Ye._asap = m;
                  function pe() {
                    var Y = void 0;
                    if (typeof O.g < "u")
                      Y = O.g;
                    else if (typeof self < "u")
                      Y = self;
                    else
                      try {
                        Y = Function("return this")();
                      } catch {
                        throw new Error("polyfill failed because global object is unavailable in this environment");
                      }
                    var z = Y.Promise;
                    if (z) {
                      var X = null;
                      try {
                        X = Object.prototype.toString.call(z.resolve());
                      } catch {
                      }
                      if (X === "[object Promise]" && !z.cast)
                        return;
                    }
                    Y.Promise = Ye;
                  }
                  return Ye.polyfill = pe, Ye.Promise = Ye, Ye;
                });
              }
            ),
            /***/
            "./node_modules/events/events.js": (
              /*!***************************************!*\
                !*** ./node_modules/events/events.js ***!
                \***************************************/
              /***/
              function(T) {
                var w = typeof Reflect == "object" ? Reflect : null, O = w && typeof w.apply == "function" ? w.apply : function(F, L, U) {
                  return Function.prototype.apply.call(F, L, U);
                }, R;
                w && typeof w.ownKeys == "function" ? R = w.ownKeys : Object.getOwnPropertySymbols ? R = function(F) {
                  return Object.getOwnPropertyNames(F).concat(Object.getOwnPropertySymbols(F));
                } : R = function(F) {
                  return Object.getOwnPropertyNames(F);
                };
                function v(k) {
                  console && console.warn && console.warn(k);
                }
                var h = Number.isNaN || function(F) {
                  return F !== F;
                };
                function l() {
                  l.init.call(this);
                }
                T.exports = l, T.exports.once = M, l.EventEmitter = l, l.prototype._events = void 0, l.prototype._eventsCount = 0, l.prototype._maxListeners = void 0;
                var u = 10;
                function f(k) {
                  if (typeof k != "function")
                    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof k);
                }
                Object.defineProperty(l, "defaultMaxListeners", {
                  enumerable: !0,
                  get: function() {
                    return u;
                  },
                  set: function(k) {
                    if (typeof k != "number" || k < 0 || h(k))
                      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + k + ".");
                    u = k;
                  }
                }), l.init = function() {
                  (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
                }, l.prototype.setMaxListeners = function(F) {
                  if (typeof F != "number" || F < 0 || h(F))
                    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + F + ".");
                  return this._maxListeners = F, this;
                };
                function p(k) {
                  return k._maxListeners === void 0 ? l.defaultMaxListeners : k._maxListeners;
                }
                l.prototype.getMaxListeners = function() {
                  return p(this);
                }, l.prototype.emit = function(F) {
                  for (var L = [], U = 1; U < arguments.length; U++)
                    L.push(arguments[U]);
                  var j = F === "error", G = this._events;
                  if (G !== void 0)
                    j = j && G.error === void 0;
                  else if (!j)
                    return !1;
                  if (j) {
                    var B;
                    if (L.length > 0 && (B = L[0]), B instanceof Error)
                      throw B;
                    var re = new Error("Unhandled error." + (B ? " (" + B.message + ")" : ""));
                    throw re.context = B, re;
                  }
                  var le = G[F];
                  if (le === void 0)
                    return !1;
                  if (typeof le == "function")
                    O(le, this, L);
                  else
                    for (var Q = le.length, ue = d(le, Q), U = 0; U < Q; ++U)
                      O(ue[U], this, L);
                  return !0;
                };
                function m(k, F, L, U) {
                  var j, G, B;
                  if (f(L), G = k._events, G === void 0 ? (G = k._events = /* @__PURE__ */ Object.create(null), k._eventsCount = 0) : (G.newListener !== void 0 && (k.emit("newListener", F, L.listener ? L.listener : L), G = k._events), B = G[F]), B === void 0)
                    B = G[F] = L, ++k._eventsCount;
                  else if (typeof B == "function" ? B = G[F] = U ? [L, B] : [B, L] : U ? B.unshift(L) : B.push(L), j = p(k), j > 0 && B.length > j && !B.warned) {
                    B.warned = !0;
                    var re = new Error("Possible EventEmitter memory leak detected. " + B.length + " " + String(F) + " listeners added. Use emitter.setMaxListeners() to increase limit");
                    re.name = "MaxListenersExceededWarning", re.emitter = k, re.type = F, re.count = B.length, v(re);
                  }
                  return k;
                }
                l.prototype.addListener = function(F, L) {
                  return m(this, F, L, !1);
                }, l.prototype.on = l.prototype.addListener, l.prototype.prependListener = function(F, L) {
                  return m(this, F, L, !0);
                };
                function g() {
                  if (!this.fired)
                    return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
                }
                function y(k, F, L) {
                  var U = { fired: !1, wrapFn: void 0, target: k, type: F, listener: L }, j = g.bind(U);
                  return j.listener = L, U.wrapFn = j, j;
                }
                l.prototype.once = function(F, L) {
                  return f(L), this.on(F, y(this, F, L)), this;
                }, l.prototype.prependOnceListener = function(F, L) {
                  return f(L), this.prependListener(F, y(this, F, L)), this;
                }, l.prototype.removeListener = function(F, L) {
                  var U, j, G, B, re;
                  if (f(L), j = this._events, j === void 0)
                    return this;
                  if (U = j[F], U === void 0)
                    return this;
                  if (U === L || U.listener === L)
                    --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete j[F], j.removeListener && this.emit("removeListener", F, U.listener || L));
                  else if (typeof U != "function") {
                    for (G = -1, B = U.length - 1; B >= 0; B--)
                      if (U[B] === L || U[B].listener === L) {
                        re = U[B].listener, G = B;
                        break;
                      }
                    if (G < 0)
                      return this;
                    G === 0 ? U.shift() : E(U, G), U.length === 1 && (j[F] = U[0]), j.removeListener !== void 0 && this.emit("removeListener", F, re || L);
                  }
                  return this;
                }, l.prototype.off = l.prototype.removeListener, l.prototype.removeAllListeners = function(F) {
                  var L, U, j;
                  if (U = this._events, U === void 0)
                    return this;
                  if (U.removeListener === void 0)
                    return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : U[F] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete U[F]), this;
                  if (arguments.length === 0) {
                    var G = Object.keys(U), B;
                    for (j = 0; j < G.length; ++j)
                      B = G[j], B !== "removeListener" && this.removeAllListeners(B);
                    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
                  }
                  if (L = U[F], typeof L == "function")
                    this.removeListener(F, L);
                  else if (L !== void 0)
                    for (j = L.length - 1; j >= 0; j--)
                      this.removeListener(F, L[j]);
                  return this;
                };
                function _(k, F, L) {
                  var U = k._events;
                  if (U === void 0)
                    return [];
                  var j = U[F];
                  return j === void 0 ? [] : typeof j == "function" ? L ? [j.listener || j] : [j] : L ? D(j) : d(j, j.length);
                }
                l.prototype.listeners = function(F) {
                  return _(this, F, !0);
                }, l.prototype.rawListeners = function(F) {
                  return _(this, F, !1);
                }, l.listenerCount = function(k, F) {
                  return typeof k.listenerCount == "function" ? k.listenerCount(F) : x.call(k, F);
                }, l.prototype.listenerCount = x;
                function x(k) {
                  var F = this._events;
                  if (F !== void 0) {
                    var L = F[k];
                    if (typeof L == "function")
                      return 1;
                    if (L !== void 0)
                      return L.length;
                  }
                  return 0;
                }
                l.prototype.eventNames = function() {
                  return this._eventsCount > 0 ? R(this._events) : [];
                };
                function d(k, F) {
                  for (var L = new Array(F), U = 0; U < F; ++U)
                    L[U] = k[U];
                  return L;
                }
                function E(k, F) {
                  for (; F + 1 < k.length; F++)
                    k[F] = k[F + 1];
                  k.pop();
                }
                function D(k) {
                  for (var F = new Array(k.length), L = 0; L < F.length; ++L)
                    F[L] = k[L].listener || k[L];
                  return F;
                }
                function M(k, F) {
                  return new Promise(function(L, U) {
                    function j(B) {
                      k.removeListener(F, G), U(B);
                    }
                    function G() {
                      typeof k.removeListener == "function" && k.removeListener("error", j), L([].slice.call(arguments));
                    }
                    I(k, F, G, { once: !0 }), F !== "error" && C(k, j, { once: !0 });
                  });
                }
                function C(k, F, L) {
                  typeof k.on == "function" && I(k, "error", F, L);
                }
                function I(k, F, L, U) {
                  if (typeof k.on == "function")
                    U.once ? k.once(F, L) : k.on(F, L);
                  else if (typeof k.addEventListener == "function")
                    k.addEventListener(F, function j(G) {
                      U.once && k.removeEventListener(F, j), L(G);
                    });
                  else
                    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof k);
                }
              }
            ),
            /***/
            "./node_modules/webworkify-webpack/index.js": (
              /*!**************************************************!*\
                !*** ./node_modules/webworkify-webpack/index.js ***!
                \**************************************************/
              /***/
              function(T, w, O) {
                function R(g) {
                  var y = {};
                  function _(d) {
                    if (y[d])
                      return y[d].exports;
                    var E = y[d] = {
                      /******/
                      i: d,
                      /******/
                      l: !1,
                      /******/
                      exports: {}
                      /******/
                    };
                    return g[d].call(E.exports, E, E.exports, _), E.l = !0, E.exports;
                  }
                  _.m = g, _.c = y, _.i = function(d) {
                    return d;
                  }, _.d = function(d, E, D) {
                    _.o(d, E) || Object.defineProperty(d, E, {
                      /******/
                      configurable: !1,
                      /******/
                      enumerable: !0,
                      /******/
                      get: D
                      /******/
                    });
                  }, _.r = function(d) {
                    Object.defineProperty(d, "__esModule", { value: !0 });
                  }, _.n = function(d) {
                    var E = d && d.__esModule ? (
                      /******/
                      function() {
                        return d.default;
                      }
                    ) : (
                      /******/
                      function() {
                        return d;
                      }
                    );
                    return _.d(E, "a", E), E;
                  }, _.o = function(d, E) {
                    return Object.prototype.hasOwnProperty.call(d, E);
                  }, _.p = "/", _.oe = function(d) {
                    throw console.error(d), d;
                  };
                  var x = _(_.s = ENTRY_MODULE);
                  return x.default || x;
                }
                var v = "[\\.|\\-|\\+|\\w|/|@]+", h = "\\(\\s*(/\\*.*?\\*/)?\\s*.*?(" + v + ").*?\\)";
                function l(g) {
                  return (g + "").replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
                }
                function u(g) {
                  return !isNaN(1 * g);
                }
                function f(g, y, _) {
                  var x = {};
                  x[_] = [];
                  var d = y.toString(), E = d.match(/^function\s?\w*\(\w+,\s*\w+,\s*(\w+)\)/);
                  if (!E)
                    return x;
                  for (var D = E[1], M = new RegExp("(\\\\n|\\W)" + l(D) + h, "g"), C; C = M.exec(d); )
                    C[3] !== "dll-reference" && x[_].push(C[3]);
                  for (M = new RegExp("\\(" + l(D) + '\\("(dll-reference\\s(' + v + '))"\\)\\)' + h, "g"); C = M.exec(d); )
                    g[C[2]] || (x[_].push(C[1]), g[C[2]] = O(C[1]).m), x[C[2]] = x[C[2]] || [], x[C[2]].push(C[4]);
                  for (var I = Object.keys(x), k = 0; k < I.length; k++)
                    for (var F = 0; F < x[I[k]].length; F++)
                      u(x[I[k]][F]) && (x[I[k]][F] = 1 * x[I[k]][F]);
                  return x;
                }
                function p(g) {
                  var y = Object.keys(g);
                  return y.reduce(function(_, x) {
                    return _ || g[x].length > 0;
                  }, !1);
                }
                function m(g, y) {
                  for (var _ = {
                    main: [y]
                  }, x = {
                    main: []
                  }, d = {
                    main: {}
                  }; p(_); )
                    for (var E = Object.keys(_), D = 0; D < E.length; D++) {
                      var M = E[D], C = _[M], I = C.pop();
                      if (d[M] = d[M] || {}, !(d[M][I] || !g[M][I])) {
                        d[M][I] = !0, x[M] = x[M] || [], x[M].push(I);
                        for (var k = f(g, g[M][I], M), F = Object.keys(k), L = 0; L < F.length; L++)
                          _[F[L]] = _[F[L]] || [], _[F[L]] = _[F[L]].concat(k[F[L]]);
                      }
                    }
                  return x;
                }
                T.exports = function(g, y) {
                  y = y || {};
                  var _ = {
                    main: O.m
                  }, x = y.all ? { main: Object.keys(_.main) } : m(_, g), d = "";
                  Object.keys(x).filter(function(I) {
                    return I !== "main";
                  }).forEach(function(I) {
                    for (var k = 0; x[I][k]; )
                      k++;
                    x[I].push(k), _[I][k] = "(function(module, exports, __webpack_require__) { module.exports = __webpack_require__; })", d = d + "var " + I + " = (" + R.toString().replace("ENTRY_MODULE", JSON.stringify(k)) + ")({" + x[I].map(function(F) {
                      return "" + JSON.stringify(F) + ": " + _[I][F].toString();
                    }).join(",") + `});
`;
                  }), d = d + "new ((" + R.toString().replace("ENTRY_MODULE", JSON.stringify(g)) + ")({" + x.main.map(function(I) {
                    return "" + JSON.stringify(I) + ": " + _.main[I].toString();
                  }).join(",") + "}))(self);";
                  var E = new window.Blob([d], { type: "text/javascript" });
                  if (y.bare)
                    return E;
                  var D = window.URL || window.webkitURL || window.mozURL || window.msURL, M = D.createObjectURL(E), C = new window.Worker(M);
                  return C.objectURL = M, C;
                };
              }
            ),
            /***/
            "./src/config.js": (
              /*!***********************!*\
                !*** ./src/config.js ***!
                \***********************/
              /***/
              function(T, w, O) {
                O.r(w), O.d(w, {
                  /* harmony export */
                  defaultConfig: function() {
                    return (
                      /* binding */
                      R
                    );
                  },
                  /* harmony export */
                  createDefaultConfig: function() {
                    return (
                      /* binding */
                      v
                    );
                  }
                  /* harmony export */
                });
                var R = {
                  enableWorker: !1,
                  enableStashBuffer: !0,
                  stashInitialSize: void 0,
                  isLive: !1,
                  lazyLoad: !0,
                  lazyLoadMaxDuration: 3 * 60,
                  lazyLoadRecoverDuration: 30,
                  deferLoadAfterSourceOpen: !0,
                  // autoCleanupSourceBuffer: default as false, leave unspecified
                  autoCleanupMaxBackwardDuration: 3 * 60,
                  autoCleanupMinBackwardDuration: 2 * 60,
                  statisticsInfoReportInterval: 600,
                  fixAudioTimestampGap: !0,
                  accurateSeek: !1,
                  seekType: "range",
                  seekParamStart: "bstart",
                  seekParamEnd: "bend",
                  rangeLoadZeroStart: !1,
                  customSeekHandler: void 0,
                  reuseRedirectedURL: !1,
                  // referrerPolicy: leave as unspecified
                  headers: void 0,
                  customLoader: void 0
                };
                function v() {
                  return Object.assign({}, R);
                }
              }
            ),
            /***/
            "./src/core/features.js": (
              /*!******************************!*\
                !*** ./src/core/features.js ***!
                \******************************/
              /***/
              function(T, w, O) {
                O.r(w);
                var R = O(
                  /*! ../io/io-controller.js */
                  "./src/io/io-controller.js"
                ), v = O(
                  /*! ../config.js */
                  "./src/config.js"
                ), h = (
                  /** @class */
                  function() {
                    function l() {
                    }
                    return l.supportMSEH264Playback = function() {
                      return window.MediaSource && window.MediaSource.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"');
                    }, l.supportMSEH265Playback = function() {
                      return window.MediaSource && window.MediaSource.isTypeSupported('video/mp4; codecs="hvc1.1.6.L93.B0"');
                    }, l.supportNetworkStreamIO = function() {
                      var u = new R.default({}, (0, v.createDefaultConfig)()), f = u.loaderType;
                      return u.destroy(), f == "fetch-stream-loader" || f == "xhr-moz-chunked-loader";
                    }, l.getNetworkLoaderTypeName = function() {
                      var u = new R.default({}, (0, v.createDefaultConfig)()), f = u.loaderType;
                      return u.destroy(), f;
                    }, l.supportNativeMediaPlayback = function(u) {
                      l.videoElement == null && (l.videoElement = window.document.createElement("video"));
                      var f = l.videoElement.canPlayType(u);
                      return f === "probably" || f == "maybe";
                    }, l.getFeatureList = function() {
                      var u = {
                        mseFlvPlayback: !1,
                        mseLiveFlvPlayback: !1,
                        networkStreamIO: !1,
                        networkLoaderName: "",
                        nativeMP4H264Playback: !1,
                        nativeMP4H265Playback: !1,
                        nativeWebmVP8Playback: !1,
                        nativeWebmVP9Playback: !1
                      };
                      return u.mseFlvPlayback = l.supportMSEH264Playback(), u.networkStreamIO = l.supportNetworkStreamIO(), u.networkLoaderName = l.getNetworkLoaderTypeName(), u.mseLiveFlvPlayback = u.mseFlvPlayback && u.networkStreamIO, u.nativeMP4H264Playback = l.supportNativeMediaPlayback('video/mp4; codecs="avc1.42001E, mp4a.40.2"'), u.nativeMP4H265Playback = l.supportNativeMediaPlayback('video/mp4; codecs="hvc1.1.6.L93.B0"'), u.nativeWebmVP8Playback = l.supportNativeMediaPlayback('video/webm; codecs="vp8.0, vorbis"'), u.nativeWebmVP9Playback = l.supportNativeMediaPlayback('video/webm; codecs="vp9"'), u;
                    }, l;
                  }()
                );
                w.default = h;
              }
            ),
            /***/
            "./src/core/media-info.js": (
              /*!********************************!*\
                !*** ./src/core/media-info.js ***!
                \********************************/
              /***/
              function(T, w, O) {
                O.r(w);
                var R = (
                  /** @class */
                  function() {
                    function v() {
                      this.mimeType = null, this.duration = null, this.hasAudio = null, this.hasVideo = null, this.audioCodec = null, this.videoCodec = null, this.audioDataRate = null, this.videoDataRate = null, this.audioSampleRate = null, this.audioChannelCount = null, this.width = null, this.height = null, this.fps = null, this.profile = null, this.level = null, this.refFrames = null, this.chromaFormat = null, this.sarNum = null, this.sarDen = null, this.metadata = null, this.segments = null, this.segmentCount = null, this.hasKeyframesIndex = null, this.keyframesIndex = null;
                    }
                    return v.prototype.isComplete = function() {
                      var h = this.hasAudio === !1 || this.hasAudio === !0 && this.audioCodec != null && this.audioSampleRate != null && this.audioChannelCount != null, l = this.hasVideo === !1 || this.hasVideo === !0 && this.videoCodec != null && this.width != null && this.height != null && this.fps != null && this.profile != null && this.level != null && this.refFrames != null && this.chromaFormat != null && this.sarNum != null && this.sarDen != null;
                      return this.mimeType != null && this.duration != null && this.metadata != null && this.hasKeyframesIndex != null && h && l;
                    }, v.prototype.isSeekable = function() {
                      return this.hasKeyframesIndex === !0;
                    }, v.prototype.getNearestKeyframe = function(h) {
                      if (this.keyframesIndex == null)
                        return null;
                      var l = this.keyframesIndex, u = this._search(l.times, h);
                      return {
                        index: u,
                        milliseconds: l.times[u],
                        fileposition: l.filepositions[u]
                      };
                    }, v.prototype._search = function(h, l) {
                      var u = 0, f = h.length - 1, p = 0, m = 0, g = f;
                      for (l < h[0] && (u = 0, m = g + 1); m <= g; )
                        if (p = m + Math.floor((g - m) / 2), p === f || l >= h[p] && l < h[p + 1]) {
                          u = p;
                          break;
                        } else
                          h[p] < l ? m = p + 1 : g = p - 1;
                      return u;
                    }, v;
                  }()
                );
                w.default = R;
              }
            ),
            /***/
            "./src/core/media-segment-info.js": (
              /*!****************************************!*\
                !*** ./src/core/media-segment-info.js ***!
                \****************************************/
              /***/
              function(T, w, O) {
                O.r(w), O.d(w, {
                  /* harmony export */
                  SampleInfo: function() {
                    return (
                      /* binding */
                      R
                    );
                  },
                  /* harmony export */
                  MediaSegmentInfo: function() {
                    return (
                      /* binding */
                      v
                    );
                  },
                  /* harmony export */
                  IDRSampleList: function() {
                    return (
                      /* binding */
                      h
                    );
                  },
                  /* harmony export */
                  MediaSegmentInfoList: function() {
                    return (
                      /* binding */
                      l
                    );
                  }
                  /* harmony export */
                });
                var R = (
                  /** @class */
                  function() {
                    function u(f, p, m, g, y) {
                      this.dts = f, this.pts = p, this.duration = m, this.originalDts = g, this.isSyncPoint = y, this.fileposition = null;
                    }
                    return u;
                  }()
                ), v = (
                  /** @class */
                  function() {
                    function u() {
                      this.beginDts = 0, this.endDts = 0, this.beginPts = 0, this.endPts = 0, this.originalBeginDts = 0, this.originalEndDts = 0, this.syncPoints = [], this.firstSample = null, this.lastSample = null;
                    }
                    return u.prototype.appendSyncPoint = function(f) {
                      f.isSyncPoint = !0, this.syncPoints.push(f);
                    }, u;
                  }()
                ), h = (
                  /** @class */
                  function() {
                    function u() {
                      this._list = [];
                    }
                    return u.prototype.clear = function() {
                      this._list = [];
                    }, u.prototype.appendArray = function(f) {
                      var p = this._list;
                      f.length !== 0 && (p.length > 0 && f[0].originalDts < p[p.length - 1].originalDts && this.clear(), Array.prototype.push.apply(p, f));
                    }, u.prototype.getLastSyncPointBeforeDts = function(f) {
                      if (this._list.length == 0)
                        return null;
                      var p = this._list, m = 0, g = p.length - 1, y = 0, _ = 0, x = g;
                      for (f < p[0].dts && (m = 0, _ = x + 1); _ <= x; )
                        if (y = _ + Math.floor((x - _) / 2), y === g || f >= p[y].dts && f < p[y + 1].dts) {
                          m = y;
                          break;
                        } else
                          p[y].dts < f ? _ = y + 1 : x = y - 1;
                      return this._list[m];
                    }, u;
                  }()
                ), l = (
                  /** @class */
                  function() {
                    function u(f) {
                      this._type = f, this._list = [], this._lastAppendLocation = -1;
                    }
                    return Object.defineProperty(u.prototype, "type", {
                      get: function() {
                        return this._type;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(u.prototype, "length", {
                      get: function() {
                        return this._list.length;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), u.prototype.isEmpty = function() {
                      return this._list.length === 0;
                    }, u.prototype.clear = function() {
                      this._list = [], this._lastAppendLocation = -1;
                    }, u.prototype._searchNearestSegmentBefore = function(f) {
                      var p = this._list;
                      if (p.length === 0)
                        return -2;
                      var m = p.length - 1, g = 0, y = 0, _ = m, x = 0;
                      if (f < p[0].originalBeginDts)
                        return x = -1, x;
                      for (; y <= _; )
                        if (g = y + Math.floor((_ - y) / 2), g === m || f > p[g].lastSample.originalDts && f < p[g + 1].originalBeginDts) {
                          x = g;
                          break;
                        } else
                          p[g].originalBeginDts < f ? y = g + 1 : _ = g - 1;
                      return x;
                    }, u.prototype._searchNearestSegmentAfter = function(f) {
                      return this._searchNearestSegmentBefore(f) + 1;
                    }, u.prototype.append = function(f) {
                      var p = this._list, m = f, g = this._lastAppendLocation, y = 0;
                      g !== -1 && g < p.length && m.originalBeginDts >= p[g].lastSample.originalDts && (g === p.length - 1 || g < p.length - 1 && m.originalBeginDts < p[g + 1].originalBeginDts) ? y = g + 1 : p.length > 0 && (y = this._searchNearestSegmentBefore(m.originalBeginDts) + 1), this._lastAppendLocation = y, this._list.splice(y, 0, m);
                    }, u.prototype.getLastSegmentBefore = function(f) {
                      var p = this._searchNearestSegmentBefore(f);
                      return p >= 0 ? this._list[p] : null;
                    }, u.prototype.getLastSampleBefore = function(f) {
                      var p = this.getLastSegmentBefore(f);
                      return p != null ? p.lastSample : null;
                    }, u.prototype.getLastSyncPointBefore = function(f) {
                      for (var p = this._searchNearestSegmentBefore(f), m = this._list[p].syncPoints; m.length === 0 && p > 0; )
                        p--, m = this._list[p].syncPoints;
                      return m.length > 0 ? m[m.length - 1] : null;
                    }, u;
                  }()
                );
              }
            ),
            /***/
            "./src/core/mse-controller.js": (
              /*!************************************!*\
                !*** ./src/core/mse-controller.js ***!
                \************************************/
              /***/
              function(T, w, O) {
                O.r(w);
                var R = O(
                  /*! events */
                  "./node_modules/events/events.js"
                ), v = /* @__PURE__ */ O.n(R), h = O(
                  /*! ../utils/logger.js */
                  "./src/utils/logger.js"
                ), l = O(
                  /*! ../utils/browser.js */
                  "./src/utils/browser.js"
                ), u = O(
                  /*! ./mse-events.js */
                  "./src/core/mse-events.js"
                ), f = O(
                  /*! ./media-segment-info.js */
                  "./src/core/media-segment-info.js"
                ), p = O(
                  /*! ../utils/exception.js */
                  "./src/utils/exception.js"
                ), m = (
                  /** @class */
                  function() {
                    function g(y) {
                      this.TAG = "MSEController", this._config = y, this._emitter = new (v())(), this._config.isLive && this._config.autoCleanupSourceBuffer == null && (this._config.autoCleanupSourceBuffer = !0), this.e = {
                        onSourceOpen: this._onSourceOpen.bind(this),
                        onSourceEnded: this._onSourceEnded.bind(this),
                        onSourceClose: this._onSourceClose.bind(this),
                        onSourceBufferError: this._onSourceBufferError.bind(this),
                        onSourceBufferUpdateEnd: this._onSourceBufferUpdateEnd.bind(this)
                      }, this._mediaSource = null, this._mediaSourceObjectURL = null, this._mediaElement = null, this._isBufferFull = !1, this._hasPendingEos = !1, this._requireSetMediaDuration = !1, this._pendingMediaDuration = 0, this._pendingSourceBufferInit = [], this._mimeTypes = {
                        video: null,
                        audio: null
                      }, this._sourceBuffers = {
                        video: null,
                        audio: null
                      }, this._lastInitSegments = {
                        video: null,
                        audio: null
                      }, this._pendingSegments = {
                        video: [],
                        audio: []
                      }, this._pendingRemoveRanges = {
                        video: [],
                        audio: []
                      }, this._idrList = new f.IDRSampleList();
                    }
                    return g.prototype.destroy = function() {
                      (this._mediaElement || this._mediaSource) && this.detachMediaElement(), this.e = null, this._emitter.removeAllListeners(), this._emitter = null;
                    }, g.prototype.on = function(y, _) {
                      this._emitter.addListener(y, _);
                    }, g.prototype.off = function(y, _) {
                      this._emitter.removeListener(y, _);
                    }, g.prototype.attachMediaElement = function(y) {
                      if (this._mediaSource)
                        throw new p.IllegalStateException("MediaSource has been attached to an HTMLMediaElement!");
                      var _ = this._mediaSource = new window.MediaSource();
                      _.addEventListener("sourceopen", this.e.onSourceOpen), _.addEventListener("sourceended", this.e.onSourceEnded), _.addEventListener("sourceclose", this.e.onSourceClose), this._mediaElement = y, this._mediaSourceObjectURL = window.URL.createObjectURL(this._mediaSource), y.src = this._mediaSourceObjectURL;
                    }, g.prototype.detachMediaElement = function() {
                      if (this._mediaSource) {
                        var y = this._mediaSource;
                        for (var _ in this._sourceBuffers) {
                          var x = this._pendingSegments[_];
                          x.splice(0, x.length), this._pendingSegments[_] = null, this._pendingRemoveRanges[_] = null, this._lastInitSegments[_] = null;
                          var d = this._sourceBuffers[_];
                          if (d) {
                            if (y.readyState !== "closed") {
                              try {
                                y.removeSourceBuffer(d);
                              } catch (E) {
                                h.default.e(this.TAG, E.message);
                              }
                              d.removeEventListener("error", this.e.onSourceBufferError), d.removeEventListener("updateend", this.e.onSourceBufferUpdateEnd);
                            }
                            this._mimeTypes[_] = null, this._sourceBuffers[_] = null;
                          }
                        }
                        if (y.readyState === "open")
                          try {
                            y.endOfStream();
                          } catch (E) {
                            h.default.e(this.TAG, E.message);
                          }
                        y.removeEventListener("sourceopen", this.e.onSourceOpen), y.removeEventListener("sourceended", this.e.onSourceEnded), y.removeEventListener("sourceclose", this.e.onSourceClose), this._pendingSourceBufferInit = [], this._isBufferFull = !1, this._idrList.clear(), this._mediaSource = null;
                      }
                      this._mediaElement && (this._mediaElement.src = "", this._mediaElement.removeAttribute("src"), this._mediaElement = null), this._mediaSourceObjectURL && (window.URL.revokeObjectURL(this._mediaSourceObjectURL), this._mediaSourceObjectURL = null);
                    }, g.prototype.appendInitSegment = function(y, _) {
                      if (!this._mediaSource || this._mediaSource.readyState !== "open") {
                        this._pendingSourceBufferInit.push(y), this._pendingSegments[y.type].push(y);
                        return;
                      }
                      var x = y, d = "" + x.container;
                      x.codec && x.codec.length > 0 && (d += ";codecs=" + x.codec);
                      var E = !1;
                      if (h.default.v(this.TAG, "Received Initialization Segment, mimeType: " + d), this._lastInitSegments[x.type] = x, d !== this._mimeTypes[x.type]) {
                        if (this._mimeTypes[x.type])
                          h.default.v(this.TAG, "Notice: " + x.type + " mimeType changed, origin: " + this._mimeTypes[x.type] + ", target: " + d);
                        else {
                          E = !0;
                          try {
                            var D = this._sourceBuffers[x.type] = this._mediaSource.addSourceBuffer(d);
                            D.addEventListener("error", this.e.onSourceBufferError), D.addEventListener("updateend", this.e.onSourceBufferUpdateEnd);
                          } catch (M) {
                            h.default.e(this.TAG, M.message), this._emitter.emit(u.default.ERROR, { code: M.code, msg: M.message });
                            return;
                          }
                        }
                        this._mimeTypes[x.type] = d;
                      }
                      _ || this._pendingSegments[x.type].push(x), E || this._sourceBuffers[x.type] && !this._sourceBuffers[x.type].updating && this._doAppendSegments(), l.default.safari && x.container === "audio/mpeg" && x.mediaDuration > 0 && (this._requireSetMediaDuration = !0, this._pendingMediaDuration = x.mediaDuration / 1e3, this._updateMediaSourceDuration());
                    }, g.prototype.appendMediaSegment = function(y) {
                      var _ = y;
                      this._pendingSegments[_.type].push(_), this._config.autoCleanupSourceBuffer && this._needCleanupSourceBuffer() && this._doCleanupSourceBuffer();
                      var x = this._sourceBuffers[_.type];
                      x && !x.updating && !this._hasPendingRemoveRanges() && this._doAppendSegments();
                    }, g.prototype.seek = function(y) {
                      for (var _ in this._sourceBuffers)
                        if (this._sourceBuffers[_]) {
                          var x = this._sourceBuffers[_];
                          if (this._mediaSource.readyState === "open")
                            try {
                              x.abort();
                            } catch (I) {
                              h.default.e(this.TAG, I.message);
                            }
                          this._idrList.clear();
                          var d = this._pendingSegments[_];
                          if (d.splice(0, d.length), this._mediaSource.readyState !== "closed") {
                            for (var E = 0; E < x.buffered.length; E++) {
                              var D = x.buffered.start(E), M = x.buffered.end(E);
                              this._pendingRemoveRanges[_].push({ start: D, end: M });
                            }
                            if (x.updating || this._doRemoveRanges(), l.default.safari) {
                              var C = this._lastInitSegments[_];
                              C && (this._pendingSegments[_].push(C), x.updating || this._doAppendSegments());
                            }
                          }
                        }
                    }, g.prototype.endOfStream = function() {
                      var y = this._mediaSource, _ = this._sourceBuffers;
                      if (!y || y.readyState !== "open") {
                        y && y.readyState === "closed" && this._hasPendingSegments() && (this._hasPendingEos = !0);
                        return;
                      }
                      _.video && _.video.updating || _.audio && _.audio.updating ? this._hasPendingEos = !0 : (this._hasPendingEos = !1, y.endOfStream());
                    }, g.prototype.getNearestKeyframe = function(y) {
                      return this._idrList.getLastSyncPointBeforeDts(y);
                    }, g.prototype._needCleanupSourceBuffer = function() {
                      if (!this._config.autoCleanupSourceBuffer)
                        return !1;
                      var y = this._mediaElement.currentTime;
                      for (var _ in this._sourceBuffers) {
                        var x = this._sourceBuffers[_];
                        if (x) {
                          var d = x.buffered;
                          if (d.length >= 1 && y - d.start(0) >= this._config.autoCleanupMaxBackwardDuration)
                            return !0;
                        }
                      }
                      return !1;
                    }, g.prototype._doCleanupSourceBuffer = function() {
                      var y = this._mediaElement.currentTime;
                      for (var _ in this._sourceBuffers) {
                        var x = this._sourceBuffers[_];
                        if (x) {
                          for (var d = x.buffered, E = !1, D = 0; D < d.length; D++) {
                            var M = d.start(D), C = d.end(D);
                            if (M <= y && y < C + 3) {
                              if (y - M >= this._config.autoCleanupMaxBackwardDuration) {
                                E = !0;
                                var I = y - this._config.autoCleanupMinBackwardDuration;
                                this._pendingRemoveRanges[_].push({ start: M, end: I });
                              }
                            } else
                              C < y && (E = !0, this._pendingRemoveRanges[_].push({ start: M, end: C }));
                          }
                          E && !x.updating && this._doRemoveRanges();
                        }
                      }
                    }, g.prototype._updateMediaSourceDuration = function() {
                      var y = this._sourceBuffers;
                      if (!(this._mediaElement.readyState === 0 || this._mediaSource.readyState !== "open") && !(y.video && y.video.updating || y.audio && y.audio.updating)) {
                        var _ = this._mediaSource.duration, x = this._pendingMediaDuration;
                        x > 0 && (isNaN(_) || x > _) && (h.default.v(this.TAG, "Update MediaSource duration from " + _ + " to " + x), this._mediaSource.duration = x), this._requireSetMediaDuration = !1, this._pendingMediaDuration = 0;
                      }
                    }, g.prototype._doRemoveRanges = function() {
                      for (var y in this._pendingRemoveRanges)
                        if (!(!this._sourceBuffers[y] || this._sourceBuffers[y].updating))
                          for (var _ = this._sourceBuffers[y], x = this._pendingRemoveRanges[y]; x.length && !_.updating; ) {
                            var d = x.shift();
                            _.remove(d.start, d.end);
                          }
                    }, g.prototype._doAppendSegments = function() {
                      var y = this._pendingSegments;
                      for (var _ in y)
                        if (!(!this._sourceBuffers[_] || this._sourceBuffers[_].updating) && y[_].length > 0) {
                          var x = y[_].shift();
                          if (x.timestampOffset) {
                            var d = this._sourceBuffers[_].timestampOffset, E = x.timestampOffset / 1e3, D = Math.abs(d - E);
                            D > 0.1 && (h.default.v(this.TAG, "Update MPEG audio timestampOffset from " + d + " to " + E), this._sourceBuffers[_].timestampOffset = E), delete x.timestampOffset;
                          }
                          if (!x.data || x.data.byteLength === 0)
                            continue;
                          try {
                            this._sourceBuffers[_].appendBuffer(x.data), this._isBufferFull = !1, _ === "video" && x.hasOwnProperty("info") && this._idrList.appendArray(x.info.syncPoints);
                          } catch (M) {
                            this._pendingSegments[_].unshift(x), M.code === 22 ? (this._isBufferFull || this._emitter.emit(u.default.BUFFER_FULL), this._isBufferFull = !0) : (h.default.e(this.TAG, _, M.message), this._emitter.emit(u.default.ERROR, { code: M.code, msg: M.message }));
                          }
                        }
                    }, g.prototype._onSourceOpen = function() {
                      if (h.default.v(this.TAG, "MediaSource onSourceOpen"), this._mediaSource.removeEventListener("sourceopen", this.e.onSourceOpen), this._pendingSourceBufferInit.length > 0)
                        for (var y = this._pendingSourceBufferInit; y.length; ) {
                          var _ = y.shift();
                          this.appendInitSegment(_, !0);
                        }
                      this._hasPendingSegments() && this._doAppendSegments(), this._emitter.emit(u.default.SOURCE_OPEN);
                    }, g.prototype._onSourceEnded = function() {
                      h.default.v(this.TAG, "MediaSource onSourceEnded");
                    }, g.prototype._onSourceClose = function() {
                      h.default.v(this.TAG, "MediaSource onSourceClose"), this._mediaSource && this.e != null && (this._mediaSource.removeEventListener("sourceopen", this.e.onSourceOpen), this._mediaSource.removeEventListener("sourceended", this.e.onSourceEnded), this._mediaSource.removeEventListener("sourceclose", this.e.onSourceClose));
                    }, g.prototype._hasPendingSegments = function() {
                      var y = this._pendingSegments;
                      return (y.video && y.video.length) > 0 || y.audio && y.audio.length > 0;
                    }, g.prototype._hasPendingRemoveRanges = function() {
                      var y = this._pendingRemoveRanges;
                      return (y.video && y.video.length) > 0 || y.audio && y.audio.length > 0;
                    }, g.prototype._onSourceBufferUpdateEnd = function() {
                      this._requireSetMediaDuration ? this._updateMediaSourceDuration() : this._hasPendingRemoveRanges() ? this._doRemoveRanges() : this._hasPendingSegments() ? this._doAppendSegments() : this._hasPendingEos && this.endOfStream(), this._emitter.emit(u.default.UPDATE_END);
                    }, g.prototype._onSourceBufferError = function(y) {
                      h.default.e(this.TAG, "SourceBuffer Error: " + y);
                    }, g;
                  }()
                );
                w.default = m;
              }
            ),
            /***/
            "./src/core/mse-events.js": (
              /*!********************************!*\
                !*** ./src/core/mse-events.js ***!
                \********************************/
              /***/
              function(T, w, O) {
                O.r(w);
                var R = {
                  ERROR: "error",
                  SOURCE_OPEN: "source_open",
                  UPDATE_END: "update_end",
                  BUFFER_FULL: "buffer_full"
                };
                w.default = R;
              }
            ),
            /***/
            "./src/core/transmuxer.js": (
              /*!********************************!*\
                !*** ./src/core/transmuxer.js ***!
                \********************************/
              /***/
              function(T, w, O) {
                O.r(w);
                var R = O(
                  /*! events */
                  "./node_modules/events/events.js"
                ), v = /* @__PURE__ */ O.n(R), h = O(
                  /*! webworkify-webpack */
                  "./node_modules/webworkify-webpack/index.js"
                ), l = /* @__PURE__ */ O.n(h), u = O(
                  /*! ../utils/logger.js */
                  "./src/utils/logger.js"
                ), f = O(
                  /*! ../utils/logging-control.js */
                  "./src/utils/logging-control.js"
                ), p = O(
                  /*! ./transmuxing-controller.js */
                  "./src/core/transmuxing-controller.js"
                ), m = O(
                  /*! ./transmuxing-events.js */
                  "./src/core/transmuxing-events.js"
                ), g = O(
                  /*! ./media-info.js */
                  "./src/core/media-info.js"
                ), y = (
                  /** @class */
                  function() {
                    function _(x, d) {
                      if (this.TAG = "Transmuxer", this._emitter = new (v())(), d.enableWorker && typeof Worker < "u")
                        try {
                          this._worker = l()(
                            /*require.resolve*/
                            /*! ./transmuxing-worker */
                            "./src/core/transmuxing-worker.js"
                          ), this._workerDestroying = !1, this._worker.addEventListener("message", this._onWorkerMessage.bind(this)), this._worker.postMessage({ cmd: "init", param: [x, d] }), this.e = {
                            onLoggingConfigChanged: this._onLoggingConfigChanged.bind(this)
                          }, f.default.registerListener(this.e.onLoggingConfigChanged), this._worker.postMessage({ cmd: "logging_config", param: f.default.getConfig() });
                        } catch {
                          u.default.e(this.TAG, "Error while initialize transmuxing worker, fallback to inline transmuxing"), this._worker = null, this._controller = new p.default(x, d);
                        }
                      else
                        this._controller = new p.default(x, d);
                      if (this._controller) {
                        var E = this._controller;
                        E.on(m.default.IO_ERROR, this._onIOError.bind(this)), E.on(m.default.DEMUX_ERROR, this._onDemuxError.bind(this)), E.on(m.default.INIT_SEGMENT, this._onInitSegment.bind(this)), E.on(m.default.MEDIA_SEGMENT, this._onMediaSegment.bind(this)), E.on(m.default.LOADING_COMPLETE, this._onLoadingComplete.bind(this)), E.on(m.default.RECOVERED_EARLY_EOF, this._onRecoveredEarlyEof.bind(this)), E.on(m.default.MEDIA_INFO, this._onMediaInfo.bind(this)), E.on(m.default.METADATA_ARRIVED, this._onMetaDataArrived.bind(this)), E.on(m.default.SCRIPTDATA_ARRIVED, this._onScriptDataArrived.bind(this)), E.on(m.default.STATISTICS_INFO, this._onStatisticsInfo.bind(this)), E.on(m.default.RECOMMEND_SEEKPOINT, this._onRecommendSeekpoint.bind(this));
                      }
                    }
                    return _.prototype.destroy = function() {
                      this._worker ? this._workerDestroying || (this._workerDestroying = !0, this._worker.postMessage({ cmd: "destroy" }), f.default.removeListener(this.e.onLoggingConfigChanged), this.e = null) : (this._controller.destroy(), this._controller = null), this._emitter.removeAllListeners(), this._emitter = null;
                    }, _.prototype.on = function(x, d) {
                      this._emitter.addListener(x, d);
                    }, _.prototype.off = function(x, d) {
                      this._emitter.removeListener(x, d);
                    }, _.prototype.hasWorker = function() {
                      return this._worker != null;
                    }, _.prototype.open = function() {
                      this._worker ? this._worker.postMessage({ cmd: "start" }) : this._controller.start();
                    }, _.prototype.close = function() {
                      this._worker ? this._worker.postMessage({ cmd: "stop" }) : this._controller.stop();
                    }, _.prototype.seek = function(x) {
                      this._worker ? this._worker.postMessage({ cmd: "seek", param: x }) : this._controller.seek(x);
                    }, _.prototype.pause = function() {
                      this._worker ? this._worker.postMessage({ cmd: "pause" }) : this._controller.pause();
                    }, _.prototype.resume = function() {
                      this._worker ? this._worker.postMessage({ cmd: "resume" }) : this._controller.resume();
                    }, _.prototype._onInitSegment = function(x, d) {
                      var E = this;
                      Promise.resolve().then(function() {
                        E._emitter.emit(m.default.INIT_SEGMENT, x, d);
                      });
                    }, _.prototype._onMediaSegment = function(x, d) {
                      var E = this;
                      Promise.resolve().then(function() {
                        E._emitter.emit(m.default.MEDIA_SEGMENT, x, d);
                      });
                    }, _.prototype._onLoadingComplete = function() {
                      var x = this;
                      Promise.resolve().then(function() {
                        x._emitter.emit(m.default.LOADING_COMPLETE);
                      });
                    }, _.prototype._onRecoveredEarlyEof = function() {
                      var x = this;
                      Promise.resolve().then(function() {
                        x._emitter.emit(m.default.RECOVERED_EARLY_EOF);
                      });
                    }, _.prototype._onMediaInfo = function(x) {
                      var d = this;
                      Promise.resolve().then(function() {
                        d._emitter.emit(m.default.MEDIA_INFO, x);
                      });
                    }, _.prototype._onMetaDataArrived = function(x) {
                      var d = this;
                      Promise.resolve().then(function() {
                        d._emitter.emit(m.default.METADATA_ARRIVED, x);
                      });
                    }, _.prototype._onScriptDataArrived = function(x) {
                      var d = this;
                      Promise.resolve().then(function() {
                        d._emitter.emit(m.default.SCRIPTDATA_ARRIVED, x);
                      });
                    }, _.prototype._onStatisticsInfo = function(x) {
                      var d = this;
                      Promise.resolve().then(function() {
                        d._emitter.emit(m.default.STATISTICS_INFO, x);
                      });
                    }, _.prototype._onIOError = function(x, d) {
                      var E = this;
                      Promise.resolve().then(function() {
                        E._emitter.emit(m.default.IO_ERROR, x, d);
                      });
                    }, _.prototype._onDemuxError = function(x, d) {
                      var E = this;
                      Promise.resolve().then(function() {
                        E._emitter.emit(m.default.DEMUX_ERROR, x, d);
                      });
                    }, _.prototype._onRecommendSeekpoint = function(x) {
                      var d = this;
                      Promise.resolve().then(function() {
                        d._emitter.emit(m.default.RECOMMEND_SEEKPOINT, x);
                      });
                    }, _.prototype._onLoggingConfigChanged = function(x) {
                      this._worker && this._worker.postMessage({ cmd: "logging_config", param: x });
                    }, _.prototype._onWorkerMessage = function(x) {
                      var d = x.data, E = d.data;
                      if (d.msg === "destroyed" || this._workerDestroying) {
                        this._workerDestroying = !1, this._worker.terminate(), this._worker = null;
                        return;
                      }
                      switch (d.msg) {
                        case m.default.INIT_SEGMENT:
                        case m.default.MEDIA_SEGMENT:
                          this._emitter.emit(d.msg, E.type, E.data);
                          break;
                        case m.default.LOADING_COMPLETE:
                        case m.default.RECOVERED_EARLY_EOF:
                          this._emitter.emit(d.msg);
                          break;
                        case m.default.MEDIA_INFO:
                          Object.setPrototypeOf(E, g.default.prototype), this._emitter.emit(d.msg, E);
                          break;
                        case m.default.METADATA_ARRIVED:
                        case m.default.SCRIPTDATA_ARRIVED:
                        case m.default.STATISTICS_INFO:
                          this._emitter.emit(d.msg, E);
                          break;
                        case m.default.IO_ERROR:
                        case m.default.DEMUX_ERROR:
                          this._emitter.emit(d.msg, E.type, E.info);
                          break;
                        case m.default.RECOMMEND_SEEKPOINT:
                          this._emitter.emit(d.msg, E);
                          break;
                        case "logcat_callback":
                          u.default.emitter.emit("log", E.type, E.logcat);
                          break;
                      }
                    }, _;
                  }()
                );
                w.default = y;
              }
            ),
            /***/
            "./src/core/transmuxing-controller.js": (
              /*!********************************************!*\
                !*** ./src/core/transmuxing-controller.js ***!
                \********************************************/
              /***/
              function(T, w, O) {
                O.r(w);
                var R = O(
                  /*! events */
                  "./node_modules/events/events.js"
                ), v = /* @__PURE__ */ O.n(R), h = O(
                  /*! ../utils/logger.js */
                  "./src/utils/logger.js"
                ), l = O(
                  /*! ../utils/browser.js */
                  "./src/utils/browser.js"
                ), u = O(
                  /*! ./media-info.js */
                  "./src/core/media-info.js"
                ), f = O(
                  /*! ../demux/flv-demuxer.js */
                  "./src/demux/flv-demuxer.js"
                ), p = O(
                  /*! ../remux/mp4-remuxer.js */
                  "./src/remux/mp4-remuxer.js"
                ), m = O(
                  /*! ../demux/demux-errors.js */
                  "./src/demux/demux-errors.js"
                ), g = O(
                  /*! ../io/io-controller.js */
                  "./src/io/io-controller.js"
                ), y = O(
                  /*! ./transmuxing-events.js */
                  "./src/core/transmuxing-events.js"
                ), _ = (
                  /** @class */
                  function() {
                    function x(d, E) {
                      this.TAG = "TransmuxingController", this._emitter = new (v())(), this._config = E, d.segments || (d.segments = [{
                        duration: d.duration,
                        filesize: d.filesize,
                        url: d.url
                      }]), typeof d.cors != "boolean" && (d.cors = !0), typeof d.withCredentials != "boolean" && (d.withCredentials = !1), this._mediaDataSource = d, this._currentSegmentIndex = 0;
                      var D = 0;
                      this._mediaDataSource.segments.forEach(function(M) {
                        M.timestampBase = D, D += M.duration, M.cors = d.cors, M.withCredentials = d.withCredentials, E.referrerPolicy && (M.referrerPolicy = E.referrerPolicy);
                      }), !isNaN(D) && this._mediaDataSource.duration !== D && (this._mediaDataSource.duration = D), this._mediaInfo = null, this._demuxer = null, this._remuxer = null, this._ioctl = null, this._pendingSeekTime = null, this._pendingResolveSeekPoint = null, this._statisticsReporter = null;
                    }
                    return x.prototype.destroy = function() {
                      this._mediaInfo = null, this._mediaDataSource = null, this._statisticsReporter && this._disableStatisticsReporter(), this._ioctl && (this._ioctl.destroy(), this._ioctl = null), this._demuxer && (this._demuxer.destroy(), this._demuxer = null), this._remuxer && (this._remuxer.destroy(), this._remuxer = null), this._emitter.removeAllListeners(), this._emitter = null;
                    }, x.prototype.on = function(d, E) {
                      this._emitter.addListener(d, E);
                    }, x.prototype.off = function(d, E) {
                      this._emitter.removeListener(d, E);
                    }, x.prototype.start = function() {
                      this._loadSegment(0), this._enableStatisticsReporter();
                    }, x.prototype._loadSegment = function(d, E) {
                      this._currentSegmentIndex = d;
                      var D = this._mediaDataSource.segments[d], M = this._ioctl = new g.default(D, this._config, d);
                      M.onError = this._onIOException.bind(this), M.onSeeked = this._onIOSeeked.bind(this), M.onComplete = this._onIOComplete.bind(this), M.onRedirect = this._onIORedirect.bind(this), M.onRecoveredEarlyEof = this._onIORecoveredEarlyEof.bind(this), E ? this._demuxer.bindDataSource(this._ioctl) : M.onDataArrival = this._onInitChunkArrival.bind(this), M.open(E);
                    }, x.prototype.stop = function() {
                      this._internalAbort(), this._disableStatisticsReporter();
                    }, x.prototype._internalAbort = function() {
                      this._ioctl && (this._ioctl.destroy(), this._ioctl = null);
                    }, x.prototype.pause = function() {
                      this._ioctl && this._ioctl.isWorking() && (this._ioctl.pause(), this._disableStatisticsReporter());
                    }, x.prototype.resume = function() {
                      this._ioctl && this._ioctl.isPaused() && (this._ioctl.resume(), this._enableStatisticsReporter());
                    }, x.prototype.seek = function(d) {
                      if (!(this._mediaInfo == null || !this._mediaInfo.isSeekable())) {
                        var E = this._searchSegmentIndexContains(d);
                        if (E === this._currentSegmentIndex) {
                          var D = this._mediaInfo.segments[E];
                          if (D == null)
                            this._pendingSeekTime = d;
                          else {
                            var M = D.getNearestKeyframe(d);
                            this._remuxer.seek(M.milliseconds), this._ioctl.seek(M.fileposition), this._pendingResolveSeekPoint = M.milliseconds;
                          }
                        } else {
                          var C = this._mediaInfo.segments[E];
                          if (C == null)
                            this._pendingSeekTime = d, this._internalAbort(), this._remuxer.seek(), this._remuxer.insertDiscontinuity(), this._loadSegment(E);
                          else {
                            var M = C.getNearestKeyframe(d);
                            this._internalAbort(), this._remuxer.seek(d), this._remuxer.insertDiscontinuity(), this._demuxer.resetMediaInfo(), this._demuxer.timestampBase = this._mediaDataSource.segments[E].timestampBase, this._loadSegment(E, M.fileposition), this._pendingResolveSeekPoint = M.milliseconds, this._reportSegmentMediaInfo(E);
                          }
                        }
                        this._enableStatisticsReporter();
                      }
                    }, x.prototype._searchSegmentIndexContains = function(d) {
                      for (var E = this._mediaDataSource.segments, D = E.length - 1, M = 0; M < E.length; M++)
                        if (d < E[M].timestampBase) {
                          D = M - 1;
                          break;
                        }
                      return D;
                    }, x.prototype._onInitChunkArrival = function(d, E) {
                      var D = this, M = null, C = 0;
                      if (E > 0)
                        this._demuxer.bindDataSource(this._ioctl), this._demuxer.timestampBase = this._mediaDataSource.segments[this._currentSegmentIndex].timestampBase, C = this._demuxer.parseChunks(d, E);
                      else if ((M = f.default.probe(d)).match) {
                        this._demuxer = new f.default(M, this._config), this._remuxer || (this._remuxer = new p.default(this._config));
                        var I = this._mediaDataSource;
                        I.duration != null && !isNaN(I.duration) && (this._demuxer.overridedDuration = I.duration), typeof I.hasAudio == "boolean" && (this._demuxer.overridedHasAudio = I.hasAudio), typeof I.hasVideo == "boolean" && (this._demuxer.overridedHasVideo = I.hasVideo), this._demuxer.timestampBase = I.segments[this._currentSegmentIndex].timestampBase, this._demuxer.onError = this._onDemuxException.bind(this), this._demuxer.onMediaInfo = this._onMediaInfo.bind(this), this._demuxer.onMetaDataArrived = this._onMetaDataArrived.bind(this), this._demuxer.onScriptDataArrived = this._onScriptDataArrived.bind(this), this._remuxer.bindDataSource(this._demuxer.bindDataSource(this._ioctl)), this._remuxer.onInitSegment = this._onRemuxerInitSegmentArrival.bind(this), this._remuxer.onMediaSegment = this._onRemuxerMediaSegmentArrival.bind(this), C = this._demuxer.parseChunks(d, E);
                      } else
                        M = null, h.default.e(this.TAG, "Non-FLV, Unsupported media type!"), Promise.resolve().then(function() {
                          D._internalAbort();
                        }), this._emitter.emit(y.default.DEMUX_ERROR, m.default.FORMAT_UNSUPPORTED, "Non-FLV, Unsupported media type"), C = 0;
                      return C;
                    }, x.prototype._onMediaInfo = function(d) {
                      var E = this;
                      this._mediaInfo == null && (this._mediaInfo = Object.assign({}, d), this._mediaInfo.keyframesIndex = null, this._mediaInfo.segments = [], this._mediaInfo.segmentCount = this._mediaDataSource.segments.length, Object.setPrototypeOf(this._mediaInfo, u.default.prototype));
                      var D = Object.assign({}, d);
                      Object.setPrototypeOf(D, u.default.prototype), this._mediaInfo.segments[this._currentSegmentIndex] = D, this._reportSegmentMediaInfo(this._currentSegmentIndex), this._pendingSeekTime != null && Promise.resolve().then(function() {
                        var M = E._pendingSeekTime;
                        E._pendingSeekTime = null, E.seek(M);
                      });
                    }, x.prototype._onMetaDataArrived = function(d) {
                      this._emitter.emit(y.default.METADATA_ARRIVED, d);
                    }, x.prototype._onScriptDataArrived = function(d) {
                      this._emitter.emit(y.default.SCRIPTDATA_ARRIVED, d);
                    }, x.prototype._onIOSeeked = function() {
                      this._remuxer.insertDiscontinuity();
                    }, x.prototype._onIOComplete = function(d) {
                      var E = d, D = E + 1;
                      D < this._mediaDataSource.segments.length ? (this._internalAbort(), this._remuxer.flushStashedSamples(), this._loadSegment(D)) : (this._remuxer.flushStashedSamples(), this._emitter.emit(y.default.LOADING_COMPLETE), this._disableStatisticsReporter());
                    }, x.prototype._onIORedirect = function(d) {
                      var E = this._ioctl.extraData;
                      this._mediaDataSource.segments[E].redirectedURL = d;
                    }, x.prototype._onIORecoveredEarlyEof = function() {
                      this._emitter.emit(y.default.RECOVERED_EARLY_EOF);
                    }, x.prototype._onIOException = function(d, E) {
                      h.default.e(this.TAG, "IOException: type = " + d + ", code = " + E.code + ", msg = " + E.msg), this._emitter.emit(y.default.IO_ERROR, d, E), this._disableStatisticsReporter();
                    }, x.prototype._onDemuxException = function(d, E) {
                      h.default.e(this.TAG, "DemuxException: type = " + d + ", info = " + E), this._emitter.emit(y.default.DEMUX_ERROR, d, E);
                    }, x.prototype._onRemuxerInitSegmentArrival = function(d, E) {
                      this._emitter.emit(y.default.INIT_SEGMENT, d, E);
                    }, x.prototype._onRemuxerMediaSegmentArrival = function(d, E) {
                      if (this._pendingSeekTime == null && (this._emitter.emit(y.default.MEDIA_SEGMENT, d, E), this._pendingResolveSeekPoint != null && d === "video")) {
                        var D = E.info.syncPoints, M = this._pendingResolveSeekPoint;
                        this._pendingResolveSeekPoint = null, l.default.safari && D.length > 0 && D[0].originalDts === M && (M = D[0].pts), this._emitter.emit(y.default.RECOMMEND_SEEKPOINT, M);
                      }
                    }, x.prototype._enableStatisticsReporter = function() {
                      this._statisticsReporter == null && (this._statisticsReporter = self.setInterval(this._reportStatisticsInfo.bind(this), this._config.statisticsInfoReportInterval));
                    }, x.prototype._disableStatisticsReporter = function() {
                      this._statisticsReporter && (self.clearInterval(this._statisticsReporter), this._statisticsReporter = null);
                    }, x.prototype._reportSegmentMediaInfo = function(d) {
                      var E = this._mediaInfo.segments[d], D = Object.assign({}, E);
                      D.duration = this._mediaInfo.duration, D.segmentCount = this._mediaInfo.segmentCount, delete D.segments, delete D.keyframesIndex, this._emitter.emit(y.default.MEDIA_INFO, D);
                    }, x.prototype._reportStatisticsInfo = function() {
                      var d = {};
                      d.url = this._ioctl.currentURL, d.hasRedirect = this._ioctl.hasRedirect, d.hasRedirect && (d.redirectedURL = this._ioctl.currentRedirectedURL), d.speed = this._ioctl.currentSpeed, d.loaderType = this._ioctl.loaderType, d.currentSegmentIndex = this._currentSegmentIndex, d.totalSegmentCount = this._mediaDataSource.segments.length, this._emitter.emit(y.default.STATISTICS_INFO, d);
                    }, x;
                  }()
                );
                w.default = _;
              }
            ),
            /***/
            "./src/core/transmuxing-events.js": (
              /*!****************************************!*\
                !*** ./src/core/transmuxing-events.js ***!
                \****************************************/
              /***/
              function(T, w, O) {
                O.r(w);
                var R = {
                  IO_ERROR: "io_error",
                  DEMUX_ERROR: "demux_error",
                  INIT_SEGMENT: "init_segment",
                  MEDIA_SEGMENT: "media_segment",
                  LOADING_COMPLETE: "loading_complete",
                  RECOVERED_EARLY_EOF: "recovered_early_eof",
                  MEDIA_INFO: "media_info",
                  METADATA_ARRIVED: "metadata_arrived",
                  SCRIPTDATA_ARRIVED: "scriptdata_arrived",
                  STATISTICS_INFO: "statistics_info",
                  RECOMMEND_SEEKPOINT: "recommend_seekpoint"
                };
                w.default = R;
              }
            ),
            /***/
            "./src/core/transmuxing-worker.js": (
              /*!****************************************!*\
                !*** ./src/core/transmuxing-worker.js ***!
                \****************************************/
              /***/
              function(T, w, O) {
                O.r(w);
                var R = O(
                  /*! ../utils/logging-control.js */
                  "./src/utils/logging-control.js"
                ), v = O(
                  /*! ../utils/polyfill.js */
                  "./src/utils/polyfill.js"
                ), h = O(
                  /*! ./transmuxing-controller.js */
                  "./src/core/transmuxing-controller.js"
                ), l = O(
                  /*! ./transmuxing-events.js */
                  "./src/core/transmuxing-events.js"
                ), u = function(f) {
                  var p = null, m = F.bind(this);
                  v.default.install(), f.addEventListener("message", function(L) {
                    switch (L.data.cmd) {
                      case "init":
                        p = new h.default(L.data.param[0], L.data.param[1]), p.on(l.default.IO_ERROR, C.bind(this)), p.on(l.default.DEMUX_ERROR, I.bind(this)), p.on(l.default.INIT_SEGMENT, g.bind(this)), p.on(l.default.MEDIA_SEGMENT, y.bind(this)), p.on(l.default.LOADING_COMPLETE, _.bind(this)), p.on(l.default.RECOVERED_EARLY_EOF, x.bind(this)), p.on(l.default.MEDIA_INFO, d.bind(this)), p.on(l.default.METADATA_ARRIVED, E.bind(this)), p.on(l.default.SCRIPTDATA_ARRIVED, D.bind(this)), p.on(l.default.STATISTICS_INFO, M.bind(this)), p.on(l.default.RECOMMEND_SEEKPOINT, k.bind(this));
                        break;
                      case "destroy":
                        p && (p.destroy(), p = null), f.postMessage({ msg: "destroyed" });
                        break;
                      case "start":
                        p.start();
                        break;
                      case "stop":
                        p.stop();
                        break;
                      case "seek":
                        p.seek(L.data.param);
                        break;
                      case "pause":
                        p.pause();
                        break;
                      case "resume":
                        p.resume();
                        break;
                      case "logging_config": {
                        var U = L.data.param;
                        R.default.applyConfig(U), U.enableCallback === !0 ? R.default.addLogListener(m) : R.default.removeLogListener(m);
                        break;
                      }
                    }
                  });
                  function g(L, U) {
                    var j = {
                      msg: l.default.INIT_SEGMENT,
                      data: {
                        type: L,
                        data: U
                      }
                    };
                    f.postMessage(j, [U.data]);
                  }
                  function y(L, U) {
                    var j = {
                      msg: l.default.MEDIA_SEGMENT,
                      data: {
                        type: L,
                        data: U
                      }
                    };
                    f.postMessage(j, [U.data]);
                  }
                  function _() {
                    var L = {
                      msg: l.default.LOADING_COMPLETE
                    };
                    f.postMessage(L);
                  }
                  function x() {
                    var L = {
                      msg: l.default.RECOVERED_EARLY_EOF
                    };
                    f.postMessage(L);
                  }
                  function d(L) {
                    var U = {
                      msg: l.default.MEDIA_INFO,
                      data: L
                    };
                    f.postMessage(U);
                  }
                  function E(L) {
                    var U = {
                      msg: l.default.METADATA_ARRIVED,
                      data: L
                    };
                    f.postMessage(U);
                  }
                  function D(L) {
                    var U = {
                      msg: l.default.SCRIPTDATA_ARRIVED,
                      data: L
                    };
                    f.postMessage(U);
                  }
                  function M(L) {
                    var U = {
                      msg: l.default.STATISTICS_INFO,
                      data: L
                    };
                    f.postMessage(U);
                  }
                  function C(L, U) {
                    f.postMessage({
                      msg: l.default.IO_ERROR,
                      data: {
                        type: L,
                        info: U
                      }
                    });
                  }
                  function I(L, U) {
                    f.postMessage({
                      msg: l.default.DEMUX_ERROR,
                      data: {
                        type: L,
                        info: U
                      }
                    });
                  }
                  function k(L) {
                    f.postMessage({
                      msg: l.default.RECOMMEND_SEEKPOINT,
                      data: L
                    });
                  }
                  function F(L, U) {
                    f.postMessage({
                      msg: "logcat_callback",
                      data: {
                        type: L,
                        logcat: U
                      }
                    });
                  }
                };
                w.default = u;
              }
            ),
            /***/
            "./src/demux/amf-parser.js": (
              /*!*********************************!*\
                !*** ./src/demux/amf-parser.js ***!
                \*********************************/
              /***/
              function(T, w, O) {
                O.r(w);
                var R = O(
                  /*! ../utils/logger.js */
                  "./src/utils/logger.js"
                ), v = O(
                  /*! ../utils/utf8-conv.js */
                  "./src/utils/utf8-conv.js"
                ), h = O(
                  /*! ../utils/exception.js */
                  "./src/utils/exception.js"
                ), l = function() {
                  var f = new ArrayBuffer(2);
                  return new DataView(f).setInt16(0, 256, !0), new Int16Array(f)[0] === 256;
                }(), u = (
                  /** @class */
                  function() {
                    function f() {
                    }
                    return f.parseScriptData = function(p, m, g) {
                      var y = {};
                      try {
                        var _ = f.parseValue(p, m, g), x = f.parseValue(p, m + _.size, g - _.size);
                        y[_.data] = x.data;
                      } catch (d) {
                        R.default.e("AMF", d.toString());
                      }
                      return y;
                    }, f.parseObject = function(p, m, g) {
                      if (g < 3)
                        throw new h.IllegalStateException("Data not enough when parse ScriptDataObject");
                      var y = f.parseString(p, m, g), _ = f.parseValue(p, m + y.size, g - y.size), x = _.objectEnd;
                      return {
                        data: {
                          name: y.data,
                          value: _.data
                        },
                        size: y.size + _.size,
                        objectEnd: x
                      };
                    }, f.parseVariable = function(p, m, g) {
                      return f.parseObject(p, m, g);
                    }, f.parseString = function(p, m, g) {
                      if (g < 2)
                        throw new h.IllegalStateException("Data not enough when parse String");
                      var y = new DataView(p, m, g), _ = y.getUint16(0, !l), x;
                      return _ > 0 ? x = (0, v.default)(new Uint8Array(p, m + 2, _)) : x = "", {
                        data: x,
                        size: 2 + _
                      };
                    }, f.parseLongString = function(p, m, g) {
                      if (g < 4)
                        throw new h.IllegalStateException("Data not enough when parse LongString");
                      var y = new DataView(p, m, g), _ = y.getUint32(0, !l), x;
                      return _ > 0 ? x = (0, v.default)(new Uint8Array(p, m + 4, _)) : x = "", {
                        data: x,
                        size: 4 + _
                      };
                    }, f.parseDate = function(p, m, g) {
                      if (g < 10)
                        throw new h.IllegalStateException("Data size invalid when parse Date");
                      var y = new DataView(p, m, g), _ = y.getFloat64(0, !l), x = y.getInt16(8, !l);
                      return _ += x * 60 * 1e3, {
                        data: new Date(_),
                        size: 8 + 2
                      };
                    }, f.parseValue = function(p, m, g) {
                      if (g < 1)
                        throw new h.IllegalStateException("Data not enough when parse Value");
                      var y = new DataView(p, m, g), _ = 1, x = y.getUint8(0), d, E = !1;
                      try {
                        switch (x) {
                          case 0:
                            d = y.getFloat64(1, !l), _ += 8;
                            break;
                          case 1: {
                            var D = y.getUint8(1);
                            d = !!D, _ += 1;
                            break;
                          }
                          case 2: {
                            var M = f.parseString(p, m + 1, g - 1);
                            d = M.data, _ += M.size;
                            break;
                          }
                          case 3: {
                            d = {};
                            var C = 0;
                            for ((y.getUint32(g - 4, !l) & 16777215) === 9 && (C = 3); _ < g - 4; ) {
                              var I = f.parseObject(p, m + _, g - _ - C);
                              if (I.objectEnd)
                                break;
                              d[I.data.name] = I.data.value, _ += I.size;
                            }
                            if (_ <= g - 3) {
                              var k = y.getUint32(_ - 1, !l) & 16777215;
                              k === 9 && (_ += 3);
                            }
                            break;
                          }
                          case 8: {
                            d = {}, _ += 4;
                            var C = 0;
                            for ((y.getUint32(g - 4, !l) & 16777215) === 9 && (C = 3); _ < g - 8; ) {
                              var F = f.parseVariable(p, m + _, g - _ - C);
                              if (F.objectEnd)
                                break;
                              d[F.data.name] = F.data.value, _ += F.size;
                            }
                            if (_ <= g - 3) {
                              var k = y.getUint32(_ - 1, !l) & 16777215;
                              k === 9 && (_ += 3);
                            }
                            break;
                          }
                          case 9:
                            d = void 0, _ = 1, E = !0;
                            break;
                          case 10: {
                            d = [];
                            var L = y.getUint32(1, !l);
                            _ += 4;
                            for (var U = 0; U < L; U++) {
                              var j = f.parseValue(p, m + _, g - _);
                              d.push(j.data), _ += j.size;
                            }
                            break;
                          }
                          case 11: {
                            var G = f.parseDate(p, m + 1, g - 1);
                            d = G.data, _ += G.size;
                            break;
                          }
                          case 12: {
                            var B = f.parseString(p, m + 1, g - 1);
                            d = B.data, _ += B.size;
                            break;
                          }
                          default:
                            _ = g, R.default.w("AMF", "Unsupported AMF value type " + x);
                        }
                      } catch (re) {
                        R.default.e("AMF", re.toString());
                      }
                      return {
                        data: d,
                        size: _,
                        objectEnd: E
                      };
                    }, f;
                  }()
                );
                w.default = u;
              }
            ),
            /***/
            "./src/demux/demux-errors.js": (
              /*!***********************************!*\
                !*** ./src/demux/demux-errors.js ***!
                \***********************************/
              /***/
              function(T, w, O) {
                O.r(w);
                var R = {
                  OK: "OK",
                  FORMAT_ERROR: "FormatError",
                  FORMAT_UNSUPPORTED: "FormatUnsupported",
                  CODEC_UNSUPPORTED: "CodecUnsupported"
                };
                w.default = R;
              }
            ),
            /***/
            "./src/demux/exp-golomb.js": (
              /*!*********************************!*\
                !*** ./src/demux/exp-golomb.js ***!
                \*********************************/
              /***/
              function(T, w, O) {
                O.r(w);
                var R = O(
                  /*! ../utils/exception.js */
                  "./src/utils/exception.js"
                ), v = (
                  /** @class */
                  function() {
                    function h(l) {
                      this.TAG = "ExpGolomb", this._buffer = l, this._buffer_index = 0, this._total_bytes = l.byteLength, this._total_bits = l.byteLength * 8, this._current_word = 0, this._current_word_bits_left = 0;
                    }
                    return h.prototype.destroy = function() {
                      this._buffer = null;
                    }, h.prototype._fillCurrentWord = function() {
                      var l = this._total_bytes - this._buffer_index;
                      if (l <= 0)
                        throw new R.IllegalStateException("ExpGolomb: _fillCurrentWord() but no bytes available");
                      var u = Math.min(4, l), f = new Uint8Array(4);
                      f.set(this._buffer.subarray(this._buffer_index, this._buffer_index + u)), this._current_word = new DataView(f.buffer).getUint32(0, !1), this._buffer_index += u, this._current_word_bits_left = u * 8;
                    }, h.prototype.readBits = function(l) {
                      if (l > 32)
                        throw new R.InvalidArgumentException("ExpGolomb: readBits() bits exceeded max 32bits!");
                      if (l <= this._current_word_bits_left) {
                        var u = this._current_word >>> 32 - l;
                        return this._current_word <<= l, this._current_word_bits_left -= l, u;
                      }
                      var f = this._current_word_bits_left ? this._current_word : 0;
                      f = f >>> 32 - this._current_word_bits_left;
                      var p = l - this._current_word_bits_left;
                      this._fillCurrentWord();
                      var m = Math.min(p, this._current_word_bits_left), g = this._current_word >>> 32 - m;
                      return this._current_word <<= m, this._current_word_bits_left -= m, f = f << m | g, f;
                    }, h.prototype.readBool = function() {
                      return this.readBits(1) === 1;
                    }, h.prototype.readByte = function() {
                      return this.readBits(8);
                    }, h.prototype._skipLeadingZero = function() {
                      var l;
                      for (l = 0; l < this._current_word_bits_left; l++)
                        if (this._current_word & 2147483648 >>> l)
                          return this._current_word <<= l, this._current_word_bits_left -= l, l;
                      return this._fillCurrentWord(), l + this._skipLeadingZero();
                    }, h.prototype.readUEG = function() {
                      var l = this._skipLeadingZero();
                      return this.readBits(l + 1) - 1;
                    }, h.prototype.readSEG = function() {
                      var l = this.readUEG();
                      return l & 1 ? l + 1 >>> 1 : -1 * (l >>> 1);
                    }, h;
                  }()
                );
                w.default = v;
              }
            ),
            /***/
            "./src/demux/flv-demuxer.js": (
              /*!**********************************!*\
                !*** ./src/demux/flv-demuxer.js ***!
                \**********************************/
              /***/
              function(T, w, O) {
                O.r(w);
                var R = O(
                  /*! ../utils/logger.js */
                  "./src/utils/logger.js"
                ), v = O(
                  /*! ./amf-parser.js */
                  "./src/demux/amf-parser.js"
                ), h = O(
                  /*! ./sps-parser.js */
                  "./src/demux/sps-parser.js"
                ), l = O(
                  /*! ./hevc-sps-parser.js */
                  "./src/demux/hevc-sps-parser.js"
                ), u = O(
                  /*! ./demux-errors.js */
                  "./src/demux/demux-errors.js"
                ), f = O(
                  /*! ../core/media-info.js */
                  "./src/core/media-info.js"
                ), p = O(
                  /*! ../utils/exception.js */
                  "./src/utils/exception.js"
                );
                function m(y, _) {
                  return y[_] << 24 | y[_ + 1] << 16 | y[_ + 2] << 8 | y[_ + 3];
                }
                var g = (
                  /** @class */
                  function() {
                    function y(_, x) {
                      this.TAG = "FLVDemuxer", this._config = x, this._onError = null, this._onMediaInfo = null, this._onMetaDataArrived = null, this._onScriptDataArrived = null, this._onTrackMetadata = null, this._onDataAvailable = null, this._dataOffset = _.dataOffset, this._firstParse = !0, this._dispatch = !1, this._hasAudio = _.hasAudioTrack, this._hasVideo = _.hasVideoTrack, this._hasAudioFlagOverrided = !1, this._hasVideoFlagOverrided = !1, this._audioInitialMetadataDispatched = !1, this._videoInitialMetadataDispatched = !1, this._mediaInfo = new f.default(), this._mediaInfo.hasAudio = this._hasAudio, this._mediaInfo.hasVideo = this._hasVideo, this._metadata = null, this._audioMetadata = null, this._videoMetadata = null, this._naluLengthSize = 4, this._timestampBase = 0, this._timescale = 1e3, this._duration = 0, this._durationOverrided = !1, this._referenceFrameRate = {
                        fixed: !0,
                        fps: 23.976,
                        fps_num: 23976,
                        fps_den: 1e3
                      }, this._flvSoundRateTable = [5500, 11025, 22050, 44100, 48e3], this._mpegSamplingRates = [
                        96e3,
                        88200,
                        64e3,
                        48e3,
                        44100,
                        32e3,
                        24e3,
                        22050,
                        16e3,
                        12e3,
                        11025,
                        8e3,
                        7350
                      ], this._mpegAudioV10SampleRateTable = [44100, 48e3, 32e3, 0], this._mpegAudioV20SampleRateTable = [22050, 24e3, 16e3, 0], this._mpegAudioV25SampleRateTable = [11025, 12e3, 8e3, 0], this._mpegAudioL1BitRateTable = [0, 32, 64, 96, 128, 160, 192, 224, 256, 288, 320, 352, 384, 416, 448, -1], this._mpegAudioL2BitRateTable = [0, 32, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 384, -1], this._mpegAudioL3BitRateTable = [0, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, -1], this._videoTrack = { type: "video", id: 1, sequenceNumber: 0, samples: [], length: 0 }, this._audioTrack = { type: "audio", id: 2, sequenceNumber: 0, samples: [], length: 0 }, this._littleEndian = function() {
                        var d = new ArrayBuffer(2);
                        return new DataView(d).setInt16(0, 256, !0), new Int16Array(d)[0] === 256;
                      }();
                    }
                    return y.prototype.destroy = function() {
                      this._mediaInfo = null, this._metadata = null, this._audioMetadata = null, this._videoMetadata = null, this._videoTrack = null, this._audioTrack = null, this._onError = null, this._onMediaInfo = null, this._onMetaDataArrived = null, this._onScriptDataArrived = null, this._onTrackMetadata = null, this._onDataAvailable = null;
                    }, y.probe = function(_) {
                      var x = new Uint8Array(_), d = { match: !1 };
                      if (x.byteLength < 4 || x[0] !== 70 || x[1] !== 76 || x[2] !== 86 || x[3] !== 1)
                        return d;
                      var E = (x[4] & 4) >>> 2 !== 0, D = (x[4] & 1) !== 0, M = m(x, 5);
                      return M < 9 ? d : {
                        match: !0,
                        consumed: M,
                        dataOffset: M,
                        hasAudioTrack: E,
                        hasVideoTrack: D
                      };
                    }, y.prototype.bindDataSource = function(_) {
                      return _.onDataArrival = this.parseChunks.bind(this), this;
                    }, Object.defineProperty(y.prototype, "onTrackMetadata", {
                      // prototype: function(type: string, metadata: any): void
                      get: function() {
                        return this._onTrackMetadata;
                      },
                      set: function(_) {
                        this._onTrackMetadata = _;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(y.prototype, "onMediaInfo", {
                      // prototype: function(mediaInfo: MediaInfo): void
                      get: function() {
                        return this._onMediaInfo;
                      },
                      set: function(_) {
                        this._onMediaInfo = _;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(y.prototype, "onMetaDataArrived", {
                      get: function() {
                        return this._onMetaDataArrived;
                      },
                      set: function(_) {
                        this._onMetaDataArrived = _;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(y.prototype, "onScriptDataArrived", {
                      get: function() {
                        return this._onScriptDataArrived;
                      },
                      set: function(_) {
                        this._onScriptDataArrived = _;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(y.prototype, "onError", {
                      // prototype: function(type: number, info: string): void
                      get: function() {
                        return this._onError;
                      },
                      set: function(_) {
                        this._onError = _;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(y.prototype, "onDataAvailable", {
                      // prototype: function(videoTrack: any, audioTrack: any): void
                      get: function() {
                        return this._onDataAvailable;
                      },
                      set: function(_) {
                        this._onDataAvailable = _;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(y.prototype, "timestampBase", {
                      // timestamp base for output samples, must be in milliseconds
                      get: function() {
                        return this._timestampBase;
                      },
                      set: function(_) {
                        this._timestampBase = _;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(y.prototype, "overridedDuration", {
                      get: function() {
                        return this._duration;
                      },
                      // Force-override media duration. Must be in milliseconds, int32
                      set: function(_) {
                        this._durationOverrided = !0, this._duration = _, this._mediaInfo.duration = _;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(y.prototype, "overridedHasAudio", {
                      // Force-override audio track present flag, boolean
                      set: function(_) {
                        this._hasAudioFlagOverrided = !0, this._hasAudio = _, this._mediaInfo.hasAudio = _;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(y.prototype, "overridedHasVideo", {
                      // Force-override video track present flag, boolean
                      set: function(_) {
                        this._hasVideoFlagOverrided = !0, this._hasVideo = _, this._mediaInfo.hasVideo = _;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), y.prototype.resetMediaInfo = function() {
                      this._mediaInfo = new f.default();
                    }, y.prototype._isInitialMetadataDispatched = function() {
                      return this._hasAudio && this._hasVideo ? this._audioInitialMetadataDispatched && this._videoInitialMetadataDispatched : this._hasAudio && !this._hasVideo ? this._audioInitialMetadataDispatched : !this._hasAudio && this._hasVideo ? this._videoInitialMetadataDispatched : !1;
                    }, y.prototype.parseChunks = function(_, x) {
                      if (!this._onError || !this._onMediaInfo || !this._onTrackMetadata || !this._onDataAvailable)
                        throw new p.IllegalStateException("Flv: onError & onMediaInfo & onTrackMetadata & onDataAvailable callback must be specified");
                      var d = 0, E = this._littleEndian;
                      if (x === 0)
                        if (_.byteLength > 13) {
                          var D = y.probe(_);
                          d = D.dataOffset;
                        } else
                          return 0;
                      if (this._firstParse) {
                        this._firstParse = !1, x + d !== this._dataOffset && R.default.w(this.TAG, "First time parsing but chunk byteStart invalid!");
                        var M = new DataView(_, d), C = M.getUint32(0, !E);
                        C !== 0 && R.default.w(this.TAG, "PrevTagSize0 !== 0 !!!"), d += 4;
                      }
                      for (; d < _.byteLength; ) {
                        this._dispatch = !0;
                        var M = new DataView(_, d);
                        if (d + 11 + 4 > _.byteLength)
                          break;
                        var I = M.getUint8(0), k = M.getUint32(0, !E) & 16777215;
                        if (d + 11 + k + 4 > _.byteLength)
                          break;
                        if (I !== 8 && I !== 9 && I !== 18) {
                          R.default.w(this.TAG, "Unsupported tag type " + I + ", skipped"), d += 11 + k + 4;
                          continue;
                        }
                        var F = M.getUint8(4), L = M.getUint8(5), U = M.getUint8(6), j = M.getUint8(7), G = U | L << 8 | F << 16 | j << 24, B = M.getUint32(7, !E) & 16777215;
                        B !== 0 && R.default.w(this.TAG, "Meet tag which has StreamID != 0!");
                        var re = d + 11;
                        switch (I) {
                          case 8:
                            this._parseAudioData(_, re, k, G);
                            break;
                          case 9:
                            this._parseVideoData(_, re, k, G, x + d);
                            break;
                          case 18:
                            this._parseScriptData(_, re, k);
                            break;
                        }
                        var le = M.getUint32(11 + k, !E);
                        le !== 11 + k && R.default.w(this.TAG, "Invalid PrevTagSize " + le), d += 11 + k + 4;
                      }
                      return this._isInitialMetadataDispatched() && this._dispatch && (this._audioTrack.length || this._videoTrack.length) && this._onDataAvailable(this._audioTrack, this._videoTrack), d;
                    }, y.prototype._parseScriptData = function(_, x, d) {
                      var E = v.default.parseScriptData(_, x, d);
                      if (E.hasOwnProperty("onMetaData")) {
                        if (E.onMetaData == null || typeof E.onMetaData != "object") {
                          R.default.w(this.TAG, "Invalid onMetaData structure!");
                          return;
                        }
                        this._metadata && R.default.w(this.TAG, "Found another onMetaData tag!"), this._metadata = E;
                        var D = this._metadata.onMetaData;
                        if (this._onMetaDataArrived && this._onMetaDataArrived(Object.assign({}, D)), typeof D.hasAudio == "boolean" && this._hasAudioFlagOverrided === !1 && (this._hasAudio = D.hasAudio, this._mediaInfo.hasAudio = this._hasAudio), typeof D.hasVideo == "boolean" && this._hasVideoFlagOverrided === !1 && (this._hasVideo = D.hasVideo, this._mediaInfo.hasVideo = this._hasVideo), typeof D.audiodatarate == "number" && (this._mediaInfo.audioDataRate = D.audiodatarate), typeof D.videodatarate == "number" && (this._mediaInfo.videoDataRate = D.videodatarate), typeof D.width == "number" && (this._mediaInfo.width = D.width), typeof D.height == "number" && (this._mediaInfo.height = D.height), typeof D.duration == "number") {
                          if (!this._durationOverrided) {
                            var M = Math.floor(D.duration * this._timescale);
                            this._duration = M, this._mediaInfo.duration = M;
                          }
                        } else
                          this._mediaInfo.duration = 0;
                        if (typeof D.framerate == "number") {
                          var C = Math.floor(D.framerate * 1e3);
                          if (C > 0) {
                            var I = C / 1e3;
                            this._referenceFrameRate.fixed = !0, this._referenceFrameRate.fps = I, this._referenceFrameRate.fps_num = C, this._referenceFrameRate.fps_den = 1e3, this._mediaInfo.fps = I;
                          }
                        }
                        if (typeof D.keyframes == "object") {
                          this._mediaInfo.hasKeyframesIndex = !0;
                          var k = D.keyframes;
                          this._mediaInfo.keyframesIndex = this._parseKeyframesIndex(k), D.keyframes = null;
                        } else
                          this._mediaInfo.hasKeyframesIndex = !1;
                        this._dispatch = !1, this._mediaInfo.metadata = D, R.default.v(this.TAG, "Parsed onMetaData"), this._mediaInfo.isComplete() && this._onMediaInfo(this._mediaInfo);
                      }
                      Object.keys(E).length > 0 && this._onScriptDataArrived && this._onScriptDataArrived(Object.assign({}, E));
                    }, y.prototype._parseKeyframesIndex = function(_) {
                      for (var x = [], d = [], E = 1; E < _.times.length; E++) {
                        var D = this._timestampBase + Math.floor(_.times[E] * 1e3);
                        x.push(D), d.push(_.filepositions[E]);
                      }
                      return {
                        times: x,
                        filepositions: d
                      };
                    }, y.prototype._parseAudioData = function(_, x, d, E) {
                      if (d <= 1) {
                        R.default.w(this.TAG, "Flv: Invalid audio packet, missing SoundData payload!");
                        return;
                      }
                      if (!(this._hasAudioFlagOverrided === !0 && this._hasAudio === !1)) {
                        this._littleEndian;
                        var D = new DataView(_, x, d), M = D.getUint8(0), C = M >>> 4;
                        if (C !== 2 && C !== 10) {
                          this._onError(u.default.CODEC_UNSUPPORTED, "Flv: Unsupported audio codec idx: " + C);
                          return;
                        }
                        var I = 0, k = (M & 12) >>> 2;
                        if (k >= 0 && k <= 4)
                          I = this._flvSoundRateTable[k];
                        else {
                          this._onError(u.default.FORMAT_ERROR, "Flv: Invalid audio sample rate idx: " + k);
                          return;
                        }
                        var F = M & 1, L = this._audioMetadata, U = this._audioTrack;
                        if (L || (this._hasAudio === !1 && this._hasAudioFlagOverrided === !1 && (this._hasAudio = !0, this._mediaInfo.hasAudio = !0), L = this._audioMetadata = {}, L.type = "audio", L.id = U.id, L.timescale = this._timescale, L.duration = this._duration, L.audioSampleRate = I, L.channelCount = F === 0 ? 1 : 2), C === 10) {
                          var j = this._parseAACAudioData(_, x + 1, d - 1);
                          if (j == null)
                            return;
                          if (j.packetType === 0) {
                            L.config && R.default.w(this.TAG, "Found another AudioSpecificConfig!");
                            var G = j.data;
                            L.audioSampleRate = G.samplingRate, L.channelCount = G.channelCount, L.codec = G.codec, L.originalCodec = G.originalCodec, L.config = G.config, L.refSampleDuration = 1024 / L.audioSampleRate * L.timescale, R.default.v(this.TAG, "Parsed AudioSpecificConfig"), this._isInitialMetadataDispatched() ? this._dispatch && (this._audioTrack.length || this._videoTrack.length) && this._onDataAvailable(this._audioTrack, this._videoTrack) : this._audioInitialMetadataDispatched = !0, this._dispatch = !1, this._onTrackMetadata("audio", L);
                            var B = this._mediaInfo;
                            B.audioCodec = L.originalCodec, B.audioSampleRate = L.audioSampleRate, B.audioChannelCount = L.channelCount, B.hasVideo ? B.videoCodec != null && (B.mimeType = 'video/x-flv; codecs="' + B.videoCodec + "," + B.audioCodec + '"') : B.mimeType = 'video/x-flv; codecs="' + B.audioCodec + '"', B.isComplete() && this._onMediaInfo(B);
                          } else if (j.packetType === 1) {
                            var re = this._timestampBase + E, le = { unit: j.data, length: j.data.byteLength, dts: re, pts: re };
                            U.samples.push(le), U.length += j.data.length;
                          } else
                            R.default.e(this.TAG, "Flv: Unsupported AAC data type " + j.packetType);
                        } else if (C === 2) {
                          if (!L.codec) {
                            var G = this._parseMP3AudioData(_, x + 1, d - 1, !0);
                            if (G == null)
                              return;
                            L.audioSampleRate = G.samplingRate, L.channelCount = G.channelCount, L.codec = G.codec, L.originalCodec = G.originalCodec, L.refSampleDuration = 1152 / L.audioSampleRate * L.timescale, R.default.v(this.TAG, "Parsed MPEG Audio Frame Header"), this._audioInitialMetadataDispatched = !0, this._onTrackMetadata("audio", L);
                            var B = this._mediaInfo;
                            B.audioCodec = L.codec, B.audioSampleRate = L.audioSampleRate, B.audioChannelCount = L.channelCount, B.audioDataRate = G.bitRate, B.hasVideo ? B.videoCodec != null && (B.mimeType = 'video/x-flv; codecs="' + B.videoCodec + "," + B.audioCodec + '"') : B.mimeType = 'video/x-flv; codecs="' + B.audioCodec + '"', B.isComplete() && this._onMediaInfo(B);
                          }
                          var Q = this._parseMP3AudioData(_, x + 1, d - 1, !1);
                          if (Q == null)
                            return;
                          var re = this._timestampBase + E, ue = { unit: Q, length: Q.byteLength, dts: re, pts: re };
                          U.samples.push(ue), U.length += Q.length;
                        }
                      }
                    }, y.prototype._parseAACAudioData = function(_, x, d) {
                      if (d <= 1) {
                        R.default.w(this.TAG, "Flv: Invalid AAC packet, missing AACPacketType or/and Data!");
                        return;
                      }
                      var E = {}, D = new Uint8Array(_, x, d);
                      return E.packetType = D[0], D[0] === 0 ? E.data = this._parseAACAudioSpecificConfig(_, x + 1, d - 1) : E.data = D.subarray(1), E;
                    }, y.prototype._parseAACAudioSpecificConfig = function(_, x, d) {
                      var E = new Uint8Array(_, x, d), D = null, M = 0, C = 0, I = 0, k = null;
                      if (M = C = E[0] >>> 3, I = (E[0] & 7) << 1 | E[1] >>> 7, I < 0 || I >= this._mpegSamplingRates.length) {
                        this._onError(u.default.FORMAT_ERROR, "Flv: AAC invalid sampling frequency index!");
                        return;
                      }
                      var F = this._mpegSamplingRates[I], L = (E[1] & 120) >>> 3;
                      if (L < 0 || L >= 8) {
                        this._onError(u.default.FORMAT_ERROR, "Flv: AAC invalid channel configuration");
                        return;
                      }
                      M === 5 && (k = (E[1] & 7) << 1 | E[2] >>> 7, (E[2] & 124) >>> 2);
                      var U = self.navigator.userAgent.toLowerCase();
                      return U.indexOf("firefox") !== -1 ? I >= 6 ? (M = 5, D = new Array(4), k = I - 3) : (M = 2, D = new Array(2), k = I) : U.indexOf("android") !== -1 ? (M = 2, D = new Array(2), k = I) : (M = 5, k = I, D = new Array(4), I >= 6 ? k = I - 3 : L === 1 && (M = 2, D = new Array(2), k = I)), D[0] = M << 3, D[0] |= (I & 15) >>> 1, D[1] = (I & 15) << 7, D[1] |= (L & 15) << 3, M === 5 && (D[1] |= (k & 15) >>> 1, D[2] = (k & 1) << 7, D[2] |= 8, D[3] = 0), {
                        config: D,
                        samplingRate: F,
                        channelCount: L,
                        codec: "mp4a.40." + M,
                        originalCodec: "mp4a.40." + C
                      };
                    }, y.prototype._parseMP3AudioData = function(_, x, d, E) {
                      if (d < 4) {
                        R.default.w(this.TAG, "Flv: Invalid MP3 packet, header missing!");
                        return;
                      }
                      this._littleEndian;
                      var D = new Uint8Array(_, x, d), M = null;
                      if (E) {
                        if (D[0] !== 255)
                          return;
                        var C = D[1] >>> 3 & 3, I = (D[1] & 6) >> 1, k = (D[2] & 240) >>> 4, F = (D[2] & 12) >>> 2, L = D[3] >>> 6 & 3, U = L !== 3 ? 2 : 1, j = 0, G = 0, B = "mp3";
                        switch (C) {
                          case 0:
                            j = this._mpegAudioV25SampleRateTable[F];
                            break;
                          case 2:
                            j = this._mpegAudioV20SampleRateTable[F];
                            break;
                          case 3:
                            j = this._mpegAudioV10SampleRateTable[F];
                            break;
                        }
                        switch (I) {
                          case 1:
                            k < this._mpegAudioL3BitRateTable.length && (G = this._mpegAudioL3BitRateTable[k]);
                            break;
                          case 2:
                            k < this._mpegAudioL2BitRateTable.length && (G = this._mpegAudioL2BitRateTable[k]);
                            break;
                          case 3:
                            k < this._mpegAudioL1BitRateTable.length && (G = this._mpegAudioL1BitRateTable[k]);
                            break;
                        }
                        M = {
                          bitRate: G,
                          samplingRate: j,
                          channelCount: U,
                          codec: B,
                          originalCodec: B
                        };
                      } else
                        M = D;
                      return M;
                    }, y.prototype._parseVideoData = function(_, x, d, E, D) {
                      if (d <= 1) {
                        R.default.w(this.TAG, "Flv: Invalid video packet, missing VideoData payload!");
                        return;
                      }
                      if (!(this._hasVideoFlagOverrided === !0 && this._hasVideo === !1)) {
                        var M = new Uint8Array(_, x, d)[0], C = (M & 240) >>> 4, I = M & 15;
                        if (I === 7)
                          this._parseAVCVideoPacket(_, x + 1, d - 1, E, D, C);
                        else if (I === 12)
                          this._parseHVCVideoPacket(_, x + 1, d - 1, E, D, C);
                        else {
                          this._onError(u.default.CODEC_UNSUPPORTED, "Flv: Unsupported codec in video frame: " + I);
                          return;
                        }
                      }
                    }, y.prototype._parseAVCVideoPacket = function(_, x, d, E, D, M) {
                      if (d < 4) {
                        R.default.w(this.TAG, "Flv: Invalid AVC packet, missing AVCPacketType or/and CompositionTime");
                        return;
                      }
                      var C = this._littleEndian, I = new DataView(_, x, d), k = I.getUint8(0), F = I.getUint32(0, !C) & 16777215, L = F << 8 >> 8;
                      if (k === 0)
                        this._parseAVCDecoderConfigurationRecord(_, x + 4, d - 4);
                      else if (k === 1)
                        this._parseAVCVideoData(_, x + 4, d - 4, E, D, M, L);
                      else if (k !== 2) {
                        this._onError(u.default.FORMAT_ERROR, "Flv: Invalid video packet type " + k);
                        return;
                      }
                    }, y.prototype._parseAVCDecoderConfigurationRecord = function(_, x, d) {
                      if (d < 7) {
                        R.default.w(this.TAG, "Flv: Invalid AVCDecoderConfigurationRecord, lack of data!");
                        return;
                      }
                      var E = this._videoMetadata, D = this._videoTrack, M = this._littleEndian, C = new DataView(_, x, d);
                      E ? typeof E.avcc < "u" && R.default.w(this.TAG, "Found another AVCDecoderConfigurationRecord!") : (this._hasVideo === !1 && this._hasVideoFlagOverrided === !1 && (this._hasVideo = !0, this._mediaInfo.hasVideo = !0), E = this._videoMetadata = {}, E.type = "video", E.id = D.id, E.timescale = this._timescale, E.duration = this._duration);
                      var I = C.getUint8(0), k = C.getUint8(1);
                      if (C.getUint8(2), C.getUint8(3), I !== 1 || k === 0) {
                        this._onError(u.default.FORMAT_ERROR, "Flv: Invalid AVCDecoderConfigurationRecord");
                        return;
                      }
                      if (this._naluLengthSize = (C.getUint8(4) & 3) + 1, this._naluLengthSize !== 3 && this._naluLengthSize !== 4) {
                        this._onError(u.default.FORMAT_ERROR, "Flv: Strange NaluLengthSizeMinusOne: " + (this._naluLengthSize - 1));
                        return;
                      }
                      var F = C.getUint8(5) & 31;
                      if (F === 0) {
                        this._onError(u.default.FORMAT_ERROR, "Flv: Invalid AVCDecoderConfigurationRecord: No SPS");
                        return;
                      } else
                        F > 1 && R.default.w(this.TAG, "Flv: Strange AVCDecoderConfigurationRecord: SPS Count = " + F);
                      for (var L = 6, U = 0; U < F; U++) {
                        var j = C.getUint16(L, !M);
                        if (L += 2, j !== 0) {
                          var G = new Uint8Array(_, x + L, j);
                          L += j;
                          var B = h.default.parseSPS(G);
                          if (U === 0) {
                            E.codecWidth = B.codec_size.width, E.codecHeight = B.codec_size.height, E.presentWidth = B.present_size.width, E.presentHeight = B.present_size.height, E.profile = B.profile_string, E.level = B.level_string, E.bitDepth = B.bit_depth, E.chromaFormat = B.chroma_format, E.sarRatio = B.sar_ratio, E.frameRate = B.frame_rate, (B.frame_rate.fixed === !1 || B.frame_rate.fps_num === 0 || B.frame_rate.fps_den === 0) && (E.frameRate = this._referenceFrameRate);
                            var re = E.frameRate.fps_den, le = E.frameRate.fps_num;
                            E.refSampleDuration = E.timescale * (re / le);
                            for (var Q = G.subarray(1, 4), ue = "avc1.", ce = 0; ce < 3; ce++) {
                              var de = Q[ce].toString(16);
                              de.length < 2 && (de = "0" + de), ue += de;
                            }
                            E.codec = ue;
                            var te = this._mediaInfo;
                            te.width = E.codecWidth, te.height = E.codecHeight, te.fps = E.frameRate.fps, te.profile = E.profile, te.level = E.level, te.refFrames = B.ref_frames, te.chromaFormat = B.chroma_format_string, te.sarNum = E.sarRatio.width, te.sarDen = E.sarRatio.height, te.videoCodec = ue, te.hasAudio ? te.audioCodec != null && (te.mimeType = 'video/x-flv; codecs="' + te.videoCodec + "," + te.audioCodec + '"') : te.mimeType = 'video/x-flv; codecs="' + te.videoCodec + '"', te.isComplete() && this._onMediaInfo(te);
                          }
                        }
                      }
                      var V = C.getUint8(L);
                      if (V === 0) {
                        this._onError(u.default.FORMAT_ERROR, "Flv: Invalid AVCDecoderConfigurationRecord: No PPS");
                        return;
                      } else
                        V > 1 && R.default.w(this.TAG, "Flv: Strange AVCDecoderConfigurationRecord: PPS Count = " + V);
                      L++;
                      for (var U = 0; U < V; U++) {
                        var j = C.getUint16(L, !M);
                        L += 2, j !== 0 && (L += j);
                      }
                      E.avcc = new Uint8Array(d), E.avcc.set(new Uint8Array(_, x, d), 0), R.default.v(this.TAG, "Parsed AVCDecoderConfigurationRecord"), this._isInitialMetadataDispatched() ? this._dispatch && (this._audioTrack.length || this._videoTrack.length) && this._onDataAvailable(this._audioTrack, this._videoTrack) : this._videoInitialMetadataDispatched = !0, this._dispatch = !1, this._onTrackMetadata("video", E);
                    }, y.prototype._parseAVCVideoData = function(_, x, d, E, D, M, C) {
                      for (var I = this._littleEndian, k = new DataView(_, x, d), F = [], L = 0, U = 0, j = this._naluLengthSize, G = this._timestampBase + E, B = M === 1; U < d; ) {
                        if (U + 4 >= d) {
                          R.default.w(this.TAG, "Malformed Nalu near timestamp " + G + ", offset = " + U + ", dataSize = " + d);
                          break;
                        }
                        var re = k.getUint32(U, !I);
                        if (j === 3 && (re >>>= 8), re > d - j) {
                          R.default.w(this.TAG, "Malformed Nalus near timestamp " + G + ", NaluSize > DataSize!");
                          return;
                        }
                        var le = k.getUint8(U + j) & 31;
                        le === 5 && (B = !0);
                        var Q = new Uint8Array(_, x + U, j + re), ue = { type: le, data: Q };
                        F.push(ue), L += Q.byteLength, U += j + re;
                      }
                      if (F.length) {
                        var ce = this._videoTrack, de = {
                          units: F,
                          length: L,
                          isKeyframe: B,
                          dts: G,
                          cts: C,
                          pts: G + C
                        };
                        B && (de.fileposition = D), ce.samples.push(de), ce.length += L;
                      }
                    }, y.prototype._parseHVCVideoPacket = function(_, x, d, E, D, M) {
                      if (d < 4) {
                        R.default.w(this.TAG, "Flv: Invalid HVC packet, missing HVCPacketType or/and CompositionTime");
                        return;
                      }
                      var C = this._littleEndian, I = new DataView(_, x, d), k = I.getUint8(0), F = I.getUint32(0, !C) & 16777215, L = F << 8 >> 8;
                      if (k === 0)
                        this._parseHVCDecoderConfigurationRecord(_, x + 4, d - 4);
                      else if (k === 1)
                        this._parseHVCVideoData(_, x + 4, d - 4, E, D, M, L);
                      else if (k !== 2) {
                        this._onError(u.default.FORMAT_ERROR, "Flv: Invalid video packet type " + k);
                        return;
                      }
                    }, y.prototype._parseHVCDecoderConfigurationRecord = function(_, x, d) {
                      if (d < 23) {
                        R.default.w(this.TAG, "Flv: Invalid HVCDecoderConfigurationRecord, lack of data!");
                        return;
                      }
                      var E = this._videoMetadata, D = this._videoTrack, M = this._littleEndian, C = new DataView(_, x, d);
                      E ? typeof E.hvcc < "u" && R.default.w(this.TAG, "Found another HVCDecoderConfigurationRecord!") : (this._hasVideo === !1 && this._hasVideoFlagOverrided === !1 && (this._hasVideo = !0, this._mediaInfo.hasVideo = !0), E = this._videoMetadata = {}, E.type = "video", E.id = D.id, E.timescale = this._timescale, E.duration = this._duration);
                      var I = C.getUint8(0), k = C.getUint8(1) & 31;
                      if (I !== 1 || k === 0) {
                        this._onError(u.default.FORMAT_ERROR, "Flv: Invalid HVCDecoderConfigurationRecord");
                        return;
                      }
                      if (this._naluLengthSize = (C.getUint8(21) & 3) + 1, this._naluLengthSize !== 3 && this._naluLengthSize !== 4) {
                        this._onError(u.default.FORMAT_ERROR, "Flv: Strange NaluLengthSizeMinusOne: " + (this._naluLengthSize - 1));
                        return;
                      }
                      for (var F = C.getUint8(22), L = 23, U, j, G, B = [], re = 0; re < F; re++) {
                        var le = C.getUint8(L++) & 63, Q = C.getUint16(L, !M);
                        if (L += 2, Q !== 0) {
                          switch (le) {
                            case 32:
                              U += Q;
                              break;
                            case 33:
                              j += Q;
                              break;
                            case 34:
                              G += Q;
                              break;
                          }
                          for (var ue = 0; ue < Q; ue++) {
                            var ce = C.getUint16(L, !M);
                            if (L += 2, ce !== 0) {
                              if (le === 33) {
                                var de = new Uint8Array(_, x + L, ce);
                                B.push(de);
                              }
                              L += ce;
                            }
                          }
                        }
                      }
                      if (U === 0) {
                        this._onError(u.default.FORMAT_ERROR, "Flv: Invalid HVCDecoderConfigurationRecord: No VPS");
                        return;
                      } else
                        U > 1 && R.default.w(this.TAG, "Flv: Strange HVCDecoderConfigurationRecord: VPS Count = " + U);
                      if (j === 0) {
                        this._onError(u.default.FORMAT_ERROR, "Flv: Invalid HVCDecoderConfigurationRecord: No SPS");
                        return;
                      } else
                        j > 1 && R.default.w(this.TAG, "Flv: Strange HVCDecoderConfigurationRecord: SPS Count = " + j);
                      if (G === 0) {
                        this._onError(u.default.FORMAT_ERROR, "Flv: Invalid HVCDecoderConfigurationRecord: No PPS");
                        return;
                      } else
                        G > 1 && R.default.w(this.TAG, "Flv: Strange HVCDecoderConfigurationRecord: PPS Count = " + j);
                      var te = B[0], V = l.default.parseSPS(te);
                      E.codecWidth = V.codec_size.width, E.codecHeight = V.codec_size.height, E.presentWidth = V.present_size.width, E.presentHeight = V.present_size.height, E.profile = V.profile_string, E.level = V.level_string, E.profile_idc = V.profile_idc, E.level_idc = V.level_idc, E.bitDepth = V.bit_depth, E.chromaFormat = V.chroma_format, E.sarRatio = V.sar_ratio, E.frameRate = V.frame_rate, (V.frame_rate.fixed === !1 || V.frame_rate.fps_num === 0 || V.frame_rate.fps_den === 0) && (E.frameRate = this._referenceFrameRate);
                      var xe = E.frameRate.fps_den, be = E.frameRate.fps_num;
                      E.refSampleDuration = E.timescale * (xe / be);
                      var je = "hvc1." + E.profile_idc + ".1.L" + E.level_idc + ".B0";
                      E.codec = je;
                      var H = this._mediaInfo;
                      H.width = E.codecWidth, H.height = E.codecHeight, H.fps = E.frameRate.fps, H.profile = E.profile, H.level = E.level, H.refFrames = V.ref_frames, H.chromaFormat = V.chroma_format_string, H.sarNum = E.sarRatio.width, H.sarDen = E.sarRatio.height, H.videoCodec = je, H.hasAudio ? H.audioCodec != null && (H.mimeType = 'video/x-flv; codecs="' + H.videoCodec + "," + H.audioCodec + '"') : H.mimeType = 'video/x-flv; codecs="' + H.videoCodec + '"', H.isComplete() && this._onMediaInfo(H), E.hvcc = new Uint8Array(d), E.hvcc.set(new Uint8Array(_, x, d), 0), R.default.v(this.TAG, "Parsed HVCDecoderConfigurationRecord"), this._isInitialMetadataDispatched() ? this._dispatch && (this._audioTrack.length || this._videoTrack.length) && this._onDataAvailable(this._audioTrack, this._videoTrack) : this._videoInitialMetadataDispatched = !0, this._dispatch = !1, this._onTrackMetadata("video", E);
                    }, y.prototype._parseHVCVideoData = function(_, x, d, E, D, M, C) {
                      for (var I = this._littleEndian, k = new DataView(_, x, d), F = [], L = 0, U = 0, j = this._naluLengthSize, G = this._timestampBase + E, B = M === 1; U < d; ) {
                        if (U + 4 >= d) {
                          R.default.w(this.TAG, "Malformed Nalu near timestamp " + G + ", offset = " + U + ", dataSize = " + d);
                          break;
                        }
                        var re = k.getUint32(U, !I);
                        if (j === 3 && (re >>>= 8), re > d - j) {
                          R.default.w(this.TAG, "Malformed Nalus near timestamp " + G + ", NaluSize > DataSize!");
                          return;
                        }
                        var le = k.getUint8(U + j) >> 1 & 63;
                        le >= 16 && le <= 23 && (B = !0);
                        var Q = new Uint8Array(_, x + U, j + re), ue = { type: le, data: Q };
                        F.push(ue), L += Q.byteLength, U += j + re;
                      }
                      if (F.length) {
                        var ce = this._videoTrack, de = {
                          units: F,
                          length: L,
                          isKeyframe: B,
                          dts: G,
                          cts: C,
                          pts: G + C
                        };
                        B && (de.fileposition = D), ce.samples.push(de), ce.length += L;
                      }
                    }, y;
                  }()
                );
                w.default = g;
              }
            ),
            /***/
            "./src/demux/hevc-sps-parser.js": (
              /*!**************************************!*\
                !*** ./src/demux/hevc-sps-parser.js ***!
                \**************************************/
              /***/
              function(T, w, O) {
                O.r(w);
                var R = O(
                  /*! ./exp-golomb.js */
                  "./src/demux/exp-golomb.js"
                ), v = O(
                  /*! ./sps-parser.js */
                  "./src/demux/sps-parser.js"
                ), h = (
                  /** @class */
                  function() {
                    function l() {
                    }
                    return l.parseSPS = function(u) {
                      var f = v.default._ebsp2rbsp(u), p = new R.default(f), m = {};
                      p.readBits(16), p.readBits(4);
                      var g = p.readBits(3);
                      p.readBits(1), l._hvcc_parse_ptl(p, m, g), p.readUEG();
                      var y = 0, _ = p.readUEG();
                      _ == 3 && (y = p.readBits(1)), m.sar_width = m.sar_height = 1, m.conf_win_left_offset = m.conf_win_right_offset = m.conf_win_top_offset = m.conf_win_bottom_offset = 0, m.def_disp_win_left_offset = m.def_disp_win_right_offset = m.def_disp_win_top_offset = m.def_disp_win_bottom_offset = 0;
                      var x = p.readUEG(), d = p.readUEG(), E = p.readBits(1);
                      E && (m.conf_win_left_offset = p.readUEG(), m.conf_win_right_offset = p.readUEG(), m.conf_win_top_offset = p.readUEG(), m.conf_win_bottom_offset = p.readUEG());
                      var D = p.readUEG() + 8;
                      p.readUEG();
                      for (var M = p.readUEG(), C = p.readBits(1) ? 0 : g; C <= g; C++)
                        l._skip_sub_layer_ordering_info(p);
                      p.readUEG(), p.readUEG(), p.readUEG(), p.readUEG(), p.readUEG(), p.readUEG(), p.readBits(1) && // scaling_list_enabled_flag
                      p.readBits(1) && l._skip_scaling_list_data(p), p.readBits(1), p.readBits(1), p.readBits(1) && (p.readBits(4), p.readBits(4), p.readUEG(), p.readUEG(), p.readBits(1));
                      var I = [], k = p.readUEG();
                      for (C = 0; C < k; C++) {
                        var F = l._parse_rps(p, C, k, I);
                        if (F < 0)
                          return F;
                      }
                      if (p.readBits(1)) {
                        var L = p.readUEG();
                        for (C = 0; C < L; C++) {
                          var U = Math.min(M + 4, 16);
                          if (U > 32) {
                            for (var j = U / 32, G = U % 32, B = 0; B < j; B++)
                              p.readBits(32);
                            p.readBits(G);
                          } else
                            p.readBits(U);
                          p.readBits(1);
                        }
                      }
                      var re = 1;
                      p.readBits(1), p.readBits(1), p.readBits(1) && l._hvcc_parse_vui(p, m, g);
                      var le = l.getProfileString(m.profile_idc), Q = l.getLevelString(m.level_idc), ue = 1;
                      (m.sar_width !== 1 || m.sar_height !== 1) && (ue = m.sar_width / m.sar_height);
                      var ce = x, de = d, te = (_ === 1 || _ == 2) && y === 0 ? 2 : 1, V = _ === 1 && y === 0 ? 2 : 1;
                      ce -= te * (m.conf_win_left_offset + m.conf_win_right_offset), de -= V * (m.conf_win_top_offset + m.conf_win_bottom_offset);
                      var xe = Math.ceil(ce * ue);
                      return p.destroy(), p = null, {
                        profile_string: le,
                        level_string: Q,
                        profile_idc: m.profile_idc,
                        level_idc: m.level_idc,
                        bit_depth: D,
                        ref_frames: re,
                        chroma_format: _,
                        chroma_format_string: l.getChromaFormatString(_),
                        frame_rate: {
                          fixed: m.fps_fixed,
                          fps: m.fps,
                          fps_den: m.fps_den,
                          fps_num: m.fps_num
                        },
                        sar_ratio: {
                          width: m.sar_width,
                          height: m.sar_height
                        },
                        codec_size: {
                          width: ce,
                          height: de
                        },
                        present_size: {
                          width: xe,
                          height: de
                        }
                      };
                    }, l._hvcc_parse_ptl = function(u, f, p) {
                      u.readBits(2);
                      var m = u.readBits(1), g = u.readBits(5);
                      u.readBits(32), u.readBits(32), u.readBits(16);
                      var y = u.readByte();
                      f.tier_flag === void 0 || f.level_idc === void 0 || f.tier_flag < m ? f.level_idc = y : f.level_idc = Math.max(f.level_idc, y), f.profile_idc = Math.max(f.profile_idc === void 0 ? 0 : f.profile_idc, g);
                      for (var _ = [], x = [], d = 0; d < p; d++)
                        _.push(u.readBits(1)), x.push(u.readBits(1));
                      if (p > 0)
                        for (var d = p; d < 8; d++)
                          u.readBits(2);
                      for (var d = 0; d < p; d++)
                        _[d] && (u.readBits(32), u.readBits(32), u.readBits(24)), x[d] && u.readByte();
                    }, l._parse_rps = function(u, f, p, m) {
                      if (f && u.readBits(1)) {
                        if (f >= p)
                          return -1;
                        u.readBits(1), u.readUEG(), m[f] = 0;
                        for (var g = 0; g <= m[f - 1]; g++) {
                          var y = 0, _ = u.readBits(1);
                          _ || (y = u.readBits(1)), (_ || y) && m[f]++;
                        }
                      } else {
                        var x = u.readUEG(), d = u.readUEG();
                        m[f] = x + d;
                        for (var g = 0; g < x; g++)
                          u.readUEG(), u.readBits(1);
                        for (var g = 0; g < d; g++)
                          u.readUEG(), u.readBits(1);
                      }
                      return 0;
                    }, l._hvcc_parse_vui = function(u, f, p) {
                      u.readBits(1) && u.readByte() == 255 && (f.sar_width = u.readBits(16), f.sar_height = u.readBits(16)), u.readBits(1) && u.readBits(1), u.readBits(1) && (u.readBits(4), u.readBits(1) && u.readBits(24)), u.readBits(1) && (u.readUEG(), u.readUEG()), u.readBits(3), f.default_display_window_flag = u.readBits(1), f.default_display_window_flag && (f.def_disp_win_left_offset = u.readUEG(), f.def_disp_win_right_offset = u.readUEG(), f.def_disp_win_top_offset = u.readUEG(), f.def_disp_win_bottom_offset = u.readUEG()), u.readBits(1) && (l._skip_timing_info(u, f), u.readBits(1) && l._skip_hrd_parameters(u, f, 1, p)), u.readBits(1) && (u.readBits(3), u.readUEG(), u.readUEG(), u.readUEG(), u.readUEG(), u.readUEG());
                    }, l._skip_sub_layer_ordering_info = function(u, f) {
                      u.readUEG(), u.readUEG(), u.readUEG();
                    }, l._skip_scaling_list_data = function(u) {
                      for (var f = 0; f < 4; f++)
                        for (var p = 0; p < (f == 3 ? 2 : 6); p++)
                          if (!u.readBits(1))
                            u.readUEG();
                          else {
                            var m = Math.min(64, 1 << 4 + (f << 1));
                            f > 1 && u.readSEG();
                            for (var g = 0; g < m; g++)
                              u.readSEG();
                          }
                    }, l._skip_sub_layer_hrd_parameters = function(u, f, p) {
                      for (var m = 0; m <= f; m++)
                        u.readUEG(), u.readUEG(), p && (u.readUEG(), u.readUEG()), u.readBits(1);
                    }, l._skip_timing_info = function(u, f) {
                      f.fps_den = u.readBits(32), f.fps_num = u.readBits(32), f.fps_den > 0 && (f.fps = f.fps_num / f.fps_den);
                      var p = 0;
                      u.readBits(1) && (p = u.readUEG(), p >= 0 && (f.fps /= p + 1));
                    }, l._skip_hrd_parameters = function(u, f, p) {
                      var m = 0, g = 0, y = 0;
                      if (f && (g = u.readBits(1), y = u.readBits(1), g || y)) {
                        var _ = u.readBits(1);
                        _ && u.readBits(19), u.readByte(), _ && u.readBits(4), u.readBits(15);
                      }
                      for (var x = 0; x <= p; x++) {
                        var d = 0, E = 0, D = 0, M = u.readBits(1);
                        hvcc.fps_fixed = M, M || (D = u.readBits(1)), D ? u.readUEG() : E = u.readBits(1), E || (d = u.readUEG(u)), g && l._skip_sub_layer_hrd_parameters(u, d, m), y && l._skip_sub_layer_hrd_parameters(u, d, m);
                      }
                    }, l.getProfileString = function(u) {
                      switch (u) {
                        case 1:
                          return "Main";
                        case 2:
                          return "Main10";
                        case 3:
                          return "MainSP";
                        case 4:
                          return "Rext";
                        case 9:
                          return "SCC";
                        default:
                          return "Unknown";
                      }
                    }, l.getLevelString = function(u) {
                      return (u / 30).toFixed(1);
                    }, l.getChromaFormatString = function(u) {
                      switch (u) {
                        case 0:
                          return "4:0:0";
                        case 1:
                          return "4:2:0";
                        case 2:
                          return "4:2:2";
                        case 3:
                          return "4:4:4";
                        default:
                          return "Unknown";
                      }
                    }, l;
                  }()
                );
                w.default = h;
              }
            ),
            /***/
            "./src/demux/sps-parser.js": (
              /*!*********************************!*\
                !*** ./src/demux/sps-parser.js ***!
                \*********************************/
              /***/
              function(T, w, O) {
                O.r(w);
                var R = O(
                  /*! ./exp-golomb.js */
                  "./src/demux/exp-golomb.js"
                ), v = (
                  /** @class */
                  function() {
                    function h() {
                    }
                    return h._ebsp2rbsp = function(l) {
                      for (var u = l, f = u.byteLength, p = new Uint8Array(f), m = 0, g = 0; g < f; g++)
                        g >= 2 && u[g] === 3 && u[g - 1] === 0 && u[g - 2] === 0 || (p[m] = u[g], m++);
                      return new Uint8Array(p.buffer, 0, m);
                    }, h.parseSPS = function(l) {
                      var u = h._ebsp2rbsp(l), f = new R.default(u);
                      f.readByte();
                      var p = f.readByte();
                      f.readByte();
                      var m = f.readByte();
                      f.readUEG();
                      var g = h.getProfileString(p), y = h.getLevelString(m), _ = 1, x = 420, d = [0, 420, 422, 444], E = 8;
                      if ((p === 100 || p === 110 || p === 122 || p === 244 || p === 44 || p === 83 || p === 86 || p === 118 || p === 128 || p === 138 || p === 144) && (_ = f.readUEG(), _ === 3 && f.readBits(1), _ <= 3 && (x = d[_]), E = f.readUEG() + 8, f.readUEG(), f.readBits(1), f.readBool()))
                        for (var D = _ !== 3 ? 8 : 12, M = 0; M < D; M++)
                          f.readBool() && (M < 6 ? h._skipScalingList(f, 16) : h._skipScalingList(f, 64));
                      f.readUEG();
                      var C = f.readUEG();
                      if (C === 0)
                        f.readUEG();
                      else if (C === 1) {
                        f.readBits(1), f.readSEG(), f.readSEG();
                        for (var I = f.readUEG(), M = 0; M < I; M++)
                          f.readSEG();
                      }
                      var k = f.readUEG();
                      f.readBits(1);
                      var F = f.readUEG(), L = f.readUEG(), U = f.readBits(1);
                      U === 0 && f.readBits(1), f.readBits(1);
                      var j = 0, G = 0, B = 0, re = 0, le = f.readBool();
                      le && (j = f.readUEG(), G = f.readUEG(), B = f.readUEG(), re = f.readUEG());
                      var Q = 1, ue = 1, ce = 0, de = !0, te = 0, V = 0, xe = f.readBool();
                      if (xe) {
                        if (f.readBool()) {
                          var be = f.readByte(), je = [1, 12, 10, 16, 40, 24, 20, 32, 80, 18, 15, 64, 160, 4, 3, 2], H = [1, 11, 11, 11, 33, 11, 11, 11, 33, 11, 11, 33, 99, 3, 2, 1];
                          be > 0 && be < 16 ? (Q = je[be - 1], ue = H[be - 1]) : be === 255 && (Q = f.readByte() << 8 | f.readByte(), ue = f.readByte() << 8 | f.readByte());
                        }
                        if (f.readBool() && f.readBool(), f.readBool() && (f.readBits(4), f.readBool() && f.readBits(24)), f.readBool() && (f.readUEG(), f.readUEG()), f.readBool()) {
                          var Me = f.readBits(32), Ve = f.readBits(32);
                          de = f.readBool(), te = Ve, V = Me * 2, ce = te / V;
                        }
                      }
                      var Se = 1;
                      (Q !== 1 || ue !== 1) && (Se = Q / ue);
                      var ne = 0, Qe = 0;
                      if (_ === 0)
                        ne = 1, Qe = 2 - U;
                      else {
                        var qe = _ === 3 ? 1 : 2, rt = _ === 1 ? 2 : 1;
                        ne = qe, Qe = rt * (2 - U);
                      }
                      var lt = (F + 1) * 16, ht = (2 - U) * ((L + 1) * 16);
                      lt -= (j + G) * ne, ht -= (B + re) * Qe;
                      var ct = Math.ceil(lt * Se);
                      return f.destroy(), f = null, {
                        profile_string: g,
                        level_string: y,
                        bit_depth: E,
                        ref_frames: k,
                        chroma_format: x,
                        chroma_format_string: h.getChromaFormatString(x),
                        frame_rate: {
                          fixed: de,
                          fps: ce,
                          fps_den: V,
                          fps_num: te
                        },
                        sar_ratio: {
                          width: Q,
                          height: ue
                        },
                        codec_size: {
                          width: lt,
                          height: ht
                        },
                        present_size: {
                          width: ct,
                          height: ht
                        }
                      };
                    }, h._skipScalingList = function(l, u) {
                      for (var f = 8, p = 8, m = 0, g = 0; g < u; g++)
                        p !== 0 && (m = l.readSEG(), p = (f + m + 256) % 256), f = p === 0 ? f : p;
                    }, h.getProfileString = function(l) {
                      switch (l) {
                        case 66:
                          return "Baseline";
                        case 77:
                          return "Main";
                        case 88:
                          return "Extended";
                        case 100:
                          return "High";
                        case 110:
                          return "High10";
                        case 122:
                          return "High422";
                        case 244:
                          return "High444";
                        default:
                          return "Unknown";
                      }
                    }, h.getLevelString = function(l) {
                      return (l / 10).toFixed(1);
                    }, h.getChromaFormatString = function(l) {
                      switch (l) {
                        case 420:
                          return "4:2:0";
                        case 422:
                          return "4:2:2";
                        case 444:
                          return "4:4:4";
                        default:
                          return "Unknown";
                      }
                    }, h;
                  }()
                );
                w.default = v;
              }
            ),
            /***/
            "./src/flv.js": (
              /*!********************!*\
                !*** ./src/flv.js ***!
                \********************/
              /***/
              function(T, w, O) {
                O.r(w);
                var R = O(
                  /*! ./utils/polyfill.js */
                  "./src/utils/polyfill.js"
                ), v = O(
                  /*! ./core/features.js */
                  "./src/core/features.js"
                ), h = O(
                  /*! ./io/loader.js */
                  "./src/io/loader.js"
                ), l = O(
                  /*! ./player/flv-player.js */
                  "./src/player/flv-player.js"
                ), u = O(
                  /*! ./player/native-player.js */
                  "./src/player/native-player.js"
                ), f = O(
                  /*! ./player/player-events.js */
                  "./src/player/player-events.js"
                ), p = O(
                  /*! ./player/player-errors.js */
                  "./src/player/player-errors.js"
                ), m = O(
                  /*! ./utils/logging-control.js */
                  "./src/utils/logging-control.js"
                ), g = O(
                  /*! ./utils/exception.js */
                  "./src/utils/exception.js"
                );
                R.default.install();
                function y(E, D) {
                  var M = E;
                  if (M == null || typeof M != "object")
                    throw new g.InvalidArgumentException("MediaDataSource must be an javascript object!");
                  if (!M.hasOwnProperty("type"))
                    throw new g.InvalidArgumentException("MediaDataSource must has type field to indicate video file type!");
                  switch (M.type) {
                    case "flv":
                      return new l.default(M, D);
                    default:
                      return new u.default(M, D);
                  }
                }
                function _() {
                  return v.default.supportMSEH264Playback();
                }
                function x() {
                  return v.default.getFeatureList();
                }
                var d = {};
                d.createPlayer = y, d.isSupported = _, d.getFeatureList = x, d.BaseLoader = h.BaseLoader, d.LoaderStatus = h.LoaderStatus, d.LoaderErrors = h.LoaderErrors, d.Events = f.default, d.ErrorTypes = p.ErrorTypes, d.ErrorDetails = p.ErrorDetails, d.FlvPlayer = l.default, d.NativePlayer = u.default, d.LoggingControl = m.default, Object.defineProperty(d, "version", {
                  enumerable: !0,
                  get: function() {
                    return "1.7.2";
                  }
                }), w.default = d;
              }
            ),
            /***/
            "./src/index.js": (
              /*!**********************!*\
                !*** ./src/index.js ***!
                \**********************/
              /***/
              function(T, w, O) {
                T.exports = O(
                  /*! ./flv.js */
                  "./src/flv.js"
                ).default;
              }
            ),
            /***/
            "./src/io/fetch-stream-loader.js": (
              /*!***************************************!*\
                !*** ./src/io/fetch-stream-loader.js ***!
                \***************************************/
              /***/
              function(T, w, O) {
                O.r(w);
                var R = O(
                  /*! ../utils/browser.js */
                  "./src/utils/browser.js"
                ), v = O(
                  /*! ./loader.js */
                  "./src/io/loader.js"
                ), h = O(
                  /*! ../utils/exception.js */
                  "./src/utils/exception.js"
                ), l = function() {
                  var f = function(p, m) {
                    return f = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(g, y) {
                      g.__proto__ = y;
                    } || function(g, y) {
                      for (var _ in y)
                        Object.prototype.hasOwnProperty.call(y, _) && (g[_] = y[_]);
                    }, f(p, m);
                  };
                  return function(p, m) {
                    if (typeof m != "function" && m !== null)
                      throw new TypeError("Class extends value " + String(m) + " is not a constructor or null");
                    f(p, m);
                    function g() {
                      this.constructor = p;
                    }
                    p.prototype = m === null ? Object.create(m) : (g.prototype = m.prototype, new g());
                  };
                }(), u = (
                  /** @class */
                  function(f) {
                    l(p, f);
                    function p(m, g) {
                      var y = f.call(this, "fetch-stream-loader") || this;
                      return y.TAG = "FetchStreamLoader", y._seekHandler = m, y._config = g, y._needStash = !0, y._requestAbort = !1, y._contentLength = null, y._receivedLength = 0, y;
                    }
                    return p.isSupported = function() {
                      try {
                        var m = R.default.msedge && R.default.version.minor >= 15048, g = R.default.msedge ? m : !0;
                        return self.fetch && self.ReadableStream && g;
                      } catch {
                        return !1;
                      }
                    }, p.prototype.destroy = function() {
                      this.isWorking() && this.abort(), f.prototype.destroy.call(this);
                    }, p.prototype.open = function(m, g) {
                      var y = this;
                      this._dataSource = m, this._range = g;
                      var _ = m.url;
                      this._config.reuseRedirectedURL && m.redirectedURL != null && (_ = m.redirectedURL);
                      var x = this._seekHandler.getConfig(_, g), d = new self.Headers();
                      if (typeof x.headers == "object") {
                        var E = x.headers;
                        for (var D in E)
                          E.hasOwnProperty(D) && d.append(D, E[D]);
                      }
                      var M = {
                        method: "GET",
                        headers: d,
                        mode: "cors",
                        cache: "default",
                        // The default policy of Fetch API in the whatwg standard
                        // Safari incorrectly indicates 'no-referrer' as default policy, fuck it
                        referrerPolicy: "no-referrer-when-downgrade"
                      };
                      if (typeof this._config.headers == "object")
                        for (var D in this._config.headers)
                          d.append(D, this._config.headers[D]);
                      m.cors === !1 && (M.mode = "same-origin"), m.withCredentials && (M.credentials = "include"), m.referrerPolicy && (M.referrerPolicy = m.referrerPolicy), self.AbortController && (this._abortController = new self.AbortController(), M.signal = this._abortController.signal), this._status = v.LoaderStatus.kConnecting, self.fetch(x.url, M).then(function(C) {
                        if (y._requestAbort) {
                          y._status = v.LoaderStatus.kIdle, C.body.cancel();
                          return;
                        }
                        if (C.ok && C.status >= 200 && C.status <= 299) {
                          if (C.url !== x.url && y._onURLRedirect) {
                            var I = y._seekHandler.removeURLParameters(C.url);
                            y._onURLRedirect(I);
                          }
                          var k = C.headers.get("Content-Length");
                          return k != null && (y._contentLength = parseInt(k), y._contentLength !== 0 && y._onContentLengthKnown && y._onContentLengthKnown(y._contentLength)), y._pump.call(y, C.body.getReader());
                        } else if (y._status = v.LoaderStatus.kError, y._onError)
                          y._onError(v.LoaderErrors.HTTP_STATUS_CODE_INVALID, { code: C.status, msg: C.statusText });
                        else
                          throw new h.RuntimeException("FetchStreamLoader: Http code invalid, " + C.status + " " + C.statusText);
                      }).catch(function(C) {
                        if (!(y._abortController && y._abortController.signal.aborted))
                          if (y._status = v.LoaderStatus.kError, y._onError)
                            y._onError(v.LoaderErrors.EXCEPTION, { code: -1, msg: C.message });
                          else
                            throw C;
                      });
                    }, p.prototype.abort = function() {
                      if (this._requestAbort = !0, (this._status !== v.LoaderStatus.kBuffering || !R.default.chrome) && this._abortController)
                        try {
                          this._abortController.abort();
                        } catch {
                        }
                    }, p.prototype._pump = function(m) {
                      var g = this;
                      return m.read().then(function(y) {
                        if (y.done)
                          if (g._contentLength !== null && g._receivedLength < g._contentLength) {
                            g._status = v.LoaderStatus.kError;
                            var _ = v.LoaderErrors.EARLY_EOF, x = { code: -1, msg: "Fetch stream meet Early-EOF" };
                            if (g._onError)
                              g._onError(_, x);
                            else
                              throw new h.RuntimeException(x.msg);
                          } else
                            g._status = v.LoaderStatus.kComplete, g._onComplete && g._onComplete(g._range.from, g._range.from + g._receivedLength - 1);
                        else {
                          if (g._abortController && g._abortController.signal.aborted) {
                            g._status = v.LoaderStatus.kComplete;
                            return;
                          } else if (g._requestAbort === !0)
                            return g._status = v.LoaderStatus.kComplete, m.cancel();
                          g._status = v.LoaderStatus.kBuffering;
                          var d = y.value.buffer, E = g._range.from + g._receivedLength;
                          g._receivedLength += d.byteLength, g._onDataArrival && g._onDataArrival(d, E, g._receivedLength), g._pump(m);
                        }
                      }).catch(function(y) {
                        if (g._abortController && g._abortController.signal.aborted) {
                          g._status = v.LoaderStatus.kComplete;
                          return;
                        }
                        if (!(y.code === 11 && R.default.msedge)) {
                          g._status = v.LoaderStatus.kError;
                          var _ = 0, x = null;
                          if ((y.code === 19 || y.message === "network error") && // NETWORK_ERR
                          (g._contentLength === null || g._contentLength !== null && g._receivedLength < g._contentLength) ? (_ = v.LoaderErrors.EARLY_EOF, x = { code: y.code, msg: "Fetch stream meet Early-EOF" }) : (_ = v.LoaderErrors.EXCEPTION, x = { code: y.code, msg: y.message }), g._onError)
                            g._onError(_, x);
                          else
                            throw new h.RuntimeException(x.msg);
                        }
                      });
                    }, p;
                  }(v.BaseLoader)
                );
                w.default = u;
              }
            ),
            /***/
            "./src/io/io-controller.js": (
              /*!*********************************!*\
                !*** ./src/io/io-controller.js ***!
                \*********************************/
              /***/
              function(T, w, O) {
                O.r(w);
                var R = O(
                  /*! ../utils/logger.js */
                  "./src/utils/logger.js"
                ), v = O(
                  /*! ./speed-sampler.js */
                  "./src/io/speed-sampler.js"
                ), h = O(
                  /*! ./loader.js */
                  "./src/io/loader.js"
                ), l = O(
                  /*! ./fetch-stream-loader.js */
                  "./src/io/fetch-stream-loader.js"
                ), u = O(
                  /*! ./xhr-moz-chunked-loader.js */
                  "./src/io/xhr-moz-chunked-loader.js"
                ), f = O(
                  /*! ./xhr-range-loader.js */
                  "./src/io/xhr-range-loader.js"
                ), p = O(
                  /*! ./websocket-loader.js */
                  "./src/io/websocket-loader.js"
                ), m = O(
                  /*! ./range-seek-handler.js */
                  "./src/io/range-seek-handler.js"
                ), g = O(
                  /*! ./param-seek-handler.js */
                  "./src/io/param-seek-handler.js"
                ), y = O(
                  /*! ../utils/exception.js */
                  "./src/utils/exception.js"
                ), _ = (
                  /** @class */
                  function() {
                    function x(d, E, D) {
                      this.TAG = "IOController", this._config = E, this._extraData = D, this._stashInitialSize = 1024 * 384, E.stashInitialSize != null && E.stashInitialSize > 0 && (this._stashInitialSize = E.stashInitialSize), this._stashUsed = 0, this._stashSize = this._stashInitialSize, this._bufferSize = 1024 * 1024 * 3, this._stashBuffer = new ArrayBuffer(this._bufferSize), this._stashByteStart = 0, this._enableStash = !0, E.enableStashBuffer === !1 && (this._enableStash = !1), this._loader = null, this._loaderClass = null, this._seekHandler = null, this._dataSource = d, this._isWebSocketURL = /wss?:\/\/(.+?)/.test(d.url), this._refTotalLength = d.filesize ? d.filesize : null, this._totalLength = this._refTotalLength, this._fullRequestFlag = !1, this._currentRange = null, this._redirectedURL = null, this._speedNormalized = 0, this._speedSampler = new v.default(), this._speedNormalizeList = [64, 128, 256, 384, 512, 768, 1024, 1536, 2048, 3072, 4096], this._isEarlyEofReconnecting = !1, this._paused = !1, this._resumeFrom = 0, this._onDataArrival = null, this._onSeeked = null, this._onError = null, this._onComplete = null, this._onRedirect = null, this._onRecoveredEarlyEof = null, this._selectSeekHandler(), this._selectLoader(), this._createLoader();
                    }
                    return x.prototype.destroy = function() {
                      this._loader.isWorking() && this._loader.abort(), this._loader.destroy(), this._loader = null, this._loaderClass = null, this._dataSource = null, this._stashBuffer = null, this._stashUsed = this._stashSize = this._bufferSize = this._stashByteStart = 0, this._currentRange = null, this._speedSampler = null, this._isEarlyEofReconnecting = !1, this._onDataArrival = null, this._onSeeked = null, this._onError = null, this._onComplete = null, this._onRedirect = null, this._onRecoveredEarlyEof = null, this._extraData = null;
                    }, x.prototype.isWorking = function() {
                      return this._loader && this._loader.isWorking() && !this._paused;
                    }, x.prototype.isPaused = function() {
                      return this._paused;
                    }, Object.defineProperty(x.prototype, "status", {
                      get: function() {
                        return this._loader.status;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(x.prototype, "extraData", {
                      get: function() {
                        return this._extraData;
                      },
                      set: function(d) {
                        this._extraData = d;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(x.prototype, "onDataArrival", {
                      // prototype: function onDataArrival(chunks: ArrayBuffer, byteStart: number): number
                      get: function() {
                        return this._onDataArrival;
                      },
                      set: function(d) {
                        this._onDataArrival = d;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(x.prototype, "onSeeked", {
                      get: function() {
                        return this._onSeeked;
                      },
                      set: function(d) {
                        this._onSeeked = d;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(x.prototype, "onError", {
                      // prototype: function onError(type: number, info: {code: number, msg: string}): void
                      get: function() {
                        return this._onError;
                      },
                      set: function(d) {
                        this._onError = d;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(x.prototype, "onComplete", {
                      get: function() {
                        return this._onComplete;
                      },
                      set: function(d) {
                        this._onComplete = d;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(x.prototype, "onRedirect", {
                      get: function() {
                        return this._onRedirect;
                      },
                      set: function(d) {
                        this._onRedirect = d;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(x.prototype, "onRecoveredEarlyEof", {
                      get: function() {
                        return this._onRecoveredEarlyEof;
                      },
                      set: function(d) {
                        this._onRecoveredEarlyEof = d;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(x.prototype, "currentURL", {
                      get: function() {
                        return this._dataSource.url;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(x.prototype, "hasRedirect", {
                      get: function() {
                        return this._redirectedURL != null || this._dataSource.redirectedURL != null;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(x.prototype, "currentRedirectedURL", {
                      get: function() {
                        return this._redirectedURL || this._dataSource.redirectedURL;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(x.prototype, "currentSpeed", {
                      // in KB/s
                      get: function() {
                        return this._loaderClass === f.default ? this._loader.currentSpeed : this._speedSampler.lastSecondKBps;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(x.prototype, "loaderType", {
                      get: function() {
                        return this._loader.type;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), x.prototype._selectSeekHandler = function() {
                      var d = this._config;
                      if (d.seekType === "range")
                        this._seekHandler = new m.default(this._config.rangeLoadZeroStart);
                      else if (d.seekType === "param") {
                        var E = d.seekParamStart || "bstart", D = d.seekParamEnd || "bend";
                        this._seekHandler = new g.default(E, D);
                      } else if (d.seekType === "custom") {
                        if (typeof d.customSeekHandler != "function")
                          throw new y.InvalidArgumentException("Custom seekType specified in config but invalid customSeekHandler!");
                        this._seekHandler = new d.customSeekHandler();
                      } else
                        throw new y.InvalidArgumentException("Invalid seekType in config: " + d.seekType);
                    }, x.prototype._selectLoader = function() {
                      if (this._config.customLoader != null)
                        this._loaderClass = this._config.customLoader;
                      else if (this._isWebSocketURL)
                        this._loaderClass = p.default;
                      else if (l.default.isSupported())
                        this._loaderClass = l.default;
                      else if (u.default.isSupported())
                        this._loaderClass = u.default;
                      else if (f.default.isSupported())
                        this._loaderClass = f.default;
                      else
                        throw new y.RuntimeException("Your browser doesn't support xhr with arraybuffer responseType!");
                    }, x.prototype._createLoader = function() {
                      this._loader = new this._loaderClass(this._seekHandler, this._config), this._loader.needStashBuffer === !1 && (this._enableStash = !1), this._loader.onContentLengthKnown = this._onContentLengthKnown.bind(this), this._loader.onURLRedirect = this._onURLRedirect.bind(this), this._loader.onDataArrival = this._onLoaderChunkArrival.bind(this), this._loader.onComplete = this._onLoaderComplete.bind(this), this._loader.onError = this._onLoaderError.bind(this);
                    }, x.prototype.open = function(d) {
                      this._currentRange = { from: 0, to: -1 }, d && (this._currentRange.from = d), this._speedSampler.reset(), d || (this._fullRequestFlag = !0), this._loader.open(this._dataSource, Object.assign({}, this._currentRange));
                    }, x.prototype.abort = function() {
                      this._loader.abort(), this._paused && (this._paused = !1, this._resumeFrom = 0);
                    }, x.prototype.pause = function() {
                      this.isWorking() && (this._loader.abort(), this._stashUsed !== 0 ? (this._resumeFrom = this._stashByteStart, this._currentRange.to = this._stashByteStart - 1) : this._resumeFrom = this._currentRange.to + 1, this._stashUsed = 0, this._stashByteStart = 0, this._paused = !0);
                    }, x.prototype.resume = function() {
                      if (this._paused) {
                        this._paused = !1;
                        var d = this._resumeFrom;
                        this._resumeFrom = 0, this._internalSeek(d, !0);
                      }
                    }, x.prototype.seek = function(d) {
                      this._paused = !1, this._stashUsed = 0, this._stashByteStart = 0, this._internalSeek(d, !0);
                    }, x.prototype._internalSeek = function(d, E) {
                      this._loader.isWorking() && this._loader.abort(), this._flushStashBuffer(E), this._loader.destroy(), this._loader = null;
                      var D = { from: d, to: -1 };
                      this._currentRange = { from: D.from, to: -1 }, this._speedSampler.reset(), this._stashSize = this._stashInitialSize, this._createLoader(), this._loader.open(this._dataSource, D), this._onSeeked && this._onSeeked();
                    }, x.prototype.updateUrl = function(d) {
                      if (!d || typeof d != "string" || d.length === 0)
                        throw new y.InvalidArgumentException("Url must be a non-empty string!");
                      this._dataSource.url = d;
                    }, x.prototype._expandBuffer = function(d) {
                      for (var E = this._stashSize; E + 1024 * 1024 * 1 < d; )
                        E *= 2;
                      if (E += 1024 * 1024 * 1, E !== this._bufferSize) {
                        var D = new ArrayBuffer(E);
                        if (this._stashUsed > 0) {
                          var M = new Uint8Array(this._stashBuffer, 0, this._stashUsed), C = new Uint8Array(D, 0, E);
                          C.set(M, 0);
                        }
                        this._stashBuffer = D, this._bufferSize = E;
                      }
                    }, x.prototype._normalizeSpeed = function(d) {
                      var E = this._speedNormalizeList, D = E.length - 1, M = 0, C = 0, I = D;
                      if (d < E[0])
                        return E[0];
                      for (; C <= I; ) {
                        if (M = C + Math.floor((I - C) / 2), M === D || d >= E[M] && d < E[M + 1])
                          return E[M];
                        E[M] < d ? C = M + 1 : I = M - 1;
                      }
                    }, x.prototype._adjustStashSize = function(d) {
                      var E = 0;
                      this._config.isLive || d < 512 ? E = d : d >= 512 && d <= 1024 ? E = Math.floor(d * 1.5) : E = d * 2, E > 8192 && (E = 8192);
                      var D = E * 1024 + 1024 * 1024 * 1;
                      this._bufferSize < D && this._expandBuffer(D), this._stashSize = E * 1024;
                    }, x.prototype._dispatchChunks = function(d, E) {
                      return this._currentRange.to = E + d.byteLength - 1, this._onDataArrival(d, E);
                    }, x.prototype._onURLRedirect = function(d) {
                      this._redirectedURL = d, this._onRedirect && this._onRedirect(d);
                    }, x.prototype._onContentLengthKnown = function(d) {
                      d && this._fullRequestFlag && (this._totalLength = d, this._fullRequestFlag = !1);
                    }, x.prototype._onLoaderChunkArrival = function(d, E, D) {
                      if (!this._onDataArrival)
                        throw new y.IllegalStateException("IOController: No existing consumer (onDataArrival) callback!");
                      if (!this._paused) {
                        this._isEarlyEofReconnecting && (this._isEarlyEofReconnecting = !1, this._onRecoveredEarlyEof && this._onRecoveredEarlyEof()), this._speedSampler.addBytes(d.byteLength);
                        var M = this._speedSampler.lastSecondKBps;
                        if (M !== 0) {
                          var C = this._normalizeSpeed(M);
                          this._speedNormalized !== C && (this._speedNormalized = C, this._adjustStashSize(C));
                        }
                        if (this._enableStash)
                          if (this._stashUsed === 0 && this._stashByteStart === 0 && (this._stashByteStart = E), this._stashUsed + d.byteLength <= this._stashSize) {
                            var F = new Uint8Array(this._stashBuffer, 0, this._stashSize);
                            F.set(new Uint8Array(d), this._stashUsed), this._stashUsed += d.byteLength;
                          } else {
                            var F = new Uint8Array(this._stashBuffer, 0, this._bufferSize);
                            if (this._stashUsed > 0) {
                              var U = this._stashBuffer.slice(0, this._stashUsed), I = this._dispatchChunks(U, this._stashByteStart);
                              if (I < U.byteLength) {
                                if (I > 0) {
                                  var L = new Uint8Array(U, I);
                                  F.set(L, 0), this._stashUsed = L.byteLength, this._stashByteStart += I;
                                }
                              } else
                                this._stashUsed = 0, this._stashByteStart += I;
                              this._stashUsed + d.byteLength > this._bufferSize && (this._expandBuffer(this._stashUsed + d.byteLength), F = new Uint8Array(this._stashBuffer, 0, this._bufferSize)), F.set(new Uint8Array(d), this._stashUsed), this._stashUsed += d.byteLength;
                            } else {
                              var I = this._dispatchChunks(d, E);
                              if (I < d.byteLength) {
                                var k = d.byteLength - I;
                                k > this._bufferSize && (this._expandBuffer(k), F = new Uint8Array(this._stashBuffer, 0, this._bufferSize)), F.set(new Uint8Array(d, I), 0), this._stashUsed += k, this._stashByteStart = E + I;
                              }
                            }
                          }
                        else if (this._stashUsed === 0) {
                          var I = this._dispatchChunks(d, E);
                          if (I < d.byteLength) {
                            var k = d.byteLength - I;
                            k > this._bufferSize && this._expandBuffer(k);
                            var F = new Uint8Array(this._stashBuffer, 0, this._bufferSize);
                            F.set(new Uint8Array(d, I), 0), this._stashUsed += k, this._stashByteStart = E + I;
                          }
                        } else {
                          this._stashUsed + d.byteLength > this._bufferSize && this._expandBuffer(this._stashUsed + d.byteLength);
                          var F = new Uint8Array(this._stashBuffer, 0, this._bufferSize);
                          F.set(new Uint8Array(d), this._stashUsed), this._stashUsed += d.byteLength;
                          var I = this._dispatchChunks(this._stashBuffer.slice(0, this._stashUsed), this._stashByteStart);
                          if (I < this._stashUsed && I > 0) {
                            var L = new Uint8Array(this._stashBuffer, I);
                            F.set(L, 0);
                          }
                          this._stashUsed -= I, this._stashByteStart += I;
                        }
                      }
                    }, x.prototype._flushStashBuffer = function(d) {
                      if (this._stashUsed > 0) {
                        var E = this._stashBuffer.slice(0, this._stashUsed), D = this._dispatchChunks(E, this._stashByteStart), M = E.byteLength - D;
                        if (D < E.byteLength)
                          if (d)
                            R.default.w(this.TAG, M + " bytes unconsumed data remain when flush buffer, dropped");
                          else {
                            if (D > 0) {
                              var C = new Uint8Array(this._stashBuffer, 0, this._bufferSize), I = new Uint8Array(E, D);
                              C.set(I, 0), this._stashUsed = I.byteLength, this._stashByteStart += D;
                            }
                            return 0;
                          }
                        return this._stashUsed = 0, this._stashByteStart = 0, M;
                      }
                      return 0;
                    }, x.prototype._onLoaderComplete = function(d, E) {
                      this._flushStashBuffer(!0), this._onComplete && this._onComplete(this._extraData);
                    }, x.prototype._onLoaderError = function(d, E) {
                      switch (R.default.e(this.TAG, "Loader error, code = " + E.code + ", msg = " + E.msg), this._flushStashBuffer(!1), this._isEarlyEofReconnecting && (this._isEarlyEofReconnecting = !1, d = h.LoaderErrors.UNRECOVERABLE_EARLY_EOF), d) {
                        case h.LoaderErrors.EARLY_EOF: {
                          if (!this._config.isLive && this._totalLength) {
                            var D = this._currentRange.to + 1;
                            D < this._totalLength && (R.default.w(this.TAG, "Connection lost, trying reconnect..."), this._isEarlyEofReconnecting = !0, this._internalSeek(D, !1));
                            return;
                          }
                          d = h.LoaderErrors.UNRECOVERABLE_EARLY_EOF;
                          break;
                        }
                        case h.LoaderErrors.UNRECOVERABLE_EARLY_EOF:
                        case h.LoaderErrors.CONNECTING_TIMEOUT:
                        case h.LoaderErrors.HTTP_STATUS_CODE_INVALID:
                        case h.LoaderErrors.EXCEPTION:
                          break;
                      }
                      if (this._onError)
                        this._onError(d, E);
                      else
                        throw new y.RuntimeException("IOException: " + E.msg);
                    }, x;
                  }()
                );
                w.default = _;
              }
            ),
            /***/
            "./src/io/loader.js": (
              /*!**************************!*\
                !*** ./src/io/loader.js ***!
                \**************************/
              /***/
              function(T, w, O) {
                O.r(w), O.d(w, {
                  /* harmony export */
                  LoaderStatus: function() {
                    return (
                      /* binding */
                      v
                    );
                  },
                  /* harmony export */
                  LoaderErrors: function() {
                    return (
                      /* binding */
                      h
                    );
                  },
                  /* harmony export */
                  BaseLoader: function() {
                    return (
                      /* binding */
                      l
                    );
                  }
                  /* harmony export */
                });
                var R = O(
                  /*! ../utils/exception.js */
                  "./src/utils/exception.js"
                ), v = {
                  kIdle: 0,
                  kConnecting: 1,
                  kBuffering: 2,
                  kError: 3,
                  kComplete: 4
                }, h = {
                  OK: "OK",
                  EXCEPTION: "Exception",
                  HTTP_STATUS_CODE_INVALID: "HttpStatusCodeInvalid",
                  CONNECTING_TIMEOUT: "ConnectingTimeout",
                  EARLY_EOF: "EarlyEof",
                  UNRECOVERABLE_EARLY_EOF: "UnrecoverableEarlyEof"
                }, l = (
                  /** @class */
                  function() {
                    function u(f) {
                      this._type = f || "undefined", this._status = v.kIdle, this._needStash = !1, this._onContentLengthKnown = null, this._onURLRedirect = null, this._onDataArrival = null, this._onError = null, this._onComplete = null;
                    }
                    return u.prototype.destroy = function() {
                      this._status = v.kIdle, this._onContentLengthKnown = null, this._onURLRedirect = null, this._onDataArrival = null, this._onError = null, this._onComplete = null;
                    }, u.prototype.isWorking = function() {
                      return this._status === v.kConnecting || this._status === v.kBuffering;
                    }, Object.defineProperty(u.prototype, "type", {
                      get: function() {
                        return this._type;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(u.prototype, "status", {
                      get: function() {
                        return this._status;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(u.prototype, "needStashBuffer", {
                      get: function() {
                        return this._needStash;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(u.prototype, "onContentLengthKnown", {
                      get: function() {
                        return this._onContentLengthKnown;
                      },
                      set: function(f) {
                        this._onContentLengthKnown = f;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(u.prototype, "onURLRedirect", {
                      get: function() {
                        return this._onURLRedirect;
                      },
                      set: function(f) {
                        this._onURLRedirect = f;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(u.prototype, "onDataArrival", {
                      get: function() {
                        return this._onDataArrival;
                      },
                      set: function(f) {
                        this._onDataArrival = f;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(u.prototype, "onError", {
                      get: function() {
                        return this._onError;
                      },
                      set: function(f) {
                        this._onError = f;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(u.prototype, "onComplete", {
                      get: function() {
                        return this._onComplete;
                      },
                      set: function(f) {
                        this._onComplete = f;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), u.prototype.open = function(f, p) {
                      throw new R.NotImplementedException("Unimplemented abstract function!");
                    }, u.prototype.abort = function() {
                      throw new R.NotImplementedException("Unimplemented abstract function!");
                    }, u;
                  }()
                );
              }
            ),
            /***/
            "./src/io/param-seek-handler.js": (
              /*!**************************************!*\
                !*** ./src/io/param-seek-handler.js ***!
                \**************************************/
              /***/
              function(T, w, O) {
                O.r(w);
                var R = (
                  /** @class */
                  function() {
                    function v(h, l) {
                      this._startName = h, this._endName = l;
                    }
                    return v.prototype.getConfig = function(h, l) {
                      var u = h;
                      if (l.from !== 0 || l.to !== -1) {
                        var f = !0;
                        u.indexOf("?") === -1 && (u += "?", f = !1), f && (u += "&"), u += this._startName + "=" + l.from.toString(), l.to !== -1 && (u += "&" + this._endName + "=" + l.to.toString());
                      }
                      return {
                        url: u,
                        headers: {}
                      };
                    }, v.prototype.removeURLParameters = function(h) {
                      var l = h.split("?")[0], u = void 0, f = h.indexOf("?");
                      f !== -1 && (u = h.substring(f + 1));
                      var p = "";
                      if (u != null && u.length > 0)
                        for (var m = u.split("&"), g = 0; g < m.length; g++) {
                          var y = m[g].split("="), _ = g > 0;
                          y[0] !== this._startName && y[0] !== this._endName && (_ && (p += "&"), p += m[g]);
                        }
                      return p.length === 0 ? l : l + "?" + p;
                    }, v;
                  }()
                );
                w.default = R;
              }
            ),
            /***/
            "./src/io/range-seek-handler.js": (
              /*!**************************************!*\
                !*** ./src/io/range-seek-handler.js ***!
                \**************************************/
              /***/
              function(T, w, O) {
                O.r(w);
                var R = (
                  /** @class */
                  function() {
                    function v(h) {
                      this._zeroStart = h || !1;
                    }
                    return v.prototype.getConfig = function(h, l) {
                      var u = {};
                      if (l.from !== 0 || l.to !== -1) {
                        var f = void 0;
                        l.to !== -1 ? f = "bytes=" + l.from.toString() + "-" + l.to.toString() : f = "bytes=" + l.from.toString() + "-", u.Range = f;
                      } else
                        this._zeroStart && (u.Range = "bytes=0-");
                      return {
                        url: h,
                        headers: u
                      };
                    }, v.prototype.removeURLParameters = function(h) {
                      return h;
                    }, v;
                  }()
                );
                w.default = R;
              }
            ),
            /***/
            "./src/io/speed-sampler.js": (
              /*!*********************************!*\
                !*** ./src/io/speed-sampler.js ***!
                \*********************************/
              /***/
              function(T, w, O) {
                O.r(w);
                var R = (
                  /** @class */
                  function() {
                    function v() {
                      this._firstCheckpoint = 0, this._lastCheckpoint = 0, this._intervalBytes = 0, this._totalBytes = 0, this._lastSecondBytes = 0, self.performance && self.performance.now ? this._now = self.performance.now.bind(self.performance) : this._now = Date.now;
                    }
                    return v.prototype.reset = function() {
                      this._firstCheckpoint = this._lastCheckpoint = 0, this._totalBytes = this._intervalBytes = 0, this._lastSecondBytes = 0;
                    }, v.prototype.addBytes = function(h) {
                      this._firstCheckpoint === 0 ? (this._firstCheckpoint = this._now(), this._lastCheckpoint = this._firstCheckpoint, this._intervalBytes += h, this._totalBytes += h) : this._now() - this._lastCheckpoint < 1e3 ? (this._intervalBytes += h, this._totalBytes += h) : (this._lastSecondBytes = this._intervalBytes, this._intervalBytes = h, this._totalBytes += h, this._lastCheckpoint = this._now());
                    }, Object.defineProperty(v.prototype, "currentKBps", {
                      get: function() {
                        this.addBytes(0);
                        var h = (this._now() - this._lastCheckpoint) / 1e3;
                        return h == 0 && (h = 1), this._intervalBytes / h / 1024;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(v.prototype, "lastSecondKBps", {
                      get: function() {
                        return this.addBytes(0), this._lastSecondBytes !== 0 ? this._lastSecondBytes / 1024 : this._now() - this._lastCheckpoint >= 500 ? this.currentKBps : 0;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(v.prototype, "averageKBps", {
                      get: function() {
                        var h = (this._now() - this._firstCheckpoint) / 1e3;
                        return this._totalBytes / h / 1024;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), v;
                  }()
                );
                w.default = R;
              }
            ),
            /***/
            "./src/io/websocket-loader.js": (
              /*!************************************!*\
                !*** ./src/io/websocket-loader.js ***!
                \************************************/
              /***/
              function(T, w, O) {
                O.r(w);
                var R = O(
                  /*! ./loader.js */
                  "./src/io/loader.js"
                ), v = O(
                  /*! ../utils/exception.js */
                  "./src/utils/exception.js"
                ), h = function() {
                  var u = function(f, p) {
                    return u = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(m, g) {
                      m.__proto__ = g;
                    } || function(m, g) {
                      for (var y in g)
                        Object.prototype.hasOwnProperty.call(g, y) && (m[y] = g[y]);
                    }, u(f, p);
                  };
                  return function(f, p) {
                    if (typeof p != "function" && p !== null)
                      throw new TypeError("Class extends value " + String(p) + " is not a constructor or null");
                    u(f, p);
                    function m() {
                      this.constructor = f;
                    }
                    f.prototype = p === null ? Object.create(p) : (m.prototype = p.prototype, new m());
                  };
                }(), l = (
                  /** @class */
                  function(u) {
                    h(f, u);
                    function f() {
                      var p = u.call(this, "websocket-loader") || this;
                      return p.TAG = "WebSocketLoader", p._needStash = !0, p._ws = null, p._requestAbort = !1, p._receivedLength = 0, p;
                    }
                    return f.isSupported = function() {
                      try {
                        return typeof self.WebSocket < "u";
                      } catch {
                        return !1;
                      }
                    }, f.prototype.destroy = function() {
                      this._ws && this.abort(), u.prototype.destroy.call(this);
                    }, f.prototype.open = function(p) {
                      try {
                        var m = this._ws = new self.WebSocket(p.url);
                        m.binaryType = "arraybuffer", m.onopen = this._onWebSocketOpen.bind(this), m.onclose = this._onWebSocketClose.bind(this), m.onmessage = this._onWebSocketMessage.bind(this), m.onerror = this._onWebSocketError.bind(this), this._status = R.LoaderStatus.kConnecting;
                      } catch (y) {
                        this._status = R.LoaderStatus.kError;
                        var g = { code: y.code, msg: y.message };
                        if (this._onError)
                          this._onError(R.LoaderErrors.EXCEPTION, g);
                        else
                          throw new v.RuntimeException(g.msg);
                      }
                    }, f.prototype.abort = function() {
                      var p = this._ws;
                      p && (p.readyState === 0 || p.readyState === 1) && (this._requestAbort = !0, p.close()), this._ws = null, this._status = R.LoaderStatus.kComplete;
                    }, f.prototype._onWebSocketOpen = function(p) {
                      this._status = R.LoaderStatus.kBuffering;
                    }, f.prototype._onWebSocketClose = function(p) {
                      if (this._requestAbort === !0) {
                        this._requestAbort = !1;
                        return;
                      }
                      this._status = R.LoaderStatus.kComplete, this._onComplete && this._onComplete(0, this._receivedLength - 1);
                    }, f.prototype._onWebSocketMessage = function(p) {
                      var m = this;
                      if (p.data instanceof ArrayBuffer)
                        this._dispatchArrayBuffer(p.data);
                      else if (p.data instanceof Blob) {
                        var g = new FileReader();
                        g.onload = function() {
                          m._dispatchArrayBuffer(g.result);
                        }, g.readAsArrayBuffer(p.data);
                      } else {
                        this._status = R.LoaderStatus.kError;
                        var y = { code: -1, msg: "Unsupported WebSocket message type: " + p.data.constructor.name };
                        if (this._onError)
                          this._onError(R.LoaderErrors.EXCEPTION, y);
                        else
                          throw new v.RuntimeException(y.msg);
                      }
                    }, f.prototype._dispatchArrayBuffer = function(p) {
                      var m = p, g = this._receivedLength;
                      this._receivedLength += m.byteLength, this._onDataArrival && this._onDataArrival(m, g, this._receivedLength);
                    }, f.prototype._onWebSocketError = function(p) {
                      this._status = R.LoaderStatus.kError;
                      var m = {
                        code: p.code,
                        msg: p.message
                      };
                      if (this._onError)
                        this._onError(R.LoaderErrors.EXCEPTION, m);
                      else
                        throw new v.RuntimeException(m.msg);
                    }, f;
                  }(R.BaseLoader)
                );
                w.default = l;
              }
            ),
            /***/
            "./src/io/xhr-moz-chunked-loader.js": (
              /*!******************************************!*\
                !*** ./src/io/xhr-moz-chunked-loader.js ***!
                \******************************************/
              /***/
              function(T, w, O) {
                O.r(w);
                var R = O(
                  /*! ../utils/logger.js */
                  "./src/utils/logger.js"
                ), v = O(
                  /*! ./loader.js */
                  "./src/io/loader.js"
                ), h = O(
                  /*! ../utils/exception.js */
                  "./src/utils/exception.js"
                ), l = function() {
                  var f = function(p, m) {
                    return f = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(g, y) {
                      g.__proto__ = y;
                    } || function(g, y) {
                      for (var _ in y)
                        Object.prototype.hasOwnProperty.call(y, _) && (g[_] = y[_]);
                    }, f(p, m);
                  };
                  return function(p, m) {
                    if (typeof m != "function" && m !== null)
                      throw new TypeError("Class extends value " + String(m) + " is not a constructor or null");
                    f(p, m);
                    function g() {
                      this.constructor = p;
                    }
                    p.prototype = m === null ? Object.create(m) : (g.prototype = m.prototype, new g());
                  };
                }(), u = (
                  /** @class */
                  function(f) {
                    l(p, f);
                    function p(m, g) {
                      var y = f.call(this, "xhr-moz-chunked-loader") || this;
                      return y.TAG = "MozChunkedLoader", y._seekHandler = m, y._config = g, y._needStash = !0, y._xhr = null, y._requestAbort = !1, y._contentLength = null, y._receivedLength = 0, y;
                    }
                    return p.isSupported = function() {
                      try {
                        var m = new XMLHttpRequest();
                        return m.open("GET", "https://example.com", !0), m.responseType = "moz-chunked-arraybuffer", m.responseType === "moz-chunked-arraybuffer";
                      } catch (g) {
                        return R.default.w("MozChunkedLoader", g.message), !1;
                      }
                    }, p.prototype.destroy = function() {
                      this.isWorking() && this.abort(), this._xhr && (this._xhr.onreadystatechange = null, this._xhr.onprogress = null, this._xhr.onloadend = null, this._xhr.onerror = null, this._xhr = null), f.prototype.destroy.call(this);
                    }, p.prototype.open = function(m, g) {
                      this._dataSource = m, this._range = g;
                      var y = m.url;
                      this._config.reuseRedirectedURL && m.redirectedURL != null && (y = m.redirectedURL);
                      var _ = this._seekHandler.getConfig(y, g);
                      this._requestURL = _.url;
                      var x = this._xhr = new XMLHttpRequest();
                      if (x.open("GET", _.url, !0), x.responseType = "moz-chunked-arraybuffer", x.onreadystatechange = this._onReadyStateChange.bind(this), x.onprogress = this._onProgress.bind(this), x.onloadend = this._onLoadEnd.bind(this), x.onerror = this._onXhrError.bind(this), m.withCredentials && (x.withCredentials = !0), typeof _.headers == "object") {
                        var d = _.headers;
                        for (var E in d)
                          d.hasOwnProperty(E) && x.setRequestHeader(E, d[E]);
                      }
                      if (typeof this._config.headers == "object") {
                        var d = this._config.headers;
                        for (var E in d)
                          d.hasOwnProperty(E) && x.setRequestHeader(E, d[E]);
                      }
                      this._status = v.LoaderStatus.kConnecting, x.send();
                    }, p.prototype.abort = function() {
                      this._requestAbort = !0, this._xhr && this._xhr.abort(), this._status = v.LoaderStatus.kComplete;
                    }, p.prototype._onReadyStateChange = function(m) {
                      var g = m.target;
                      if (g.readyState === 2) {
                        if (g.responseURL != null && g.responseURL !== this._requestURL && this._onURLRedirect) {
                          var y = this._seekHandler.removeURLParameters(g.responseURL);
                          this._onURLRedirect(y);
                        }
                        if (g.status !== 0 && (g.status < 200 || g.status > 299))
                          if (this._status = v.LoaderStatus.kError, this._onError)
                            this._onError(v.LoaderErrors.HTTP_STATUS_CODE_INVALID, { code: g.status, msg: g.statusText });
                          else
                            throw new h.RuntimeException("MozChunkedLoader: Http code invalid, " + g.status + " " + g.statusText);
                        else
                          this._status = v.LoaderStatus.kBuffering;
                      }
                    }, p.prototype._onProgress = function(m) {
                      if (this._status !== v.LoaderStatus.kError) {
                        this._contentLength === null && m.total !== null && m.total !== 0 && (this._contentLength = m.total, this._onContentLengthKnown && this._onContentLengthKnown(this._contentLength));
                        var g = m.target.response, y = this._range.from + this._receivedLength;
                        this._receivedLength += g.byteLength, this._onDataArrival && this._onDataArrival(g, y, this._receivedLength);
                      }
                    }, p.prototype._onLoadEnd = function(m) {
                      if (this._requestAbort === !0) {
                        this._requestAbort = !1;
                        return;
                      } else if (this._status === v.LoaderStatus.kError)
                        return;
                      this._status = v.LoaderStatus.kComplete, this._onComplete && this._onComplete(this._range.from, this._range.from + this._receivedLength - 1);
                    }, p.prototype._onXhrError = function(m) {
                      this._status = v.LoaderStatus.kError;
                      var g = 0, y = null;
                      if (this._contentLength && m.loaded < this._contentLength ? (g = v.LoaderErrors.EARLY_EOF, y = { code: -1, msg: "Moz-Chunked stream meet Early-Eof" }) : (g = v.LoaderErrors.EXCEPTION, y = { code: -1, msg: m.constructor.name + " " + m.type }), this._onError)
                        this._onError(g, y);
                      else
                        throw new h.RuntimeException(y.msg);
                    }, p;
                  }(v.BaseLoader)
                );
                w.default = u;
              }
            ),
            /***/
            "./src/io/xhr-range-loader.js": (
              /*!************************************!*\
                !*** ./src/io/xhr-range-loader.js ***!
                \************************************/
              /***/
              function(T, w, O) {
                O.r(w);
                var R = O(
                  /*! ../utils/logger.js */
                  "./src/utils/logger.js"
                ), v = O(
                  /*! ./speed-sampler.js */
                  "./src/io/speed-sampler.js"
                ), h = O(
                  /*! ./loader.js */
                  "./src/io/loader.js"
                ), l = O(
                  /*! ../utils/exception.js */
                  "./src/utils/exception.js"
                ), u = function() {
                  var p = function(m, g) {
                    return p = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(y, _) {
                      y.__proto__ = _;
                    } || function(y, _) {
                      for (var x in _)
                        Object.prototype.hasOwnProperty.call(_, x) && (y[x] = _[x]);
                    }, p(m, g);
                  };
                  return function(m, g) {
                    if (typeof g != "function" && g !== null)
                      throw new TypeError("Class extends value " + String(g) + " is not a constructor or null");
                    p(m, g);
                    function y() {
                      this.constructor = m;
                    }
                    m.prototype = g === null ? Object.create(g) : (y.prototype = g.prototype, new y());
                  };
                }(), f = (
                  /** @class */
                  function(p) {
                    u(m, p);
                    function m(g, y) {
                      var _ = p.call(this, "xhr-range-loader") || this;
                      return _.TAG = "RangeLoader", _._seekHandler = g, _._config = y, _._needStash = !1, _._chunkSizeKBList = [
                        128,
                        256,
                        384,
                        512,
                        768,
                        1024,
                        1536,
                        2048,
                        3072,
                        4096,
                        5120,
                        6144,
                        7168,
                        8192
                      ], _._currentChunkSizeKB = 384, _._currentSpeedNormalized = 0, _._zeroSpeedChunkCount = 0, _._xhr = null, _._speedSampler = new v.default(), _._requestAbort = !1, _._waitForTotalLength = !1, _._totalLengthReceived = !1, _._currentRequestURL = null, _._currentRedirectedURL = null, _._currentRequestRange = null, _._totalLength = null, _._contentLength = null, _._receivedLength = 0, _._lastTimeLoaded = 0, _;
                    }
                    return m.isSupported = function() {
                      try {
                        var g = new XMLHttpRequest();
                        return g.open("GET", "https://example.com", !0), g.responseType = "arraybuffer", g.responseType === "arraybuffer";
                      } catch (y) {
                        return R.default.w("RangeLoader", y.message), !1;
                      }
                    }, m.prototype.destroy = function() {
                      this.isWorking() && this.abort(), this._xhr && (this._xhr.onreadystatechange = null, this._xhr.onprogress = null, this._xhr.onload = null, this._xhr.onerror = null, this._xhr = null), p.prototype.destroy.call(this);
                    }, Object.defineProperty(m.prototype, "currentSpeed", {
                      get: function() {
                        return this._speedSampler.lastSecondKBps;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), m.prototype.open = function(g, y) {
                      this._dataSource = g, this._range = y, this._status = h.LoaderStatus.kConnecting;
                      var _ = !1;
                      this._dataSource.filesize != null && this._dataSource.filesize !== 0 && (_ = !0, this._totalLength = this._dataSource.filesize), !this._totalLengthReceived && !_ ? (this._waitForTotalLength = !0, this._internalOpen(this._dataSource, { from: 0, to: -1 })) : this._openSubRange();
                    }, m.prototype._openSubRange = function() {
                      var g = this._currentChunkSizeKB * 1024, y = this._range.from + this._receivedLength, _ = y + g;
                      this._contentLength != null && _ - this._range.from >= this._contentLength && (_ = this._range.from + this._contentLength - 1), this._currentRequestRange = { from: y, to: _ }, this._internalOpen(this._dataSource, this._currentRequestRange);
                    }, m.prototype._internalOpen = function(g, y) {
                      this._lastTimeLoaded = 0;
                      var _ = g.url;
                      this._config.reuseRedirectedURL && (this._currentRedirectedURL != null ? _ = this._currentRedirectedURL : g.redirectedURL != null && (_ = g.redirectedURL));
                      var x = this._seekHandler.getConfig(_, y);
                      this._currentRequestURL = x.url;
                      var d = this._xhr = new XMLHttpRequest();
                      if (d.open("GET", x.url, !0), d.responseType = "arraybuffer", d.onreadystatechange = this._onReadyStateChange.bind(this), d.onprogress = this._onProgress.bind(this), d.onload = this._onLoad.bind(this), d.onerror = this._onXhrError.bind(this), g.withCredentials && (d.withCredentials = !0), typeof x.headers == "object") {
                        var E = x.headers;
                        for (var D in E)
                          E.hasOwnProperty(D) && d.setRequestHeader(D, E[D]);
                      }
                      if (typeof this._config.headers == "object") {
                        var E = this._config.headers;
                        for (var D in E)
                          E.hasOwnProperty(D) && d.setRequestHeader(D, E[D]);
                      }
                      d.send();
                    }, m.prototype.abort = function() {
                      this._requestAbort = !0, this._internalAbort(), this._status = h.LoaderStatus.kComplete;
                    }, m.prototype._internalAbort = function() {
                      this._xhr && (this._xhr.onreadystatechange = null, this._xhr.onprogress = null, this._xhr.onload = null, this._xhr.onerror = null, this._xhr.abort(), this._xhr = null);
                    }, m.prototype._onReadyStateChange = function(g) {
                      var y = g.target;
                      if (y.readyState === 2) {
                        if (y.responseURL != null) {
                          var _ = this._seekHandler.removeURLParameters(y.responseURL);
                          y.responseURL !== this._currentRequestURL && _ !== this._currentRedirectedURL && (this._currentRedirectedURL = _, this._onURLRedirect && this._onURLRedirect(_));
                        }
                        if (y.status >= 200 && y.status <= 299) {
                          if (this._waitForTotalLength)
                            return;
                          this._status = h.LoaderStatus.kBuffering;
                        } else if (this._status = h.LoaderStatus.kError, this._onError)
                          this._onError(h.LoaderErrors.HTTP_STATUS_CODE_INVALID, { code: y.status, msg: y.statusText });
                        else
                          throw new l.RuntimeException("RangeLoader: Http code invalid, " + y.status + " " + y.statusText);
                      }
                    }, m.prototype._onProgress = function(g) {
                      if (this._status !== h.LoaderStatus.kError) {
                        if (this._contentLength === null) {
                          var y = !1;
                          if (this._waitForTotalLength) {
                            this._waitForTotalLength = !1, this._totalLengthReceived = !0, y = !0;
                            var _ = g.total;
                            this._internalAbort(), _ != null & _ !== 0 && (this._totalLength = _);
                          }
                          if (this._range.to === -1 ? this._contentLength = this._totalLength - this._range.from : this._contentLength = this._range.to - this._range.from + 1, y) {
                            this._openSubRange();
                            return;
                          }
                          this._onContentLengthKnown && this._onContentLengthKnown(this._contentLength);
                        }
                        var x = g.loaded - this._lastTimeLoaded;
                        this._lastTimeLoaded = g.loaded, this._speedSampler.addBytes(x);
                      }
                    }, m.prototype._normalizeSpeed = function(g) {
                      var y = this._chunkSizeKBList, _ = y.length - 1, x = 0, d = 0, E = _;
                      if (g < y[0])
                        return y[0];
                      for (; d <= E; ) {
                        if (x = d + Math.floor((E - d) / 2), x === _ || g >= y[x] && g < y[x + 1])
                          return y[x];
                        y[x] < g ? d = x + 1 : E = x - 1;
                      }
                    }, m.prototype._onLoad = function(g) {
                      if (this._status !== h.LoaderStatus.kError) {
                        if (this._waitForTotalLength) {
                          this._waitForTotalLength = !1;
                          return;
                        }
                        this._lastTimeLoaded = 0;
                        var y = this._speedSampler.lastSecondKBps;
                        if (y === 0 && (this._zeroSpeedChunkCount++, this._zeroSpeedChunkCount >= 3 && (y = this._speedSampler.currentKBps)), y !== 0) {
                          var _ = this._normalizeSpeed(y);
                          this._currentSpeedNormalized !== _ && (this._currentSpeedNormalized = _, this._currentChunkSizeKB = _);
                        }
                        var x = g.target.response, d = this._range.from + this._receivedLength;
                        this._receivedLength += x.byteLength;
                        var E = !1;
                        this._contentLength != null && this._receivedLength < this._contentLength ? this._openSubRange() : E = !0, this._onDataArrival && this._onDataArrival(x, d, this._receivedLength), E && (this._status = h.LoaderStatus.kComplete, this._onComplete && this._onComplete(this._range.from, this._range.from + this._receivedLength - 1));
                      }
                    }, m.prototype._onXhrError = function(g) {
                      this._status = h.LoaderStatus.kError;
                      var y = 0, _ = null;
                      if (this._contentLength && this._receivedLength > 0 && this._receivedLength < this._contentLength ? (y = h.LoaderErrors.EARLY_EOF, _ = { code: -1, msg: "RangeLoader meet Early-Eof" }) : (y = h.LoaderErrors.EXCEPTION, _ = { code: -1, msg: g.constructor.name + " " + g.type }), this._onError)
                        this._onError(y, _);
                      else
                        throw new l.RuntimeException(_.msg);
                    }, m;
                  }(h.BaseLoader)
                );
                w.default = f;
              }
            ),
            /***/
            "./src/player/flv-player.js": (
              /*!**********************************!*\
                !*** ./src/player/flv-player.js ***!
                \**********************************/
              /***/
              function(T, w, O) {
                O.r(w);
                var R = O(
                  /*! events */
                  "./node_modules/events/events.js"
                ), v = /* @__PURE__ */ O.n(R), h = O(
                  /*! ../utils/logger.js */
                  "./src/utils/logger.js"
                ), l = O(
                  /*! ../utils/browser.js */
                  "./src/utils/browser.js"
                ), u = O(
                  /*! ./player-events.js */
                  "./src/player/player-events.js"
                ), f = O(
                  /*! ../core/transmuxer.js */
                  "./src/core/transmuxer.js"
                ), p = O(
                  /*! ../core/transmuxing-events.js */
                  "./src/core/transmuxing-events.js"
                ), m = O(
                  /*! ../core/mse-controller.js */
                  "./src/core/mse-controller.js"
                ), g = O(
                  /*! ../core/mse-events.js */
                  "./src/core/mse-events.js"
                ), y = O(
                  /*! ./player-errors.js */
                  "./src/player/player-errors.js"
                ), _ = O(
                  /*! ../config.js */
                  "./src/config.js"
                ), x = O(
                  /*! ../utils/exception.js */
                  "./src/utils/exception.js"
                ), d = (
                  /** @class */
                  function() {
                    function E(D, M) {
                      if (this.TAG = "FlvPlayer", this._type = "FlvPlayer", this._emitter = new (v())(), this._config = (0, _.createDefaultConfig)(), typeof M == "object" && Object.assign(this._config, M), D.type.toLowerCase() !== "flv")
                        throw new x.InvalidArgumentException("FlvPlayer requires an flv MediaDataSource input!");
                      D.isLive === !0 && (this._config.isLive = !0), this.e = {
                        onvLoadedMetadata: this._onvLoadedMetadata.bind(this),
                        onvSeeking: this._onvSeeking.bind(this),
                        onvCanPlay: this._onvCanPlay.bind(this),
                        onvStalled: this._onvStalled.bind(this),
                        onvProgress: this._onvProgress.bind(this)
                      }, self.performance && self.performance.now ? this._now = self.performance.now.bind(self.performance) : this._now = Date.now, this._pendingSeekTime = null, this._requestSetTime = !1, this._seekpointRecord = null, this._progressChecker = null, this._mediaDataSource = D, this._mediaElement = null, this._msectl = null, this._transmuxer = null, this._mseSourceOpened = !1, this._hasPendingLoad = !1, this._receivedCanPlay = !1, this._mediaInfo = null, this._statisticsInfo = null;
                      var C = l.default.chrome && (l.default.version.major < 50 || l.default.version.major === 50 && l.default.version.build < 2661);
                      this._alwaysSeekKeyframe = !!(C || l.default.msedge || l.default.msie), this._alwaysSeekKeyframe && (this._config.accurateSeek = !1);
                    }
                    return E.prototype.destroy = function() {
                      this._progressChecker != null && (window.clearInterval(this._progressChecker), this._progressChecker = null), this._transmuxer && this.unload(), this._mediaElement && this.detachMediaElement(), this.e = null, this._mediaDataSource = null, this._emitter.removeAllListeners(), this._emitter = null;
                    }, E.prototype.on = function(D, M) {
                      var C = this;
                      D === u.default.MEDIA_INFO ? this._mediaInfo != null && Promise.resolve().then(function() {
                        C._emitter.emit(u.default.MEDIA_INFO, C.mediaInfo);
                      }) : D === u.default.STATISTICS_INFO && this._statisticsInfo != null && Promise.resolve().then(function() {
                        C._emitter.emit(u.default.STATISTICS_INFO, C.statisticsInfo);
                      }), this._emitter.addListener(D, M);
                    }, E.prototype.off = function(D, M) {
                      this._emitter.removeListener(D, M);
                    }, E.prototype.attachMediaElement = function(D) {
                      var M = this;
                      if (this._mediaElement = D, D.addEventListener("loadedmetadata", this.e.onvLoadedMetadata), D.addEventListener("seeking", this.e.onvSeeking), D.addEventListener("canplay", this.e.onvCanPlay), D.addEventListener("stalled", this.e.onvStalled), D.addEventListener("progress", this.e.onvProgress), this._msectl = new m.default(this._config), this._msectl.on(g.default.UPDATE_END, this._onmseUpdateEnd.bind(this)), this._msectl.on(g.default.BUFFER_FULL, this._onmseBufferFull.bind(this)), this._msectl.on(g.default.SOURCE_OPEN, function() {
                        M._mseSourceOpened = !0, M._hasPendingLoad && (M._hasPendingLoad = !1, M.load());
                      }), this._msectl.on(g.default.ERROR, function(C) {
                        M._emitter.emit(u.default.ERROR, y.ErrorTypes.MEDIA_ERROR, y.ErrorDetails.MEDIA_MSE_ERROR, C);
                      }), this._msectl.attachMediaElement(D), this._pendingSeekTime != null)
                        try {
                          D.currentTime = this._pendingSeekTime, this._pendingSeekTime = null;
                        } catch {
                        }
                    }, E.prototype.detachMediaElement = function() {
                      this._mediaElement && (this._msectl.detachMediaElement(), this._mediaElement.removeEventListener("loadedmetadata", this.e.onvLoadedMetadata), this._mediaElement.removeEventListener("seeking", this.e.onvSeeking), this._mediaElement.removeEventListener("canplay", this.e.onvCanPlay), this._mediaElement.removeEventListener("stalled", this.e.onvStalled), this._mediaElement.removeEventListener("progress", this.e.onvProgress), this._mediaElement = null), this._msectl && (this._msectl.destroy(), this._msectl = null);
                    }, E.prototype.load = function() {
                      var D = this;
                      if (!this._mediaElement)
                        throw new x.IllegalStateException("HTMLMediaElement must be attached before load()!");
                      if (this._transmuxer)
                        throw new x.IllegalStateException("FlvPlayer.load() has been called, please call unload() first!");
                      if (!this._hasPendingLoad) {
                        if (this._config.deferLoadAfterSourceOpen && this._mseSourceOpened === !1) {
                          this._hasPendingLoad = !0;
                          return;
                        }
                        this._mediaElement.readyState > 0 && (this._requestSetTime = !0, this._mediaElement.currentTime = 0), this._transmuxer = new f.default(this._mediaDataSource, this._config), this._transmuxer.on(p.default.INIT_SEGMENT, function(M, C) {
                          D._msectl.appendInitSegment(C);
                        }), this._transmuxer.on(p.default.MEDIA_SEGMENT, function(M, C) {
                          if (D._msectl.appendMediaSegment(C), D._config.lazyLoad && !D._config.isLive) {
                            var I = D._mediaElement.currentTime;
                            C.info.endDts >= (I + D._config.lazyLoadMaxDuration) * 1e3 && D._progressChecker == null && (h.default.v(D.TAG, "Maximum buffering duration exceeded, suspend transmuxing task"), D._suspendTransmuxer());
                          }
                        }), this._transmuxer.on(p.default.LOADING_COMPLETE, function() {
                          D._msectl.endOfStream(), D._emitter.emit(u.default.LOADING_COMPLETE);
                        }), this._transmuxer.on(p.default.RECOVERED_EARLY_EOF, function() {
                          D._emitter.emit(u.default.RECOVERED_EARLY_EOF);
                        }), this._transmuxer.on(p.default.IO_ERROR, function(M, C) {
                          D._emitter.emit(u.default.ERROR, y.ErrorTypes.NETWORK_ERROR, M, C);
                        }), this._transmuxer.on(p.default.DEMUX_ERROR, function(M, C) {
                          D._emitter.emit(u.default.ERROR, y.ErrorTypes.MEDIA_ERROR, M, { code: -1, msg: C });
                        }), this._transmuxer.on(p.default.MEDIA_INFO, function(M) {
                          D._mediaInfo = M, D._emitter.emit(u.default.MEDIA_INFO, Object.assign({}, M));
                        }), this._transmuxer.on(p.default.METADATA_ARRIVED, function(M) {
                          D._emitter.emit(u.default.METADATA_ARRIVED, M);
                        }), this._transmuxer.on(p.default.SCRIPTDATA_ARRIVED, function(M) {
                          D._emitter.emit(u.default.SCRIPTDATA_ARRIVED, M);
                        }), this._transmuxer.on(p.default.STATISTICS_INFO, function(M) {
                          D._statisticsInfo = D._fillStatisticsInfo(M), D._emitter.emit(u.default.STATISTICS_INFO, Object.assign({}, D._statisticsInfo));
                        }), this._transmuxer.on(p.default.RECOMMEND_SEEKPOINT, function(M) {
                          D._mediaElement && !D._config.accurateSeek && (D._requestSetTime = !0, D._mediaElement.currentTime = M / 1e3);
                        }), this._transmuxer.open();
                      }
                    }, E.prototype.unload = function() {
                      this._mediaElement && this._mediaElement.pause(), this._msectl && this._msectl.seek(0), this._transmuxer && (this._transmuxer.close(), this._transmuxer.destroy(), this._transmuxer = null);
                    }, E.prototype.play = function() {
                      return this._mediaElement.play();
                    }, E.prototype.pause = function() {
                      this._mediaElement.pause();
                    }, Object.defineProperty(E.prototype, "type", {
                      get: function() {
                        return this._type;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(E.prototype, "buffered", {
                      get: function() {
                        return this._mediaElement.buffered;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(E.prototype, "duration", {
                      get: function() {
                        return this._mediaElement.duration;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(E.prototype, "volume", {
                      get: function() {
                        return this._mediaElement.volume;
                      },
                      set: function(D) {
                        this._mediaElement.volume = D;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(E.prototype, "muted", {
                      get: function() {
                        return this._mediaElement.muted;
                      },
                      set: function(D) {
                        this._mediaElement.muted = D;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(E.prototype, "currentTime", {
                      get: function() {
                        return this._mediaElement ? this._mediaElement.currentTime : 0;
                      },
                      set: function(D) {
                        this._mediaElement ? this._internalSeek(D) : this._pendingSeekTime = D;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(E.prototype, "mediaInfo", {
                      get: function() {
                        return Object.assign({}, this._mediaInfo);
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(E.prototype, "statisticsInfo", {
                      get: function() {
                        return this._statisticsInfo == null && (this._statisticsInfo = {}), this._statisticsInfo = this._fillStatisticsInfo(this._statisticsInfo), Object.assign({}, this._statisticsInfo);
                      },
                      enumerable: !1,
                      configurable: !0
                    }), E.prototype._fillStatisticsInfo = function(D) {
                      if (D.playerType = this._type, !(this._mediaElement instanceof HTMLVideoElement))
                        return D;
                      var M = !0, C = 0, I = 0;
                      if (this._mediaElement.getVideoPlaybackQuality) {
                        var k = this._mediaElement.getVideoPlaybackQuality();
                        C = k.totalVideoFrames, I = k.droppedVideoFrames;
                      } else
                        this._mediaElement.webkitDecodedFrameCount != null ? (C = this._mediaElement.webkitDecodedFrameCount, I = this._mediaElement.webkitDroppedFrameCount) : M = !1;
                      return M && (D.decodedFrames = C, D.droppedFrames = I), D;
                    }, E.prototype._onmseUpdateEnd = function() {
                      if (!(!this._config.lazyLoad || this._config.isLive)) {
                        for (var D = this._mediaElement.buffered, M = this._mediaElement.currentTime, C = 0, I = 0; I < D.length; I++) {
                          var k = D.start(I), F = D.end(I);
                          if (k <= M && M < F) {
                            C = F;
                            break;
                          }
                        }
                        C >= M + this._config.lazyLoadMaxDuration && this._progressChecker == null && (h.default.v(this.TAG, "Maximum buffering duration exceeded, suspend transmuxing task"), this._suspendTransmuxer());
                      }
                    }, E.prototype._onmseBufferFull = function() {
                      h.default.v(this.TAG, "MSE SourceBuffer is full, suspend transmuxing task"), this._progressChecker == null && this._suspendTransmuxer();
                    }, E.prototype._suspendTransmuxer = function() {
                      this._transmuxer && (this._transmuxer.pause(), this._progressChecker == null && (this._progressChecker = window.setInterval(this._checkProgressAndResume.bind(this), 1e3)));
                    }, E.prototype._checkProgressAndResume = function() {
                      for (var D = this._mediaElement.currentTime, M = this._mediaElement.buffered, C = !1, I = 0; I < M.length; I++) {
                        var k = M.start(I), F = M.end(I);
                        if (D >= k && D < F) {
                          D >= F - this._config.lazyLoadRecoverDuration && (C = !0);
                          break;
                        }
                      }
                      C && (window.clearInterval(this._progressChecker), this._progressChecker = null, C && (h.default.v(this.TAG, "Continue loading from paused position"), this._transmuxer.resume()));
                    }, E.prototype._isTimepointBuffered = function(D) {
                      for (var M = this._mediaElement.buffered, C = 0; C < M.length; C++) {
                        var I = M.start(C), k = M.end(C);
                        if (D >= I && D < k)
                          return !0;
                      }
                      return !1;
                    }, E.prototype._internalSeek = function(D) {
                      var M = this._isTimepointBuffered(D), C = !1, I = 0;
                      if (D < 1 && this._mediaElement.buffered.length > 0) {
                        var k = this._mediaElement.buffered.start(0);
                        (k < 1 && D < k || l.default.safari) && (C = !0, I = l.default.safari ? 0.1 : k);
                      }
                      if (C)
                        this._requestSetTime = !0, this._mediaElement.currentTime = I;
                      else if (M) {
                        if (!this._alwaysSeekKeyframe)
                          this._requestSetTime = !0, this._mediaElement.currentTime = D;
                        else {
                          var F = this._msectl.getNearestKeyframe(Math.floor(D * 1e3));
                          this._requestSetTime = !0, F != null ? this._mediaElement.currentTime = F.dts / 1e3 : this._mediaElement.currentTime = D;
                        }
                        this._progressChecker != null && this._checkProgressAndResume();
                      } else
                        this._progressChecker != null && (window.clearInterval(this._progressChecker), this._progressChecker = null), this._msectl.seek(D), this._transmuxer.seek(Math.floor(D * 1e3)), this._config.accurateSeek && (this._requestSetTime = !0, this._mediaElement.currentTime = D);
                    }, E.prototype._checkAndApplyUnbufferedSeekpoint = function() {
                      if (this._seekpointRecord)
                        if (this._seekpointRecord.recordTime <= this._now() - 100) {
                          var D = this._mediaElement.currentTime;
                          this._seekpointRecord = null, this._isTimepointBuffered(D) || (this._progressChecker != null && (window.clearTimeout(this._progressChecker), this._progressChecker = null), this._msectl.seek(D), this._transmuxer.seek(Math.floor(D * 1e3)), this._config.accurateSeek && (this._requestSetTime = !0, this._mediaElement.currentTime = D));
                        } else
                          window.setTimeout(this._checkAndApplyUnbufferedSeekpoint.bind(this), 50);
                    }, E.prototype._checkAndResumeStuckPlayback = function(D) {
                      var M = this._mediaElement;
                      if (D || !this._receivedCanPlay || M.readyState < 2) {
                        var C = M.buffered;
                        C.length > 0 && M.currentTime < C.start(0) && (h.default.w(this.TAG, "Playback seems stuck at " + M.currentTime + ", seek to " + C.start(0)), this._requestSetTime = !0, this._mediaElement.currentTime = C.start(0), this._mediaElement.removeEventListener("progress", this.e.onvProgress));
                      } else
                        this._mediaElement.removeEventListener("progress", this.e.onvProgress);
                    }, E.prototype._onvLoadedMetadata = function(D) {
                      this._pendingSeekTime != null && (this._mediaElement.currentTime = this._pendingSeekTime, this._pendingSeekTime = null);
                    }, E.prototype._onvSeeking = function(D) {
                      var M = this._mediaElement.currentTime, C = this._mediaElement.buffered;
                      if (this._requestSetTime) {
                        this._requestSetTime = !1;
                        return;
                      }
                      if (M < 1 && C.length > 0) {
                        var I = C.start(0);
                        if (I < 1 && M < I || l.default.safari) {
                          this._requestSetTime = !0, this._mediaElement.currentTime = l.default.safari ? 0.1 : I;
                          return;
                        }
                      }
                      if (this._isTimepointBuffered(M)) {
                        if (this._alwaysSeekKeyframe) {
                          var k = this._msectl.getNearestKeyframe(Math.floor(M * 1e3));
                          k != null && (this._requestSetTime = !0, this._mediaElement.currentTime = k.dts / 1e3);
                        }
                        this._progressChecker != null && this._checkProgressAndResume();
                        return;
                      }
                      this._seekpointRecord = {
                        seekPoint: M,
                        recordTime: this._now()
                      }, window.setTimeout(this._checkAndApplyUnbufferedSeekpoint.bind(this), 50);
                    }, E.prototype._onvCanPlay = function(D) {
                      this._receivedCanPlay = !0, this._mediaElement.removeEventListener("canplay", this.e.onvCanPlay);
                    }, E.prototype._onvStalled = function(D) {
                      this._checkAndResumeStuckPlayback(!0);
                    }, E.prototype._onvProgress = function(D) {
                      this._checkAndResumeStuckPlayback();
                    }, E;
                  }()
                );
                w.default = d;
              }
            ),
            /***/
            "./src/player/native-player.js": (
              /*!*************************************!*\
                !*** ./src/player/native-player.js ***!
                \*************************************/
              /***/
              function(T, w, O) {
                O.r(w);
                var R = O(
                  /*! events */
                  "./node_modules/events/events.js"
                ), v = /* @__PURE__ */ O.n(R), h = O(
                  /*! ./player-events.js */
                  "./src/player/player-events.js"
                ), l = O(
                  /*! ../config.js */
                  "./src/config.js"
                ), u = O(
                  /*! ../utils/exception.js */
                  "./src/utils/exception.js"
                ), f = (
                  /** @class */
                  function() {
                    function p(m, g) {
                      if (this.TAG = "NativePlayer", this._type = "NativePlayer", this._emitter = new (v())(), this._config = (0, l.createDefaultConfig)(), typeof g == "object" && Object.assign(this._config, g), m.type.toLowerCase() === "flv")
                        throw new u.InvalidArgumentException("NativePlayer does't support flv MediaDataSource input!");
                      if (m.hasOwnProperty("segments"))
                        throw new u.InvalidArgumentException("NativePlayer(" + m.type + ") doesn't support multipart playback!");
                      this.e = {
                        onvLoadedMetadata: this._onvLoadedMetadata.bind(this)
                      }, this._pendingSeekTime = null, this._statisticsReporter = null, this._mediaDataSource = m, this._mediaElement = null;
                    }
                    return p.prototype.destroy = function() {
                      this._mediaElement && (this.unload(), this.detachMediaElement()), this.e = null, this._mediaDataSource = null, this._emitter.removeAllListeners(), this._emitter = null;
                    }, p.prototype.on = function(m, g) {
                      var y = this;
                      m === h.default.MEDIA_INFO ? this._mediaElement != null && this._mediaElement.readyState !== 0 && Promise.resolve().then(function() {
                        y._emitter.emit(h.default.MEDIA_INFO, y.mediaInfo);
                      }) : m === h.default.STATISTICS_INFO && this._mediaElement != null && this._mediaElement.readyState !== 0 && Promise.resolve().then(function() {
                        y._emitter.emit(h.default.STATISTICS_INFO, y.statisticsInfo);
                      }), this._emitter.addListener(m, g);
                    }, p.prototype.off = function(m, g) {
                      this._emitter.removeListener(m, g);
                    }, p.prototype.attachMediaElement = function(m) {
                      if (this._mediaElement = m, m.addEventListener("loadedmetadata", this.e.onvLoadedMetadata), this._pendingSeekTime != null)
                        try {
                          m.currentTime = this._pendingSeekTime, this._pendingSeekTime = null;
                        } catch {
                        }
                    }, p.prototype.detachMediaElement = function() {
                      this._mediaElement && (this._mediaElement.src = "", this._mediaElement.removeAttribute("src"), this._mediaElement.removeEventListener("loadedmetadata", this.e.onvLoadedMetadata), this._mediaElement = null), this._statisticsReporter != null && (window.clearInterval(this._statisticsReporter), this._statisticsReporter = null);
                    }, p.prototype.load = function() {
                      if (!this._mediaElement)
                        throw new u.IllegalStateException("HTMLMediaElement must be attached before load()!");
                      this._mediaElement.src = this._mediaDataSource.url, this._mediaElement.readyState > 0 && (this._mediaElement.currentTime = 0), this._mediaElement.preload = "auto", this._mediaElement.load(), this._statisticsReporter = window.setInterval(this._reportStatisticsInfo.bind(this), this._config.statisticsInfoReportInterval);
                    }, p.prototype.unload = function() {
                      this._mediaElement && (this._mediaElement.src = "", this._mediaElement.removeAttribute("src")), this._statisticsReporter != null && (window.clearInterval(this._statisticsReporter), this._statisticsReporter = null);
                    }, p.prototype.play = function() {
                      return this._mediaElement.play();
                    }, p.prototype.pause = function() {
                      this._mediaElement.pause();
                    }, Object.defineProperty(p.prototype, "type", {
                      get: function() {
                        return this._type;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(p.prototype, "buffered", {
                      get: function() {
                        return this._mediaElement.buffered;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(p.prototype, "duration", {
                      get: function() {
                        return this._mediaElement.duration;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(p.prototype, "volume", {
                      get: function() {
                        return this._mediaElement.volume;
                      },
                      set: function(m) {
                        this._mediaElement.volume = m;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(p.prototype, "muted", {
                      get: function() {
                        return this._mediaElement.muted;
                      },
                      set: function(m) {
                        this._mediaElement.muted = m;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(p.prototype, "currentTime", {
                      get: function() {
                        return this._mediaElement ? this._mediaElement.currentTime : 0;
                      },
                      set: function(m) {
                        this._mediaElement ? this._mediaElement.currentTime = m : this._pendingSeekTime = m;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(p.prototype, "mediaInfo", {
                      get: function() {
                        var m = this._mediaElement instanceof HTMLAudioElement ? "audio/" : "video/", g = {
                          mimeType: m + this._mediaDataSource.type
                        };
                        return this._mediaElement && (g.duration = Math.floor(this._mediaElement.duration * 1e3), this._mediaElement instanceof HTMLVideoElement && (g.width = this._mediaElement.videoWidth, g.height = this._mediaElement.videoHeight)), g;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(p.prototype, "statisticsInfo", {
                      get: function() {
                        var m = {
                          playerType: this._type,
                          url: this._mediaDataSource.url
                        };
                        if (!(this._mediaElement instanceof HTMLVideoElement))
                          return m;
                        var g = !0, y = 0, _ = 0;
                        if (this._mediaElement.getVideoPlaybackQuality) {
                          var x = this._mediaElement.getVideoPlaybackQuality();
                          y = x.totalVideoFrames, _ = x.droppedVideoFrames;
                        } else
                          this._mediaElement.webkitDecodedFrameCount != null ? (y = this._mediaElement.webkitDecodedFrameCount, _ = this._mediaElement.webkitDroppedFrameCount) : g = !1;
                        return g && (m.decodedFrames = y, m.droppedFrames = _), m;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), p.prototype._onvLoadedMetadata = function(m) {
                      this._pendingSeekTime != null && (this._mediaElement.currentTime = this._pendingSeekTime, this._pendingSeekTime = null), this._emitter.emit(h.default.MEDIA_INFO, this.mediaInfo);
                    }, p.prototype._reportStatisticsInfo = function() {
                      this._emitter.emit(h.default.STATISTICS_INFO, this.statisticsInfo);
                    }, p;
                  }()
                );
                w.default = f;
              }
            ),
            /***/
            "./src/player/player-errors.js": (
              /*!*************************************!*\
                !*** ./src/player/player-errors.js ***!
                \*************************************/
              /***/
              function(T, w, O) {
                O.r(w), O.d(w, {
                  /* harmony export */
                  ErrorTypes: function() {
                    return (
                      /* binding */
                      h
                    );
                  },
                  /* harmony export */
                  ErrorDetails: function() {
                    return (
                      /* binding */
                      l
                    );
                  }
                  /* harmony export */
                });
                var R = O(
                  /*! ../io/loader.js */
                  "./src/io/loader.js"
                ), v = O(
                  /*! ../demux/demux-errors.js */
                  "./src/demux/demux-errors.js"
                ), h = {
                  NETWORK_ERROR: "NetworkError",
                  MEDIA_ERROR: "MediaError",
                  OTHER_ERROR: "OtherError"
                }, l = {
                  NETWORK_EXCEPTION: R.LoaderErrors.EXCEPTION,
                  NETWORK_STATUS_CODE_INVALID: R.LoaderErrors.HTTP_STATUS_CODE_INVALID,
                  NETWORK_TIMEOUT: R.LoaderErrors.CONNECTING_TIMEOUT,
                  NETWORK_UNRECOVERABLE_EARLY_EOF: R.LoaderErrors.UNRECOVERABLE_EARLY_EOF,
                  MEDIA_MSE_ERROR: "MediaMSEError",
                  MEDIA_FORMAT_ERROR: v.default.FORMAT_ERROR,
                  MEDIA_FORMAT_UNSUPPORTED: v.default.FORMAT_UNSUPPORTED,
                  MEDIA_CODEC_UNSUPPORTED: v.default.CODEC_UNSUPPORTED
                };
              }
            ),
            /***/
            "./src/player/player-events.js": (
              /*!*************************************!*\
                !*** ./src/player/player-events.js ***!
                \*************************************/
              /***/
              function(T, w, O) {
                O.r(w);
                var R = {
                  ERROR: "error",
                  LOADING_COMPLETE: "loading_complete",
                  RECOVERED_EARLY_EOF: "recovered_early_eof",
                  MEDIA_INFO: "media_info",
                  METADATA_ARRIVED: "metadata_arrived",
                  SCRIPTDATA_ARRIVED: "scriptdata_arrived",
                  STATISTICS_INFO: "statistics_info"
                };
                w.default = R;
              }
            ),
            /***/
            "./src/remux/aac-silent.js": (
              /*!*********************************!*\
                !*** ./src/remux/aac-silent.js ***!
                \*********************************/
              /***/
              function(T, w, O) {
                O.r(w);
                var R = (
                  /** @class */
                  function() {
                    function v() {
                    }
                    return v.getSilentFrame = function(h, l) {
                      if (h === "mp4a.40.2") {
                        if (l === 1)
                          return new Uint8Array([0, 200, 0, 128, 35, 128]);
                        if (l === 2)
                          return new Uint8Array([33, 0, 73, 144, 2, 25, 0, 35, 128]);
                        if (l === 3)
                          return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 142]);
                        if (l === 4)
                          return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 128, 44, 128, 8, 2, 56]);
                        if (l === 5)
                          return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 130, 48, 4, 153, 0, 33, 144, 2, 56]);
                        if (l === 6)
                          return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 130, 48, 4, 153, 0, 33, 144, 2, 0, 178, 0, 32, 8, 224]);
                      } else {
                        if (l === 1)
                          return new Uint8Array([1, 64, 34, 128, 163, 78, 230, 128, 186, 8, 0, 0, 0, 28, 6, 241, 193, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
                        if (l === 2)
                          return new Uint8Array([1, 64, 34, 128, 163, 94, 230, 128, 186, 8, 0, 0, 0, 0, 149, 0, 6, 241, 161, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
                        if (l === 3)
                          return new Uint8Array([1, 64, 34, 128, 163, 94, 230, 128, 186, 8, 0, 0, 0, 0, 149, 0, 6, 241, 161, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
                      }
                      return null;
                    }, v;
                  }()
                );
                w.default = R;
              }
            ),
            /***/
            "./src/remux/mp4-generator.js": (
              /*!************************************!*\
                !*** ./src/remux/mp4-generator.js ***!
                \************************************/
              /***/
              function(T, w, O) {
                O.r(w);
                var R = (
                  /** @class */
                  function() {
                    function v() {
                    }
                    return v.init = function() {
                      v.types = {
                        hvc1: [],
                        hvcC: [],
                        avc1: [],
                        avcC: [],
                        btrt: [],
                        dinf: [],
                        dref: [],
                        esds: [],
                        ftyp: [],
                        hdlr: [],
                        mdat: [],
                        mdhd: [],
                        mdia: [],
                        mfhd: [],
                        minf: [],
                        moof: [],
                        moov: [],
                        mp4a: [],
                        mvex: [],
                        mvhd: [],
                        sdtp: [],
                        stbl: [],
                        stco: [],
                        stsc: [],
                        stsd: [],
                        stsz: [],
                        stts: [],
                        tfdt: [],
                        tfhd: [],
                        traf: [],
                        trak: [],
                        trun: [],
                        trex: [],
                        tkhd: [],
                        vmhd: [],
                        smhd: [],
                        pasp: [],
                        ".mp3": []
                      };
                      for (var h in v.types)
                        v.types.hasOwnProperty(h) && (v.types[h] = [
                          h.charCodeAt(0),
                          h.charCodeAt(1),
                          h.charCodeAt(2),
                          h.charCodeAt(3)
                        ]);
                      var l = v.constants = {};
                      l.FTYP = new Uint8Array([
                        105,
                        115,
                        111,
                        109,
                        0,
                        0,
                        0,
                        1,
                        105,
                        115,
                        111,
                        109,
                        97,
                        118,
                        99,
                        49
                        // avc1
                      ]), l.STSD_PREFIX = new Uint8Array([
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1
                        // entry_count
                      ]), l.STTS = new Uint8Array([
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                        // entry_count
                      ]), l.STSC = l.STCO = l.STTS, l.STSZ = new Uint8Array([
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                        // sample_count
                      ]), l.HDLR_VIDEO = new Uint8Array([
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        118,
                        105,
                        100,
                        101,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        86,
                        105,
                        100,
                        101,
                        111,
                        72,
                        97,
                        110,
                        100,
                        108,
                        101,
                        114,
                        0
                        // name: VideoHandler
                      ]), l.HDLR_AUDIO = new Uint8Array([
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        115,
                        111,
                        117,
                        110,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        83,
                        111,
                        117,
                        110,
                        100,
                        72,
                        97,
                        110,
                        100,
                        108,
                        101,
                        114,
                        0
                        // name: SoundHandler
                      ]), l.DREF = new Uint8Array([
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        12,
                        117,
                        114,
                        108,
                        32,
                        0,
                        0,
                        0,
                        1
                        // version(0) + flags
                      ]), l.SMHD = new Uint8Array([
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                        // balance(2) + reserved(2)
                      ]), l.VMHD = new Uint8Array([
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                      ]);
                    }, v.box = function(h) {
                      for (var l = 8, u = null, f = Array.prototype.slice.call(arguments, 1), p = f.length, m = 0; m < p; m++)
                        l += f[m].byteLength;
                      u = new Uint8Array(l), u[0] = l >>> 24 & 255, u[1] = l >>> 16 & 255, u[2] = l >>> 8 & 255, u[3] = l & 255, u.set(h, 4);
                      for (var g = 8, m = 0; m < p; m++)
                        u.set(f[m], g), g += f[m].byteLength;
                      return u;
                    }, v.generateInitSegment = function(h) {
                      var l = v.box(v.types.ftyp, v.constants.FTYP), u = v.moov(h), f = new Uint8Array(l.byteLength + u.byteLength);
                      return f.set(l, 0), f.set(u, l.byteLength), f;
                    }, v.moov = function(h) {
                      var l = v.mvhd(h.timescale, h.duration), u = v.trak(h), f = v.mvex(h);
                      return v.box(v.types.moov, l, u, f);
                    }, v.mvhd = function(h, l) {
                      return v.box(v.types.mvhd, new Uint8Array([
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        h >>> 24 & 255,
                        h >>> 16 & 255,
                        h >>> 8 & 255,
                        h & 255,
                        l >>> 24 & 255,
                        l >>> 16 & 255,
                        l >>> 8 & 255,
                        l & 255,
                        0,
                        1,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        64,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        255,
                        255,
                        255,
                        255
                        // next_track_ID
                      ]));
                    }, v.trak = function(h) {
                      return v.box(v.types.trak, v.tkhd(h), v.mdia(h));
                    }, v.tkhd = function(h) {
                      var l = h.id, u = h.duration, f = h.presentWidth, p = h.presentHeight;
                      return v.box(v.types.tkhd, new Uint8Array([
                        0,
                        0,
                        0,
                        7,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        l >>> 24 & 255,
                        l >>> 16 & 255,
                        l >>> 8 & 255,
                        l & 255,
                        0,
                        0,
                        0,
                        0,
                        u >>> 24 & 255,
                        u >>> 16 & 255,
                        u >>> 8 & 255,
                        u & 255,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        64,
                        0,
                        0,
                        0,
                        f >>> 8 & 255,
                        f & 255,
                        0,
                        0,
                        p >>> 8 & 255,
                        p & 255,
                        0,
                        0
                      ]));
                    }, v.mdia = function(h) {
                      return v.box(v.types.mdia, v.mdhd(h), v.hdlr(h), v.minf(h));
                    }, v.mdhd = function(h) {
                      var l = h.timescale, u = h.duration;
                      return v.box(v.types.mdhd, new Uint8Array([
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        l >>> 24 & 255,
                        l >>> 16 & 255,
                        l >>> 8 & 255,
                        l & 255,
                        u >>> 24 & 255,
                        u >>> 16 & 255,
                        u >>> 8 & 255,
                        u & 255,
                        85,
                        196,
                        0,
                        0
                        // pre_defined = 0
                      ]));
                    }, v.hdlr = function(h) {
                      var l = null;
                      return h.type === "audio" ? l = v.constants.HDLR_AUDIO : l = v.constants.HDLR_VIDEO, v.box(v.types.hdlr, l);
                    }, v.minf = function(h) {
                      var l = null;
                      return h.type === "audio" ? l = v.box(v.types.smhd, v.constants.SMHD) : l = v.box(v.types.vmhd, v.constants.VMHD), v.box(v.types.minf, l, v.dinf(), v.stbl(h));
                    }, v.dinf = function() {
                      var h = v.box(v.types.dinf, v.box(v.types.dref, v.constants.DREF));
                      return h;
                    }, v.stbl = function(h) {
                      var l = v.box(
                        v.types.stbl,
                        // type: stbl
                        v.stsd(h),
                        // Sample Description Table
                        v.box(v.types.stts, v.constants.STTS),
                        // Time-To-Sample
                        v.box(v.types.stsc, v.constants.STSC),
                        // Sample-To-Chunk
                        v.box(v.types.stsz, v.constants.STSZ),
                        // Sample size
                        v.box(v.types.stco, v.constants.STCO)
                        // Chunk offset
                      );
                      return l;
                    }, v.stsd = function(h) {
                      return h.type === "audio" ? h.codec === "mp3" ? v.box(v.types.stsd, v.constants.STSD_PREFIX, v.mp3(h)) : v.box(v.types.stsd, v.constants.STSD_PREFIX, v.mp4a(h)) : h.codec.indexOf("avc1") >= 0 ? v.box(v.types.stsd, v.constants.STSD_PREFIX, v.avc1(h)) : v.box(v.types.stsd, v.constants.STSD_PREFIX, v.hvc1(h));
                    }, v.mp3 = function(h) {
                      var l = h.channelCount, u = h.audioSampleRate, f = new Uint8Array([
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        l,
                        0,
                        16,
                        0,
                        0,
                        0,
                        0,
                        u >>> 8 & 255,
                        u & 255,
                        0,
                        0
                      ]);
                      return v.box(v.types[".mp3"], f);
                    }, v.mp4a = function(h) {
                      var l = h.channelCount, u = h.audioSampleRate, f = new Uint8Array([
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        l,
                        0,
                        16,
                        0,
                        0,
                        0,
                        0,
                        u >>> 8 & 255,
                        u & 255,
                        0,
                        0
                      ]);
                      return v.box(v.types.mp4a, f, v.esds(h));
                    }, v.esds = function(h) {
                      var l = h.config || [], u = l.length, f = new Uint8Array([
                        0,
                        0,
                        0,
                        0,
                        3,
                        23 + u,
                        0,
                        1,
                        0,
                        4,
                        15 + u,
                        64,
                        21,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        5
                        // descriptor_type
                      ].concat([
                        u
                      ]).concat(l).concat([
                        6,
                        1,
                        2
                        // GASpecificConfig
                      ]));
                      return v.box(v.types.esds, f);
                    }, v.avc1 = function(h) {
                      var l = h.avcc, u = h.codecWidth, f = h.codecHeight, p = new Uint8Array([
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        u >>> 8 & 255,
                        u & 255,
                        f >>> 8 & 255,
                        f & 255,
                        0,
                        72,
                        0,
                        0,
                        0,
                        72,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        10,
                        120,
                        113,
                        113,
                        47,
                        102,
                        108,
                        118,
                        46,
                        106,
                        115,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        24,
                        255,
                        255
                        // pre_defined = -1
                      ]);
                      return v.box(v.types.avc1, p, v.box(v.types.avcC, l));
                    }, v.hvc1 = function(h) {
                      var l = h.hvcc, u = h.codecWidth, f = h.codecHeight, p = new Uint8Array([
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        u >>> 8 & 255,
                        u & 255,
                        f >>> 8 & 255,
                        f & 255,
                        0,
                        72,
                        0,
                        0,
                        0,
                        72,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        10,
                        120,
                        113,
                        113,
                        47,
                        102,
                        108,
                        118,
                        46,
                        106,
                        115,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        24,
                        255,
                        255
                        // pre_defined = -1
                      ]);
                      return v.box(v.types.hvc1, p, v.box(v.types.hvcC, l));
                    }, v.mvex = function(h) {
                      return v.box(v.types.mvex, v.trex(h));
                    }, v.trex = function(h) {
                      var l = h.id, u = new Uint8Array([
                        0,
                        0,
                        0,
                        0,
                        l >>> 24 & 255,
                        l >>> 16 & 255,
                        l >>> 8 & 255,
                        l & 255,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        1
                        // default_sample_flags
                      ]);
                      return v.box(v.types.trex, u);
                    }, v.moof = function(h, l) {
                      return v.box(v.types.moof, v.mfhd(h.sequenceNumber), v.traf(h, l));
                    }, v.mfhd = function(h) {
                      var l = new Uint8Array([
                        0,
                        0,
                        0,
                        0,
                        h >>> 24 & 255,
                        h >>> 16 & 255,
                        h >>> 8 & 255,
                        h & 255
                      ]);
                      return v.box(v.types.mfhd, l);
                    }, v.traf = function(h, l) {
                      var u = h.id, f = v.box(v.types.tfhd, new Uint8Array([
                        0,
                        0,
                        0,
                        0,
                        u >>> 24 & 255,
                        u >>> 16 & 255,
                        u >>> 8 & 255,
                        u & 255
                      ])), p = v.box(v.types.tfdt, new Uint8Array([
                        0,
                        0,
                        0,
                        0,
                        l >>> 24 & 255,
                        l >>> 16 & 255,
                        l >>> 8 & 255,
                        l & 255
                      ])), m = v.sdtp(h), g = v.trun(h, m.byteLength + 16 + 16 + 8 + 16 + 8 + 8);
                      return v.box(v.types.traf, f, p, g, m);
                    }, v.sdtp = function(h) {
                      for (var l = h.samples || [], u = l.length, f = new Uint8Array(4 + u), p = 0; p < u; p++) {
                        var m = l[p].flags;
                        f[p + 4] = m.isLeading << 6 | m.dependsOn << 4 | m.isDependedOn << 2 | m.hasRedundancy;
                      }
                      return v.box(v.types.sdtp, f);
                    }, v.trun = function(h, l) {
                      var u = h.samples || [], f = u.length, p = 12 + 16 * f, m = new Uint8Array(p);
                      l += 8 + p, m.set([
                        0,
                        0,
                        15,
                        1,
                        f >>> 24 & 255,
                        f >>> 16 & 255,
                        f >>> 8 & 255,
                        f & 255,
                        l >>> 24 & 255,
                        l >>> 16 & 255,
                        l >>> 8 & 255,
                        l & 255
                      ], 0);
                      for (var g = 0; g < f; g++) {
                        var y = u[g].duration, _ = u[g].size, x = u[g].flags, d = u[g].cts;
                        m.set([
                          y >>> 24 & 255,
                          y >>> 16 & 255,
                          y >>> 8 & 255,
                          y & 255,
                          _ >>> 24 & 255,
                          _ >>> 16 & 255,
                          _ >>> 8 & 255,
                          _ & 255,
                          x.isLeading << 2 | x.dependsOn,
                          x.isDependedOn << 6 | x.hasRedundancy << 4 | x.isNonSync,
                          0,
                          0,
                          d >>> 24 & 255,
                          d >>> 16 & 255,
                          d >>> 8 & 255,
                          d & 255
                        ], 12 + 16 * g);
                      }
                      return v.box(v.types.trun, m);
                    }, v.mdat = function(h) {
                      return v.box(v.types.mdat, h);
                    }, v;
                  }()
                );
                R.init(), w.default = R;
              }
            ),
            /***/
            "./src/remux/mp4-remuxer.js": (
              /*!**********************************!*\
                !*** ./src/remux/mp4-remuxer.js ***!
                \**********************************/
              /***/
              function(T, w, O) {
                O.r(w);
                var R = O(
                  /*! ../utils/logger.js */
                  "./src/utils/logger.js"
                ), v = O(
                  /*! ./mp4-generator.js */
                  "./src/remux/mp4-generator.js"
                ), h = O(
                  /*! ./aac-silent.js */
                  "./src/remux/aac-silent.js"
                ), l = O(
                  /*! ../utils/browser.js */
                  "./src/utils/browser.js"
                ), u = O(
                  /*! ../core/media-segment-info.js */
                  "./src/core/media-segment-info.js"
                ), f = O(
                  /*! ../utils/exception.js */
                  "./src/utils/exception.js"
                ), p = (
                  /** @class */
                  function() {
                    function m(g) {
                      this.TAG = "MP4Remuxer", this._config = g, this._isLive = g.isLive === !0, this._dtsBase = -1, this._dtsBaseInited = !1, this._audioDtsBase = 1 / 0, this._videoDtsBase = 1 / 0, this._audioNextDts = void 0, this._videoNextDts = void 0, this._audioStashedLastSample = null, this._videoStashedLastSample = null, this._audioMeta = null, this._videoMeta = null, this._audioSegmentInfoList = new u.MediaSegmentInfoList("audio"), this._videoSegmentInfoList = new u.MediaSegmentInfoList("video"), this._onInitSegment = null, this._onMediaSegment = null, this._forceFirstIDR = !!(l.default.chrome && (l.default.version.major < 50 || l.default.version.major === 50 && l.default.version.build < 2661)), this._fillSilentAfterSeek = l.default.msedge || l.default.msie, this._mp3UseMpegAudio = !l.default.firefox, this._fillAudioTimestampGap = this._config.fixAudioTimestampGap;
                    }
                    return m.prototype.destroy = function() {
                      this._dtsBase = -1, this._dtsBaseInited = !1, this._audioMeta = null, this._videoMeta = null, this._audioSegmentInfoList.clear(), this._audioSegmentInfoList = null, this._videoSegmentInfoList.clear(), this._videoSegmentInfoList = null, this._onInitSegment = null, this._onMediaSegment = null;
                    }, m.prototype.bindDataSource = function(g) {
                      return g.onDataAvailable = this.remux.bind(this), g.onTrackMetadata = this._onTrackMetadataReceived.bind(this), this;
                    }, Object.defineProperty(m.prototype, "onInitSegment", {
                      /* prototype: function onInitSegment(type: string, initSegment: ArrayBuffer): void
                         InitSegment: {
                             type: string,
                             data: ArrayBuffer,
                             codec: string,
                             container: string
                         }
                      */
                      get: function() {
                        return this._onInitSegment;
                      },
                      set: function(g) {
                        this._onInitSegment = g;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(m.prototype, "onMediaSegment", {
                      /* prototype: function onMediaSegment(type: string, mediaSegment: MediaSegment): void
                         MediaSegment: {
                             type: string,
                             data: ArrayBuffer,
                             sampleCount: int32
                             info: MediaSegmentInfo
                         }
                      */
                      get: function() {
                        return this._onMediaSegment;
                      },
                      set: function(g) {
                        this._onMediaSegment = g;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), m.prototype.insertDiscontinuity = function() {
                      this._audioNextDts = this._videoNextDts = void 0;
                    }, m.prototype.seek = function(g) {
                      this._audioStashedLastSample = null, this._videoStashedLastSample = null, this._videoSegmentInfoList.clear(), this._audioSegmentInfoList.clear();
                    }, m.prototype.remux = function(g, y) {
                      if (!this._onMediaSegment)
                        throw new f.IllegalStateException("MP4Remuxer: onMediaSegment callback must be specificed!");
                      this._dtsBaseInited || this._calculateDtsBase(g, y), this._remuxVideo(y), this._remuxAudio(g);
                    }, m.prototype._onTrackMetadataReceived = function(g, y) {
                      var _ = null, x = "mp4", d = y.codec;
                      if (g === "audio")
                        this._audioMeta = y, y.codec === "mp3" && this._mp3UseMpegAudio ? (x = "mpeg", d = "", _ = new Uint8Array()) : _ = v.default.generateInitSegment(y);
                      else if (g === "video")
                        this._videoMeta = y, _ = v.default.generateInitSegment(y);
                      else
                        return;
                      if (!this._onInitSegment)
                        throw new f.IllegalStateException("MP4Remuxer: onInitSegment callback must be specified!");
                      this._onInitSegment(g, {
                        type: g,
                        data: _.buffer,
                        codec: d,
                        container: g + "/" + x,
                        mediaDuration: y.duration
                        // in timescale 1000 (milliseconds)
                      });
                    }, m.prototype._calculateDtsBase = function(g, y) {
                      this._dtsBaseInited || (g.samples && g.samples.length && (this._audioDtsBase = g.samples[0].dts), y.samples && y.samples.length && (this._videoDtsBase = y.samples[0].dts), this._dtsBase = Math.min(this._audioDtsBase, this._videoDtsBase), this._dtsBaseInited = !0);
                    }, m.prototype.flushStashedSamples = function() {
                      var g = this._videoStashedLastSample, y = this._audioStashedLastSample, _ = {
                        type: "video",
                        id: 1,
                        sequenceNumber: 0,
                        samples: [],
                        length: 0
                      };
                      g != null && (_.samples.push(g), _.length = g.length);
                      var x = {
                        type: "audio",
                        id: 2,
                        sequenceNumber: 0,
                        samples: [],
                        length: 0
                      };
                      y != null && (x.samples.push(y), x.length = y.length), this._videoStashedLastSample = null, this._audioStashedLastSample = null, this._remuxVideo(_, !0), this._remuxAudio(x, !0);
                    }, m.prototype._remuxAudio = function(g, y) {
                      if (this._audioMeta != null) {
                        var _ = g, x = _.samples, d = void 0, E = -1, D = -1, M = this._audioMeta.refSampleDuration, C = this._audioMeta.codec === "mp3" && this._mp3UseMpegAudio, I = this._dtsBaseInited && this._audioNextDts === void 0, k = !1;
                        if (!(!x || x.length === 0) && !(x.length === 1 && !y)) {
                          var F = 0, L = null, U = 0;
                          C ? (F = 0, U = _.length) : (F = 8, U = 8 + _.length);
                          var j = null;
                          if (x.length > 1 && (j = x.pop(), U -= j.length), this._audioStashedLastSample != null) {
                            var G = this._audioStashedLastSample;
                            this._audioStashedLastSample = null, x.unshift(G), U += G.length;
                          }
                          j != null && (this._audioStashedLastSample = j);
                          var B = x[0].dts - this._dtsBase;
                          if (this._audioNextDts)
                            d = B - this._audioNextDts;
                          else if (this._audioSegmentInfoList.isEmpty())
                            d = 0, this._fillSilentAfterSeek && !this._videoSegmentInfoList.isEmpty() && this._audioMeta.originalCodec !== "mp3" && (k = !0);
                          else {
                            var re = this._audioSegmentInfoList.getLastSampleBefore(B);
                            if (re != null) {
                              var le = B - (re.originalDts + re.duration);
                              le <= 3 && (le = 0);
                              var Q = re.dts + re.duration + le;
                              d = B - Q;
                            } else
                              d = 0;
                          }
                          if (k) {
                            var ue = B - d, ce = this._videoSegmentInfoList.getLastSegmentBefore(B);
                            if (ce != null && ce.beginDts < ue) {
                              var de = h.default.getSilentFrame(this._audioMeta.originalCodec, this._audioMeta.channelCount);
                              if (de) {
                                var te = ce.beginDts, V = ue - ce.beginDts;
                                R.default.v(this.TAG, "InsertPrefixSilentAudio: dts: " + te + ", duration: " + V), x.unshift({ unit: de, dts: te, pts: te }), U += de.byteLength;
                              }
                            } else
                              k = !1;
                          }
                          for (var xe = [], be = 0; be < x.length; be++) {
                            var G = x[be], je = G.unit, H = G.dts - this._dtsBase, te = H, Me = !1, Ve = null, Se = 0;
                            if (!(H < -1e-3)) {
                              if (this._audioMeta.codec !== "mp3") {
                                var ne = H, Qe = 3;
                                if (this._audioNextDts && (ne = this._audioNextDts), d = H - ne, d <= -Qe * M) {
                                  R.default.w(this.TAG, "Dropping 1 audio frame (originalDts: " + H + " ms ,curRefDts: " + ne + " ms)  due to dtsCorrection: " + d + " ms overlap.");
                                  continue;
                                } else if (d >= Qe * M && this._fillAudioTimestampGap && !l.default.safari) {
                                  Me = !0;
                                  var qe = Math.floor(d / M);
                                  R.default.w(this.TAG, `Large audio timestamp gap detected, may cause AV sync to drift. Silent frames will be generated to avoid unsync.
` + ("originalDts: " + H + " ms, curRefDts: " + ne + " ms, ") + ("dtsCorrection: " + Math.round(d) + " ms, generate: " + qe + " frames")), te = Math.floor(ne), Se = Math.floor(ne + M) - te;
                                  var de = h.default.getSilentFrame(this._audioMeta.originalCodec, this._audioMeta.channelCount);
                                  de == null && (R.default.w(this.TAG, "Unable to generate silent frame for " + (this._audioMeta.originalCodec + " with " + this._audioMeta.channelCount + " channels, repeat last frame")), de = je), Ve = [];
                                  for (var rt = 0; rt < qe; rt++) {
                                    ne = ne + M;
                                    var lt = Math.floor(ne), ht = Math.floor(ne + M) - lt, ct = {
                                      dts: lt,
                                      pts: lt,
                                      cts: 0,
                                      unit: de,
                                      size: de.byteLength,
                                      duration: ht,
                                      originalDts: H,
                                      flags: {
                                        isLeading: 0,
                                        dependsOn: 1,
                                        isDependedOn: 0,
                                        hasRedundancy: 0
                                      }
                                    };
                                    Ve.push(ct), U += ct.size;
                                  }
                                  this._audioNextDts = ne + M;
                                } else
                                  te = Math.floor(ne), Se = Math.floor(ne + M) - te, this._audioNextDts = ne + M;
                              } else {
                                if (te = H - d, be !== x.length - 1) {
                                  var ut = x[be + 1].dts - this._dtsBase - d;
                                  Se = ut - te;
                                } else if (j != null) {
                                  var ut = j.dts - this._dtsBase - d;
                                  Se = ut - te;
                                } else
                                  xe.length >= 1 ? Se = xe[xe.length - 1].duration : Se = Math.floor(M);
                                this._audioNextDts = te + Se;
                              }
                              E === -1 && (E = te), xe.push({
                                dts: te,
                                pts: te,
                                cts: 0,
                                unit: G.unit,
                                size: G.unit.byteLength,
                                duration: Se,
                                originalDts: H,
                                flags: {
                                  isLeading: 0,
                                  dependsOn: 1,
                                  isDependedOn: 0,
                                  hasRedundancy: 0
                                }
                              }), Me && xe.push.apply(xe, Ve);
                            }
                          }
                          if (xe.length === 0) {
                            _.samples = [], _.length = 0;
                            return;
                          }
                          C ? L = new Uint8Array(U) : (L = new Uint8Array(U), L[0] = U >>> 24 & 255, L[1] = U >>> 16 & 255, L[2] = U >>> 8 & 255, L[3] = U & 255, L.set(v.default.types.mdat, 4));
                          for (var be = 0; be < xe.length; be++) {
                            var je = xe[be].unit;
                            L.set(je, F), F += je.byteLength;
                          }
                          var Fe = xe[xe.length - 1];
                          D = Fe.dts + Fe.duration;
                          var Ue = new u.MediaSegmentInfo();
                          Ue.beginDts = E, Ue.endDts = D, Ue.beginPts = E, Ue.endPts = D, Ue.originalBeginDts = xe[0].originalDts, Ue.originalEndDts = Fe.originalDts + Fe.duration, Ue.firstSample = new u.SampleInfo(xe[0].dts, xe[0].pts, xe[0].duration, xe[0].originalDts, !1), Ue.lastSample = new u.SampleInfo(Fe.dts, Fe.pts, Fe.duration, Fe.originalDts, !1), this._isLive || this._audioSegmentInfoList.append(Ue), _.samples = xe, _.sequenceNumber++;
                          var Et = null;
                          C ? Et = new Uint8Array() : Et = v.default.moof(_, E), _.samples = [], _.length = 0;
                          var Pt = {
                            type: "audio",
                            data: this._mergeBoxes(Et, L).buffer,
                            sampleCount: xe.length,
                            info: Ue
                          };
                          C && I && (Pt.timestampOffset = E), this._onMediaSegment("audio", Pt);
                        }
                      }
                    }, m.prototype._remuxVideo = function(g, y) {
                      if (this._videoMeta != null) {
                        var _ = g, x = _.samples, d = void 0, E = -1, D = -1, M = -1, C = -1;
                        if (!(!x || x.length === 0) && !(x.length === 1 && !y)) {
                          var I = 8, k = null, F = 8 + g.length, L = null;
                          if (x.length > 1 && (L = x.pop(), F -= L.length), this._videoStashedLastSample != null) {
                            var U = this._videoStashedLastSample;
                            this._videoStashedLastSample = null, x.unshift(U), F += U.length;
                          }
                          L != null && (this._videoStashedLastSample = L);
                          var j = x[0].dts - this._dtsBase;
                          if (this._videoNextDts)
                            d = j - this._videoNextDts;
                          else if (this._videoSegmentInfoList.isEmpty())
                            d = 0;
                          else {
                            var G = this._videoSegmentInfoList.getLastSampleBefore(j);
                            if (G != null) {
                              var B = j - (G.originalDts + G.duration);
                              B <= 3 && (B = 0);
                              var re = G.dts + G.duration + B;
                              d = j - re;
                            } else
                              d = 0;
                          }
                          for (var le = new u.MediaSegmentInfo(), Q = [], ue = 0; ue < x.length; ue++) {
                            var U = x[ue], ce = U.dts - this._dtsBase, de = U.isKeyframe, te = ce - d, V = U.cts, xe = te + V;
                            E === -1 && (E = te, M = xe);
                            var be = 0;
                            if (ue !== x.length - 1) {
                              var je = x[ue + 1].dts - this._dtsBase - d;
                              be = je - te;
                            } else if (L != null) {
                              var je = L.dts - this._dtsBase - d;
                              be = je - te;
                            } else
                              Q.length >= 1 ? be = Q[Q.length - 1].duration : be = Math.floor(this._videoMeta.refSampleDuration);
                            if (de) {
                              var H = new u.SampleInfo(te, xe, be, U.dts, !0);
                              H.fileposition = U.fileposition, le.appendSyncPoint(H);
                            }
                            Q.push({
                              dts: te,
                              pts: xe,
                              cts: V,
                              units: U.units,
                              size: U.length,
                              isKeyframe: de,
                              duration: be,
                              originalDts: ce,
                              flags: {
                                isLeading: 0,
                                dependsOn: de ? 2 : 1,
                                isDependedOn: de ? 1 : 0,
                                hasRedundancy: 0,
                                isNonSync: de ? 0 : 1
                              }
                            });
                          }
                          k = new Uint8Array(F), k[0] = F >>> 24 & 255, k[1] = F >>> 16 & 255, k[2] = F >>> 8 & 255, k[3] = F & 255, k.set(v.default.types.mdat, 4);
                          for (var ue = 0; ue < Q.length; ue++)
                            for (var Me = Q[ue].units; Me.length; ) {
                              var Ve = Me.shift(), Se = Ve.data;
                              k.set(Se, I), I += Se.byteLength;
                            }
                          var ne = Q[Q.length - 1];
                          if (D = ne.dts + ne.duration, C = ne.pts + ne.duration, this._videoNextDts = D, le.beginDts = E, le.endDts = D, le.beginPts = M, le.endPts = C, le.originalBeginDts = Q[0].originalDts, le.originalEndDts = ne.originalDts + ne.duration, le.firstSample = new u.SampleInfo(Q[0].dts, Q[0].pts, Q[0].duration, Q[0].originalDts, Q[0].isKeyframe), le.lastSample = new u.SampleInfo(ne.dts, ne.pts, ne.duration, ne.originalDts, ne.isKeyframe), this._isLive || this._videoSegmentInfoList.append(le), _.samples = Q, _.sequenceNumber++, this._forceFirstIDR) {
                            var Qe = Q[0].flags;
                            Qe.dependsOn = 2, Qe.isNonSync = 0;
                          }
                          var qe = v.default.moof(_, E);
                          _.samples = [], _.length = 0, this._onMediaSegment("video", {
                            type: "video",
                            data: this._mergeBoxes(qe, k).buffer,
                            sampleCount: Q.length,
                            info: le
                          });
                        }
                      }
                    }, m.prototype._mergeBoxes = function(g, y) {
                      var _ = new Uint8Array(g.byteLength + y.byteLength);
                      return _.set(g, 0), _.set(y, g.byteLength), _;
                    }, m;
                  }()
                );
                w.default = p;
              }
            ),
            /***/
            "./src/utils/browser.js": (
              /*!******************************!*\
                !*** ./src/utils/browser.js ***!
                \******************************/
              /***/
              function(T, w, O) {
                O.r(w);
                var R = {};
                function v() {
                  var h = self.navigator.userAgent.toLowerCase(), l = /(edge)\/([\w.]+)/.exec(h) || /(opr)[\/]([\w.]+)/.exec(h) || /(chrome)[ \/]([\w.]+)/.exec(h) || /(iemobile)[\/]([\w.]+)/.exec(h) || /(version)(applewebkit)[ \/]([\w.]+).*(safari)[ \/]([\w.]+)/.exec(h) || /(webkit)[ \/]([\w.]+).*(version)[ \/]([\w.]+).*(safari)[ \/]([\w.]+)/.exec(h) || /(webkit)[ \/]([\w.]+)/.exec(h) || /(opera)(?:.*version|)[ \/]([\w.]+)/.exec(h) || /(msie) ([\w.]+)/.exec(h) || h.indexOf("trident") >= 0 && /(rv)(?::| )([\w.]+)/.exec(h) || h.indexOf("compatible") < 0 && /(firefox)[ \/]([\w.]+)/.exec(h) || [], u = /(ipad)/.exec(h) || /(ipod)/.exec(h) || /(windows phone)/.exec(h) || /(iphone)/.exec(h) || /(kindle)/.exec(h) || /(android)/.exec(h) || /(windows)/.exec(h) || /(mac)/.exec(h) || /(linux)/.exec(h) || /(cros)/.exec(h) || [], f = {
                    browser: l[5] || l[3] || l[1] || "",
                    version: l[2] || l[4] || "0",
                    majorVersion: l[4] || l[2] || "0",
                    platform: u[0] || ""
                  }, p = {};
                  if (f.browser) {
                    p[f.browser] = !0;
                    var m = f.majorVersion.split(".");
                    p.version = {
                      major: parseInt(f.majorVersion, 10),
                      string: f.version
                    }, m.length > 1 && (p.version.minor = parseInt(m[1], 10)), m.length > 2 && (p.version.build = parseInt(m[2], 10));
                  }
                  if (f.platform && (p[f.platform] = !0), (p.chrome || p.opr || p.safari) && (p.webkit = !0), p.rv || p.iemobile) {
                    p.rv && delete p.rv;
                    var g = "msie";
                    f.browser = g, p[g] = !0;
                  }
                  if (p.edge) {
                    delete p.edge;
                    var y = "msedge";
                    f.browser = y, p[y] = !0;
                  }
                  if (p.opr) {
                    var _ = "opera";
                    f.browser = _, p[_] = !0;
                  }
                  if (p.safari && p.android) {
                    var x = "android";
                    f.browser = x, p[x] = !0;
                  }
                  p.name = f.browser, p.platform = f.platform;
                  for (var d in R)
                    R.hasOwnProperty(d) && delete R[d];
                  Object.assign(R, p);
                }
                v(), w.default = R;
              }
            ),
            /***/
            "./src/utils/exception.js": (
              /*!********************************!*\
                !*** ./src/utils/exception.js ***!
                \********************************/
              /***/
              function(T, w, O) {
                O.r(w), O.d(w, {
                  /* harmony export */
                  RuntimeException: function() {
                    return (
                      /* binding */
                      v
                    );
                  },
                  /* harmony export */
                  IllegalStateException: function() {
                    return (
                      /* binding */
                      h
                    );
                  },
                  /* harmony export */
                  InvalidArgumentException: function() {
                    return (
                      /* binding */
                      l
                    );
                  },
                  /* harmony export */
                  NotImplementedException: function() {
                    return (
                      /* binding */
                      u
                    );
                  }
                  /* harmony export */
                });
                var R = function() {
                  var f = function(p, m) {
                    return f = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(g, y) {
                      g.__proto__ = y;
                    } || function(g, y) {
                      for (var _ in y)
                        Object.prototype.hasOwnProperty.call(y, _) && (g[_] = y[_]);
                    }, f(p, m);
                  };
                  return function(p, m) {
                    if (typeof m != "function" && m !== null)
                      throw new TypeError("Class extends value " + String(m) + " is not a constructor or null");
                    f(p, m);
                    function g() {
                      this.constructor = p;
                    }
                    p.prototype = m === null ? Object.create(m) : (g.prototype = m.prototype, new g());
                  };
                }(), v = (
                  /** @class */
                  function() {
                    function f(p) {
                      this._message = p;
                    }
                    return Object.defineProperty(f.prototype, "name", {
                      get: function() {
                        return "RuntimeException";
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(f.prototype, "message", {
                      get: function() {
                        return this._message;
                      },
                      enumerable: !1,
                      configurable: !0
                    }), f.prototype.toString = function() {
                      return this.name + ": " + this.message;
                    }, f;
                  }()
                ), h = (
                  /** @class */
                  function(f) {
                    R(p, f);
                    function p(m) {
                      return f.call(this, m) || this;
                    }
                    return Object.defineProperty(p.prototype, "name", {
                      get: function() {
                        return "IllegalStateException";
                      },
                      enumerable: !1,
                      configurable: !0
                    }), p;
                  }(v)
                ), l = (
                  /** @class */
                  function(f) {
                    R(p, f);
                    function p(m) {
                      return f.call(this, m) || this;
                    }
                    return Object.defineProperty(p.prototype, "name", {
                      get: function() {
                        return "InvalidArgumentException";
                      },
                      enumerable: !1,
                      configurable: !0
                    }), p;
                  }(v)
                ), u = (
                  /** @class */
                  function(f) {
                    R(p, f);
                    function p(m) {
                      return f.call(this, m) || this;
                    }
                    return Object.defineProperty(p.prototype, "name", {
                      get: function() {
                        return "NotImplementedException";
                      },
                      enumerable: !1,
                      configurable: !0
                    }), p;
                  }(v)
                );
              }
            ),
            /***/
            "./src/utils/logger.js": (
              /*!*****************************!*\
                !*** ./src/utils/logger.js ***!
                \*****************************/
              /***/
              function(T, w, O) {
                O.r(w);
                var R = O(
                  /*! events */
                  "./node_modules/events/events.js"
                ), v = /* @__PURE__ */ O.n(R), h = (
                  /** @class */
                  function() {
                    function l() {
                    }
                    return l.e = function(u, f) {
                      (!u || l.FORCE_GLOBAL_TAG) && (u = l.GLOBAL_TAG);
                      var p = "[" + u + "] > " + f;
                      l.ENABLE_CALLBACK && l.emitter.emit("log", "error", p), l.ENABLE_ERROR && (console.error ? console.error(p) : console.warn ? console.warn(p) : console.log(p));
                    }, l.i = function(u, f) {
                      (!u || l.FORCE_GLOBAL_TAG) && (u = l.GLOBAL_TAG);
                      var p = "[" + u + "] > " + f;
                      l.ENABLE_CALLBACK && l.emitter.emit("log", "info", p), l.ENABLE_INFO && (console.info ? console.info(p) : console.log(p));
                    }, l.w = function(u, f) {
                      (!u || l.FORCE_GLOBAL_TAG) && (u = l.GLOBAL_TAG);
                      var p = "[" + u + "] > " + f;
                      l.ENABLE_CALLBACK && l.emitter.emit("log", "warn", p), l.ENABLE_WARN && (console.warn ? console.warn(p) : console.log(p));
                    }, l.d = function(u, f) {
                      (!u || l.FORCE_GLOBAL_TAG) && (u = l.GLOBAL_TAG);
                      var p = "[" + u + "] > " + f;
                      l.ENABLE_CALLBACK && l.emitter.emit("log", "debug", p), l.ENABLE_DEBUG && (console.debug ? console.debug(p) : console.log(p));
                    }, l.v = function(u, f) {
                      (!u || l.FORCE_GLOBAL_TAG) && (u = l.GLOBAL_TAG);
                      var p = "[" + u + "] > " + f;
                      l.ENABLE_CALLBACK && l.emitter.emit("log", "verbose", p), l.ENABLE_VERBOSE && console.log(p);
                    }, l;
                  }()
                );
                h.GLOBAL_TAG = "flv.js", h.FORCE_GLOBAL_TAG = !1, h.ENABLE_ERROR = !0, h.ENABLE_INFO = !0, h.ENABLE_WARN = !0, h.ENABLE_DEBUG = !0, h.ENABLE_VERBOSE = !0, h.ENABLE_CALLBACK = !1, h.emitter = new (v())(), w.default = h;
              }
            ),
            /***/
            "./src/utils/logging-control.js": (
              /*!**************************************!*\
                !*** ./src/utils/logging-control.js ***!
                \**************************************/
              /***/
              function(T, w, O) {
                O.r(w);
                var R = O(
                  /*! events */
                  "./node_modules/events/events.js"
                ), v = /* @__PURE__ */ O.n(R), h = O(
                  /*! ./logger.js */
                  "./src/utils/logger.js"
                ), l = (
                  /** @class */
                  function() {
                    function u() {
                    }
                    return Object.defineProperty(u, "forceGlobalTag", {
                      get: function() {
                        return h.default.FORCE_GLOBAL_TAG;
                      },
                      set: function(f) {
                        h.default.FORCE_GLOBAL_TAG = f, u._notifyChange();
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(u, "globalTag", {
                      get: function() {
                        return h.default.GLOBAL_TAG;
                      },
                      set: function(f) {
                        h.default.GLOBAL_TAG = f, u._notifyChange();
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(u, "enableAll", {
                      get: function() {
                        return h.default.ENABLE_VERBOSE && h.default.ENABLE_DEBUG && h.default.ENABLE_INFO && h.default.ENABLE_WARN && h.default.ENABLE_ERROR;
                      },
                      set: function(f) {
                        h.default.ENABLE_VERBOSE = f, h.default.ENABLE_DEBUG = f, h.default.ENABLE_INFO = f, h.default.ENABLE_WARN = f, h.default.ENABLE_ERROR = f, u._notifyChange();
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(u, "enableDebug", {
                      get: function() {
                        return h.default.ENABLE_DEBUG;
                      },
                      set: function(f) {
                        h.default.ENABLE_DEBUG = f, u._notifyChange();
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(u, "enableVerbose", {
                      get: function() {
                        return h.default.ENABLE_VERBOSE;
                      },
                      set: function(f) {
                        h.default.ENABLE_VERBOSE = f, u._notifyChange();
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(u, "enableInfo", {
                      get: function() {
                        return h.default.ENABLE_INFO;
                      },
                      set: function(f) {
                        h.default.ENABLE_INFO = f, u._notifyChange();
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(u, "enableWarn", {
                      get: function() {
                        return h.default.ENABLE_WARN;
                      },
                      set: function(f) {
                        h.default.ENABLE_WARN = f, u._notifyChange();
                      },
                      enumerable: !1,
                      configurable: !0
                    }), Object.defineProperty(u, "enableError", {
                      get: function() {
                        return h.default.ENABLE_ERROR;
                      },
                      set: function(f) {
                        h.default.ENABLE_ERROR = f, u._notifyChange();
                      },
                      enumerable: !1,
                      configurable: !0
                    }), u.getConfig = function() {
                      return {
                        globalTag: h.default.GLOBAL_TAG,
                        forceGlobalTag: h.default.FORCE_GLOBAL_TAG,
                        enableVerbose: h.default.ENABLE_VERBOSE,
                        enableDebug: h.default.ENABLE_DEBUG,
                        enableInfo: h.default.ENABLE_INFO,
                        enableWarn: h.default.ENABLE_WARN,
                        enableError: h.default.ENABLE_ERROR,
                        enableCallback: h.default.ENABLE_CALLBACK
                      };
                    }, u.applyConfig = function(f) {
                      h.default.GLOBAL_TAG = f.globalTag, h.default.FORCE_GLOBAL_TAG = f.forceGlobalTag, h.default.ENABLE_VERBOSE = f.enableVerbose, h.default.ENABLE_DEBUG = f.enableDebug, h.default.ENABLE_INFO = f.enableInfo, h.default.ENABLE_WARN = f.enableWarn, h.default.ENABLE_ERROR = f.enableError, h.default.ENABLE_CALLBACK = f.enableCallback;
                    }, u._notifyChange = function() {
                      var f = u.emitter;
                      if (f.listenerCount("change") > 0) {
                        var p = u.getConfig();
                        f.emit("change", p);
                      }
                    }, u.registerListener = function(f) {
                      u.emitter.addListener("change", f);
                    }, u.removeListener = function(f) {
                      u.emitter.removeListener("change", f);
                    }, u.addLogListener = function(f) {
                      h.default.emitter.addListener("log", f), h.default.emitter.listenerCount("log") > 0 && (h.default.ENABLE_CALLBACK = !0, u._notifyChange());
                    }, u.removeLogListener = function(f) {
                      h.default.emitter.removeListener("log", f), h.default.emitter.listenerCount("log") === 0 && (h.default.ENABLE_CALLBACK = !1, u._notifyChange());
                    }, u;
                  }()
                );
                l.emitter = new (v())(), w.default = l;
              }
            ),
            /***/
            "./src/utils/polyfill.js": (
              /*!*******************************!*\
                !*** ./src/utils/polyfill.js ***!
                \*******************************/
              /***/
              function(T, w, O) {
                O.r(w);
                var R = (
                  /** @class */
                  function() {
                    function v() {
                    }
                    return v.install = function() {
                      Object.setPrototypeOf = Object.setPrototypeOf || function(h, l) {
                        return h.__proto__ = l, h;
                      }, Object.assign = Object.assign || function(h) {
                        if (h == null)
                          throw new TypeError("Cannot convert undefined or null to object");
                        for (var l = Object(h), u = 1; u < arguments.length; u++) {
                          var f = arguments[u];
                          if (f != null)
                            for (var p in f)
                              f.hasOwnProperty(p) && (l[p] = f[p]);
                        }
                        return l;
                      }, typeof self.Promise != "function" && O(
                        /*! es6-promise */
                        "./node_modules/es6-promise/dist/es6-promise.js"
                      ).polyfill();
                    }, v;
                  }()
                );
                R.install(), w.default = R;
              }
            ),
            /***/
            "./src/utils/utf8-conv.js": (
              /*!********************************!*\
                !*** ./src/utils/utf8-conv.js ***!
                \********************************/
              /***/
              function(T, w, O) {
                O.r(w);
                function R(h, l, u) {
                  var f = h;
                  if (l + u < f.length) {
                    for (; u--; )
                      if ((f[++l] & 192) !== 128)
                        return !1;
                    return !0;
                  } else
                    return !1;
                }
                function v(h) {
                  for (var l = [], u = h, f = 0, p = h.length; f < p; ) {
                    if (u[f] < 128) {
                      l.push(String.fromCharCode(u[f])), ++f;
                      continue;
                    } else if (!(u[f] < 192)) {
                      if (u[f] < 224) {
                        if (R(u, f, 1)) {
                          var m = (u[f] & 31) << 6 | u[f + 1] & 63;
                          if (m >= 128) {
                            l.push(String.fromCharCode(m & 65535)), f += 2;
                            continue;
                          }
                        }
                      } else if (u[f] < 240) {
                        if (R(u, f, 2)) {
                          var m = (u[f] & 15) << 12 | (u[f + 1] & 63) << 6 | u[f + 2] & 63;
                          if (m >= 2048 && (m & 63488) !== 55296) {
                            l.push(String.fromCharCode(m & 65535)), f += 3;
                            continue;
                          }
                        }
                      } else if (u[f] < 248 && R(u, f, 3)) {
                        var m = (u[f] & 7) << 18 | (u[f + 1] & 63) << 12 | (u[f + 2] & 63) << 6 | u[f + 3] & 63;
                        if (m > 65536 && m < 1114112) {
                          m -= 65536, l.push(String.fromCharCode(m >>> 10 | 55296)), l.push(String.fromCharCode(m & 1023 | 56320)), f += 4;
                          continue;
                        }
                      }
                    }
                    l.push(String.fromCharCode(65533)), ++f;
                  }
                  return l.join("");
                }
                w.default = v;
              }
            )
            /******/
          }, s = {};
          function o(T) {
            var w = s[T];
            if (w !== void 0)
              return w.exports;
            var O = s[T] = {
              /******/
              // no module.id needed
              /******/
              // no module.loaded needed
              /******/
              exports: {}
              /******/
            };
            return i[T].call(O.exports, O, O.exports, o), O.exports;
          }
          o.m = i, function() {
            o.n = function(T) {
              var w = T && T.__esModule ? (
                /******/
                function() {
                  return T.default;
                }
              ) : (
                /******/
                function() {
                  return T;
                }
              );
              return o.d(w, { a: w }), w;
            };
          }(), function() {
            o.d = function(T, w) {
              for (var O in w)
                o.o(w, O) && !o.o(T, O) && Object.defineProperty(T, O, { enumerable: !0, get: w[O] });
            };
          }(), function() {
            o.g = function() {
              if (typeof globalThis == "object")
                return globalThis;
              try {
                return this || new Function("return this")();
              } catch {
                if (typeof window == "object")
                  return window;
              }
            }();
          }(), function() {
            o.o = function(T, w) {
              return Object.prototype.hasOwnProperty.call(T, w);
            };
          }(), function() {
            o.r = function(T) {
              typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(T, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(T, "__esModule", { value: !0 });
            };
          }();
          var b = o("./src/index.js");
          return b;
        }()
      );
    });
  }(Si)), Si.exports;
}
var G_ = j_();
const bn = /* @__PURE__ */ Ai(G_);
function zr(e) {
  this.gl = e, this.texture = e.createTexture(), e.bindTexture(e.TEXTURE_2D, this.texture), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MAG_FILTER, e.LINEAR), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MIN_FILTER, e.LINEAR), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_S, e.CLAMP_TO_EDGE), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_T, e.CLAMP_TO_EDGE);
}
zr.prototype.bind = function(e, r, i) {
  var s = this.gl;
  s.activeTexture([s.TEXTURE0, s.TEXTURE1, s.TEXTURE2][e]), s.bindTexture(s.TEXTURE_2D, this.texture), s.uniform1i(s.getUniformLocation(r, i), e);
};
zr.prototype.fill = function(e, r, i) {
  var s = this.gl;
  s.bindTexture(s.TEXTURE_2D, this.texture), s.texImage2D(s.TEXTURE_2D, 0, s.LUMINANCE, e, r, 0, s.LUMINANCE, s.UNSIGNED_BYTE, i);
};
function nn(e, r) {
  this.canvas = e, this.gl = e.getContext("webgl", {
    preserveDrawingBuffer: !0
  }) || e.getContext("experimental-webgl", {
    preserveDrawingBuffer: !0
  }), this.initGL(r);
}
nn.prototype.initGL = function(e) {
  if (!this.gl) {
    console.log("[ER] WebGL not supported.");
    return;
  }
  console.log("WebGL supported.");
  var r = this.gl;
  r.pixelStorei(r.UNPACK_ALIGNMENT, 1);
  var i = r.createProgram(), s = [
    "attribute highp vec4 aVertexPosition;",
    "attribute vec2 aTextureCoord;",
    "varying highp vec2 vTextureCoord;",
    "void main(void) {",
    " gl_Position = aVertexPosition;",
    " vTextureCoord = aTextureCoord;",
    "}"
  ].join(`
`), o = r.createShader(r.VERTEX_SHADER);
  r.shaderSource(o, s), r.compileShader(o);
  var b = [
    "precision highp float;",
    "varying lowp vec2 vTextureCoord;",
    "uniform sampler2D YTexture;",
    "uniform sampler2D UTexture;",
    "uniform sampler2D VTexture;",
    "const mat4 YUV2RGB = mat4",
    "(",
    " 1.1643828125, 0, 1.59602734375, -.87078515625,",
    " 1.1643828125, -.39176171875, -.81296875, .52959375,",
    " 1.1643828125, 2.017234375, 0, -1.081390625,",
    " 0, 0, 0, 1",
    ");",
    "void main(void) {",
    " gl_FragColor = vec4( texture2D(YTexture, vTextureCoord).x, texture2D(UTexture, vTextureCoord).x, texture2D(VTexture, vTextureCoord).x, 1) * YUV2RGB;",
    "}"
  ].join(`
`), T = r.createShader(r.FRAGMENT_SHADER);
  r.shaderSource(T, b), r.compileShader(T), r.attachShader(i, o), r.attachShader(i, T), r.linkProgram(i), r.useProgram(i), r.getProgramParameter(i, r.LINK_STATUS) || console.log("[ER] Shader link failed.");
  var w = r.getAttribLocation(i, "aVertexPosition");
  r.enableVertexAttribArray(w);
  var O = r.getAttribLocation(i, "aTextureCoord");
  r.enableVertexAttribArray(O);
  var R = r.createBuffer();
  r.bindBuffer(r.ARRAY_BUFFER, R), r.bufferData(r.ARRAY_BUFFER, new Float32Array([1, 1, 0, -1, 1, 0, 1, -1, 0, -1, -1, 0]), r.STATIC_DRAW), r.vertexAttribPointer(w, 3, r.FLOAT, !1, 0, 0);
  var v = r.createBuffer();
  r.bindBuffer(r.ARRAY_BUFFER, v), r.bufferData(r.ARRAY_BUFFER, new Float32Array([1, 0, 0, 0, 1, 1, 0, 1]), r.STATIC_DRAW), r.vertexAttribPointer(O, 2, r.FLOAT, !1, 0, 0), r.y = new zr(r), r.u = new zr(r), r.v = new zr(r), r.y.bind(0, i, "YTexture"), r.u.bind(1, i, "UTexture"), r.v.bind(2, i, "VTexture");
};
nn.prototype.renderFrame = function(e, r, i, s, o) {
  if (!this.gl) {
    console.log("[ER] Render frame failed due to WebGL not supported.");
    return;
  }
  var b = this.gl;
  b.viewport(0, 0, b.canvas.width, b.canvas.height), b.clearColor(0, 0, 0, 0), b.clear(b.COLOR_BUFFER_BIT), b.y.fill(r, i, e.subarray(0, s)), b.u.fill(r >> 1, i >> 1, e.subarray(s, s + o)), b.v.fill(r >> 1, i >> 1, e.subarray(s + o, e.length)), b.drawArrays(b.TRIANGLE_STRIP, 0, 4);
};
nn.prototype.fullscreen = function() {
  var e = this.canvas;
  e.RequestFullScreen ? e.RequestFullScreen() : e.webkitRequestFullScreen ? e.webkitRequestFullScreen() : e.mozRequestFullScreen ? e.mozRequestFullScreen() : e.msRequestFullscreen ? e.msRequestFullscreen() : alert("This browser doesn't supporter fullscreen");
};
nn.prototype.exitfullscreen = function() {
  document.exitFullscreen ? document.exitFullscreen() : document.webkitExitFullscreen ? document.webkitExitFullscreen() : document.mozCancelFullScreen ? document.mozCancelFullScreen() : document.msExitFullscreen ? document.msExitFullscreen() : alert("Exit fullscreen doesn't work");
};
var wi = { exports: {} }, ra;
function V_() {
  return ra || (ra = 1, function(e, r) {
    (function(i, s) {
      e.exports = s();
    })(ki, function() {
      class i {
        constructor(o) {
          this.init(o);
        }
        init(o) {
          const b = {
            inputCodec: "Int16",
            // 传入的数据是采用多少位编码，默认16位
            channels: 1,
            // 声道数
            sampleRate: 8e3,
            // 采样率 单位Hz
            flushTime: 1e3
            // 缓存时间 单位 ms
          };
          this.option = Object.assign({}, b, o), this.samples = new Float32Array(), this.interval = setInterval(this.flush.bind(this), this.option.flushTime), this.convertValue = this.getConvertValue(), this.typedArray = this.getTypedArray(), this.initAudioContext(), this.bindAudioContextEvent();
        }
        getConvertValue() {
          const o = {
            Int8: 128,
            Int16: 32768,
            Int32: 2147483648,
            Float32: 1
          };
          if (!o[this.option.inputCodec])
            throw new Error("wrong codec.please input one of these codecs:Int8,Int16,Int32,Float32");
          return o[this.option.inputCodec];
        }
        getTypedArray() {
          const o = {
            Int8: Int8Array,
            Int16: Int16Array,
            Int32: Int32Array,
            Float32: Float32Array
          };
          if (!o[this.option.inputCodec])
            throw new Error("wrong codec.please input one of these codecs:Int8,Int16,Int32,Float32");
          return o[this.option.inputCodec];
        }
        initAudioContext() {
          this.audioCtx = new (window.AudioContext || window.webkitAudioContext)(), this.gainNode = this.audioCtx.createGain(), this.gainNode.gain.value = 0.1, this.gainNode.connect(this.audioCtx.destination), this.startTime = this.audioCtx.currentTime;
        }
        static isTypedArray(o) {
          return o.byteLength && o.buffer && o.buffer.constructor == ArrayBuffer || o.constructor == ArrayBuffer;
        }
        isSupported(o) {
          if (!i.isTypedArray(o))
            throw new Error("请传入ArrayBuffer或者任意TypedArray");
          return !0;
        }
        feed(o) {
          this.isSupported(o), o = this.getFormattedValue(o);
          const b = new Float32Array(this.samples.length + o.length);
          b.set(this.samples, 0), b.set(o, this.samples.length), this.samples = b;
        }
        getFormattedValue(o) {
          o.constructor == ArrayBuffer ? o = new this.typedArray(o) : o = new this.typedArray(o.buffer);
          let b = new Float32Array(o.length);
          for (let T = 0; T < o.length; T++)
            b[T] = o[T] / this.convertValue;
          return b;
        }
        volume(o) {
          this.gainNode.gain.value = o;
        }
        destroy() {
          this.interval && clearInterval(this.interval), this.samples = null, this.audioCtx.close(), this.audioCtx = null;
        }
        flush() {
          if (!this.samples.length)
            return;
          const o = this;
          var b = this.audioCtx.createBufferSource();
          typeof this.option.onended == "function" && (b.onended = function(O) {
            o.option.onended(this, O);
          });
          const T = this.samples.length / this.option.channels, w = this.audioCtx.createBuffer(this.option.channels, T, this.option.sampleRate);
          for (let O = 0; O < this.option.channels; O++) {
            const R = w.getChannelData(O);
            let v = O, h = 50;
            for (let l = 0; l < T; l++)
              R[l] = this.samples[v], l < 50 && (R[l] = R[l] * l / 50), l >= T - 51 && (R[l] = R[l] * h-- / 50), v += this.option.channels;
          }
          this.startTime < this.audioCtx.currentTime && (this.startTime = this.audioCtx.currentTime), b.buffer = w, b.connect(this.gainNode), b.start(this.startTime), this.startTime += w.duration, this.samples = new Float32Array();
        }
        async pause() {
          await this.audioCtx.suspend();
        }
        async continue() {
          await this.audioCtx.resume();
        }
        bindAudioContextEvent() {
          const o = this;
          typeof o.option.onstatechange == "function" && (this.audioCtx.onstatechange = function(b) {
            o.audioCtx && o.option.onstatechange(this, b, o.audioCtx.state);
          });
        }
      }
      return i;
    });
  }(wi)), wi.exports;
}
var H_ = V_();
const K_ = /* @__PURE__ */ Ai(H_), Ja = "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", na = typeof window < "u" && window.Blob && new Blob([atob(Ja)], { type: "text/javascript;charset=utf-8" });
function Z_() {
  let e;
  try {
    if (e = na && (window.URL || window.webkitURL).createObjectURL(na), !e)
      throw "";
    return new Worker(e);
  } catch {
    return new Worker("data:application/javascript;base64," + Ja);
  } finally {
    e && (window.URL || window.webkitURL).revokeObjectURL(e);
  }
}
const Qa = "KGZ1bmN0aW9uKCl7InVzZSBzdHJpY3QiO2Z1bmN0aW9uIGsoYyl7Y29uc3QgZT1uZXcgSW50OEFycmF5KGMpO2Zvcih2YXIgaT1uZXcgSW50MTZBcnJheShlLmxlbmd0aCksbz0wO288ZS5sZW5ndGg7bysrKXt2YXIgYT1lW29dXjg1LHM9KGEmMTUpPDw0LHA9KGEmMTEyKT4+NDtzd2l0Y2gocCl7Y2FzZSAwOnMrPTg7YnJlYWs7Y2FzZSAxOnMrPTI2NDticmVhaztkZWZhdWx0OnMrPTI2NCxzPDw9cC0xfWlbb109YSYxMjg/czotc31yZXR1cm4gaX1sZXQgdCxyPVtdLGw9ITAsbj0hMSxmPW51bGwsdT0hMSxkPSExO2Z1bmN0aW9uIGcoe3VybDpjLHNlc3Npb25pZDplfSl7dD1uZXcgV2ViU29ja2V0KGMpLHQub25vcGVuPWZ1bmN0aW9uKCl7Y29uc29sZS5sb2coIldlYlNvY2tldCBvcGVuIiksdC5zZW5kKGBJTklUOiR7ZX1gKSxzZWxmLnBvc3RNZXNzYWdlKHt0eXBlOiJXZWJTb2NrZXRPcGVuIn0pfSx0Lm9uY2xvc2U9ZnVuY3Rpb24oKXtjb25zb2xlLmxvZygiV2ViU29ja2V0IGNsb3NlZCIpLHNlbGYucG9zdE1lc3NhZ2Uoe3R5cGU6IldlYlNvY2tldENsb3NlZCJ9KX0sdC5vbmVycm9yPWZ1bmN0aW9uKGkpe2NvbnNvbGUuZXJyb3IoIldlYlNvY2tldCBlcnJvciBvYnNlcnZlZDoiLGkpfSx0Lm9ubWVzc2FnZT1hc3luYyBmdW5jdGlvbihpKXtjb25zdCBvPWkuZGF0YTtpZih0eXBlb2Ygbz09InN0cmluZyIpe28uc3RhcnRzV2l0aCgiSU5JVF9SU1A6RVJST1IiKXx8by5zdGFydHNXaXRoKCJTVEFSVF9SU1A6RVJST1IiKT90LmNsb3NlKCk6bz09PSJJTklUX1JTUDpPSyImJnQuc2VuZChgU1RBUlQ6JHtlfWApO3JldHVybn1pZihvLnNpemU+MCl7Y29uc3QgYT1hd2FpdCBvLmFycmF5QnVmZmVyKCkscz1uZXcgVWludDhBcnJheShhKSxwPXNbMF09PT0xLHY9c1swXT09PTI7aWYocCl7aWYoZj09PW51bGwmJihmPXNbMl0sc2VsZi5wb3N0TWVzc2FnZSh7dHlwZToidmlkZW9Db2RlYyIsZGF0YTpmfSkpLHUpe2NvbnN0IHk9c1syXT09PTMsaD1zWzJdIT09MztsZXQgYj0hMTt5P2I9c1s2XT09PTA6aCYmKGI9c1s2XT09PTEpLGImJihuPSEwKSxuJiZyLnB1c2goYSksbCYmbiYmKFMoKSxsPSExKX19ZWxzZSBpZih2JiZuJiZkKXtjb25zdCB5PWsoYS5zbGljZSgxOSkpO3NlbGYucG9zdE1lc3NhZ2Uoe3R5cGU6ImF1ZGlvUmVzcG9uc2UiLGRhdGE6eX0pfX19fWZ1bmN0aW9uIFIoKXt0JiYoY29uc29sZS5sb2coImNsb3NlIHdlYnNvY2tldCIpLHQuY2xvc2UoKSxuPSExLGw9ITAscj1bXSxmPW51bGwsdT0hMSxkPSExKX1mdW5jdGlvbiBTKGMpe2lmKHIubGVuZ3RoKXtjb25zdCBlPXIuc2hpZnQoKTtzZWxmLnBvc3RNZXNzYWdlKHt0eXBlOiJ2aWRlb1Jlc3BvbnNlIixkYXRhOmV9KX1lbHNlIGw9ITB9c2VsZi5vbm1lc3NhZ2U9ZnVuY3Rpb24oYyl7Y29uc3QgZT1jLmRhdGE7c3dpdGNoKGUudHlwZSl7Y2FzZSJpbml0V3MiOmcoZSk7YnJlYWs7Y2FzZSJjbG9zZVdzIjpSKCk7YnJlYWs7Y2FzZSJ2aWRlb1BsYXkiOnU9ZS5wbGF5aW5nO2JyZWFrO2Nhc2UidmlkZW9SZXF1ZXN0IjpTKCk7YnJlYWs7Y2FzZSJhdWRpb1BsYXkiOmQ9ZS5wbGF5aW5nO2JyZWFrO2Nhc2UicGF1c2UiOnQmJnQuY2xvc2UoKSxyPVtdO2JyZWFrO2Nhc2UicmVzdW1lIjp1PSEwLGQ9ITAsbD0hMCxuPSExLGcoZSk7YnJlYWt9fX0pKCk7Cg==", ia = typeof window < "u" && window.Blob && new Blob([atob(Qa)], { type: "text/javascript;charset=utf-8" });
function z_() {
  let e;
  try {
    if (e = ia && (window.URL || window.webkitURL).createObjectURL(ia), !e)
      throw "";
    return new Worker(e);
  } catch {
    return new Worker("data:application/javascript;base64," + Qa);
  } finally {
    e && (window.URL || window.webkitURL).revokeObjectURL(e);
  }
}
var kr, fr;
const tt = class tt {
  constructor({ canvasElement: r }) {
    hi(this, kr, void 0);
    hi(this, fr, void 0);
    Ie(this, "canvas");
    Ie(this, "decoder_type");
    Ie(this, "sessionid");
    Ie(this, "devid");
    Ie(this, "chnid");
    Ie(this, "md5");
    Ie(this, "wasmFilePath");
    Ie(this, "eventCallback");
    Ie(this, "firstFrame", !0);
    Ie(this, "currentTime", 0);
    Ie(this, "volume", 1);
    Ie(this, "muted", !0);
    Ie(this, "resolution", {
      width: 0,
      height: 0
    });
    Ie(this, "webglPlayer");
    Ie(this, "pcmPlayer");
    Ie(this, "decoder");
    Ie(this, "downloader");
    Ie(this, "combinedArray", new Int16Array());
    Ie(this, "playTimerId", null);
    Ie(this, "frameBuffer", []);
    Ie(this, "frameInterval", tt.DEFAULT_FRAME_INTERVAL);
    Ie(this, "wsLinkStatus", !1);
    Ie(this, "getVideoCodingFromWs");
    this.canvas = r;
  }
  init({ devid: r, chnid: i, md5: s, baseURL: o, muted: b, volume: T, wasmFilePath: w, eventCallback: O }) {
    gn(this, kr, o), this.devid = r, this.chnid = i, this.md5 = s, this.wasmFilePath = w, this.eventCallback = O, this.muted = b, this.volume = T, o.startsWith("https") ? gn(this, fr, `wss://${o.split("https://")[1]}`) : o.startsWith("http") && gn(this, fr, `ws://${o.split("http://")[1]}`);
  }
  initDownloadWorker() {
    this.downloader = new z_(), this.downloader.onmessage = (r) => {
      const { type: i, data: s } = r.data;
      switch (i) {
        case "videoCodec":
          this.getVideoCodingFromWs && this.getVideoCodingFromWs(s);
          break;
        case "videoResponse":
          this.decoder && this.decoder.postMessage({ type: "decodeVideo", data: s });
          break;
        case "audioResponse":
          this.feedAudioData(s);
          break;
        case "WebSocketOpen":
          this.wsLinkStatus = !0;
          break;
        case "WebSocketClosed":
          this.wsLinkStatus = !1;
          break;
        case "clearFrameBuffer":
          console.log("frameBufferLength", this.frameBuffer.length), this.frameBuffer = [];
          break;
      }
    };
  }
  initDecodeWorker() {
    return new Promise((r, i) => {
      if (this.decoder) {
        r();
        return;
      }
      this.decoder = new Z_(), this.decoder.postMessage({ type: "loadWasm", filePath: this.wasmFilePath }), this.decoder.onmessage = (s) => {
        const o = s.data;
        switch (o.type) {
          case "wasmLoaded":
            console.log("wasm loaded"), this.decoder && this.decoder.postMessage({ type: "openDecoder", decoderType: this.decoder_type }), r();
            break;
          case "videoRequest":
            this.downloader && this.downloader.postMessage({
              type: "videoRequest"
            });
            break;
          case "videoFrame":
            this.frameBuffer.push(o.data), this.firstFrame && (this.firstFrame = !1, this.displayVideoFrame());
            break;
          case "closeDecoderSuccess":
            console.log("closeDecoder success");
            break;
          case "openDecoderSuccess":
            console.log("openDecoder success");
            break;
          case "openDecoderFail":
            console.log("openDecoder failed with error");
            break;
        }
      };
    });
  }
  login() {
    return new Promise((r, i) => {
      fetch(`${Br(this, kr)}/login?devid=${this.devid}&chnid=${this.chnid}&md5=${this.md5}`).then((s) => {
        s.ok ? s.text().then((o) => {
          if (o.startsWith("sessionid=")) {
            const b = o.split("=")[1];
            r(b);
          } else
            i(`login error: ${o}`);
        }) : i(`login error: ${s.statusText}`);
      }).catch((s) => {
        i(`login error: ${s.message}`);
      });
    });
  }
  logout(r) {
    return new Promise((i, s) => {
      fetch(`${Br(this, kr)}/logout?sessionid=${r}`).then((o) => {
        o.ok ? i() : s(o.statusText);
      }).catch((o) => {
        s(o.message);
      });
    });
  }
  getVideoCoding() {
    return this.initDownloadWorker(), new Promise((r, i) => {
      this.login().then((s) => {
        this.sessionid = s, this.downloader && (this.downloader.postMessage({
          type: "initWs",
          url: Br(this, fr),
          sessionid: s
        }), this.getVideoCodingFromWs = (o) => {
          let b = "";
          o === 3 ? (this.decoder_type = tt.DECODER_H265, b = "h265") : (this.decoder_type = tt.DECODER_H264, b = "h264"), console.log("codeType:", b), r(this.decoder_type);
        });
      }).catch((s) => {
        i(s);
      });
    });
  }
  startPlay() {
    this.eventCallback({ type: "start" }), this.initDecodeWorker().then(() => {
      this.downloader && (this.downloader.postMessage({
        type: "videoPlay",
        playing: !0
      }), this.eventCallback({ type: "canPlay" })), this.muted || this.startPlayAudio();
    });
  }
  stopPlay() {
    this.sessionid && (this.logout(this.sessionid), this.sessionid = ""), this.downloader && (this.downloader.postMessage({
      type: "closeWs"
    }), this.downloader.terminate(), this.downloader = null), this.decoder && (this.eventCallback({ type: "stop" }), this.decoder.terminate(), this.decoder = null), this.playTimerId && (clearTimeout(this.playTimerId), this.playTimerId = null), this.webglPlayer && this.webglPlayer.gl.clear(this.webglPlayer.gl.COLOR_BUFFER_BIT), this.stopPlayAudio(), this.frameBuffer = [], this.firstFrame = !0, this.currentTime = 0, this.frameInterval = tt.DEFAULT_FRAME_INTERVAL, this.wsLinkStatus = !1;
  }
  resume() {
    this.downloader && (this.downloader.postMessage({
      type: "resume",
      url: Br(this, fr),
      sessionid: this.sessionid
    }), this.pcmPlayer && this.pcmPlayer.continue());
  }
  pause() {
    this.downloader && this.downloader.postMessage({
      type: "pause"
    }), this.playTimerId && (clearTimeout(this.playTimerId), this.playTimerId = null), this.pcmPlayer && this.pcmPlayer.pause(), this.frameBuffer = [], this.firstFrame = !0, this.currentTime = 0, this.frameInterval = tt.DEFAULT_FRAME_INTERVAL, this.wsLinkStatus = !1;
  }
  displayVideoFrame() {
    if (this.frameBuffer.length) {
      this.frameBuffer.length < 16 ? this.frameInterval = tt.DEFAULT_FRAME_INTERVAL : this.frameBuffer.length < 32 ? this.frameInterval = tt.DEFAULT_FRAME_INTERVAL / 1.5 : this.frameBuffer.length < 64 ? this.frameInterval = tt.DEFAULT_FRAME_INTERVAL / 2 : this.frameInterval = tt.DEFAULT_FRAME_INTERVAL / 2.5;
      const r = this.frameBuffer.shift();
      r.frameTime && (this.currentTime = r.frameTime), this.videoFrameRender(r);
    } else if (!this.wsLinkStatus) {
      this.eventCallback({ type: "ended" });
      return;
    }
    this.playTimerId = setTimeout(() => {
      this.displayVideoFrame();
    }, this.frameInterval);
  }
  videoFrameRender(r) {
    const i = new Uint8Array(r.data), s = r.width, o = r.height, b = s * o, T = s / 2 * (o / 2);
    this.canvas.width = s, this.canvas.height = o, (this.resolution.width !== s || this.resolution.height !== o) && (console.log("分辨率", `${s} * ${o}`), this.resolution = { width: s, height: o }, this.eventCallback({ type: "resolution", resolution: { width: s, height: o } })), this.eventCallback({ type: "timeupdate", currentTime: this.currentTime / 1e3 }), this.webglPlayer || (this.webglPlayer = new nn(this.canvas, {
      preserveDrawingBuffer: !1
    })), this.webglPlayer.renderFrame(i, s, o, b, T);
  }
  initPcmPlayer() {
    this.pcmPlayer = new K_({
      inputCodec: "Int16",
      //编码格式
      channels: 1,
      //声道数
      sampleRate: 8e3,
      //采样率
      flushTime: 200,
      //缓存时间
      onended: function(r, i) {
      },
      onstatechange: function(r, i) {
        console.log("pcmPlayer statechange", i);
      }
    }), console.log("pcmPlayer init", this.pcmPlayer);
  }
  pcmPlayerDestroy() {
    this.pcmPlayer && (this.pcmPlayer.destroy(), this.pcmPlayer = null);
  }
  feedAudioData(r) {
    this.pcmPlayer && this.pcmPlayer && (this.pcmPlayer.volume(this.volume), this.pcmPlayer.feed(r));
  }
  startPlayAudio() {
    this.pcmPlayer || this.initPcmPlayer(), this.downloader && this.downloader.postMessage({ type: "audioPlay", playing: !0 });
  }
  stopPlayAudio() {
    this.pcmPlayerDestroy(), this.downloader && this.downloader.postMessage({ type: "audioPlay", playing: !1 });
  }
};
kr = new WeakMap(), fr = new WeakMap(), Ie(tt, "LOG_LEVEL_WASM", 1), Ie(tt, "DECODER_H264", 0), Ie(tt, "DECODER_H265", 1), Ie(tt, "DECODER_AVS3", 2), Ie(tt, "DEFAULT_FRAME_INTERVAL", 60), Ie(tt, "MIN_FRAME_INTERVAL", 50), Ie(tt, "MAX_FRAME_INTERVAL", 150);
let Xr = tt;
J.locale("zh-cn");
function X_(e, r) {
  var b;
  const i = document.createElement("canvas");
  i.width = e.videoWidth, i.height = e.videoHeight, (b = i.getContext("2d")) == null || b.drawImage(e, 0, 0);
  const s = i.toDataURL(), o = document.createElement("a");
  o.setAttribute("download", r), o.href = s, o.click();
}
function $_(e, r) {
  const i = e.toDataURL("image/jpg"), s = document.createElement("a");
  s.setAttribute("download", r), s.href = i, s.click();
}
function J_({
  uid: e,
  username: r = "admin",
  password: i = "123456",
  turnServerUrl: s,
  bitstream: o = 1,
  wasmFilePath: b,
  onResolutionChange: T,
  softDecoding: w = !0,
  muted: O = !0,
  onCanPlay: R,
  onError: v,
  ontimeupdate: h
}, l) {
  const [u, f] = Wr(!0), [p, m] = Wr(!1), [g, y] = Wr(!1), [_, x] = Wr(""), [d, E] = Wr(), D = br(null), M = br(null), C = br(), I = br(null), k = br(null), F = br(0), L = Td(() => W_(`user=${r}&pwd=${i}`), [r, i]);
  Ld(l, () => ({
    initPlay: U,
    startPlay: U,
    stopPlay: te,
    volumeControl: G,
    fullscreenToggle: xe,
    screenshot: je
  })), Ys(() => {
    m(O), k.current && (k.current.muted = O, O ? k.current.stopPlayAudio() : k.current.startPlayAudio());
  }, [O]), Ys(() => {
    function H() {
      console.log(document.visibilityState), console.log(document.hidden), document.visibilityState == "visible" ? k.current && k.current.resume() : document.visibilityState == "hidden" && k.current && k.current.pause();
    }
    document.addEventListener("visibilitychange", H);
    const Me = () => {
      document.fullscreenElement === D.current ? y(!0) : y(!1);
    };
    return window.addEventListener("fullscreenchange", Me), () => {
      ce(), ue(), console.log("player destroyed"), document.removeEventListener("visibilitychange", H), window.removeEventListener("fullscreenchange", Me);
    };
  }, []);
  function U() {
    return new Promise((H, Me) => {
      te(), E(), le().then((Ve) => {
        E(Ve), B(Ve), H();
      }).catch((Ve) => {
        Me(new Error(Ve));
      });
    });
  }
  function j(H) {
    v && v(H);
  }
  function G(H) {
    F.current = H, k.current && (k.current.volume = H / 100), M.current && (M.current.volume = H / 100);
  }
  function B(H = d) {
    switch (H) {
      case "flv":
        re();
        break;
      case "wasm":
        k.current && k.current.startPlay();
        break;
    }
  }
  async function re() {
    const H = `${s}/${e}_${o}.flv?key=${L}`;
    de({ type: "flv", isLive: !0, url: H });
  }
  function le() {
    return new Promise(async (H, Me) => {
      const Ve = bn.isSupported(), { nativeMP4H265Playback: Se } = bn.getFeatureList();
      k.current || (k.current = new Xr({
        canvasElement: C.current
      })), k.current.init({
        devid: e,
        chnid: o,
        md5: L,
        baseURL: s,
        wasmFilePath: b,
        eventCallback: Q,
        muted: O,
        volume: F.current / 100
      }), k.current.getVideoCoding().then((ne) => {
        !w && Ve && (ne === Xr.DECODER_H264 || Se && ne === Xr.DECODER_H265) ? (k.current.stopPlay(), H("flv")) : H("wasm");
      }).catch((ne) => {
        Me(ne);
      });
    });
  }
  function Q(H) {
    switch (H.type) {
      case "canPlay":
        console.log("wasmEvent:", "canPlay"), R && R();
        break;
      case "start":
        console.log("wasmEvent:", "startPlay");
        break;
      case "stop":
        console.log("wasmEvent:", "stopPlay");
        break;
      case "resume":
        break;
      case "pause":
        break;
      case "ended":
        break;
      case "timeupdate":
        h && h(H.currentTime);
        break;
      case "error":
        j(new Error(H.msg));
        break;
      case "resolution":
        T && T(H.resolution);
        break;
    }
  }
  function ue() {
    k.current !== null && (k.current.stopPlay(), k.current = null);
  }
  function ce() {
    I.current !== null && (I.current.unload(), I.current.detachMediaElement(), I.current.destroy(), I.current = null);
  }
  function de({ type: H, isLive: Me, url: Ve }) {
    ce(), I.current = bn.createPlayer(
      {
        type: H,
        isLive: Me,
        url: Ve,
        // hasAudio: true,
        hasVideo: !0
      },
      {
        enableWorker: !1,
        enableStashBuffer: !1,
        stashInitialSize: 128
      }
    ), I.current.attachMediaElement(M.current), I.current.load(), I.current.on(bn.Events.ERROR, function(Se) {
      console.error(Se);
    }), Me && (M.current.onprogress = () => {
      if (u && I.current.buffered.length > 0) {
        let ne = I.current.buffered.end(0) - I.current.currentTime;
        if (ne > 10 || ne < 0) {
          I.current.currentTime = I.current.buffered.end(0) - 1;
          return;
        }
        ne > 1 ? V(1.1) : V(1);
      }
    });
  }
  function te() {
    d === "flv" ? I.current && I.current.pause() : d === "wasm" && k.current && k.current.stopPlay();
  }
  function V(H) {
    M.current && (M.current.playbackRate = H);
  }
  function xe() {
    var H, Me, Ve, Se, ne, Qe, qe, rt;
    g ? document.exitFullscreen ? document.exitFullscreen() : y(!1) : (H = D.current) != null && H.requestFullscreen ? (Me = D.current) == null || Me.requestFullscreen() : (Ve = D.current) != null && Ve.msRequestFullscreen ? (Se = D.current) == null || Se.msRequestFullscreen() : (ne = D.current) != null && ne.mozRequestFullScreen ? (Qe = D.current) == null || Qe.mozRequestFullScreen() : (qe = D.current) != null && qe.webkitRequestFullscreen ? (rt = D.current) == null || rt.webkitRequestFullscreen() : (console.log("requestFullscreen api not supported"), y(!0));
  }
  function be(H) {
    H.keyCode === 27 && g && xe();
  }
  function je() {
    if (D.current) {
      const H = J().format("YYYYMMDDHHmmss");
      d === "flv" ? X_(M.current, `${e}-${H}.jpg`) : d === "wasm" && $_(C.current, `${e}-${H}.jpg`);
    }
  }
  return /* @__PURE__ */ En.jsx("div", { className: `camera-player${g ? " fullscreen" : ""}`, ref: D, onKeyDown: be, tabIndex: 1, children: /* @__PURE__ */ En.jsxs("div", { className: "player-content", children: [
    /* @__PURE__ */ En.jsx(
      "canvas",
      {
        style: {
          width: "100%",
          height: "100%",
          objectFit: "contain",
          display: d === "wasm" ? "block" : "none"
        },
        ref: C
      }
    ),
    /* @__PURE__ */ En.jsx(
      "video",
      {
        onAbort: (H) => {
          console.log("onAbort");
        },
        onRateChange: (H) => {
        },
        onPlay: (H) => {
          console.log("onPlay");
        },
        onPause: (H) => {
          console.log("onPause");
        },
        onEnded: () => {
          console.log("onEnded");
        },
        onDurationChange: (H) => {
        },
        onSeeking: () => {
          console.log("onSeeking");
        },
        onSeeked: () => {
          console.log("onSeeked");
        },
        onLoadedData: (H) => {
          console.log("onLoadedData");
        },
        onLoadedMetadata: (H) => {
          console.log("onLoadedMetadata");
        },
        onLoadStart: (H) => {
          console.log("onLoadStart");
        },
        onCanPlay: (H) => {
          console.log("onCanPlay"), R && R();
        },
        onSuspend: (H) => {
          console.log("onSuspend");
        },
        onStalled: (H) => {
          console.log("onStalled");
        },
        onError: (H) => {
          console.log("onError"), j(H.target.error);
        },
        muted: p,
        autoPlay: !0,
        className: "browser-video",
        ref: M,
        poster: _,
        crossOrigin: "anonymous",
        style: {
          width: "100%",
          height: "100%",
          display: d === "flv" ? "block" : "none"
        }
      }
    )
  ] }) });
}
const e0 = Md(J_);
export {
  e0 as default
};
